var airports = {
  AAA : {
    country: "PF",
    name: {
      en : "Anaa Arpt"
    }
  },
  AAB : {
    lat: "-26.69",
    lon: "141.048",
    country: "AU",
    name: {
      en : "Arrabury Airport"
    }
  },
  AAE : {
    lat: "36.8217",
    lon: "7.81",
    country: "DZ",
    name: {
      en : "Les Salines"
    }
  },
  AAL : {
    lat: "57.0931",
    lon: "9.85",
    country: "DK",
    name: {
      en : "Aalborg"
    }
  },
  AAM : {
    lat: "-24.8",
    lon: "31.5333",
    country: "ZA",
    name: {
      en : "Mala Mala"
    }
  },
  AAN : {
    lat: "24.25",
    lon: "55.75",
    country: "AE",
    name: {
      en : "Al Ain"
    }
  },
  AAQ : {
    lat: "44.9",
    lon: "37.3167",
    country: "RU",
    popularity: 2,
    name: {
      en : "Anapa"
    }
  },
  AAR : {
    lat: "56.3103",
    lon: "10.6181",
    country: "DK",
    popularity: 4,
    name: {
      en : "Tirstrup"
    }
  },
  AAT : {
    country: "CN",
    name: {
      en : "AAT"
    }
  },
  AAX : {
    country: "BR",
    name: {
      en : "AAX"
    }
  },
  AAY : {
    lat: "16.2",
    lon: "52.1833",
    country: "YE",
    name: {
      en : "Al Ghaydah"
    }
  },
  ABA : {
    lat: "53.7167",
    lon: "91.5",
    country: "RU",
    name: {
      en : "Abakan"
    }
  },
  ABC : {
    lat: "38.9483",
    lon: "-1.86333",
    country: "ES",
    name: {
      en : "Los Llanos"
    }
  },
  ABD : {
    lat: "30.3667",
    lon: "48.2333",
    country: "IR",
    name: {
      en : "Abadan"
    }
  },
  ABE : {
    lat: "40.6547",
    lon: "-75.4383",
    country: "US",
    name: {
      en : "Lehigh Valley"
    }
  },
  ABI : {
    lat: "32.4094",
    lon: "-99.6797",
    country: "US",
    name: {
      en : "Abilene"
    }
  },
  ABJ : {
    lat: "5.25639",
    lon: "-3.92694",
    country: "CI",
    popularity: 3,
    name: {
      en : "Felix Houphouet Boigny"
    }
  },
  ABK : {
    country: "ET",
    name: {
      en : "ABK"
    }
  },
  ABL : {
    lat: "67.0875",
    lon: "-157.846",
    country: "US",
    name: {
      en : "Ambler"
    }
  },
  ABM : {
    lat: "-10.8667",
    lon: "142.4",
    country: "AU",
    name: {
      en : "Bamaga"
    }
  },
  ABQ : {
    lat: "35.0422",
    lon: "-106.605",
    country: "US",
    name: {
      en : "Albuquerque"
    }
  },
  ABR : {
    lat: "45.4525",
    lon: "-98.4261",
    country: "US",
    name: {
      en : "Aberdeen"
    }
  },
  ABS : {
    lat: "22.3722",
    lon: "31.6153",
    country: "EG",
    name: {
      en : "Abu Simbel"
    }
  },
  ABT : {
    lat: "20.2856",
    lon: "41.6333",
    country: "SA",
    name: {
      en : "Al Aqiq"
    }
  },
  ABV : {
    lat: "9",
    lon: "7.26667",
    country: "NG",
    name: {
      en : "Abuja"
    }
  },
  ABX : {
    lat: "-36.0683",
    lon: "146.977",
    country: "AU",
    name: {
      en : "Albury"
    }
  },
  ABY : {
    lat: "31.5322",
    lon: "-84.1961",
    country: "US",
    name: {
      en : "Dougherty Cty"
    }
  },
  ABZ : {
    lat: "57.2042",
    lon: "-2.19806",
    country: "GB",
    popularity: 16,
    name: {
      en : "Dyce"
    }
  },
  ACA : {
    lat: "16.7556",
    lon: "-99.7669",
    country: "MX",
    name: {
      en : "Alvarez"
    }
  },
  ACC : {
    lat: "5.59528",
    lon: "-0.170833",
    country: "GH",
    name: {
      en : "Kotoka"
    }
  },
  ACE : {
    lat: "28.9375",
    lon: "-13.6036",
    country: "ES",
    popularity: 292,
    name: {
      en : "Lanzarote"
    }
  },
  ACH : {
    lat: "47.4833",
    lon: "9.56667",
    country: "CH",
    name: {
      en : "Altenrhein"
    }
  },
  ACI : {
    lat: "49.7069",
    lon: "-2.21528",
    country: "GB",
    name: {
      en : "The Blaye"
    }
  },
  ACK : {
    lat: "41.2567",
    lon: "-70.0597",
    country: "US",
    name: {
      en : "Nantucket Memorial"
    }
  },
  ACP : {
    country: "IR",
    name: {
      en : "ACP"
    }
  },
  ACR : {
    country: "CO",
    name: {
      en : "Araracuara Arpt"
    }
  },
  ACT : {
    lat: "31.6078",
    lon: "-97.2303",
    country: "US",
    name: {
      en : "Madison Cooper"
    }
  },
  ACU : {
    country: "PA",
    name: {
      en : "ACU"
    }
  },
  ACV : {
    lat: "40.9792",
    lon: "-124.108",
    country: "US",
    name: {
      en : "Arcata Eureka"
    }
  },
  ACX : {
    lat: "25.0856",
    lon: "104.959",
    country: "CN",
    name: {
      en : "Xingyi"
    }
  },
  ACY : {
    lat: "39.45",
    lon: "-74.5833",
    country: "US",
    city: "AIY",
    name: {
      en : "Pomona Field"
    }
  },
  ACZ : {
    country: "IR",
    name: {
      en : "ACZ"
    }
  },
  ADA : {
    lat: "36.9836",
    lon: "35.2808",
    country: "TR",
    name: {
      en : "Adana"
    }
  },
  ADB : {
    lat: "38.2833",
    lon: "27.15",
    country: "TR",
    city: "IZM",
    name: {
      en : "Adnan Menderes"
    }
  },
  ADD : {
    lat: "8.97778",
    lon: "38.7981",
    country: "ET",
    name: {
      en : "Bole"
    }
  },
  ADE : {
    lat: "12.8278",
    lon: "45.0306",
    country: "YE",
    name: {
      en : "Yemen"
    }
  },
  ADF : {
    country: "TR",
    name: {
      en : "ADF"
    }
  },
  ADJ : {
    lat: "31.95",
    lon: "35.9833",
    country: "JO",
    city: "AMM",
    name: {
      en : "Civil Marka"
    }
  },
  ADK : {
    lat: "51.8828",
    lon: "-176.645",
    country: "US",
    popularity: 5,
    name: {
      en : "Adak Island Ns"
    }
  },
  ADL : {
    lat: "-34.9483",
    lon: "138.535",
    country: "AU",
    popularity: 12,
    name: {
      en : "Adelaide"
    }
  },
  ADQ : {
    lat: "57.7542",
    lon: "-152.483",
    country: "US",
    name: {
      en : "Kodiak"
    }
  },
  ADS : {
    lat: "32.7833",
    lon: "-97.3",
    country: "US",
    city: "DFW",
    name: {
      en : "Addison"
    }
  },
  ADU : {
    lat: "38.25",
    lon: "48.3",
    country: "IR",
    name: {
      en : "Ardabil"
    }
  },
  ADZ : {
    lat: "12.5833",
    lon: "-81.7",
    country: "CO",
    name: {
      en : "San Andres Island"
    }
  },
  AEG : {
    country: "ID",
    name: {
      en : "AEG"
    }
  },
  AEI : {
    country: "ES",
    name: {
      en : "Algeciras Arpt"
    }
  },
  AEP : {
    lat: "-34.5589",
    lon: "-58.4158",
    country: "AR",
    city: "BUE",
    name: {
      en : "Jorge Newbery"
    }
  },
  AER : {
    lat: "43.45",
    lon: "39.9333",
    country: "RU",
    popularity: 98,
    name: {
      en : "Adler"
    }
  },
  AES : {
    lat: "62.5625",
    lon: "6.10528",
    country: "NO",
    name: {
      en : "Vigra"
    }
  },
  AET : {
    country: "US",
    name: {
      en : "AET"
    }
  },
  AEX : {
    lat: "31.3333",
    lon: "-92.55",
    country: "US",
    name: {
      en : "Alexandria"
    }
  },
  AEY : {
    lat: "65.6569",
    lon: "-18.0722",
    country: "IS",
    popularity: 1,
    name: {
      en : "Akureyri"
    }
  },
  AFA : {
    lat: "-34.5892",
    lon: "-68.4006",
    country: "AR",
    name: {
      en : "San Rafael"
    }
  },
  AFL : {
    lat: "-10",
    lon: "-56",
    country: "BR",
    name: {
      en : "Alta Floresta"
    }
  },
  AFS : {
    country: "UZ",
    name: {
      en : "AFS"
    }
  },
  AFT : {
    country: "SB",
    name: {
      en : "AFT"
    }
  },
  AFZ : {
    country: "IR",
    name: {
      en : "AFZ"
    }
  },
  AGA : {
    lat: "30.3806",
    lon: "-9.54583",
    country: "MA",
    name: {
      en : "Agadir Almassira"
    }
  },
  AGB : {
    country: "DE",
    city: "MUC",
    name: {
      en : "Muehlhausen Arpt"
    }
  },
  AGC : {
    lat: "40.3547",
    lon: "-79.93",
    country: "US",
    city: "PIT",
    name: {
      en : "Allegheny Cty"
    }
  },
  AGF : {
    lat: "44.1736",
    lon: "0.598611",
    country: "FR",
    name: {
      en : "La Garenne"
    }
  },
  AGH : {
    lat: "56.2931",
    lon: "12.8625",
    country: "SE",
    name: {
      en : "Angelholm Helsingborg"
    }
  },
  AGL : {
    country: "PG",
    name: {
      en : "AGL"
    }
  },
  AGM : {
    country: "GL",
    name: {
      en : "AGM"
    }
  },
  AGN : {
    lat: "57.5039",
    lon: "-134.583",
    country: "US",
    name: {
      en : "Angoon"
    }
  },
  AGP : {
    lat: "36.6717",
    lon: "-4.49806",
    country: "ES",
    name: {
      en : "Malaga"
    }
  },
  AGR : {
    lat: "27.1583",
    lon: "77.9628",
    country: "IN",
    name: {
      en : "Kheria"
    }
  },
  AGS : {
    lat: "33.3664",
    lon: "-81.9669",
    country: "US",
    name: {
      en : "Bush Field"
    }
  },
  AGT : {
    lat: "-25.5",
    lon: "-54.8333",
    country: "PY",
    name: {
      en : "Alejo Garcia"
    }
  },
  AGU : {
    lat: "21.7",
    lon: "-102.317",
    country: "MX",
    name: {
      en : "Aguascalientes"
    }
  },
  AGX : {
    country: "IN",
    name: {
      en : "Agatti Aerodrome"
    }
  },
  AHB : {
    lat: "18.2333",
    lon: "42.65",
    country: "SA",
    name: {
      en : "Abha"
    }
  },
  AHE : {
    country: "PF",
    name: {
      en : "AHE"
    }
  },
  AHN : {
    lat: "33.9483",
    lon: "-83.3269",
    country: "US",
    name: {
      en : "Athens"
    }
  },
  AHO : {
    lat: "40.6306",
    lon: "8.28889",
    country: "IT",
    name: {
      en : "Fertilia"
    }
  },
  AHS : {
    country: "HN",
    name: {
      en : "AHS"
    }
  },
  AHU : {
    country: "MA",
    name: {
      en : "Charif Al Idrissi Arpt"
    }
  },
  AIA : {
    lat: "42.0517",
    lon: "-102.807",
    country: "US",
    name: {
      en : "Alliance"
    }
  },
  AIN : {
    lat: "70.6333",
    lon: "-160.033",
    country: "US",
    name: {
      en : "Wainwright"
    }
  },
  AIRPORT : {
    city: "",
    name: {
      en : "all airports"
    }
  },
  AIT : {
    lat: "-18.85",
    lon: "-159.75",
    country: "CK",
    name: {
      en : "Aitutaki"
    }
  },
  AIU : {
    country: "CK",
    name: {
      en : "AIU"
    }
  },
  AJA : {
    lat: "41.9242",
    lon: "8.80306",
    country: "FR",
    name: {
      en : "Campo Dell Oro"
    }
  },
  AJF : {
    country: "SA",
    name: {
      en : "AJF"
    }
  },
  AJI : {
    city: "undefined",
    name: {
      en : "AJI"
    }
  },
  AJL : {
    country: "IN",
    name: {
      en : "Lengpui Airport"
    }
  },
  AJR : {
    lat: "65.5914",
    lon: "19.2856",
    country: "SE",
    name: {
      en : "Arvidsjaur"
    }
  },
  AJU : {
    lat: "-10.9833",
    lon: "-37.05",
    country: "BR",
    name: {
      en : "Santa Maria"
    }
  },
  AKA : {
    country: "CN",
    name: {
      en : "AKA"
    }
  },
  AKB : {
    country: "US",
    name: {
      en : "Atka Arpt"
    }
  },
  AKF : {
    country: "LY",
    name: {
      en : "AKF"
    }
  },
  AKI : {
    country: "US",
    name: {
      en : "AKI"
    }
  },
  AKJ : {
    lat: "43.6667",
    lon: "142.45",
    country: "JP",
    name: {
      en : "Asahikawa"
    }
  },
  AKK : {
    country: "US",
    name: {
      en : "AKK"
    }
  },
  AKL : {
    lat: "-37.0111",
    lon: "174.799",
    country: "NZ",
    popularity: 4,
    name: {
      en : "Auckland"
    }
  },
  AKN : {
    lat: "58.6686",
    lon: "-156.636",
    country: "US",
    name: {
      en : "King Salmon"
    }
  },
  AKP : {
    country: "US",
    name: {
      en : "AKP"
    }
  },
  AKR : {
    country: "NG",
    name: {
      en : "AKR"
    }
  },
  AKS : {
    country: "SB",
    name: {
      en : "AKS"
    }
  },
  AKU : {
    country: "CN",
    name: {
      en : "AKU"
    }
  },
  AKV : {
    lat: "60.7333",
    lon: "-78.5833",
    country: "CA",
    name: {
      en : "Akulivik"
    }
  },
  AKX : {
    lat: "50.25",
    lon: "57.2167",
    country: "KZ",
    name: {
      en : "Aqtobe"
    }
  },
  AKY : {
    country: "MM",
    name: {
      en : "AKY"
    }
  },
  ALA : {
    lat: "43.35",
    lon: "77.0333",
    country: "KZ",
    popularity: 44,
    name: {
      en : "Almaty"
    }
  },
  ALB : {
    lat: "42.7458",
    lon: "-73.8053",
    country: "US",
    name: {
      en : "Albany Cty"
    }
  },
  ALC : {
    lat: "38.2833",
    lon: "-0.566667",
    country: "ES",
    popularity: 8,
    name: {
      en : "Alicante"
    }
  },
  ALF : {
    lat: "69.9761",
    lon: "23.3806",
    country: "NO",
    name: {
      en : "Elvebakken"
    }
  },
  ALG : {
    lat: "36.6933",
    lon: "3.21722",
    country: "DZ",
    popularity: 58,
    name: {
      en : "Houari Boumedienne"
    }
  },
  ALH : {
    lat: "-34.945",
    lon: "117.806",
    country: "AU",
    name: {
      en : "Albany"
    }
  },
  ALL : {
    lat: "44.05",
    lon: "8.21667",
    country: "IT",
    name: {
      en : "Albenga"
    }
  },
  ALM : {
    lat: "32.8458",
    lon: "-105.985",
    country: "US",
    name: {
      en : "Alamogordo"
    }
  },
  ALO : {
    lat: "42.5561",
    lon: "-92.3997",
    country: "US",
    name: {
      en : "Livingston Betsworth Fld"
    }
  },
  ALP : {
    lat: "36.1808",
    lon: "37.2267",
    country: "SY",
    name: {
      en : "Nejrab"
    }
  },
  ALS : {
    lat: "37.4367",
    lon: "-105.867",
    country: "US",
    name: {
      en : "Alamosa"
    }
  },
  ALW : {
    lat: "46.0947",
    lon: "-118.291",
    country: "US",
    name: {
      en : "Walla Walla City County"
    }
  },
  ALY : {
    lat: "30.9",
    lon: "29.6833",
    country: "EG",
    name: {
      en : "Alexandria"
    }
  },
  ALZ : {
    country: "US",
    name: {
      en : "ALZ"
    }
  },
  AMA : {
    lat: "35.2272",
    lon: "-101.722",
    country: "US",
    name: {
      en : "Amarillo"
    }
  },
  AMD : {
    lat: "23.0664",
    lon: "72.6242",
    country: "IN",
    name: {
      en : "Ahmedabad"
    }
  },
  AMH : {
    country: "ET",
    name: {
      en : "AMH"
    }
  },
  AMI : {
    lat: "-8.56",
    lon: "116.097",
    country: "ID",
    name: {
      en : "Selaparang"
    }
  },
  AMM : {
    lat: "31.7167",
    lon: "36",
    country: "JO",
    popularity: 2,
    name: {
      en : "Queen Alia"
    }
  },
  AMQ : {
    lat: "-2.3",
    lon: "128.083",
    country: "ID",
    name: {
      en : "Pattimura"
    }
  },
  AMS : {
    lat: "52.3083",
    lon: "4.76806",
    country: "NL",
    popularity: 513,
    name: {
      en : "Schiphol"
    }
  },
  ANC : {
    lat: "61.1692",
    lon: "-149.985",
    country: "US",
    popularity: 8,
    name: {
      en : "Anchorage"
    }
  },
  ANE : {
    lat: "47.4667",
    lon: "-0.55",
    country: "FR",
    name: {
      en : "Marce"
    }
  },
  ANF : {
    lat: "-23.4394",
    lon: "-70.4428",
    country: "CL",
    name: {
      en : "Cerro Moreno"
    }
  },
  ANI : {
    lat: "61.5667",
    lon: "-159.533",
    country: "US",
    name: {
      en : "Aniak"
    }
  },
  ANM : {
    country: "MG",
    name: {
      en : "ANM"
    }
  },
  ANR : {
    lat: "51.19",
    lon: "4.46",
    country: "BE",
    name: {
      en : "Brussels North"
    }
  },
  ANS : {
    country: "PE",
    name: {
      en : "ANS"
    }
  },
  ANU : {
    lat: "17.1083",
    lon: "-61.7639",
    country: "AG",
    name: {
      en : "V C Bird"
    }
  },
  ANV : {
    country: "US",
    name: {
      en : "ANV"
    }
  },
  ANX : {
    lat: "69.293",
    lon: "16.1417",
    country: "NO",
    name: {
      en : "Andenes"
    }
  },
  AOC : {
    lat: "50.9833",
    lon: "12.45",
    country: "DE",
    name: {
      en : "Altenburg Nobitz"
    }
  },
  AOE : {
    lat: "0",
    lon: "0",
    country: "TR",
    name: {
      en : "Anadolu Airport"
    }
  },
  AOG : {
    country: "CN",
    name: {
      en : "AOG"
    }
  },
  AOI : {
    lat: "43.6167",
    lon: "13.5167",
    country: "IT",
    name: {
      en : "Falconara"
    }
  },
  AOJ : {
    lat: "40.7333",
    lon: "140.7",
    country: "JP",
    name: {
      en : "Aomori"
    }
  },
  AOK : {
    lat: "34.4167",
    lon: "27.15",
    country: "GR",
    name: {
      en : "Karpathos"
    }
  },
  AOO : {
    lat: "40.2972",
    lon: "-78.32",
    country: "US",
    name: {
      en : "Blair Cty"
    }
  },
  AOR : {
    lat: "6.19111",
    lon: "100.404",
    country: "MY",
    name: {
      en : "Sultan Abdul Hamlin"
    }
  },
  AOS : {
    country: "US",
    name: {
      en : "AOS"
    }
  },
  APA : {
    lat: "39.7333",
    lon: "-104.983",
    country: "US",
    city: "DEN",
    name: {
      en : "Centennial"
    }
  },
  APF : {
    lat: "26.1528",
    lon: "-81.7753",
    country: "US",
    name: {
      en : "Naples"
    }
  },
  APK : {
    country: "PF",
    name: {
      en : "APK"
    }
  },
  APL : {
    lat: "-15.1017",
    lon: "39.2872",
    country: "MZ",
    name: {
      en : "Nampula"
    }
  },
  APN : {
    lat: "45.0817",
    lon: "-83.5558",
    country: "US",
    name: {
      en : "Phelps Collins"
    }
  },
  APO : {
    lat: "7.03333",
    lon: "-77.2",
    country: "CO",
    name: {
      en : "Apartado"
    }
  },
  APW : {
    lat: "-13.8333",
    lon: "-172",
    country: "WS",
    popularity: 2,
    name: {
      en : "Apia"
    }
  },
  AQG : {
    lat: "30.5167",
    lon: "117.033",
    country: "CN",
    name: {
      en : "Anqing"
    }
  },
  AQI : {
    lat: "28.3281",
    lon: "46.1306",
    country: "SA",
    name: {
      en : "Qaisumah"
    }
  },
  AQJ : {
    lat: "29.6167",
    lon: "35.0167",
    country: "JO",
    popularity: 1,
    name: {
      en : "Aqaba"
    }
  },
  AQP : {
    lat: "-16.3378",
    lon: "-71.555",
    country: "PE",
    name: {
      en : "Rodriguez Ballon"
    }
  },
  ARB : {
    country: "US",
    name: {
      en : "Ann Arbor Municipal"
    }
  },
  ARC : {
    country: "US",
    name: {
      en : "Arctic Village Arpt"
    }
  },
  ARD : {
    country: "ID",
    name: {
      en : "ARD"
    }
  },
  ARH : {
    lat: "64.6333",
    lon: "40.6",
    country: "RU",
    popularity: 14,
    name: {
      en : "Arkhangelsk"
    }
  },
  ARI : {
    lat: "-18.35",
    lon: "-70.35",
    country: "CL",
    name: {
      en : "Chacalluta"
    }
  },
  ARK : {
    lat: "-3.36667",
    lon: "36.6833",
    country: "TZ",
    name: {
      en : "Arusha"
    }
  },
  ARM : {
    lat: "-30.5283",
    lon: "151.623",
    country: "AU",
    popularity: 2,
    name: {
      en : "Armidale"
    }
  },
  ARN : {
    lat: "59.6619",
    lon: "17.9339",
    country: "SE",
    city: "STO",
    popularity: 86,
    name: {
      en : "Arlanda"
    }
  },
  ART : {
    lat: "43.9908",
    lon: "-76.0214",
    country: "US",
    name: {
      en : "Watertown"
    }
  },
  ARU : {
    lat: "-21.1436",
    lon: "-50.4261",
    country: "BR",
    name: {
      en : "Aracatuba"
    }
  },
  ARV : {
    lat: "45.9242",
    lon: "-89.7322",
    country: "US",
    name: {
      en : "Noble F Lee Memorial Field"
    }
  },
  ARW : {
    lat: "46.1833",
    lon: "21.2667",
    country: "RO",
    name: {
      en : "Arad"
    }
  },
  ASB : {
    lat: "37.9817",
    lon: "58.3608",
    country: "TM",
    popularity: 2,
    name: {
      en : "Ashgabat"
    }
  },
  ASD : {
    lat: "24.6978",
    lon: "-77.7961",
    country: "BS",
    name: {
      en : "Andros Town"
    }
  },
  ASE : {
    lat: "39.2242",
    lon: "-106.869",
    country: "US",
    popularity: 3,
    name: {
      en : "Pitkin Ctyt Sardy Fld"
    }
  },
  ASF : {
    lat: "46.4167",
    lon: "48.0833",
    country: "RU",
    popularity: 5,
    name: {
      en : "Astrakhan"
    }
  },
  ASI : {
    country: "SH",
    name: {
      en : "ASI"
    }
  },
  ASJ : {
    lat: "28.4169",
    lon: "129.697",
    country: "JP",
    name: {
      en : "Amami O Shima"
    }
  },
  ASM : {
    lat: "15.2911",
    lon: "38.9103",
    country: "ER",
    name: {
      en : "Asmara"
    }
  },
  ASO : {
    country: "ET",
    name: {
      en : "ASO"
    }
  },
  ASP : {
    lat: "-23.8033",
    lon: "133.884",
    country: "AU",
    popularity: 3,
    name: {
      en : "Alice Springs"
    }
  },
  ASR : {
    lat: "38.7042",
    lon: "35.5097",
    country: "TR",
    popularity: 1,
    name: {
      en : "Kayseri"
    }
  },
  AST : {
    lat: "46.1597",
    lon: "-123.88",
    country: "US",
    name: {
      en : "Astoria"
    }
  },
  ASU : {
    lat: "-25.2392",
    lon: "-57.5192",
    country: "PY",
    popularity: 3,
    name: {
      en : "Salvio Pettirosse"
    }
  },
  ASV : {
    country: "KE",
    name: {
      en : "ASV"
    }
  },
  ASW : {
    lat: "23.965",
    lon: "32.8217",
    country: "EG",
    name: {
      en : "Daraw"
    }
  },
  ATA : {
    country: "PE",
    name: {
      en : "ATA"
    }
  },
  ATC : {
    lat: "24.6286",
    lon: "-75.6714",
    country: "BS",
    name: {
      en : "Arthurs Town"
    }
  },
  ATD : {
    country: "SB",
    name: {
      en : "ATD"
    }
  },
  ATH : {
    lat: "37.9364",
    lon: "23.9444",
    country: "GR",
    popularity: 75,
    name: {
      en : "Eleftherios Venizelos"
    }
  },
  ATK : {
    country: "US",
    name: {
      en : "ATK"
    }
  },
  ATL : {
    lat: "33.6408",
    lon: "-84.4272",
    country: "US",
    popularity: 22,
    name: {
      en : "Hartsfield Jackson"
    }
  },
  ATM : {
    country: "BR",
    name: {
      en : "Altamira Arpt"
    }
  },
  ATN : {
    country: "PG",
    name: {
      en : "ATN"
    }
  },
  ATQ : {
    lat: "31.7069",
    lon: "74.7972",
    country: "IN",
    name: {
      en : "Raja Sansi"
    }
  },
  ATT : {
    country: "US",
    name: {
      en : "ATT"
    }
  },
  ATW : {
    lat: "44.2589",
    lon: "-88.5211",
    country: "US",
    name: {
      en : "Outagamie Cty"
    }
  },
  ATY : {
    lat: "44.9089",
    lon: "-97.1542",
    country: "US",
    name: {
      en : "Watertown"
    }
  },
  ATZ : {
    country: "EG",
    name: {
      en : "ATZ"
    }
  },
  AUA : {
    lat: "12.5022",
    lon: "-70.0139",
    country: "AW",
    popularity: 2,
    name: {
      en : "Reina Beatrix"
    }
  },
  AUC : {
    country: "CO",
    name: {
      en : "Arauca Arpt"
    }
  },
  AUG : {
    lat: "44.3181",
    lon: "-69.7967",
    country: "US",
    name: {
      en : "Maine State"
    }
  },
  AUH : {
    lat: "24.4333",
    lon: "54.65",
    country: "AE",
    popularity: 12,
    name: {
      en : "Abu Dhabi"
    }
  },
  AUK : {
    country: "US",
    name: {
      en : "AUK"
    }
  },
  AUQ : {
    lat: "-9.76667",
    lon: "-139.017",
    country: "PF",
    name: {
      en : "Atuona"
    }
  },
  AUR : {
    lat: "44.8975",
    lon: "2.41806",
    country: "FR",
    name: {
      en : "Tronquieres"
    }
  },
  AUS : {
    lat: "30.2",
    lon: "-97.6667",
    country: "US",
    name: {
      en : "Bergstrom"
    }
  },
  AUU : {
    country: "AU",
    name: {
      en : "Aurukin Arpt"
    }
  },
  AUX : {
    country: "BR",
    name: {
      en : "Araguaina Arpt"
    }
  },
  AUY : {
    country: "VU",
    name: {
      en : "AUY"
    }
  },
  AVA : {
    country: "CN",
    name: {
      en : "Anshun Huangguoshu"
    }
  },
  AVL : {
    lat: "35.435",
    lon: "-82.5411",
    country: "US",
    name: {
      en : "Asheville"
    }
  },
  AVN : {
    lat: "43.9",
    lon: "4.9",
    country: "FR",
    name: {
      en : "Avignon Caumont"
    }
  },
  AVP : {
    lat: "41.3392",
    lon: "-75.7258",
    country: "US",
    name: {
      en : "Wilkes Barre Scranton"
    }
  },
  AVV : {
    lat: "-38.0944",
    lon: "144.494",
    country: "AU",
    city: "MEL",
    name: {
      en : "Melbourne Avalon"
    }
  },
  AWA : {
    country: "ET",
    name: {
      en : "Awasa"
    }
  },
  AWB : {
    country: "PG",
    name: {
      en : "AWB"
    }
  },
  AWD : {
    country: "VU",
    name: {
      en : "AWD"
    }
  },
  AWZ : {
    country: "IR",
    name: {
      en : "AWZ"
    }
  },
  AXA : {
    lat: "18.2167",
    lon: "-63.0667",
    country: "AI",
    name: {
      en : "Wallblake"
    }
  },
  AXD : {
    lat: "40.8556",
    lon: "25.95",
    country: "GR",
    name: {
      en : "Dhmokritos"
    }
  },
  AXK : {
    country: "YE",
    name: {
      en : "AXK"
    }
  },
  AXM : {
    lat: "4.45",
    lon: "-75.7667",
    country: "CO",
    name: {
      en : "El Eden"
    }
  },
  AXN : {
    lat: "45.8672",
    lon: "-95.3942",
    country: "US",
    name: {
      en : "Alexandria"
    }
  },
  AXP : {
    country: "BS",
    name: {
      en : "AXP"
    }
  },
  AXR : {
    country: "PF",
    name: {
      en : "AXR"
    }
  },
  AXT : {
    lat: "39.6167",
    lon: "140.317",
    country: "JP",
    name: {
      en : "Akita"
    }
  },
  AXU : {
    country: "ET",
    name: {
      en : "AXU"
    }
  },
  AYJ : {
    lat: "26.7494703984173",
    lon: "82.15925168781068",
    country: "IN",
    name: {
      en : "Ayodhya"
    }
  },
  AYP : {
    country: "PE",
    name: {
      en : "Yanamilla Arpt"
    }
  },
  AYQ : {
    lat: "-25.3333",
    lon: "131.05",
    country: "AU",
    name: {
      en : "Connellan"
    }
  },
  AYT : {
    lat: "36.9056",
    lon: "30.7906",
    country: "TR",
    popularity: 75,
    name: {
      en : "Antalya"
    }
  },
  AZA : {
    lat: "33.3078",
    lon: "-111.656",
    country: "US",
    city: "PHX",
    name: {
      en : "Williams Gateway"
    }
  },
  AZD : {
    lat: "31.8978",
    lon: "54.2817",
    country: "IR",
    name: {
      en : "Yazd"
    }
  },
  AZN : {
    country: "UZ",
    name: {
      en : "AZN"
    }
  },
  AZO : {
    lat: "42.2364",
    lon: "-85.5536",
    country: "US",
    name: {
      en : "Kalamazoo Cty"
    }
  },
  AZR : {
    country: "DZ",
    name: {
      en : "AZR"
    }
  },
  AZS : {
    country: "DO",
    name: {
      en : "Samana International Arpt"
    }
  },
  BAG : {
    lat: "16.3767",
    lon: "120.618",
    country: "PH",
    name: {
      en : "Loakan"
    }
  },
  BAH : {
    lat: "26.2708",
    lon: "50.6375",
    country: "BH",
    popularity: 2,
    name: {
      en : "Bahrain"
    }
  },
  BAL : {
    country: "TR",
    name: {
      en : "Batman Arpt"
    }
  },
  BAQ : {
    lat: "10.8961",
    lon: "-74.7789",
    country: "CO",
    name: {
      en : "E Cortissoz"
    }
  },
  BAS : {
    lat: "-6.98333",
    lon: "155.883",
    country: "SB",
    name: {
      en : "Balalae"
    }
  },
  BAU : {
    lat: "-22.3431",
    lon: "-49.0525",
    country: "BR",
    name: {
      en : "Bauru"
    }
  },
  BAV : {
    lat: "40.6667",
    lon: "109.983",
    country: "CN",
    name: {
      en : "Baotou"
    }
  },
  BAX : {
    lat: "53.363775",
    lon: "83.538533",
    country: "RU",
    name: {
      en : "Barnaul"
    }
  },
  BAY : {
    lat: "47.65",
    lon: "23.4667",
    country: "RO",
    name: {
      en : "Baia Mare"
    }
  },
  BAZ : {
    country: "BR",
    name: {
      en : "BAZ"
    }
  },
  BBA : {
    lat: "-45.9167",
    lon: "-71.695",
    country: "CL",
    name: {
      en : "Teniente Vidal"
    }
  },
  BBI : {
    lat: "20.2436",
    lon: "85.82",
    country: "IN",
    name: {
      en : "Bhubaneswar"
    }
  },
  BBK : {
    lat: "-17.8167",
    lon: "25.15",
    country: "BW",
    name: {
      en : "Kasane"
    }
  },
  BBN : {
    country: "MY",
    name: {
      en : "Bario Arpt"
    }
  },
  BBO : {
    country: "SO",
    name: {
      en : "BBO"
    }
  },
  BBQ : {
    country: "AG",
    name: {
      en : "BBQ"
    }
  },
  BBU : {
    lat: "44.5",
    lon: "26.1",
    country: "RO",
    city: "BUH",
    name: {
      en : "Baneasa"
    }
  },
  BCA : {
    country: "CU",
    name: {
      en : "BCA"
    }
  },
  BCD : {
    lat: "10.6444",
    lon: "122.929",
    country: "PH",
    name: {
      en : "Bacolod"
    }
  },
  BCI : {
    lat: "-23.5592",
    lon: "145.302",
    country: "AU",
    name: {
      en : "Barcaldine"
    }
  },
  BCM : {
    lat: "46.5986",
    lon: "26.8819",
    country: "RO",
    name: {
      en : "Bacau"
    }
  },
  BCN : {
    lat: "41.3028",
    lon: "2.09444",
    country: "ES",
    popularity: 238,
    name: {
      en : "Barcelona"
    }
  },
  BCT : {
    lat: "26.35",
    lon: "-80.0833",
    country: "US",
    city: "FLL",
    name: {
      en : "Boca Raton Public"
    }
  },
  BDA : {
    lat: "32.3653",
    lon: "-64.69",
    country: "BM",
    name: {
      en : "Bermuda"
    }
  },
  BDB : {
    lat: "-24.9058",
    lon: "152.321",
    country: "AU",
    name: {
      en : "Bundaberg"
    }
  },
  BDD : {
    lat: "-10.15",
    lon: "142.183",
    country: "AU",
    name: {
      en : "Badu Island"
    }
  },
  BDH : {
    country: "IR",
    name: {
      en : "BDH"
    }
  },
  BDJ : {
    lat: "-3.46667",
    lon: "114.75",
    country: "ID",
    name: {
      en : "Sjamsudin Noor"
    }
  },
  BDK : {
    country: "CI",
    name: {
      en : "BDK"
    }
  },
  BDL : {
    lat: "41.9386",
    lon: "-72.6833",
    country: "US",
    city: "HFD",
    name: {
      en : "Bradley"
    }
  },
  BDO : {
    lat: "-6.90167",
    lon: "107.576",
    country: "ID",
    name: {
      en : "Husein Sastranegara"
    }
  },
  BDP : {
    country: "NP",
    name: {
      en : "BDP"
    }
  },
  BDQ : {
    lat: "22.3292",
    lon: "73.2208",
    country: "IN",
    name: {
      en : "Vadodara"
    }
  },
  BDR : {
    lat: "41.1642",
    lon: "-73.1244",
    country: "US",
    name: {
      en : "Sikorsky Memorial"
    }
  },
  BDS : {
    lat: "40.6581",
    lon: "17.9467",
    country: "IT",
    name: {
      en : "Papola Casale"
    }
  },
  BDT : {
    country: "CD",
    name: {
      en : "BDT"
    }
  },
  BDU : {
    lat: "69.0561",
    lon: "18.54",
    country: "NO",
    name: {
      en : "Bardufoss"
    }
  },
  BEB : {
    lat: "57.4822",
    lon: "-7.36472",
    country: "GB",
    name: {
      en : "Benbecula"
    }
  },
  BED : {
    lat: "42.4708",
    lon: "-71.29",
    country: "US",
    name: {
      en : "Bedford"
    }
  },
  BEG : {
    lat: "44.8192",
    lon: "20.3122",
    country: "RS",
    popularity: 205,
    name: {
      en : "Belgrade Beograd"
    }
  },
  BEJ : {
    country: "ID",
    name: {
      en : "BEJ"
    }
  },
  BEL : {
    lat: "-1.45",
    lon: "-48.4833",
    country: "BR",
    name: {
      en : "Val De Cans"
    }
  },
  BEM : {
    country: "MA",
    name: {
      en : "Beni Mellal"
    }
  },
  BEN : {
    lat: "32.1",
    lon: "20.2667",
    country: "LY",
    name: {
      en : "Benina"
    }
  },
  BER : {
    lat: "52.36",
    lon: "13.5",
    country: "DE",
    popularity: 212,
    name: {
      en : "Berlin Brandenburg"
    }
  },
  BES : {
    lat: "48.4472",
    lon: "-4.42056",
    country: "FR",
    name: {
      en : "Guipavas"
    }
  },
  BET : {
    lat: "60.7844",
    lon: "-161.831",
    country: "US",
    name: {
      en : "Bethel"
    }
  },
  BEU : {
    lat: "-24.23",
    lon: "139.445",
    country: "AU",
    name: {
      en : "Bedourie"
    }
  },
  BEW : {
    lat: "-19.7944",
    lon: "34.9119",
    country: "MZ",
    name: {
      en : "Beira"
    }
  },
  BEY : {
    lat: "33.8128",
    lon: "35.4903",
    country: "LB",
    popularity: 20,
    name: {
      en : "Beirut"
    }
  },
  BFD : {
    lat: "41.8022",
    lon: "-78.6394",
    country: "US",
    name: {
      en : "Bradford Regional"
    }
  },
  BFF : {
    lat: "41.8753",
    lon: "-103.601",
    country: "US",
    name: {
      en : "Scottsbluff"
    }
  },
  BFI : {
    lat: "47.5289",
    lon: "-122.299",
    country: "US",
    city: "SEA",
    name: {
      en : "Seattle Boeing Field"
    }
  },
  BFL : {
    lat: "35.43",
    lon: "-119.052",
    country: "US",
    name: {
      en : "Meadows Field"
    }
  },
  BFM : {
    country: "US",
    city: "MOB",
    name: {
      en : "Brookley Arpt"
    }
  },
  BFN : {
    lat: "-29.1",
    lon: "26.3",
    country: "ZA",
    name: {
      en : "Bloemfontein"
    }
  },
  BFQ : {
    country: "PA",
    name: {
      en : "BFQ"
    }
  },
  BFS : {
    lat: "54.6533",
    lon: "-6.22472",
    country: "GB",
    popularity: 16,
    name: {
      en : "Belfast"
    }
  },
  BFV : {
    lat: "15.2269",
    lon: "103.255",
    country: "TH",
    name: {
      en : "Buri Ram"
    }
  },
  BGA : {
    lat: "7.10722",
    lon: "-73.1281",
    country: "CO",
    name: {
      en : "Palo Negro"
    }
  },
  BGC : {
    country: "PT",
    name: {
      en : "BGC"
    }
  },
  BGF : {
    lat: "4.39611",
    lon: "18.5203",
    country: "CF",
    name: {
      en : "Bangui"
    }
  },
  BGG : {
    country: "TR",
    name: {
      en : "Bingöl Airport"
    }
  },
  BGI : {
    lat: "13.0722",
    lon: "-59.4931",
    country: "BB",
    popularity: 5,
    name: {
      en : "Grantley Adams"
    }
  },
  BGM : {
    lat: "42.2014",
    lon: "-75.9692",
    country: "US",
    name: {
      en : "Edwin A Link Field"
    }
  },
  BGN : {
    country: "RU",
    name: {
      en : "Belaya Gora"
    }
  },
  BGO : {
    lat: "60.2936",
    lon: "5.21944",
    country: "NO",
    name: {
      en : "Flesland"
    }
  },
  BGR : {
    lat: "44.8078",
    lon: "-68.8278",
    country: "US",
    name: {
      en : "Bangor"
    }
  },
  BGW : {
    lat: "33.2556",
    lon: "44.225",
    country: "IQ",
    name: {
      en : "Baghdad International Airport"
    }
  },
  BGY : {
    lat: "45.6683",
    lon: "9.70028",
    country: "IT",
    city: "MIL",
    name: {
      en : "Orio Al Serio"
    }
  },
  BHB : {
    lat: "44.4489",
    lon: "-68.3617",
    country: "US",
    name: {
      en : "Hancock County"
    }
  },
  BHD : {
    lat: "54.6167",
    lon: "-5.88333",
    country: "GB",
    city: "BFS",
    name: {
      en : "Belfast City"
    }
  },
  BHE : {
    lat: "-41.5167",
    lon: "173.872",
    country: "NZ",
    name: {
      en : "Woodbourne"
    }
  },
  BHG : {
    country: "HN",
    name: {
      en : "BHG"
    }
  },
  BHH : {
    country: "SA",
    name: {
      en : "BHH"
    }
  },
  BHI : {
    lat: "-38.7306",
    lon: "-62.1506",
    country: "AR",
    name: {
      en : "Commandante"
    }
  },
  BHJ : {
    lat: "23.2875",
    lon: "69.6706",
    country: "IN",
    name: {
      en : "Rudra Mata"
    }
  },
  BHK : {
    lat: "39.7667",
    lon: "64.4833",
    country: "UZ",
    name: {
      en : "Bukhara"
    }
  },
  BHM : {
    lat: "33.5631",
    lon: "-86.7556",
    country: "US",
    name: {
      en : "Birmingham"
    }
  },
  BHO : {
    lat: "23.2847",
    lon: "77.3386",
    country: "IN",
    name: {
      en : "Bhopal"
    }
  },
  BHQ : {
    lat: "-32.0017",
    lon: "141.467",
    country: "AU",
    name: {
      en : "Broken Hill"
    }
  },
  BHR : {
    country: "NP",
    name: {
      en : "BHR"
    }
  },
  BHS : {
    lat: "-33.4092",
    lon: "149.653",
    country: "AU",
    name: {
      en : "Raglan"
    }
  },
  BHU : {
    country: "IN",
    name: {
      en : "Bhavnagar Arpt"
    }
  },
  BHV : {
    country: "PK",
    name: {
      en : "BHV"
    }
  },
  BHX : {
    lat: "52.4531",
    lon: "-1.74639",
    country: "GB",
    popularity: 7,
    name: {
      en : "Birmingham"
    }
  },
  BHY : {
    lat: "21.4833",
    lon: "109.083",
    country: "CN",
    name: {
      en : "Beihai"
    }
  },
  BIA : {
    lat: "42.5492",
    lon: "9.48611",
    country: "FR",
    name: {
      en : "Poretta"
    }
  },
  BID : {
    lat: "41.1667",
    lon: "-71.5792",
    country: "US",
    name: {
      en : "Block Island"
    }
  },
  BIH : {
    country: "US",
    name: {
      en : "Bishop Airport"
    }
  },
  BII : {
    lat: "12",
    lon: "166",
    country: "MH",
    name: {
      en : "Enyu Airfield"
    }
  },
  BIK : {
    lat: "-1.18667",
    lon: "136.086",
    country: "ID",
    name: {
      en : "Mokmer"
    }
  },
  BIL : {
    lat: "45.8069",
    lon: "-108.543",
    country: "US",
    name: {
      en : "Logan Field"
    }
  },
  BIM : {
    lat: "25.7",
    lon: "-79.2833",
    country: "BS",
    name: {
      en : "Bimini"
    }
  },
  BIO : {
    lat: "43.3028",
    lon: "-2.92167",
    country: "ES",
    popularity: 2,
    name: {
      en : "Bilbao"
    }
  },
  BIQ : {
    lat: "43.4697",
    lon: "-1.52278",
    country: "FR",
    name: {
      en : "Bayonne Anglet"
    }
  },
  BIR : {
    country: "NP",
    name: {
      en : "BIR"
    }
  },
  BIS : {
    lat: "46.7666",
    lon: "-100.75",
    country: "US",
    name: {
      en : "Bismarck"
    }
  },
  BJA : {
    lat: "36.75",
    lon: "5.08333",
    country: "DZ",
    name: {
      en : "Bejaia"
    }
  },
  BJB : {
    country: "IR",
    name: {
      en : "BJB"
    }
  },
  BJF : {
    lat: "70.6",
    lon: "29.6667",
    country: "NO",
    name: {
      en : "Batsfjord"
    }
  },
  BJI : {
    lat: "47.5097",
    lon: "-94.9347",
    country: "US",
    name: {
      en : "Bemidji"
    }
  },
  BJL : {
    lat: "13.35",
    lon: "-16.6667",
    country: "GM",
    name: {
      en : "Yundum"
    }
  },
  BJM : {
    lat: "-3.38333",
    lon: "29.3667",
    country: "BI",
    name: {
      en : "Bujumbura"
    }
  },
  BJR : {
    lat: "11.5903",
    lon: "37.3847",
    country: "ET",
    name: {
      en : "Bahar Dar"
    }
  },
  BJU : {
    country: "NP",
    name: {
      en : "BJU"
    }
  },
  BJV : {
    lat: "37.25",
    lon: "27.6833",
    country: "TR",
    popularity: 2,
    name: {
      en : "Milas-Bodrum"
    }
  },
  BJW : {
    country: "ID",
    name: {
      en : "BJW"
    }
  },
  BJX : {
    lat: "20.995",
    lon: "-102.483",
    country: "MX",
    name: {
      en : "Del Bajio"
    }
  },
  BJZ : {
    lat: "38.8917",
    lon: "-6.82",
    country: "ES",
    name: {
      en : "Talaveral La Real"
    }
  },
  BKA : {
    lat: "55.61966",
    lon: "38.059822",
    country: "RU",
    popularity: 12,
    name: {
      en : "Baykit Airport"
    }
  },
  BKC : {
    country: "US",
    name: {
      en : "BKC"
    }
  },
  BKG : {
    country: "US",
    name: {
      en : "Branson Regional Arpt"
    }
  },
  BKI : {
    lat: "5.94083",
    lon: "116.05",
    country: "MY",
    name: {
      en : "Kota Kinabalu"
    }
  },
  BKK : {
    lat: "13.6897",
    lon: "100.742",
    country: "TH",
    popularity: 111,
    name: {
      en : "Suvarnabhumi"
    }
  },
  BKL : {
    lat: "41.5169",
    lon: "-81.6833",
    country: "US",
    city: "CLE",
    name: {
      en : "Burke Lakefront"
    }
  },
  BKM : {
    country: "MY",
    name: {
      en : "Bakalalan Arpt"
    }
  },
  BKO : {
    lat: "12.6322",
    lon: "-8.02667",
    country: "ML",
    name: {
      en : "Senou"
    }
  },
  BKQ : {
    lat: "-24.4342",
    lon: "145.428",
    country: "AU",
    name: {
      en : "Blackall"
    }
  },
  BKS : {
    lat: "-3.76667",
    lon: "102.3",
    country: "ID",
    name: {
      en : "Padangkemiling"
    }
  },
  BKW : {
    lat: "37.7819",
    lon: "-81.1242",
    country: "US",
    name: {
      en : "Raleigh Cty Memorial"
    }
  },
  BKY : {
    country: "CD",
    name: {
      en : "BKY"
    }
  },
  BLA : {
    lat: "10.1097",
    lon: "-64.6875",
    country: "VE",
    name: {
      en : "Gen J A Anzoategui"
    }
  },
  BLD : {
    country: "US",
    city: "LAS",
    name: {
      en : "BLD"
    }
  },
  BLE : {
    lat: "60.4233",
    lon: "15.5181",
    country: "SE",
    name: {
      en : "Dala"
    }
  },
  BLI : {
    lat: "48.7944",
    lon: "-122.535",
    country: "US",
    name: {
      en : "Bellingham"
    }
  },
  BLJ : {
    country: "DZ",
    name: {
      en : "Batna Arpt"
    }
  },
  BLK : {
    lat: "53.7719",
    lon: "-3.03611",
    country: "GB",
    name: {
      en : "Blackpool"
    }
  },
  BLL : {
    lat: "55.7383",
    lon: "9.15",
    country: "DK",
    name: {
      en : "Billund"
    }
  },
  BLQ : {
    lat: "44.5306",
    lon: "11.2925",
    country: "IT",
    popularity: 20,
    name: {
      en : "Guglielmo Marconi"
    }
  },
  BLR : {
    lat: "13.1979",
    lon: "77.7063",
    country: "IN",
    popularity: 2,
    name: {
      en : "Bengaluru"
    }
  },
  BLT : {
    lat: "-23.5833",
    lon: "148.883",
    country: "AU",
    name: {
      en : "Blackwater"
    }
  },
  BLZ : {
    lat: "-15.6747",
    lon: "34.9708",
    country: "MW",
    name: {
      en : "Chileka"
    }
  },
  BMA : {
    lat: "59.3528",
    lon: "17.9464",
    country: "SE",
    city: "STO",
    name: {
      en : "Bromma"
    }
  },
  BMD : {
    country: "MG",
    name: {
      en : "BMD"
    }
  },
  BME : {
    lat: "-17.95",
    lon: "122.23",
    country: "AU",
    name: {
      en : "Broome"
    }
  },
  BMI : {
    lat: "40.4819",
    lon: "-88.9275",
    country: "US",
    name: {
      en : "Normal"
    }
  },
  BMO : {
    country: "MM",
    name: {
      en : "BMO"
    }
  },
  BMU : {
    country: "ID",
    name: {
      en : "Bima Airport"
    }
  },
  BMV : {
    lat: "12.6667",
    lon: "108.05",
    country: "VN",
    name: {
      en : "Phung Duc"
    }
  },
  BMW : {
    country: "DZ",
    name: {
      en : "BMW"
    }
  },
  BMY : {
    country: "NC",
    name: {
      en : "BMY"
    }
  },
  BNA : {
    lat: "36.1267",
    lon: "-86.6819",
    country: "US",
    name: {
      en : "Nashville"
    }
  },
  BNC : {
    country: "CD",
    name: {
      en : "BNC"
    }
  },
  BND : {
    country: "IR",
    name: {
      en : "BND"
    }
  },
  BNE : {
    lat: "-27.425",
    lon: "153.086",
    country: "AU",
    popularity: 6,
    name: {
      en : "Brisbane"
    }
  },
  BNI : {
    country: "NG",
    name: {
      en : "BNI"
    }
  },
  BNK : {
    lat: "-28.8333",
    lon: "153.55",
    country: "AU",
    name: {
      en : "Ballina"
    }
  },
  BNN : {
    lat: "65.4603",
    lon: "12.2069",
    country: "NO",
    name: {
      en : "Bronnoy"
    }
  },
  BNS : {
    country: "VE",
    name: {
      en : "BNS"
    }
  },
  BNX : {
    lat: "44.9333",
    lon: "17.3",
    country: "BA",
    name: {
      en : "Banja Luka"
    }
  },
  BNY : {
    country: "SB",
    name: {
      en : "BNY"
    }
  },
  BOA : {
    country: "CD",
    name: {
      en : "BOA"
    }
  },
  BOB : {
    lat: "-16.4431",
    lon: "-151.748",
    country: "PF",
    popularity: 2,
    name: {
      en : "Motu Mute"
    }
  },
  BOC : {
    lat: "9.34",
    lon: "-82.2519",
    country: "PA",
    name: {
      en : "Bocas Del Toro"
    }
  },
  BOD : {
    lat: "44.8294",
    lon: "-0.714444",
    country: "FR",
    popularity: 5,
    name: {
      en : "Bordeaux"
    }
  },
  BOG : {
    lat: "4.7",
    lon: "-74.15",
    country: "CO",
    popularity: 2,
    name: {
      en : "Eldorado"
    }
  },
  BOH : {
    lat: "50.7806",
    lon: "-1.83694",
    country: "GB",
    name: {
      en : "Bournemouth"
    }
  },
  BOI : {
    lat: "43.5653",
    lon: "-116.225",
    country: "US",
    name: {
      en : "Boise Gowen Field"
    }
  },
  BOJ : {
    lat: "42.4167",
    lon: "27.2833",
    country: "BG",
    popularity: 4,
    name: {
      en : "Bourgas"
    }
  },
  BOM : {
    lat: "19.0881",
    lon: "72.8517",
    country: "IN",
    popularity: 51,
    name: {
      en : "Chhatrapati Shivaji"
    }
  },
  BON : {
    lat: "12.1342",
    lon: "-68.2733",
    country: "AN",
    name: {
      en : "Flamingo Field"
    }
  },
  BOO : {
    lat: "67.2692",
    lon: "14.3722",
    country: "NO",
    name: {
      en : "Bodo"
    }
  },
  BOS : {
    lat: "42.365",
    lon: "-71.0053",
    country: "US",
    popularity: 24,
    name: {
      en : "Logan"
    }
  },
  BOY : {
    lat: "11.1636",
    lon: "-4.32444",
    country: "BF",
    name: {
      en : "Borgo"
    }
  },
  BPE : {
    country: "CN",
    name: {
      en : "Qinhuangdao Beidaihe"
    }
  },
  BPF : {
    country: "SB",
    name: {
      en : "BPF"
    }
  },
  BPL : {
    country: "CN",
    name: {
      en : "BPL"
    }
  },
  BPM : {
    country: "IN",
    city: "HYD",
    name: {
      en : "Begumpet Airport"
    }
  },
  BPN : {
    lat: "-1.28333",
    lon: "116.833",
    country: "ID",
    popularity: 56,
    name: {
      en : "Sepingan"
    }
  },
  BPS : {
    lat: "-16.5333",
    lon: "-39.0833",
    country: "BR",
    name: {
      en : "Porto Seguro"
    }
  },
  BPT : {
    lat: "29.9508",
    lon: "-94.02",
    country: "US",
    name: {
      en : "Jefferson Cty"
    }
  },
  BPX : {
    country: "CN",
    name: {
      en : "BPX"
    }
  },
  BQG : {
    country: "RU",
    name: {
      en : "Bogorodskoye"
    }
  },
  BQJ : {
    lat: "67.648889",
    lon: "134.695",
    country: "RU",
    popularity: 4000,
    name: {
      en : "Batagay"
    }
  },
  BQK : {
    lat: "31.1667",
    lon: "-81.4833",
    country: "US",
    city: "SSI",
    name: {
      en : "Gylnco Jet Port"
    }
  },
  BQL : {
    lat: "-22.9",
    lon: "139.9",
    country: "AU",
    name: {
      en : "Boulia"
    }
  },
  BQN : {
    lat: "18.4958",
    lon: "-67.13",
    country: "US",
    name: {
      en : "Borinquen"
    }
  },
  BQS : {
    lat: "50.4167",
    lon: "127.4",
    country: "RU",
    name: {
      en : "Blagoveshchensk"
    }
  },
  BQT : {
    country: "BY",
    name: {
      en : "Brest Arpt"
    }
  },
  BRA : {
    country: "BR",
    name: {
      en : "Barreiras Arpt"
    }
  },
  BRC : {
    lat: "-41.1497",
    lon: "-71.1583",
    country: "AR",
    name: {
      en : "San Carlos De Bariloche"
    }
  },
  BRD : {
    lat: "46.3972",
    lon: "-94.1375",
    country: "US",
    name: {
      en : "Crowwing Cty"
    }
  },
  BRE : {
    lat: "53.0467",
    lon: "8.79",
    country: "DE",
    name: {
      en : "Bremen"
    }
  },
  BRI : {
    lat: "41.1411",
    lon: "16.7883",
    country: "IT",
    popularity: 8,
    name: {
      en : "Bari"
    }
  },
  BRL : {
    lat: "40.7861",
    lon: "-91.1233",
    country: "US",
    name: {
      en : "Burlington"
    }
  },
  BRM : {
    lat: "10.0453",
    lon: "-69.3561",
    country: "VE",
    name: {
      en : "Airport Barquisimeto"
    }
  },
  BRN : {
    lat: "46.9153",
    lon: "7.49917",
    country: "CH",
    popularity: 3,
    name: {
      en : "Belp"
    }
  },
  BRO : {
    lat: "25.9089",
    lon: "-97.4233",
    country: "US",
    name: {
      en : "South Padre Island"
    }
  },
  BRQ : {
    lat: "49.15",
    lon: "16.7",
    country: "CZ",
    name: {
      en : "Turnay"
    }
  },
  BRR : {
    lat: "57.0233",
    lon: "-7.44028",
    country: "GB",
    name: {
      en : "North Bay"
    }
  },
  BRS : {
    lat: "51.3817",
    lon: "-2.70889",
    country: "GB",
    name: {
      en : "Bristol"
    }
  },
  BRT : {
    country: "AU",
    name: {
      en : "Bathurst Island Arpt"
    }
  },
  BRU : {
    lat: "50.9017",
    lon: "4.49417",
    country: "BE",
    popularity: 141,
    name: {
      en : "Brussels National"
    }
  },
  BRW : {
    lat: "71.2833",
    lon: "-156.769",
    country: "US",
    name: {
      en : "Barrow WBAS"
    }
  },
  BSA : {
    country: "SO",
    name: {
      en : "BSA"
    }
  },
  BSB : {
    lat: "-15.8606",
    lon: "-47.9153",
    country: "BR",
    popularity: 1,
    name: {
      en : "Brasilia"
    }
  },
  BSC : {
    country: "CO",
    name: {
      en : "Aeropuerto Jose Celestino Mutis"
    }
  },
  BSD : {
    lat: "25.15",
    lon: "99.15",
    country: "CN",
    name: {
      en : "Baoshan"
    }
  },
  BSG : {
    country: "GQ",
    name: {
      en : "BSG"
    }
  },
  BSK : {
    lat: "34.7933",
    lon: "5.73806",
    country: "DZ",
    name: {
      en : "Biskra"
    }
  },
  BSL : {
    lat: "47.6556",
    lon: "7.65278",
    country: "CH",
    city: "EAP",
    popularity: 1,
    name: {
      en : "Basel EuroAirport Swiss"
    }
  },
  BSO : {
    country: "PH",
    name: {
      en : "BSO"
    }
  },
  BSR : {
    lat: "30.5556",
    lon: "47.7914",
    country: "IQ",
    name: {
      en : "Basra"
    }
  },
  BST : {
    country: "AF",
    name: {
      en : "BST"
    }
  },
  BSX : {
    country: "MM",
    name: {
      en : "BSX"
    }
  },
  BSZ : {
    lat: "42.8333",
    lon: "74.5667",
    country: "KG",
    city: "FRU",
    popularity: 10,
    name: {
      en : "Bishkek"
    }
  },
  BTH : {
    lat: "1.06667",
    lon: "104.133",
    country: "ID",
    name: {
      en : "Hang Nadim"
    }
  },
  BTI : {
    country: "US",
    name: {
      en : "BTI"
    }
  },
  BTJ : {
    lat: "5.52",
    lon: "95.4194",
    country: "ID",
    name: {
      en : "Blang Bintang"
    }
  },
  BTK : {
    lat: "56.3667",
    lon: "101.817",
    country: "RU",
    popularity: 4,
    name: {
      en : "Bratsk"
    }
  },
  BTM : {
    lat: "45.9511",
    lon: "-112.494",
    country: "US",
    name: {
      en : "Bert Mooney"
    }
  },
  BTR : {
    lat: "30.5317",
    lon: "-91.1506",
    country: "US",
    name: {
      en : "Ryan"
    }
  },
  BTS : {
    lat: "48.1667",
    lon: "17.2167",
    country: "SK",
    popularity: 11,
    name: {
      en : "Ivanka"
    }
  },
  BTT : {
    country: "US",
    name: {
      en : "BTT"
    }
  },
  BTU : {
    lat: "3.175",
    lon: "113.043",
    country: "MY",
    name: {
      en : "Bintulu"
    }
  },
  BTV : {
    lat: "44.4728",
    lon: "-73.153",
    country: "US",
    name: {
      en : "Burlington"
    }
  },
  BUA : {
    country: "PG",
    name: {
      en : "BUA"
    }
  },
  BUC : {
    lat: "-17.75",
    lon: "139.533",
    country: "AU",
    name: {
      en : "Burketown"
    }
  },
  BUD : {
    lat: "47.4333",
    lon: "19.2333",
    country: "HU",
    popularity: 135,
    name: {
      en : "Ferihegy"
    }
  },
  BUF : {
    lat: "42.9411",
    lon: "-78.7364",
    country: "US",
    name: {
      en : "Greater Buffalo"
    }
  },
  BUL : {
    country: "PG",
    name: {
      en : "BUL"
    }
  },
  BUN : {
    country: "CO",
    name: {
      en : "Buenaventura Arpt"
    }
  },
  BUQ : {
    lat: "-20.0164",
    lon: "28.6186",
    country: "ZW",
    name: {
      en : "Bulawayo"
    }
  },
  BUR : {
    lat: "34.2",
    lon: "-118.358",
    country: "US",
    name: {
      en : "Burbank Glendale Pasadena"
    }
  },
  BUS : {
    lat: "41.6108",
    lon: "41.6006",
    country: "GE",
    popularity: 2,
    name: {
      en : "Batumi"
    }
  },
  BUW : {
    country: "ID",
    name: {
      en : "BUW"
    }
  },
  BUX : {
    country: "CD",
    name: {
      en : "BUX"
    }
  },
  BUZ : {
    lat: "28.9492",
    lon: "50.8325",
    country: "IR",
    name: {
      en : "Bushehr"
    }
  },
  BVA : {
    lat: "49.4558",
    lon: "2.1125",
    country: "FR",
    city: "PAR",
    name: {
      en : "Beauvais Tille"
    }
  },
  BVB : {
    lat: "2.83333",
    lon: "-60.6667",
    country: "BR",
    name: {
      en : "Boa Vista"
    }
  },
  BVC : {
    lat: "16.0833",
    lon: "-22.8333",
    country: "CV",
    name: {
      en : "Rabil"
    }
  },
  BVE : {
    lat: "45.1667",
    lon: "1.53333",
    country: "FR",
    name: {
      en : "Laroche"
    }
  },
  BVG : {
    country: "NO",
    name: {
      en : "BVG"
    }
  },
  BVH : {
    country: "BR",
    name: {
      en : "Vilhena Arpt"
    }
  },
  BVI : {
    lat: "-25.8983",
    lon: "139.343",
    country: "AU",
    name: {
      en : "Birdsville"
    }
  },
  BVJ : {
    country: "RU",
    popularity: 160,
    name: {
      en : "Bovanenkovo"
    }
  },
  BVV : {
    country: "RU",
    name: {
      en : "BVV"
    }
  },
  BWA : {
    country: "NP",
    name: {
      en : "BWA"
    }
  },
  BWE : {
    lat: "52.2667",
    lon: "10.5333",
    country: "DE",
    name: {
      en : "Braunschweig"
    }
  },
  BWG : {
    country: "US",
    name: {
      en : "Warren Cty Arpt"
    }
  },
  BWI : {
    lat: "39.1756",
    lon: "-76.6714",
    country: "US",
    popularity: 16,
    name: {
      en : "Baltimore Washington"
    }
  },
  BWK : {
    country: "HR",
    name: {
      en : "BWK"
    }
  },
  BWN : {
    lat: "4.925",
    lon: "114.928",
    country: "BN",
    name: {
      en : "Brunei"
    }
  },
  BWT : {
    lat: "-40.9958",
    lon: "145.728",
    country: "AU",
    name: {
      en : "Burnie Wynyard"
    }
  },
  BWW : {
    country: "CU",
    name: {
      en : "BWW"
    }
  },
  BWX : {
    country: "ID",
    name: {
      en : "Banyuwangi"
    }
  },
  BXJ : {
    country: "KZ",
    name: {
      en : "BXJ"
    }
  },
  BXR : {
    country: "IR",
    name: {
      en : "BXR"
    }
  },
  BXU : {
    lat: "8.95139",
    lon: "125.484",
    country: "PH",
    name: {
      en : "Butuan"
    }
  },
  BXY : {
    country: "KZ",
    popularity: 189,
    name: {
      en : "Baikonur Krayniy Airport"
    }
  },
  BYC : {
    country: "BO",
    name: {
      en : "BYC"
    }
  },
  BYM : {
    country: "CU",
    name: {
      en : "BYM"
    }
  },
  BYN : {
    country: "MN",
    name: {
      en : "BYN"
    }
  },
  BYO : {
    country: "BR",
    name: {
      en : "BYO"
    }
  },
  BZE : {
    lat: "17.5361",
    lon: "-88.31",
    country: "BZ",
    name: {
      en : "Belize"
    }
  },
  BZG : {
    lat: "53.0967",
    lon: "17.9786",
    country: "PL",
    name: {
      en : "Bydgoszcz"
    }
  },
  BZK : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Bryansk Airport"
    }
  },
  BZL : {
    country: "BD",
    name: {
      en : "Barisal"
    }
  },
  BZN : {
    lat: "45.7803",
    lon: "-111.159",
    country: "US",
    name: {
      en : "Gallatin Field"
    }
  },
  BZO : {
    lat: "46.5167",
    lon: "11.3667",
    country: "IT",
    name: {
      en : "Bolzano"
    }
  },
  BZR : {
    lat: "43.3242",
    lon: "3.35444",
    country: "FR",
    name: {
      en : "Beziers Vias"
    }
  },
  BZV : {
    lat: "-4.25194",
    lon: "15.2547",
    country: "CG",
    name: {
      en : "Maya Maya"
    }
  },
  BZZ : {
    lat: "51.75",
    lon: "-1.58709",
    country: "GB",
    name: {
      en : "Brize Norton Raf Station"
    }
  },
  CAB : {
    country: "AO",
    name: {
      en : "CAB"
    }
  },
  CAC : {
    country: "BR",
    name: {
      en : "Cascavel Arpt"
    }
  },
  CAE : {
    lat: "33.9364",
    lon: "-81.1158",
    country: "US",
    name: {
      en : "Columbia Metro"
    }
  },
  CAG : {
    lat: "39.2472",
    lon: "9.06111",
    country: "IT",
    popularity: 10,
    name: {
      en : "Elmas"
    }
  },
  CAH : {
    country: "VN",
    name: {
      en : "CAH"
    }
  },
  CAI : {
    lat: "30.1375",
    lon: "31.4069",
    country: "EG",
    popularity: 81,
    name: {
      en : "Cairo"
    }
  },
  CAK : {
    lat: "40.9139",
    lon: "-81.4417",
    country: "US",
    name: {
      en : "Akron Canton Regional"
    }
  },
  CAL : {
    lat: "55.4364",
    lon: "-5.68667",
    country: "GB",
    name: {
      en : "Machrihanish"
    }
  },
  CAN : {
    lat: "23.3925",
    lon: "113.299",
    country: "CN",
    name: {
      en : "Baiyun"
    }
  },
  CAP : {
    lat: "19.7328",
    lon: "-72.195",
    country: "HT",
    name: {
      en : "Cap Haitien"
    }
  },
  CAS : {
    country: "MA",
    name: {
      en : "Anfa Airport"
    }
  },
  CAY : {
    lat: "4.81667",
    lon: "-52.3667",
    country: "GF",
    name: {
      en : "Rochambeau"
    }
  },
  CAZ : {
    country: "AU",
    name: {
      en : "Cobar Arpt"
    }
  },
  CBB : {
    lat: "-17.4283",
    lon: "-66.1717",
    country: "BO",
    name: {
      en : "J Wilsterman"
    }
  },
  CBG : {
    country: "GB",
    name: {
      en : "Cambridge Arpt"
    }
  },
  CBH : {
    country: "DZ",
    name: {
      en : "CBH"
    }
  },
  CBO : {
    lat: "7.2",
    lon: "124.167",
    country: "PH",
    name: {
      en : "Awang"
    }
  },
  CBQ : {
    country: "NG",
    name: {
      en : "CALABAR ARPT"
    }
  },
  CBR : {
    lat: "-35.3089",
    lon: "149.195",
    country: "AU",
    popularity: 83,
    name: {
      en : "Canberra"
    }
  },
  CBT : {
    country: "AO",
    name: {
      en : "CBT"
    }
  },
  CCC : {
    lat: "22.5125",
    lon: "-78.5083",
    country: "CU",
    name: {
      en : "Cayo Coco (Jardines del Rey)"
    }
  },
  CCF : {
    lat: "43.2167",
    lon: "2.31667",
    country: "FR",
    name: {
      en : "Salvaza"
    }
  },
  CCJ : {
    lat: "11.1333",
    lon: "75.95",
    country: "IN",
    name: {
      en : "Kozhikode"
    }
  },
  CCK : {
    lat: "-12.1667",
    lon: "96.9167",
    country: "CC",
    name: {
      en : "Cocos Islands"
    }
  },
  CCM : {
    country: "BR",
    name: {
      en : "Criciuma Arpt"
    }
  },
  CCN : {
    country: "AF",
    name: {
      en : "CCN"
    }
  },
  CCP : {
    lat: "-36.7683",
    lon: "-73.06",
    country: "CL",
    name: {
      en : "Carriel Sur"
    }
  },
  CCS : {
    lat: "10.6064",
    lon: "-66.9892",
    country: "VE",
    popularity: 5,
    name: {
      en : "Simon Bolivar"
    }
  },
  CCU : {
    lat: "22.6525",
    lon: "88.4492",
    country: "IN",
    name: {
      en : "Netaji Subhas Chandra Bose"
    }
  },
  CCV : {
    country: "VU",
    name: {
      en : "Craig Cove Arpt"
    }
  },
  CCZ : {
    country: "BS",
    name: {
      en : "CCZ"
    }
  },
  CDB : {
    country: "US",
    name: {
      en : "CDB"
    }
  },
  CDC : {
    lat: "37.7025",
    lon: "-113.096",
    country: "US",
    name: {
      en : "Cedar City"
    }
  },
  CDG : {
    lat: "49.0097",
    lon: "2.54861",
    country: "FR",
    city: "PAR",
    popularity: 182,
    name: {
      en : "Charles De Gaulle"
    }
  },
  CDR : {
    lat: "42.835",
    lon: "-103.098",
    country: "US",
    name: {
      en : "Chadron"
    }
  },
  CDT : {
    country: "ES",
    name: {
      en : "Castellón"
    }
  },
  CDV : {
    lat: "60.4931",
    lon: "-145.47",
    country: "US",
    name: {
      en : "Mudhole Smith"
    }
  },
  CDW : {
    country: "US",
    name: {
      en : "Caldwell Wright Arpt"
    }
  },
  CEB : {
    lat: "10.3317",
    lon: "123.907",
    country: "PH",
    name: {
      en : "Cebu"
    }
  },
  CEC : {
    lat: "41.78",
    lon: "-124.236",
    country: "US",
    name: {
      en : "Crescent City"
    }
  },
  CED : {
    lat: "-32.1317",
    lon: "133.706",
    country: "AU",
    name: {
      en : "Ceduna"
    }
  },
  CEE : {
    lat: "59.27",
    lon: "38.02",
    country: "RU",
    name: {
      en : "Cherepovets"
    }
  },
  CEG : {
    lat: "53.1667",
    lon: "-2.91667",
    country: "GB",
    name: {
      en : "Chester"
    }
  },
  CEI : {
    lat: "19.8864",
    lon: "99.8306",
    country: "TH",
    name: {
      en : "Chaing Rai"
    }
  },
  CEK : {
    lat: "55.3",
    lon: "61.5",
    country: "RU",
    popularity: 26,
    name: {
      en : "Chelyabinsk"
    }
  },
  CEM : {
    country: "US",
    name: {
      en : "CEM"
    }
  },
  CEN : {
    lat: "27.3919",
    lon: "-109.839",
    country: "MX",
    name: {
      en : "Ciudad Obregon"
    }
  },
  CER : {
    lat: "49.6511",
    lon: "-1.46528",
    country: "FR",
    name: {
      en : "Maupertius"
    }
  },
  CEZ : {
    lat: "37.3028",
    lon: "-108.627",
    country: "US",
    name: {
      en : "Montezuma County"
    }
  },
  CFB : {
    lat: "-22.925",
    lon: "-42.0786",
    country: "BR",
    name: {
      en : "Cabo Frio"
    }
  },
  CFC : {
    country: "BR",
    name: {
      en : "CFC"
    }
  },
  CFE : {
    lat: "45.7858",
    lon: "3.1675",
    country: "FR",
    name: {
      en : "Aulnat"
    }
  },
  CFG : {
    lat: "22.15",
    lon: "-80.4142",
    country: "CU",
    popularity: 2,
    name: {
      en : "Cienfuegos"
    }
  },
  CFK : {
    country: "DZ",
    name: {
      en : "Chlef Arpt"
    }
  },
  CFN : {
    lat: "55.0417",
    lon: "-8.34028",
    country: "IE",
    name: {
      en : "Donegal"
    }
  },
  CFR : {
    lat: "49.1733",
    lon: "-0.448056",
    country: "FR",
    name: {
      en : "Carpiquet"
    }
  },
  CFS : {
    lat: "-30.3217",
    lon: "153.121",
    country: "AU",
    name: {
      en : "Coffs Harbour"
    }
  },
  CFU : {
    lat: "39.6014",
    lon: "19.9103",
    country: "GR",
    popularity: 2,
    name: {
      en : "I Kapodistrias"
    }
  },
  CGA : {
    lat: "55.4792",
    lon: "-133.146",
    country: "US",
    name: {
      en : "Craig Seaplane Base"
    }
  },
  CGB : {
    lat: "-15.65",
    lon: "-56.1167",
    country: "BR",
    name: {
      en : "Marechal Rondon"
    }
  },
  CGD : {
    lat: "29.0667",
    lon: "111.583",
    country: "CN",
    name: {
      en : "Changde"
    }
  },
  CGH : {
    lat: "-23.625",
    lon: "-46.66",
    country: "BR",
    city: "SAO",
    name: {
      en : "Congonhas"
    }
  },
  CGI : {
    lat: "37.2236",
    lon: "-89.5717",
    country: "US",
    name: {
      en : "Cape Girardeau"
    }
  },
  CGK : {
    lat: "-6.11667",
    lon: "106.65",
    country: "ID",
    city: "JKT",
    popularity: 2,
    name: {
      en : "Soekarno Hatta"
    }
  },
  CGM : {
    country: "PH",
    name: {
      en : "Camiguin"
    }
  },
  CGN : {
    lat: "50.8658",
    lon: "7.14194",
    country: "DE",
    popularity: 21,
    name: {
      en : "Koeln Bonn"
    }
  },
  CGO : {
    lat: "34.8",
    lon: "113.65",
    country: "CN",
    name: {
      en : "Zhengzhou"
    }
  },
  CGP : {
    lat: "22.2575",
    lon: "91.8256",
    country: "BD",
    popularity: 1,
    name: {
      en : "Patenga"
    }
  },
  CGQ : {
    lat: "43.8833",
    lon: "125.317",
    country: "CN",
    name: {
      en : "Changchun"
    }
  },
  CGR : {
    lat: "-20.4633",
    lon: "-54.6725",
    country: "BR",
    name: {
      en : "Internacional"
    }
  },
  CGY : {
    lat: "8.41611",
    lon: "124.611",
    country: "PH",
    name: {
      en : "Lumbia"
    }
  },
  CHA : {
    lat: "35.0364",
    lon: "-85.2036",
    country: "US",
    name: {
      en : "Chattanooga Lovell Fld"
    }
  },
  CHC : {
    lat: "-43.4883",
    lon: "172.533",
    country: "NZ",
    popularity: 1,
    name: {
      en : "Christchurch"
    }
  },
  CHG : {
    country: "CN",
    name: {
      en : "CHG"
    }
  },
  CHM : {
    country: "PE",
    name: {
      en : "CHM"
    }
  },
  CHO : {
    lat: "38.1414",
    lon: "-78.4531",
    country: "US",
    name: {
      en : "Charlottesville Albemarle"
    }
  },
  CHQ : {
    lat: "35.5325",
    lon: "24.1483",
    country: "GR",
    popularity: 2,
    name: {
      en : "Souda"
    }
  },
  CHS : {
    lat: "32.8992",
    lon: "-80.0389",
    country: "US",
    name: {
      en : "Charleston"
    }
  },
  CHT : {
    country: "NZ",
    name: {
      en : "CHT"
    }
  },
  CHU : {
    country: "US",
    name: {
      en : "Chuathbaluk Arpt"
    }
  },
  CHX : {
    country: "PA",
    name: {
      en : "Changuinola Arpt"
    }
  },
  CHY : {
    country: "SB",
    name: {
      en : "CHY"
    }
  },
  CIA : {
    lat: "41.7994",
    lon: "12.5933",
    country: "IT",
    city: "ROM",
    name: {
      en : "Ciampino"
    }
  },
  CIC : {
    lat: "39.7958",
    lon: "-121.857",
    country: "US",
    name: {
      en : "Chico"
    }
  },
  CID : {
    lat: "41.8844",
    lon: "-91.7061",
    country: "US",
    name: {
      en : "Cedar Rapids"
    }
  },
  CIF : {
    country: "CN",
    name: {
      en : "CIF"
    }
  },
  CIH : {
    country: "CN",
    name: {
      en : "CIH"
    }
  },
  CIJ : {
    country: "BO",
    name: {
      en : "CIJ"
    }
  },
  CIK : {
    country: "US",
    name: {
      en : "CIK"
    }
  },
  CIP : {
    country: "ZM",
    name: {
      en : "CIP"
    }
  },
  CIT : {
    lat: "42.3",
    lon: "69.6",
    country: "KZ",
    name: {
      en : "Shymkent"
    }
  },
  CIU : {
    lat: "46.5",
    lon: "-84.35",
    country: "US",
    city: "SSM",
    name: {
      en : "Chippewa Cnty"
    }
  },
  CIW : {
    country: "VC",
    name: {
      en : "Canouan Island Minicipal"
    }
  },
  CIX : {
    lat: "-6.78972",
    lon: "-79.8322",
    country: "PE",
    popularity: 5,
    name: {
      en : "Cornel Ruiz"
    }
  },
  CIZ : {
    country: "BR",
    name: {
      en : "CIZ"
    }
  },
  CJA : {
    country: "PE",
    name: {
      en : "CJA"
    }
  },
  CJB : {
    lat: "11.0283",
    lon: "77.0433",
    country: "IN",
    name: {
      en : "Peelamedu"
    }
  },
  CJC : {
    lat: "-22.4872",
    lon: "-68.9167",
    country: "CL",
    name: {
      en : "El Loa"
    }
  },
  CJJ : {
    lat: "36.7167",
    lon: "127.507",
    country: "KR",
    name: {
      en : "Cheongju"
    }
  },
  CJL : {
    country: "PK",
    name: {
      en : "CJL"
    }
  },
  CJS : {
    lat: "31.6372",
    lon: "-106.429",
    country: "MX",
    name: {
      en : "Intl Abraham Gonzalez"
    }
  },
  CJU : {
    lat: "33.5056",
    lon: "126.495",
    country: "KR",
    name: {
      en : "Jeju"
    }
  },
  CKB : {
    lat: "39.2956",
    lon: "-80.2295",
    country: "US",
    name: {
      en : "Clarksburg Benedum"
    }
  },
  CKD : {
    country: "US",
    name: {
      en : "Crooked Creek Arpt"
    }
  },
  CKG : {
    lat: "29.5",
    lon: "106.35",
    country: "CN",
    name: {
      en : "Chongqing"
    }
  },
  CKH : {
    country: "RU",
    name: {
      en : "CKH"
    }
  },
  CKS : {
    country: "BR",
    name: {
      en : "Carajas Arpt"
    }
  },
  CKX : {
    country: "US",
    name: {
      en : "CKX"
    }
  },
  CKY : {
    lat: "9.57639",
    lon: "-13.6108",
    country: "GN",
    name: {
      en : "Conakry"
    }
  },
  CKZ : {
    lat: "0",
    lon: "0",
    country: "TR",
    name: {
      en : "Canakkale Arpt"
    }
  },
  CLA : {
    country: "BD",
    name: {
      en : "CLA"
    }
  },
  CLD : {
    lat: "33.1167",
    lon: "-117.267",
    country: "US",
    city: "SAN",
    name: {
      en : "Carlsbad"
    }
  },
  CLE : {
    lat: "41.4119",
    lon: "-81.8481",
    country: "US",
    popularity: 16,
    name: {
      en : "Hopkins"
    }
  },
  CLJ : {
    lat: "46.7833",
    lon: "23.6833",
    country: "RO",
    popularity: 231,
    name: {
      en : "Napoca"
    }
  },
  CLL : {
    lat: "30.5894",
    lon: "-96.3644",
    country: "US",
    name: {
      en : "Easterwood Field"
    }
  },
  CLM : {
    lat: "48.1189",
    lon: "-123.494",
    country: "US",
    name: {
      en : "William Fairchild"
    }
  },
  CLO : {
    lat: "3.54611",
    lon: "-76.385",
    country: "CO",
    name: {
      en : "Alfonso Bonella Aragon"
    }
  },
  CLP : {
    country: "US",
    name: {
      en : "CLP"
    }
  },
  CLQ : {
    lat: "19.3",
    lon: "-103.65",
    country: "MX",
    name: {
      en : "Colima"
    }
  },
  CLT : {
    lat: "35.2192",
    lon: "-80.9358",
    country: "US",
    popularity: 16,
    name: {
      en : "Charlotte Douglas"
    }
  },
  CLV : {
    country: "BR",
    name: {
      en : "Caldas Novas"
    }
  },
  CLY : {
    lat: "42.5278",
    lon: "8.79167",
    country: "FR",
    name: {
      en : "Ste Catherine"
    }
  },
  CMA : {
    lat: "-28.0314",
    lon: "145.616",
    country: "AU",
    name: {
      en : "Cunnamulla"
    }
  },
  CMB : {
    lat: "7.175",
    lon: "79.8847",
    country: "LK",
    popularity: 17,
    name: {
      en : "Bandaranaike"
    }
  },
  CME : {
    lat: "18.65",
    lon: "-91.8",
    country: "MX",
    name: {
      en : "Ciudad Del Carmen"
    }
  },
  CMF : {
    lat: "43.55",
    lon: "6.95",
    country: "FR",
    name: {
      en : "Chambery Aix Les Bains"
    }
  },
  CMG : {
    country: "BR",
    name: {
      en : "Internacional Corumba"
    }
  },
  CMH : {
    lat: "39.9911",
    lon: "-82.8783",
    country: "US",
    name: {
      en : "Port Columbus"
    }
  },
  CMI : {
    lat: "40.0397",
    lon: "-88.2797",
    country: "US",
    popularity: 1,
    name: {
      en : "Univ Of Illinois Willard"
    }
  },
  CMN : {
    lat: "33.3667",
    lon: "-7.58667",
    country: "MA",
    popularity: 40,
    name: {
      en : "Mohamed V"
    }
  },
  CMU : {
    country: "PG",
    name: {
      en : "CMU"
    }
  },
  CMW : {
    lat: "21.4186",
    lon: "-77.8497",
    country: "CU",
    name: {
      en : "Ign Agramonte"
    }
  },
  CMX : {
    lat: "47.1678",
    lon: "-88.4864",
    country: "US",
    name: {
      en : "Houghton Cty Memorial"
    }
  },
  CNC : {
    lat: "-10.05",
    lon: "143.067",
    country: "AU",
    name: {
      en : "Coconut Island"
    }
  },
  CND : {
    lat: "44.35",
    lon: "28.4833",
    country: "RO",
    name: {
      en : "Kogalniceanu"
    }
  },
  CNF : {
    lat: "-19.6333",
    lon: "-43.9686",
    country: "BR",
    city: "BHZ",
    name: {
      en : "Tancredo Neves"
    }
  },
  CNJ : {
    lat: "-20.6667",
    lon: "140.5",
    country: "AU",
    name: {
      en : "Cloncurry"
    }
  },
  CNM : {
    lat: "32.3372",
    lon: "-104.263",
    country: "US",
    popularity: 1,
    name: {
      en : "Carlsbad"
    }
  },
  CNN : {
    lat: "11.917381935401904",
    lon: "75.54619012491798",
    country: "IN",
    name: {
      en : "Kannur International Airport"
    }
  },
  CNP : {
    country: "GL",
    name: {
      en : "CNP"
    }
  },
  CNQ : {
    lat: "-27.4497",
    lon: "-58.7622",
    country: "AR",
    name: {
      en : "Camba Punta"
    }
  },
  CNS : {
    lat: "-16.8833",
    lon: "145.752",
    country: "AU",
    name: {
      en : "Cairns"
    }
  },
  CNX : {
    lat: "18.7719",
    lon: "98.9683",
    country: "TH",
    name: {
      en : "Chiang Mai"
    }
  },
  CNY : {
    lat: "38.7594",
    lon: "-109.746",
    country: "US",
    name: {
      en : "Moab"
    }
  },
  COD : {
    lat: "44.5158",
    lon: "-109.028",
    country: "US",
    name: {
      en : "Yellowstone Regional"
    }
  },
  COK : {
    lat: "9.94444",
    lon: "76.2719",
    country: "IN",
    name: {
      en : "Kochi"
    }
  },
  COL : {
    country: "GB",
    name: {
      en : "COL"
    }
  },
  COO : {
    lat: "6.35417",
    lon: "2.38556",
    country: "BJ",
    name: {
      en : "Cotonou"
    }
  },
  COQ : {
    country: "MN",
    name: {
      en : "COQ"
    }
  },
  COR : {
    lat: "-31.3131",
    lon: "-64.1994",
    country: "AR",
    name: {
      en : "Pajas Blanco"
    }
  },
  COS : {
    lat: "38.8089",
    lon: "-104.709",
    country: "US",
    name: {
      en : "Colorado Springs"
    }
  },
  COU : {
    lat: "38.8136",
    lon: "-92.2192",
    country: "US",
    name: {
      en : "Columbia Regional"
    }
  },
  COV : {
    lat: "36.90446479768079",
    lon: "35.06861156789746",
    country: "TR",
    city: "ADA",
    name: {
      en : "Çukurova International Airport"
    }
  },
  CPA : {
    country: "LR",
    name: {
      en : "CPA"
    }
  },
  CPC : {
    lat: "-40.0667",
    lon: "-71.1333",
    country: "AR",
    name: {
      en : "Chapelco"
    }
  },
  CPD : {
    lat: "-29.0444",
    lon: "134.753",
    country: "AU",
    name: {
      en : "Coober Pedy"
    }
  },
  CPE : {
    lat: "19.835",
    lon: "-90.5094",
    country: "MX",
    name: {
      en : "Campeche"
    }
  },
  CPH : {
    lat: "55.6081",
    lon: "12.6333",
    country: "DK",
    popularity: 114,
    name: {
      en : "Copenhagen"
    }
  },
  CPO : {
    lat: "-27.4167",
    lon: "-70.5361",
    country: "CL",
    popularity: 3,
    name: {
      en : "Chamonate"
    }
  },
  CPQ : {
    lat: "-22.9417",
    lon: "-47.1806",
    country: "BR",
    name: {
      en : "International Campinas"
    }
  },
  CPR : {
    lat: "42.9086",
    lon: "-106.463",
    country: "US",
    name: {
      en : "Natrona Cty"
    }
  },
  CPS : {
    lat: "38.6333",
    lon: "-96.1333",
    country: "US",
    city: "STL",
    name: {
      en : "East St Louis"
    }
  },
  CPT : {
    lat: "-33.9647",
    lon: "18.6022",
    country: "ZA",
    popularity: 2,
    name: {
      en : "Cape Town"
    }
  },
  CPV : {
    lat: "-7.26667",
    lon: "-35.9",
    country: "BR",
    name: {
      en : "Joao Suassuana"
    }
  },
  CQD : {
    lat: "32.2972",
    lon: "50.8422",
    country: "IR",
    name: {
      en : "Shahre Kord"
    }
  },
  CQM : {
    country: "ES",
    name: {
      en : "Ciudad Real Central Arpt"
    }
  },
  CRA : {
    lat: "44.3189",
    lon: "23.8864",
    country: "RO",
    name: {
      en : "Craiova"
    }
  },
  CRC : {
    country: "CO",
    name: {
      en : "CRC"
    }
  },
  CRD : {
    lat: "-45.7872",
    lon: "-67.4628",
    country: "AR",
    name: {
      en : "Comodoro Rivadavia"
    }
  },
  CRI : {
    country: "BS",
    name: {
      en : "CRI"
    }
  },
  CRK : {
    lat: "15.1833",
    lon: "120.55",
    country: "PH",
    city: "NCP",
    name: {
      en : "Clark Field"
    }
  },
  CRL : {
    lat: "50.4167",
    lon: "4.43333",
    country: "BE",
    city: "BRU",
    name: {
      en : "Brussels South Charleroi"
    }
  },
  CRM : {
    country: "PH",
    name: {
      en : "CRM"
    }
  },
  CRP : {
    lat: "27.7722",
    lon: "-97.5014",
    country: "US",
    name: {
      en : "Corpus Christi"
    }
  },
  CRV : {
    country: "IT",
    name: {
      en : "Crotone Arpt"
    }
  },
  CRW : {
    lat: "38.3728",
    lon: "-81.5931",
    country: "US",
    name: {
      en : "Yeager"
    }
  },
  CSA : {
    country: "GB",
    name: {
      en : "CSA"
    }
  },
  CSG : {
    lat: "32.5133",
    lon: "-84.9411",
    country: "US",
    name: {
      en : "Columbus Metro Ft Benning"
    }
  },
  CSH : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Solovki"
    }
  },
  CSX : {
    lat: "28.1867",
    lon: "113.222",
    country: "CN",
    name: {
      en : "Changsha"
    }
  },
  CSY : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "CSY"
    }
  },
  CTA : {
    lat: "37.4028",
    lon: "15.1",
    country: "IT",
    popularity: 2,
    name: {
      en : "Fontanarossa"
    }
  },
  CTC : {
    lat: "-28.4483",
    lon: "-65.7797",
    country: "AR",
    name: {
      en : "Choya"
    }
  },
  CTD : {
    country: "PA",
    name: {
      en : "Chitre Airfield"
    }
  },
  CTG : {
    lat: "10.4467",
    lon: "-75.5108",
    country: "CO",
    name: {
      en : "Rafael Nunez"
    }
  },
  CTL : {
    lat: "-26.4133",
    lon: "146.26",
    country: "AU",
    name: {
      en : "Charleville"
    }
  },
  CTM : {
    lat: "18.4819",
    lon: "-88.3333",
    country: "MX",
    name: {
      en : "Chetumal"
    }
  },
  CTN : {
    country: "AU",
    name: {
      en : "Cooktown Arpt"
    }
  },
  CTS : {
    lat: "42.7958",
    lon: "141.669",
    country: "JP",
    city: "SPK",
    name: {
      en : "Chitose"
    }
  },
  CTU : {
    lat: "30.7",
    lon: "103.95",
    country: "CN",
    name: {
      en : "Chengdu"
    }
  },
  CUC : {
    lat: "7.93",
    lon: "-72.5094",
    country: "CO",
    name: {
      en : "Camilo Dazo"
    }
  },
  CUE : {
    lat: "-2.86667",
    lon: "-78.9833",
    country: "EC",
    popularity: 2,
    name: {
      en : "Cuenca"
    }
  },
  CUF : {
    lat: "44.5353",
    lon: "7.6175",
    country: "IT",
    name: {
      en : "Levaldigi"
    }
  },
  CUK : {
    country: "BZ",
    name: {
      en : "CUK"
    }
  },
  CUL : {
    lat: "24.7644",
    lon: "-107.474",
    country: "MX",
    name: {
      en : "Fedl De Bachigualato"
    }
  },
  CUM : {
    lat: "10.4478",
    lon: "-64.1919",
    country: "VE",
    name: {
      en : "Antonio Jose De Sucre"
    }
  },
  CUN : {
    lat: "21.0333",
    lon: "-86.8667",
    country: "MX",
    popularity: 32,
    name: {
      en : "Cancun Aeropuerto Internacional"
    }
  },
  CUQ : {
    country: "AU",
    name: {
      en : "Coen Arpt"
    }
  },
  CUR : {
    lat: "12.1942",
    lon: "-68.9606",
    country: "AN",
    name: {
      en : "Areopuerto Hato"
    }
  },
  CUU : {
    lat: "28.6525",
    lon: "-106.094",
    country: "MX",
    name: {
      en : "Chihuahua"
    }
  },
  CUZ : {
    lat: "-13.5294",
    lon: "-71.9597",
    country: "PE",
    name: {
      en : "Tte Velazco Astete"
    }
  },
  CVG : {
    lat: "39.0478",
    lon: "-84.6686",
    country: "US",
    popularity: 16,
    name: {
      en : "Cincinnati No Kentucky"
    }
  },
  CVJ : {
    lat: "0",
    lon: "0",
    country: "MX",
    name: {
      en : "General Mariano Matamoros Airport"
    }
  },
  CVM : {
    lat: "23.7139",
    lon: "-98.9653",
    country: "MX",
    name: {
      en : "Ciudad Victoria"
    }
  },
  CVN : {
    lat: "34.4272",
    lon: "-103.079",
    country: "US",
    name: {
      en : "Clovis"
    }
  },
  CVO : {
    lat: "44.6333",
    lon: "-123.117",
    country: "US",
    name: {
      en : "Corvallis"
    }
  },
  CVQ : {
    lat: "-24.88",
    lon: "113.667",
    country: "AU",
    name: {
      en : "Carnarvon"
    }
  },
  CVT : {
    lat: "52.3692",
    lon: "-1.47861",
    country: "GB",
    name: {
      en : "Baginton"
    }
  },
  CVU : {
    lat: "39.7",
    lon: "-31.1",
    country: "PT",
    name: {
      en : "Corvo"
    }
  },
  CWA : {
    lat: "44.7822",
    lon: "-89.6592",
    country: "US",
    city: "AUW",
    name: {
      en : "Central Wisconsin"
    }
  },
  CWB : {
    lat: "-25.5267",
    lon: "-49.1778",
    country: "BR",
    name: {
      en : "Afonso Pena"
    }
  },
  CWC : {
    country: "UA",
    name: {
      en : "Chernovtsy Arpt"
    }
  },
  CWL : {
    lat: "51.3975",
    lon: "-3.34667",
    country: "GB",
    name: {
      en : "Cardiff Wales"
    }
  },
  CXB : {
    country: "BD",
    name: {
      en : "CXB"
    }
  },
  CXH : {
    lat: "49.2667",
    lon: "-123.117",
    country: "CA",
    city: "YVR",
    name: {
      en : "Coal Harbor Sea Plane"
    }
  },
  CXI : {
    country: "KI",
    name: {
      en : "Cassidy"
    }
  },
  CXJ : {
    lat: "-29.1667",
    lon: "-51.1833",
    country: "BR",
    name: {
      en : "Campo Dos Bugres"
    }
  },
  CXR : {
    lat: "11.9936",
    lon: "109.225",
    country: "VN",
    city: "NHA",
    name: {
      en : "Cam Ranh"
    }
  },
  CYB : {
    lat: "19.6867",
    lon: "-79.8875",
    country: "KY",
    name: {
      en : "Gerrard Smith"
    }
  },
  CYC : {
    country: "BZ",
    name: {
      en : "CYC"
    }
  },
  CYF : {
    country: "US",
    name: {
      en : "CYF"
    }
  },
  CYI : {
    country: "TW",
    name: {
      en : "Chia Yi Airport"
    }
  },
  CYO : {
    lat: "21.6167",
    lon: "-81.5167",
    country: "CU",
    name: {
      en : "Cayo Largo Del Sur"
    }
  },
  CYP : {
    country: "PH",
    name: {
      en : "CYP"
    }
  },
  CYS : {
    lat: "41.1558",
    lon: "-104.817",
    country: "US",
    popularity: 8,
    name: {
      en : "Cheyenne"
    }
  },
  CYX : {
    country: "RU",
    name: {
      en : "CYX"
    }
  },
  CYZ : {
    country: "PH",
    name: {
      en : "CYZ"
    }
  },
  CZE : {
    lat: "11.4158",
    lon: "-69.6819",
    country: "VE",
    name: {
      en : "Coro"
    }
  },
  CZL : {
    lat: "36.2769",
    lon: "6.63",
    country: "DZ",
    name: {
      en : "Ain El Bey"
    }
  },
  CZM : {
    lat: "20.5167",
    lon: "-86.9333",
    country: "MX",
    name: {
      en : "Aeropuerto De Cozumel"
    }
  },
  CZR : {
    lat: "56.91372108308345",
    lon: "118.27186567171348",
    country: "RU",
    name: {
      en : "Chara"
    }
  },
  CZS : {
    lat: "-7.58333",
    lon: "-72.7833",
    country: "BR",
    name: {
      en : "Campo"
    }
  },
  CZU : {
    country: "CO",
    name: {
      en : "Corozal Arpt"
    }
  },
  CZX : {
    lat: "31.7",
    lon: "119.967",
    country: "CN",
    name: {
      en : "Changzhou"
    }
  },
  DAB : {
    lat: "29.1825",
    lon: "-81.0528",
    country: "US",
    name: {
      en : "Daytona Beach Regional"
    }
  },
  DAC : {
    lat: "23.7806",
    lon: "90.3861",
    country: "BD",
    popularity: 3,
    name: {
      en : "Zia Intl"
    }
  },
  DAD : {
    lat: "16.0422",
    lon: "108.204",
    country: "VN",
    popularity: 1,
    name: {
      en : "Da Nang"
    }
  },
  DAL : {
    lat: "32.8469",
    lon: "-96.8533",
    country: "US",
    city: "DFW",
    name: {
      en : "Love Field"
    }
  },
  DAM : {
    lat: "33.4139",
    lon: "36.5178",
    country: "SY",
    popularity: 2,
    name: {
      en : "Damascus"
    }
  },
  DAR : {
    lat: "-6.87528",
    lon: "39.2019",
    country: "TZ",
    name: {
      en : "Es Salaam"
    }
  },
  DAT : {
    lat: "30.8",
    lon: "117.733",
    country: "CN",
    name: {
      en : "Datong"
    }
  },
  DAU : {
    country: "PG",
    name: {
      en : "DAU"
    }
  },
  DAV : {
    country: "PA",
    name: {
      en : "Enrique Malek Arpt"
    }
  },
  DAX : {
    country: "CN",
    name: {
      en : "DAX"
    }
  },
  DAY : {
    lat: "39.9",
    lon: "-84.2211",
    country: "US",
    name: {
      en : "Dayton International"
    }
  },
  DBA : {
    country: "PK",
    name: {
      en : "DBA"
    }
  },
  DBB : {
    lat: "30.930461311843008",
    lon: "28.463100338969767",
    country: "EG",
    name: {
      en : "Alalamain"
    }
  },
  DBO : {
    lat: "-32.2192",
    lon: "148.577",
    country: "AU",
    name: {
      en : "Dubbo"
    }
  },
  DBQ : {
    lat: "42.41",
    lon: "-90.7108",
    country: "US",
    name: {
      en : "Dubuque"
    }
  },
  DBV : {
    lat: "42.5633",
    lon: "18.2653",
    country: "HR",
    popularity: 4,
    name: {
      en : "Dubrovnik"
    }
  },
  DCA : {
    lat: "38.8517",
    lon: "-77.0369",
    country: "US",
    city: "WAS",
    name: {
      en : "Ronald Reagan National"
    }
  },
  DCF : {
    lat: "15.5",
    lon: "-61.3333",
    country: "DM",
    city: "DOM",
    popularity: 1,
    name: {
      en : "Canefield"
    }
  },
  DCM : {
    lat: "43.5558",
    lon: "2.28417",
    country: "FR",
    name: {
      en : "Mazamet"
    }
  },
  DCN : {
    country: "AU",
    name: {
      en : "DCN"
    }
  },
  DCY : {
    country: "CN",
    name: {
      en : "Daocheng Yading"
    }
  },
  DDC : {
    lat: "37.7617",
    lon: "-99.965",
    country: "US",
    name: {
      en : "Dodge City"
    }
  },
  DDG : {
    lat: "40",
    lon: "125",
    country: "CN",
    name: {
      en : "Dandong"
    }
  },
  DEA : {
    country: "PK",
    name: {
      en : "DEA"
    }
  },
  DEB : {
    lat: "0",
    lon: "0",
    country: "HU",
    name: {
      en : "Debrecen Arpt"
    }
  },
  DEC : {
    lat: "39.8342",
    lon: "-88.8686",
    country: "US",
    name: {
      en : "Decatur"
    }
  },
  DED : {
    lat: "30.3167",
    lon: "78.0333",
    country: "IN",
    name: {
      en : "Jolly Grant"
    }
  },
  DEE : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "DEE"
    }
  },
  DEF : {
    country: "IR",
    name: {
      en : "DEF"
    }
  },
  DEL : {
    lat: "28.5736",
    lon: "77.1008",
    country: "IN",
    popularity: 60,
    name: {
      en : "Delhi Indira Gandhi"
    }
  },
  DEN : {
    lat: "39.8547",
    lon: "-104.718",
    country: "US",
    popularity: 7,
    name: {
      en : "Denver"
    }
  },
  DEZ : {
    lat: "35.3333",
    lon: "40.15",
    country: "SY",
    name: {
      en : "Al Jafrah"
    }
  },
  DFW : {
    lat: "32.8944",
    lon: "-97.0297",
    country: "US",
    popularity: 5,
    name: {
      en : "Dallas Ft Worth"
    }
  },
  DGA : {
    country: "BZ",
    name: {
      en : "DGA"
    }
  },
  DGE : {
    country: "AU",
    name: {
      en : "Mudgee Arpt"
    }
  },
  DGO : {
    lat: "24.125",
    lon: "-104.525",
    country: "MX",
    name: {
      en : "Guadalupe Victoria"
    }
  },
  DGT : {
    country: "PH",
    name: {
      en : "Dumaguete Arpt"
    }
  },
  DHB : {
    country: "US",
    name: {
      en : "DHB"
    }
  },
  DHI : {
    country: "NP",
    name: {
      en : "DHI"
    }
  },
  DHM : {
    lat: "32.3",
    lon: "76.2667",
    country: "IN",
    name: {
      en : "Kangra Airport, Gaggal"
    }
  },
  DHN : {
    lat: "31.32",
    lon: "-85.4483",
    country: "US",
    popularity: 2,
    name: {
      en : "Dothan"
    }
  },
  DIA : {
    lat: "25.2569",
    lon: "51.5664",
    country: "QA",
    city: "DOH",
    name: {
      en : "Doha International Airport"
    }
  },
  DIB : {
    lat: "27.4839",
    lon: "95.0208",
    country: "IN",
    name: {
      en : "Chabua"
    }
  },
  DIE : {
    lat: "-12.3461",
    lon: "49.2925",
    country: "MG",
    name: {
      en : "Antsiranana Arrachart"
    }
  },
  DIG : {
    lat: "27.7897",
    lon: "99.6778",
    country: "CN",
    name: {
      en : "Diging"
    }
  },
  DIK : {
    lat: "46.8333",
    lon: "-102.9",
    country: "US",
    name: {
      en : "Dickinson"
    }
  },
  DIL : {
    lat: "-8.53333",
    lon: "125.577",
    country: "TL",
    name: {
      en : "Comoro"
    }
  },
  DIN : {
    lat: "21.3833",
    lon: "103",
    country: "VN",
    name: {
      en : "Gialam"
    }
  },
  DIR : {
    lat: "9.62222",
    lon: "41.8508",
    country: "ET",
    name: {
      en : "Aba Tenna D Yilma"
    }
  },
  DIU : {
    lat: "20.7167",
    lon: "70.9167",
    country: "IN",
    name: {
      en : "Diu"
    }
  },
  DIY : {
    lat: "37.8953",
    lon: "40.2031",
    country: "TR",
    name: {
      en : "Diyarbakir"
    }
  },
  DJB : {
    lat: "-1.63472",
    lon: "103.642",
    country: "ID",
    name: {
      en : "Sultan Taha Syarifudin"
    }
  },
  DJE : {
    lat: "33.8742",
    lon: "10.7833",
    country: "TN",
    name: {
      en : "Melita"
    }
  },
  DJG : {
    country: "DZ",
    name: {
      en : "DJG"
    }
  },
  DJJ : {
    country: "ID",
    name: {
      en : "Sentani Arpt"
    }
  },
  DKA : {
    country: "NG",
    name: {
      en : "DKA"
    }
  },
  DKR : {
    lat: "14.7408",
    lon: "-17.4906",
    country: "SN",
    name: {
      en : "Leopold Sedar Senghor"
    }
  },
  DKS : {
    country: "RU",
    name: {
      en : "Dikson"
    }
  },
  DLA : {
    lat: "4.01333",
    lon: "9.70917",
    country: "CM",
    name: {
      en : "Douala"
    }
  },
  DLC : {
    lat: "38.9667",
    lon: "121.55",
    country: "CN",
    name: {
      en : "Dalian"
    }
  },
  DLG : {
    lat: "59.05",
    lon: "-158.5",
    country: "US",
    name: {
      en : "Dillingham"
    }
  },
  DLH : {
    lat: "46.8425",
    lon: "-92.1903",
    country: "US",
    name: {
      en : "Duluth"
    }
  },
  DLI : {
    lat: "11.7497",
    lon: "108.378",
    country: "VN",
    name: {
      en : "Lienkhang"
    }
  },
  DLM : {
    lat: "36.7167",
    lon: "28.7833",
    country: "TR",
    popularity: 5,
    name: {
      en : "Dalaman"
    }
  },
  DLU : {
    lat: "25.6667",
    lon: "100.317",
    country: "CN",
    name: {
      en : "Dali"
    }
  },
  DLY : {
    country: "VU",
    name: {
      en : "DLY"
    }
  },
  DLZ : {
    country: "MN",
    name: {
      en : "DLZ"
    }
  },
  DMB : {
    lat: "42.9",
    lon: "71.3667",
    country: "KZ",
    name: {
      en : "Taraz"
    }
  },
  DMD : {
    lat: "-18",
    lon: "138.833",
    country: "AU",
    name: {
      en : "Doomadgee"
    }
  },
  DME : {
    lat: "55.4",
    lon: "37.8833",
    country: "RU",
    city: "MOW",
    popularity: 1569,
    name: {
      en : "Domodedovo"
    }
  },
  DMK : {
    lat: "13.9125",
    lon: "100.607",
    country: "TH",
    city: "BKK",
    name: {
      en : "Don Muang"
    }
  },
  DMM : {
    lat: "26.4667",
    lon: "49.8",
    country: "SA",
    popularity: 2,
    name: {
      en : "King Fahad"
    }
  },
  DMS : {
    country: "SA",
    name: {
      en : "SABTCO BUS STATION"
    }
  },
  DMU : {
    country: "IN",
    name: {
      en : "Dimapur Airport"
    }
  },
  DNA : {
    country: "JP",
    city: "OKA",
    name: {
      en : "Kadena AFB"
    }
  },
  DND : {
    lat: "56.4528",
    lon: "-3.00833",
    country: "GB",
    name: {
      en : "Riverside Park"
    }
  },
  DNH : {
    lat: "40.2",
    lon: "94.6833",
    country: "CN",
    name: {
      en : "Dunhuang"
    }
  },
  DNK : {
    lat: "48.45",
    lon: "34.9833",
    country: "UA",
    popularity: 2,
    name: {
      en : "Dnepropetrovsk"
    }
  },
  DNR : {
    lat: "48.5878",
    lon: "-2.08361",
    country: "FR",
    name: {
      en : "Pleurtuit"
    }
  },
  DNZ : {
    lat: "37.7872",
    lon: "29.7033",
    country: "TR",
    popularity: 1,
    name: {
      en : "Cardak"
    }
  },
  DOD : {
    country: "TZ",
    name: {
      en : "DOD"
    }
  },
  DOH : {
    lat: "25.2569",
    lon: "51.5664",
    country: "QA",
    popularity: 2,
    name: {
      en : "Doha Hamad International Airport"
    }
  },
  DOL : {
    country: "FR",
    name: {
      en : "Saint Gatien Arpt"
    }
  },
  DOM : {
    lat: "15.5431",
    lon: "-61.3092",
    country: "DM",
    popularity: 2,
    name: {
      en : "Melville Hall"
    }
  },
  DOP : {
    country: "NP",
    name: {
      en : "DOP"
    }
  },
  DOU : {
    country: "BR",
    name: {
      en : "Dourados Airport"
    }
  },
  DOV : {
    lat: "39.1286",
    lon: "-75.4642",
    country: "US",
    name: {
      en : "Dover AFB"
    }
  },
  DOY : {
    country: "CN",
    name: {
      en : "DOY"
    }
  },
  DPA : {
    lat: "41.9144",
    lon: "-88.2464",
    country: "US",
    city: "CHI",
    name: {
      en : "Dupage County"
    }
  },
  DPL : {
    lat: "8.6",
    lon: "123.35",
    country: "PH",
    name: {
      en : "Dipolog"
    }
  },
  DPO : {
    lat: "-41.1708",
    lon: "146.425",
    country: "AU",
    name: {
      en : "Devonport"
    }
  },
  DPS : {
    lat: "-8.74861",
    lon: "115.165",
    country: "ID",
    popularity: 58,
    name: {
      en : "Ngurah Rai"
    }
  },
  DPT : {
    country: "RU",
    name: {
      en : "Deputatsky"
    }
  },
  DQA : {
    country: "CN",
    name: {
      en : "Saertu Airport"
    }
  },
  DQM : {
    country: "OM",
    name: {
      en : "Duqm Jaaluni"
    }
  },
  DRG : {
    country: "US",
    name: {
      en : "DRG"
    }
  },
  DRK : {
    country: "CR",
    name: {
      en : "DRK"
    }
  },
  DRO : {
    lat: "37.15",
    lon: "-107.751",
    country: "US",
    name: {
      en : "Durango La Plata Cty"
    }
  },
  DRS : {
    lat: "51.1333",
    lon: "13.7667",
    country: "DE",
    name: {
      en : "Dresden"
    }
  },
  DRT : {
    lat: "29.3333",
    lon: "-100.978",
    country: "US",
    name: {
      en : "International Del Rio"
    }
  },
  DRW : {
    lat: "-12.4167",
    lon: "130.872",
    country: "AU",
    name: {
      en : "Darwin"
    }
  },
  DSA : {
    lat: "53.4753",
    lon: "-1.00389",
    country: "GB",
    name: {
      en : "Finningley"
    }
  },
  DSK : {
    country: "PK",
    name: {
      en : "DSK"
    }
  },
  DSM : {
    lat: "41.5339",
    lon: "-93.6567",
    country: "US",
    name: {
      en : "Des Moines Airport"
    }
  },
  DSN : {
    lat: "0",
    lon: "0",
    country: "CN",
    name: {
      en : "DSN"
    }
  },
  DSS : {
    country: "SN",
    name: {
      en : "Blaise Diagne International Airport"
    }
  },
  DTM : {
    lat: "51.5167",
    lon: "7.6",
    country: "DE",
    popularity: 2,
    name: {
      en : "Wickede Dortmund"
    }
  },
  DTW : {
    lat: "42.2186",
    lon: "-83.3486",
    country: "US",
    city: "DTT",
    popularity: 16,
    name: {
      en : "Detroit Metro Wayne City"
    }
  },
  DUB : {
    lat: "53.4325",
    lon: "-6.25222",
    country: "IE",
    popularity: 99,
    name: {
      en : "Dublin"
    }
  },
  DUD : {
    lat: "-45.925",
    lon: "170.2",
    country: "NZ",
    name: {
      en : "Momona"
    }
  },
  DUJ : {
    lat: "41.1783",
    lon: "-78.8989",
    country: "US",
    name: {
      en : "Dubois Jefferson Cty"
    }
  },
  DUM : {
    country: "ID",
    name: {
      en : "DUM"
    }
  },
  DUQ : {
    country: "CA",
    name: {
      en : "Duncan/Quam Rail Station"
    }
  },
  DUR : {
    lat: "-29.9692",
    lon: "30.9569",
    country: "ZA",
    name: {
      en : "Durban"
    }
  },
  DUS : {
    lat: "51.2811",
    lon: "6.75278",
    country: "DE",
    popularity: 176,
    name: {
      en : "Dusseldorf"
    }
  },
  DUT : {
    lat: "53.9011",
    lon: "-166.536",
    country: "US",
    name: {
      en : "Emergency Field"
    }
  },
  DVL : {
    lat: "48.1131",
    lon: "-98.9075",
    country: "US",
    name: {
      en : "Devils Lake"
    }
  },
  DVN : {
    lat: "41.6106",
    lon: "-90.5886",
    country: "US",
    name: {
      en : "Davenport"
    }
  },
  DVO : {
    lat: "7.13167",
    lon: "125.649",
    country: "PH",
    name: {
      en : "FRANCISCO BANGOY INTL. "
    }
  },
  DVX : {
    country: "US",
    city: "DOV",
    name: {
      en : "Delaware Airpark"
    }
  },
  DWC : {
    lat: "24.886111",
    lon: "55.172222",
    country: "AE",
    city: "DXB",
    name: {
      en : "Al Maktoum"
    }
  },
  DWD : {
    lat: "0",
    lon: "0",
    country: "SA",
    name: {
      en : "Dawadmi"
    }
  },
  DXB : {
    lat: "25.25",
    lon: "55.3578",
    country: "AE",
    popularity: 58,
    name: {
      en : "Dubai"
    }
  },
  DXN : {
    lat: "28.2109",
    lon: "77.5981",
    country: "IN",
    city: "DEL",
    popularity: 60,
    name: {
      en : "Noida International Airport"
    }
  },
  DYG : {
    lat: "29.1333",
    lon: "110.483",
    country: "CN",
    name: {
      en : "Zhangjiajie Hehua"
    }
  },
  DYR : {
    lat: "64.7333",
    lon: "177.75",
    country: "RU",
    popularity: 1,
    name: {
      en : "Anadyr"
    }
  },
  DYU : {
    lat: "38.55",
    lon: "68.8236",
    country: "TJ",
    name: {
      en : "Dushanbe"
    }
  },
  DZA : {
    lat: "-12.7833",
    lon: "45.2833",
    country: "YT",
    name: {
      en : "Dzaoudzi"
    }
  },
  DZN : {
    country: "KZ",
    name: {
      en : "DZN"
    }
  },
  EAA : {
    lat: "64.7767",
    lon: "-141.149",
    country: "US",
    name: {
      en : "Eagle"
    }
  },
  EAE : {
    country: "VU",
    name: {
      en : "EAE"
    }
  },
  EAL : {
    country: "MH",
    name: {
      en : "EAL"
    }
  },
  EAM : {
    lat: "17.6117",
    lon: "44.4297",
    country: "SA",
    name: {
      en : "Nejran"
    }
  },
  EAR : {
    lat: "40.7283",
    lon: "-98.9989",
    country: "US",
    name: {
      en : "Kearney Arrpt"
    }
  },
  EAS : {
    lat: "43.3578",
    lon: "-1.79",
    country: "ES",
    name: {
      en : "San Sebastian"
    }
  },
  EAT : {
    lat: "47.3997",
    lon: "-120.208",
    country: "US",
    name: {
      en : "Pangborn Memorial Fld"
    }
  },
  EAU : {
    lat: "44.8644",
    lon: "-91.4872",
    country: "US",
    name: {
      en : "Claire Airport"
    }
  },
  EBA : {
    country: "IT",
    name: {
      en : "Marina Di Campo Arpt"
    }
  },
  EBB : {
    lat: "0.0425",
    lon: "32.4381",
    country: "UG",
    popularity: 4,
    name: {
      en : "Entebbe"
    }
  },
  EBD : {
    country: "SD",
    name: {
      en : "EBD"
    }
  },
  EBH : {
    country: "DZ",
    name: {
      en : "EBH"
    }
  },
  EBJ : {
    lat: "55.5264",
    lon: "8.5525",
    country: "DK",
    name: {
      en : "Esbjerg"
    }
  },
  EBL : {
    lat: "36.2375",
    lon: "43.9631",
    country: "IQ",
    name: {
      en : "Erbil"
    }
  },
  EBU : {
    country: "FR",
    name: {
      en : "Boutheon Arpt"
    }
  },
  ECN : {
    lat: "35.1597",
    lon: "33.4897",
    country: "CY",
    popularity: 2,
    name: {
      en : "Ercan"
    }
  },
  ECP : {
    country: "US",
    city: "PFN",
    name: {
      en : "Northwest Florida Beaches Intl"
    }
  },
  EDA : {
    country: "US",
    name: {
      en : "Edna Bay Arpt"
    }
  },
  EDI : {
    lat: "55.95",
    lon: "-3.3725",
    country: "GB",
    popularity: 31,
    name: {
      en : "Edinburgh"
    }
  },
  EDL : {
    lat: "0.516667",
    lon: "35.2833",
    country: "KE",
    name: {
      en : "Eldoret"
    }
  },
  EDO : {
    country: "TR",
    name: {
      en : "Edremit Korfez"
    }
  },
  EDR : {
    lat: "-14.9",
    lon: "141.617",
    country: "AU",
    name: {
      en : "Edward River"
    }
  },
  EEK : {
    country: "US",
    name: {
      en : "Eek Arpt"
    }
  },
  EEM : {
    country: "ES",
    name: {
      en : "EEM"
    }
  },
  EEP : {
    country: "ES",
    name: {
      en : "EEP"
    }
  },
  EER : {
    country: "ES",
    name: {
      en : "EER"
    }
  },
  EFL : {
    lat: "38.1181",
    lon: "20.5056",
    country: "GR",
    name: {
      en : "Argostoli"
    }
  },
  EGC : {
    lat: "44.85",
    lon: "0.483333",
    country: "FR",
    name: {
      en : "Roumaniere"
    }
  },
  EGE : {
    lat: "39.645",
    lon: "-106.912",
    country: "US",
    name: {
      en : "Eagle County"
    }
  },
  EGM : {
    lat: "-8.55",
    lon: "157.85",
    country: "SB",
    name: {
      en : "Sege"
    }
  },
  EGN : {
    country: "SD",
    name: {
      en : "EGN"
    }
  },
  EGO : {
    lat: "50.6333",
    lon: "36.65",
    country: "RU",
    name: {
      en : "Belgorod"
    }
  },
  EGS : {
    lat: "65.2778",
    lon: "-14.4028",
    country: "IS",
    popularity: 3,
    name: {
      en : "Egilsstadir"
    }
  },
  EGV : {
    lat: "45.9292",
    lon: "-89.2658",
    country: "US",
    name: {
      en : "Eagle River Union"
    }
  },
  EGX : {
    country: "US",
    name: {
      en : "EGX"
    }
  },
  EIK : {
    country: "RU",
    name: {
      en : "EIK"
    }
  },
  EIN : {
    lat: "51.4533",
    lon: "5.38889",
    country: "NL",
    name: {
      en : "Welschap"
    }
  },
  EIS : {
    lat: "18.4439",
    lon: "-64.5428",
    country: "VG",
    name: {
      en : "Beef Island"
    }
  },
  EJA : {
    lat: "7.01583",
    lon: "-73.7992",
    country: "CO",
    name: {
      en : "Variguies"
    }
  },
  EJH : {
    country: "SA",
    name: {
      en : "EJH"
    }
  },
  EKO : {
    lat: "40.8239",
    lon: "-115.79",
    country: "US",
    name: {
      en : "J C Harris Field"
    }
  },
  EKS : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Shakhtyorsk"
    }
  },
  ELC : {
    country: "AU",
    name: {
      en : "ELC"
    }
  },
  ELD : {
    country: "US",
    name: {
      en : "Goodwin Field"
    }
  },
  ELF : {
    country: "SD",
    name: {
      en : "ELF"
    }
  },
  ELG : {
    country: "DZ",
    name: {
      en : "ELG"
    }
  },
  ELH : {
    lat: "25.4747",
    lon: "-76.685",
    country: "BS",
    name: {
      en : "North Eleuthera"
    }
  },
  ELI : {
    country: "US",
    name: {
      en : "ELI"
    }
  },
  ELM : {
    lat: "42.1608",
    lon: "-76.8953",
    country: "US",
    name: {
      en : "Elmira Corning Regional"
    }
  },
  ELP : {
    lat: "31.8011",
    lon: "-106.399",
    country: "US",
    name: {
      en : "El Paso"
    }
  },
  ELQ : {
    lat: "26.3033",
    lon: "43.7708",
    country: "SA",
    name: {
      en : "Gassim"
    }
  },
  ELS : {
    lat: "-33.0361",
    lon: "27.8239",
    country: "ZA",
    name: {
      en : "East London"
    }
  },
  ELU : {
    country: "DZ",
    name: {
      en : "ELU"
    }
  },
  ELV : {
    country: "US",
    name: {
      en : "ELV"
    }
  },
  ELY : {
    lat: "39.3019",
    lon: "-114.842",
    country: "US",
    name: {
      en : "Yelland Field"
    }
  },
  EMA : {
    lat: "52.8311",
    lon: "-1.32806",
    country: "GB",
    city: "NQT",
    popularity: 1,
    name: {
      en : "East Midlands"
    }
  },
  EMD : {
    lat: "-23.57",
    lon: "148.178",
    country: "AU",
    name: {
      en : "Emerald"
    }
  },
  EMK : {
    country: "US",
    name: {
      en : "EMK"
    }
  },
  ENA : {
    lat: "60.5675",
    lon: "-151.251",
    country: "US",
    name: {
      en : "Kenai"
    }
  },
  ENE : {
    country: "ID",
    name: {
      en : "ENE"
    }
  },
  ENF : {
    lat: "0",
    lon: "0",
    country: "FI",
    name: {
      en : "Enontekio"
    }
  },
  ENH : {
    country: "CN",
    name: {
      en : "ENH"
    }
  },
  ENI : {
    country: "PH",
    name: {
      en : "ENI"
    }
  },
  ENU : {
    country: "NG",
    name: {
      en : "ENU"
    }
  },
  ENW : {
    lat: "42.5833",
    lon: "-87.8167",
    country: "US",
    name: {
      en : "Kenosha"
    }
  },
  ENY : {
    lat: "36",
    lon: "109.333",
    country: "CN",
    name: {
      en : "Yanan"
    }
  },
  EOH : {
    lat: "6.21667",
    lon: "-75.5833",
    country: "CO",
    city: "MDE",
    name: {
      en : "Enrique Olaya Herrara"
    }
  },
  EOI : {
    lat: "59.1833",
    lon: "-2.78333",
    country: "GB",
    name: {
      en : "Eday"
    }
  },
  EPA : {
    country: "AR",
    city: "BUE",
    name: {
      en : "El Palomar Airport"
    }
  },
  EPR : {
    lat: "-33.685",
    lon: "121.824",
    country: "AU",
    name: {
      en : "Esperance"
    }
  },
  EPU : {
    country: "EE",
    name: {
      en : "Parnu Arpt"
    }
  },
  EQS : {
    lat: "-42.9097",
    lon: "-71.1425",
    country: "AR",
    name: {
      en : "Esquel"
    }
  },
  ERC : {
    lat: "39.7117",
    lon: "39.5169",
    country: "TR",
    name: {
      en : "Erzincan"
    }
  },
  ERF : {
    lat: "50.9833",
    lon: "10.9667",
    country: "DE",
    name: {
      en : "Erfurt"
    }
  },
  ERH : {
    country: "MA",
    name: {
      en : "Errachidia Arpt"
    }
  },
  ERI : {
    lat: "42.08",
    lon: "-80.1786",
    country: "US",
    name: {
      en : "Erie"
    }
  },
  ERL : {
    country: "CN",
    name: {
      en : "ERL"
    }
  },
  ERM : {
    country: "BR",
    name: {
      en : "ERM"
    }
  },
  ERN : {
    country: "BR",
    name: {
      en : "ERN"
    }
  },
  ERS : {
    lat: "-22.6167",
    lon: "17.0833",
    country: "NA",
    city: "WDH",
    name: {
      en : "Eros"
    }
  },
  ERZ : {
    lat: "39.9556",
    lon: "41.1736",
    country: "TR",
    name: {
      en : "Erzurum"
    }
  },
  ESB : {
    lat: "40.1333",
    lon: "33",
    country: "TR",
    city: "ANK",
    popularity: 18,
    name: {
      en : "Esenboga"
    }
  },
  ESC : {
    lat: "45.7206",
    lon: "-87.0867",
    country: "US",
    name: {
      en : "Delta County"
    }
  },
  ESD : {
    lat: "48.7083",
    lon: "-122.912",
    country: "US",
    name: {
      en : "Eastsound Orcas Is"
    }
  },
  ESK : {
    country: "TR",
    name: {
      en : "Eskişehir"
    }
  },
  ESL : {
    country: "RU",
    name: {
      en : "Elista"
    }
  },
  ESM : {
    country: "EC",
    name: {
      en : "ESM"
    }
  },
  ESR : {
    lat: "-26.3153",
    lon: "-69.7653",
    country: "CL",
    name: {
      en : "El Salvador"
    }
  },
  ESS : {
    lat: "51.4039",
    lon: "6.94167",
    country: "DE",
    popularity: 1,
    name: {
      en : "Essen"
    }
  },
  ESU : {
    lat: "31.5333",
    lon: "-9.7",
    country: "MA",
    name: {
      en : "Essaouira"
    }
  },
  ETH : {
    lat: "29.5597",
    lon: "34.9614",
    country: "IL",
    popularity: 18,
    name: {
      en : "Elat"
    }
  },
  ETM : {
    lat: "29.750",
    lon: "35",
    country: "IL",
    city: "ETH",
    popularity: 18,
    name: {
      en : "Ramon Airport"
    }
  },
  ETR : {
    country: "EC",
    name: {
      en : "ETR"
    }
  },
  ETZ : {
    lat: "48.9792",
    lon: "6.24778",
    country: "FR",
    popularity: 1,
    name: {
      en : "Metz Nancy Lorraine"
    }
  },
  EUG : {
    lat: "44.1208",
    lon: "-123.218",
    country: "US",
    name: {
      en : "Eugene"
    }
  },
  EUN : {
    lat: "27.1333",
    lon: "-13.2167",
    country: "MA",
    name: {
      en : "Hassan I"
    }
  },
  EUX : {
    lat: "17.4931",
    lon: "-62.9778",
    country: "AN",
    name: {
      en : "Roosevelt Field"
    }
  },
  EVE : {
    lat: "68.4967",
    lon: "16.6797",
    country: "NO",
    name: {
      en : "Evenes"
    }
  },
  EVG : {
    lat: "62.0333",
    lon: "14.35",
    country: "SE",
    name: {
      en : "Sveg"
    }
  },
  EVN : {
    lat: "40.15",
    lon: "44.4",
    country: "AM",
    popularity: 3,
    name: {
      en : "Yerevan"
    }
  },
  EVV : {
    lat: "38.0367",
    lon: "-87.5325",
    country: "US",
    name: {
      en : "Evansville Regional"
    }
  },
  EWB : {
    lat: "41.6769",
    lon: "-70.9592",
    country: "US",
    name: {
      en : "New Bedford"
    }
  },
  EWD : {
    country: "US",
    name: {
      en : "Wildman Lake Arpt"
    }
  },
  EWN : {
    lat: "35.0736",
    lon: "-77.0425",
    country: "US",
    name: {
      en : "Simmons Nott"
    }
  },
  EWR : {
    lat: "40.6958",
    lon: "-74.1717",
    country: "US",
    city: "NYC",
    popularity: 17,
    name: {
      en : "Newark Liberty"
    }
  },
  EXI : {
    lat: "58.4208",
    lon: "-135.447",
    country: "US",
    name: {
      en : "Excursion Inlet"
    }
  },
  EXT : {
    lat: "50.7342",
    lon: "-3.42167",
    country: "GB",
    name: {
      en : "Exeter"
    }
  },
  EYA : {
    lat: "53.689722",
    lon: "127.092222",
    country: "RU",
    name: {
      en : "Zeya Airport"
    }
  },
  EYK : {
    lat: "63.6833",
    lon: "66.6833",
    country: "RU",
    name: {
      en : "Beloyarsky"
    }
  },
  EYP : {
    country: "CO",
    name: {
      en : "El Yopal Arpt"
    }
  },
  EYW : {
    lat: "24.5561",
    lon: "-81.7597",
    country: "US",
    name: {
      en : "Key West"
    }
  },
  EZE : {
    lat: "-34.82",
    lon: "-58.5339",
    country: "AR",
    city: "BUE",
    name: {
      en : "Ministro Pistarini"
    }
  },
  EZS : {
    lat: "38.6083",
    lon: "39.2917",
    country: "TR",
    name: {
      en : "Elazig"
    }
  },
  EZV : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Beryozovo"
    }
  },
  FAC : {
    country: "PF",
    name: {
      en : "FAC"
    }
  },
  FAE : {
    lat: "62.0667",
    lon: "-7.26667",
    country: "DK",
    name: {
      en : "Faeroe"
    }
  },
  FAH : {
    country: "AF",
    name: {
      en : "FAH"
    }
  },
  FAI : {
    lat: "64.8144",
    lon: "-147.863",
    country: "US",
    name: {
      en : "Fairbanks"
    }
  },
  FAO : {
    lat: "37.0144",
    lon: "-7.97083",
    country: "PT",
    popularity: 69,
    name: {
      en : "Faro"
    }
  },
  FAR : {
    lat: "46.9156",
    lon: "-96.8147",
    country: "US",
    name: {
      en : "Hector"
    }
  },
  FAT : {
    lat: "36.7711",
    lon: "-119.714",
    country: "US",
    name: {
      en : "Fresno Air Terminal"
    }
  },
  FAV : {
    country: "PF",
    name: {
      en : "FAV"
    }
  },
  FAY : {
    lat: "34.9894",
    lon: "-78.8811",
    country: "US",
    name: {
      en : "Fayetteville"
    }
  },
  FBD : {
    country: "AF",
    name: {
      en : "Faizabad Arpt"
    }
  },
  FBM : {
    lat: "-11.5908",
    lon: "27.5292",
    country: "CD",
    name: {
      en : "Luano"
    }
  },
  FBS : {
    country: "US",
    name: {
      en : "FBS"
    }
  },
  FBU : {
    country: "NO",
    city: "OSL",
    name: {
      en : "Fornebu"
    }
  },
  FCA : {
    lat: "48.3128",
    lon: "-114.251",
    country: "US",
    name: {
      en : "Glacier Park"
    }
  },
  FCO : {
    lat: "41.8003",
    lon: "12.2389",
    country: "IT",
    city: "ROM",
    popularity: 9,
    name: {
      en : "Fiumicino"
    }
  },
  FDE : {
    lat: "61.4592",
    lon: "5.8475",
    country: "NO",
    name: {
      en : "Bringeland"
    }
  },
  FDF : {
    lat: "14.5897",
    lon: "-61.0061",
    country: "MQ",
    name: {
      en : "Lamentin"
    }
  },
  FDH : {
    lat: "47.6672",
    lon: "9.5125",
    country: "DE",
    name: {
      en : "Friedrichshafen Lowenthal"
    }
  },
  FEG : {
    country: "UZ",
    name: {
      en : "FEG"
    }
  },
  FEN : {
    lat: "-3.85",
    lon: "-32.4167",
    country: "BR",
    name: {
      en : "Fernando De Noronha"
    }
  },
  FEZ : {
    lat: "33.9333",
    lon: "-4.96667",
    country: "MA",
    name: {
      en : "Fez"
    }
  },
  FFM : {
    lat: "46.2833",
    lon: "-96.0667",
    country: "US",
    name: {
      en : "Fergus Falls"
    }
  },
  FGI : {
    lat: "-13.8333",
    lon: "-171.733",
    country: "WS",
    city: "APW",
    name: {
      en : "Fagali"
    }
  },
  FGU : {
    country: "PF",
    name: {
      en : "FGU"
    }
  },
  FHU : {
    lat: "31.5889",
    lon: "-110.343",
    country: "US",
    name: {
      en : "Sierra Vista"
    }
  },
  FHZ : {
    country: "PF",
    name: {
      en : "FHZ"
    }
  },
  FIE : {
    country: "GB",
    name: {
      en : "Fair Isle Arpt"
    }
  },
  FIH : {
    lat: "-4.38333",
    lon: "15.4333",
    country: "CD",
    name: {
      en : "Kinshasa"
    }
  },
  FJR : {
    country: "AE",
    name: {
      en : "Fujairah Intl Arpt"
    }
  },
  FKB : {
    lat: "48.7792",
    lon: "8.08028",
    country: "DE",
    popularity: 1,
    name: {
      en : "Soellingen"
    }
  },
  FKI : {
    country: "CD",
    name: {
      en : "FKI"
    }
  },
  FKL : {
    lat: "41.3792",
    lon: "-79.8597",
    country: "US",
    popularity: 1,
    name: {
      en : "Chess Lamberton"
    }
  },
  FKQ : {
    country: "ID",
    name: {
      en : "FKQ"
    }
  },
  FKS : {
    lat: "37.2267",
    lon: "140.433",
    country: "JP",
    name: {
      en : "Fukushima"
    }
  },
  FLA : {
    country: "CO",
    name: {
      en : "FLA"
    }
  },
  FLG : {
    lat: "35.1378",
    lon: "-111.672",
    country: "US",
    city: "GCN",
    name: {
      en : "Flagstaff"
    }
  },
  FLL : {
    lat: "26.0742",
    lon: "-80.1517",
    country: "US",
    name: {
      en : "Ft Lauderdale Hollywood"
    }
  },
  FLN : {
    lat: "-27.6697",
    lon: "-48.5506",
    country: "BR",
    popularity: 2,
    name: {
      en : "Hercilio Luz"
    }
  },
  FLO : {
    lat: "34.1889",
    lon: "-79.7244",
    country: "US",
    name: {
      en : "Gilbert Field"
    }
  },
  FLR : {
    lat: "43.8103",
    lon: "11.1978",
    country: "IT",
    name: {
      en : "Peretola"
    }
  },
  FLS : {
    country: "AU",
    name: {
      en : "FLS"
    }
  },
  FLW : {
    lat: "39.4667",
    lon: "-31.15",
    country: "PT",
    popularity: 1,
    name: {
      en : "Aerodromo Das Flores"
    }
  },
  FMA : {
    lat: "-26.2128",
    lon: "-58.235",
    country: "AR",
    name: {
      en : "El Pucu"
    }
  },
  FMM : {
    lat: "0",
    lon: "0",
    country: "DE",
    city: "MUC",
    name: {
      en : "Memmingen"
    }
  },
  FMN : {
    lat: "36.7411",
    lon: "-108.229",
    country: "US",
    popularity: 1,
    name: {
      en : "Four Corners Regional"
    }
  },
  FMO : {
    lat: "52.1333",
    lon: "7.68333",
    country: "DE",
    name: {
      en : "Muenster"
    }
  },
  FMY : {
    lat: "26.5833",
    lon: "-81.8667",
    country: "US",
    name: {
      en : "Page Field"
    }
  },
  FNA : {
    lat: "8.6175",
    lon: "-13.1969",
    country: "SL",
    name: {
      en : "Lungi"
    }
  },
  FNC : {
    lat: "32.6942",
    lon: "-16.7781",
    country: "PT",
    popularity: 6,
    name: {
      en : "Madeira"
    }
  },
  FNI : {
    lat: "43.75",
    lon: "4.41667",
    country: "FR",
    name: {
      en : "Nimes"
    }
  },
  FNJ : {
    lat: "39.2",
    lon: "125.667",
    country: "KP",
    name: {
      en : "Sunan"
    }
  },
  FNL : {
    country: "US",
    name: {
      en : "Municipal Airport"
    }
  },
  FNT : {
    lat: "42.9667",
    lon: "-83.7417",
    country: "US",
    name: {
      en : "Bishop"
    }
  },
  FOA : {
    country: "GB",
    name: {
      en : "FOA"
    }
  },
  FOC : {
    lat: "26.1",
    lon: "119.283",
    country: "CN",
    name: {
      en : "Fuzhou"
    }
  },
  FOD : {
    lat: "42.5525",
    lon: "-94.1897",
    country: "US",
    name: {
      en : "Ft Dodge"
    }
  },
  FOE : {
    lat: "38.9525",
    lon: "-95.6625",
    country: "US",
    city: "TOP",
    name: {
      en : "Forbes Field"
    }
  },
  FOG : {
    lat: "41.4267",
    lon: "15.5394",
    country: "IT",
    name: {
      en : "Gino Lisa"
    }
  },
  FON : {
    country: "CR",
    name: {
      en : "Fortuna Arpt"
    }
  },
  FOR : {
    lat: "-3.77667",
    lon: "-38.5344",
    country: "BR",
    name: {
      en : "Pinto Martines"
    }
  },
  FPO : {
    lat: "26.5553",
    lon: "-78.7",
    country: "BS",
    name: {
      en : "Grand Bahama"
    }
  },
  FRA : {
    lat: "50.0389",
    lon: "8.57056",
    country: "DE",
    popularity: 188,
    name: {
      en : "Frankfurt"
    }
  },
  FRD : {
    lat: "48.5264",
    lon: "-123.024",
    country: "US",
    name: {
      en : "Friday Harbor"
    }
  },
  FRE : {
    country: "SB",
    name: {
      en : "FRE"
    }
  },
  FRG : {
    lat: "40.7333",
    lon: "-73.4167",
    country: "US",
    name: {
      en : "Republic"
    }
  },
  FRL : {
    lat: "44.1953",
    lon: "12.0686",
    country: "IT",
    name: {
      en : "Luigi Ridolfi"
    }
  },
  FRO : {
    lat: "61.5819",
    lon: "5.01444",
    country: "NO",
    name: {
      en : "Flora"
    }
  },
  FRS : {
    lat: "16.9167",
    lon: "-89.8833",
    country: "GT",
    name: {
      en : "Flores"
    }
  },
  FRU : {
    lat: "42.8333",
    lon: "74.5667",
    country: "KG",
    popularity: 10,
    name: {
      en : "Bishkek"
    }
  },
  FRW : {
    lat: "-21.16",
    lon: "27.4825",
    country: "BW",
    name: {
      en : "Francistown"
    }
  },
  FSC : {
    lat: "41.5",
    lon: "9.1",
    country: "FR",
    name: {
      en : "Sud Corse"
    }
  },
  FSD : {
    lat: "43.5789",
    lon: "-96.7408",
    country: "US",
    name: {
      en : "Joe Foss Field"
    }
  },
  FSM : {
    lat: "35.3361",
    lon: "-94.37",
    country: "US",
    name: {
      en : "Ft Smith"
    }
  },
  FSP : {
    lat: "46.9167",
    lon: "-56.1667",
    country: "CA",
    name: {
      en : "St Pierre"
    }
  },
  FSZ : {
    country: "JP",
    name: {
      en : "Mount Fuhji Shizuoka Arpt"
    }
  },
  FTA : {
    country: "VU",
    name: {
      en : "FTA"
    }
  },
  FTE : {
    lat: "-50.2803",
    lon: "-72.0533",
    country: "AR",
    name: {
      en : "El Calafate"
    }
  },
  FTU : {
    country: "MG",
    name: {
      en : "Marillac Arpt"
    }
  },
  FTY : {
    lat: "33.7833",
    lon: "-84.5167",
    country: "US",
    city: "ATL",
    name: {
      en : "Fulton Cty"
    }
  },
  FUE : {
    lat: "28.4772",
    lon: "-13.9876",
    country: "ES",
    name: {
      en : "Fuerteventura"
    }
  },
  FUG : {
    country: "CN",
    name: {
      en : "FUG"
    }
  },
  FUJ : {
    lat: "32.6667",
    lon: "128.833",
    country: "JP",
    name: {
      en : "Fukue"
    }
  },
  FUK : {
    lat: "33.5822",
    lon: "130.453",
    country: "JP",
    name: {
      en : "Fukuoka"
    }
  },
  FUN : {
    lat: "-8.51667",
    lon: "179.208",
    country: "TV",
    name: {
      en : "Funafuti"
    }
  },
  FUO : {
    country: "CN",
    name: {
      en : "Fuoshan Arpt"
    }
  },
  FUT : {
    country: "WF",
    name: {
      en : "FUT"
    }
  },
  FWA : {
    lat: "40.9783",
    lon: "-85.1881",
    country: "US",
    name: {
      en : "Baer Field"
    }
  },
  FXE : {
    lat: "26.0667",
    lon: "-80.15",
    country: "US",
    city: "FLL",
    name: {
      en : "Ft Lauderdale Excutive"
    }
  },
  FYG : {
    country: "CN",
    name: {
      en : "FYG"
    }
  },
  FYJ : {
    country: "CN",
    name: {
      en : "Fuyuan Dongji"
    }
  },
  FYU : {
    country: "US",
    name: {
      en : "FYU"
    }
  },
  FZL : {
    lat: "39°35′40″",
    lon: "47°11′45″",
    country: "AZ",
    name: {
      en : "Fuzuli"
    }
  },
  GAE : {
    country: "TN",
    name: {
      en : "GAE"
    }
  },
  GAF : {
    country: "TN",
    name: {
      en : "GAF"
    }
  },
  GAJ : {
    lat: "38.4",
    lon: "140.383",
    country: "JP",
    name: {
      en : "Yamagata"
    }
  },
  GAL : {
    lat: "64.7364",
    lon: "-156.932",
    country: "US",
    name: {
      en : "Galena"
    }
  },
  GAM : {
    country: "US",
    name: {
      en : "GAM"
    }
  },
  GAN : {
    country: "MV",
    name: {
      en : "Gan International Arpt"
    }
  },
  GAO : {
    country: "CU",
    name: {
      en : "Guantanamo Airport"
    }
  },
  GAU : {
    lat: "26.1042",
    lon: "91.5875",
    country: "IN",
    name: {
      en : "Borjhar"
    }
  },
  GAX : {
    country: "GA",
    name: {
      en : "GAX"
    }
  },
  GAY : {
    lat: "24.7467",
    lon: "84.9458",
    country: "IN",
    name: {
      en : "Gaya"
    }
  },
  GBB : {
    lat: "40.82116",
    lon: "47.719048",
    country: "AZ",
    city: "",
    name: {
      en : "Gabala"
    }
  },
  GBD : {
    lat: "38.3472",
    lon: "-98.8642",
    country: "US",
    name: {
      en : "Greate Bend"
    }
  },
  GBE : {
    lat: "-24.55",
    lon: "25.9167",
    country: "BW",
    name: {
      en : "Gaborone"
    }
  },
  GBT : {
    country: "IR",
    name: {
      en : "GBT"
    }
  },
  GCC : {
    lat: "44.3514",
    lon: "-105.525",
    country: "US",
    name: {
      en : "Campbell Cty"
    }
  },
  GCI : {
    lat: "49.4361",
    lon: "-2.60278",
    country: "GB",
    name: {
      en : "Guernsey"
    }
  },
  GCK : {
    lat: "37.9286",
    lon: "-100.73",
    country: "US",
    name: {
      en : "Garden City"
    }
  },
  GCM : {
    lat: "19.2925",
    lon: "-81.3581",
    country: "KY",
    name: {
      en : "Owen Roberts"
    }
  },
  GCN : {
    country: "US",
    name: {
      en : "Grand Canyon Natl Park Arpt"
    }
  },
  GCW : {
    lat: "0",
    lon: "0",
    country: "US",
    name: {
      en : "Grand Canyon West"
    }
  },
  GDE : {
    country: "ET",
    name: {
      en : "GDE"
    }
  },
  GDL : {
    lat: "20.5239",
    lon: "-103.313",
    country: "MX",
    name: {
      en : "Miguel Hidalgo"
    }
  },
  GDN : {
    lat: "54.3667",
    lon: "18.65",
    country: "PL",
    name: {
      en : "Rebiechowo"
    }
  },
  GDQ : {
    country: "ET",
    name: {
      en : "GDQ"
    }
  },
  GDT : {
    lat: "21.4667",
    lon: "-71.1333",
    country: "TC",
    name: {
      en : "Grand Turk Is"
    }
  },
  GDV : {
    country: "US",
    name: {
      en : "Dawson Community Arpt"
    }
  },
  GDX : {
    lat: "59.9167",
    lon: "150.717",
    country: "RU",
    name: {
      en : "Magadan"
    }
  },
  GDZ : {
    lat: "44.57",
    lon: "38.01",
    country: "RU",
    name: {
      en : "Gelendzik"
    }
  },
  GEA : {
    lat: "-22.2597",
    lon: "166.471",
    country: "NC",
    city: "NOU",
    name: {
      en : "Magenta"
    }
  },
  GEG : {
    lat: "47.6169",
    lon: "-117.537",
    country: "US",
    name: {
      en : "Spokane"
    }
  },
  GEL : {
    country: "BR",
    name: {
      en : "GEL"
    }
  },
  GEO : {
    lat: "6.5",
    lon: "-58.25",
    country: "GY",
    name: {
      en : "Cheddi Jagan"
    }
  },
  GER : {
    lat: "21.8375",
    lon: "-82.78",
    country: "CU",
    name: {
      en : "Rafael Cabrera"
    }
  },
  GES : {
    lat: "6.10944",
    lon: "125.235",
    country: "PH",
    name: {
      en : "Buayan"
    }
  },
  GET : {
    lat: "-28.7917",
    lon: "114.7",
    country: "AU",
    name: {
      en : "Geraldton"
    }
  },
  GEV : {
    lat: "67.1344",
    lon: "20.8167",
    country: "SE",
    name: {
      en : "Gallivare"
    }
  },
  GFF : {
    lat: "-34.2508",
    lon: "146.066",
    country: "AU",
    name: {
      en : "Griffith"
    }
  },
  GFK : {
    lat: "47.9519",
    lon: "-97.1786",
    country: "US",
    name: {
      en : "Grand Forks Mark Andrews"
    }
  },
  GFN : {
    lat: "-29.7558",
    lon: "153.034",
    country: "AU",
    name: {
      en : "Grafton"
    }
  },
  GGG : {
    lat: "32.3867",
    lon: "-94.7153",
    country: "US",
    name: {
      en : "Greg County"
    }
  },
  GGM : {
    country: "KE",
    name: {
      en : "GGM"
    }
  },
  GGT : {
    lat: "23.4681",
    lon: "-75.7825",
    country: "BS",
    name: {
      en : "George Town"
    }
  },
  GGW : {
    lat: "48.2128",
    lon: "-106.616",
    country: "US",
    name: {
      en : "International Glasgow"
    }
  },
  GHA : {
    lat: "32.3822",
    lon: "3.80056",
    country: "DZ",
    name: {
      en : "Noumerate"
    }
  },
  GHB : {
    lat: "25.2839",
    lon: "-76.3308",
    country: "BS",
    name: {
      en : "Governors Harbour"
    }
  },
  GHT : {
    country: "LY",
    name: {
      en : "GHT"
    }
  },
  GHV : {
    lat: "45.69452394654023",
    lon: "25.51747097522291",
    country: "RO",
    city: "XHV",
    name: {
      en : "Brasov"
    }
  },
  GIB : {
    lat: "36.15",
    lon: "-5.34722",
    country: "GI",
    name: {
      en : "North Front"
    }
  },
  GIC : {
    lat: "-9.23333",
    lon: "142.217",
    country: "AU",
    name: {
      en : "Boigu Island"
    }
  },
  GIG : {
    lat: "-22.9",
    lon: "-43.2556",
    country: "BR",
    city: "RIO",
    name: {
      en : "Rio Internacional"
    }
  },
  GIL : {
    lat: "35.9192",
    lon: "74.3358",
    country: "PK",
    name: {
      en : "Gilgit"
    }
  },
  GIS : {
    lat: "-38.6597",
    lon: "177.972",
    country: "NZ",
    name: {
      en : "Gisborne"
    }
  },
  GIZ : {
    lat: "16.8667",
    lon: "42.5833",
    country: "SA",
    name: {
      en : "Gizan Aprt"
    }
  },
  GJA : {
    country: "HN",
    name: {
      en : "GJA"
    }
  },
  GJL : {
    country: "DZ",
    name: {
      en : "GJL"
    }
  },
  GJT : {
    lat: "39.1225",
    lon: "-108.527",
    country: "US",
    name: {
      en : "Walker Field"
    }
  },
  GKA : {
    lat: "-6.07917",
    lon: "145.398",
    country: "PG",
    name: {
      en : "Goroka"
    }
  },
  GLA : {
    lat: "55.8667",
    lon: "-4.43333",
    country: "GB",
    popularity: 22,
    name: {
      en : "Glasgow"
    }
  },
  GLF : {
    country: "CR",
    name: {
      en : "GLF"
    }
  },
  GLH : {
    lat: "33.4844",
    lon: "-90.985",
    country: "US",
    name: {
      en : "Greenville"
    }
  },
  GLK : {
    country: "SO",
    name: {
      en : "GLK"
    }
  },
  GLN : {
    country: "MA",
    name: {
      en : "GLN"
    }
  },
  GLO : {
    lat: "51.8833",
    lon: "-2.23333",
    country: "GB",
    name: {
      en : "Staverton"
    }
  },
  GLR : {
    lat: "45.0333",
    lon: "-84.6667",
    country: "US",
    name: {
      en : "Otsego"
    }
  },
  GLT : {
    lat: "-23.8333",
    lon: "151.254",
    country: "AU",
    name: {
      en : "Gladstone"
    }
  },
  GLV : {
    country: "US",
    name: {
      en : "GLV"
    }
  },
  GMA : {
    country: "CD",
    name: {
      en : "GMA"
    }
  },
  GMB : {
    country: "ET",
    name: {
      en : "Gambela Airport"
    }
  },
  GMO : {
    country: "NG",
    name: {
      en : "GMO"
    }
  },
  GMP : {
    lat: "37.5511",
    lon: "126.785",
    country: "KR",
    city: "SEL",
    name: {
      en : "Gimpo"
    }
  },
  GMR : {
    country: "PF",
    name: {
      en : "Gambier Island Arpt"
    }
  },
  GMZ : {
    lat: "28.0167",
    lon: "-17.2",
    country: "ES",
    name: {
      en : "La Gomera"
    }
  },
  GNA : {
    country: "BY",
    name: {
      en : "Grodna Arpt"
    }
  },
  GNB : {
    lat: "45.3628",
    lon: "5.32972",
    country: "FR",
    city: "LYS",
    popularity: 8,
    name: {
      en : "Saint Geoirs"
    }
  },
  GND : {
    lat: "12.15",
    lon: "-61.6167",
    country: "GD",
    name: {
      en : "Port Saline"
    }
  },
  GNJ : {
    lat: "40.74",
    lon: "46.32",
    country: "AZ",
    city: "KVD",
    name: {
      en : "Ganja"
    }
  },
  GNS : {
    country: "ID",
    name: {
      en : "Gunungsitoli Arpt"
    }
  },
  GNU : {
    country: "US",
    name: {
      en : "GNU"
    }
  },
  GNV : {
    lat: "29.6897",
    lon: "-82.2758",
    country: "US",
    name: {
      en : "Gainesville Regional"
    }
  },
  GNY : {
    lat: "40.1665",
    lon: "-105.922",
    country: "TR",
    name: {
      en : "Guney Anadolu"
    }
  },
  GOA : {
    lat: "44.4131",
    lon: "8.83778",
    country: "IT",
    name: {
      en : "Christoforo Colombo"
    }
  },
  GOH : {
    lat: "64.1819",
    lon: "-51.725",
    country: "GL",
    name: {
      en : "Nuuk"
    }
  },
  GOI : {
    lat: "15.3833",
    lon: "73.8333",
    country: "IN",
    popularity: 34,
    name: {
      en : "Dabolim"
    }
  },
  GOJ : {
    lat: "56",
    lon: "44",
    country: "RU",
    popularity: 21,
    name: {
      en : "Nizhniy Novgorod"
    }
  },
  GOM : {
    country: "CD",
    name: {
      en : "GOM"
    }
  },
  GOP : {
    country: "IN",
    name: {
      en : "Gorakhpur Arpt"
    }
  },
  GOQ : {
    country: "CN",
    name: {
      en : "GOQ"
    }
  },
  GOT : {
    lat: "57.6667",
    lon: "12.2833",
    country: "SE",
    name: {
      en : "Landvetter"
    }
  },
  GOV : {
    lat: "-12.2817",
    lon: "136.822",
    country: "AU",
    name: {
      en : "Nhulunbuy"
    }
  },
  GOX : {
    lat: "15.3833",
    lon: "73.8333",
    country: "IN",
    city: "GOI",
    name: {
      en : "Manohar International Airport"
    }
  },
  GOY : {
    lat: "100.432385",
    lon: "64.333864",
    country: "RU",
    name: {
      en : "Gornij"
    }
  },
  GPA : {
    country: "GR",
    name: {
      en : "Araxos Arpt"
    }
  },
  GPB : {
    country: "BR",
    name: {
      en : "GPB"
    }
  },
  GPI : {
    country: "CO",
    name: {
      en : "Guapi Arpt"
    }
  },
  GPS : {
    lat: "-0.434722",
    lon: "-90.2828",
    country: "EC",
    name: {
      en : "Baltra"
    }
  },
  GPT : {
    lat: "30.4061",
    lon: "-89.0703",
    country: "US",
    name: {
      en : "Biloxi Regional"
    }
  },
  GPZ : {
    lat: "47.2144",
    lon: "-93.5111",
    country: "US",
    name: {
      en : "Itasca County"
    }
  },
  GRB : {
    lat: "44.4881",
    lon: "-88.1306",
    country: "US",
    name: {
      en : "Austin Straubel Fld"
    }
  },
  GRI : {
    lat: "40.9672",
    lon: "-98.3067",
    country: "US",
    name: {
      en : "Hall Cty Regional"
    }
  },
  GRJ : {
    lat: "-33.9675",
    lon: "22.4211",
    country: "ZA",
    name: {
      en : "George"
    }
  },
  GRK : {
    lat: "31.0673",
    lon: "-97.8289",
    country: "US",
    city: "ILE",
    name: {
      en : "Gray AAF"
    }
  },
  GRO : {
    lat: "41.9092",
    lon: "2.76333",
    country: "ES",
    name: {
      en : "Costa Brava"
    }
  },
  GRQ : {
    lat: "53.1203",
    lon: "6.57556",
    country: "NL",
    name: {
      en : "Eelde"
    }
  },
  GRR : {
    lat: "42.8811",
    lon: "-85.5242",
    country: "US",
    name: {
      en : "Kent County"
    }
  },
  GRU : {
    lat: "-23.4333",
    lon: "-46.4833",
    country: "BR",
    city: "SAO",
    name: {
      en : "Guarulhos"
    }
  },
  GRV : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Grozny"
    }
  },
  GRW : {
    lat: "39.05",
    lon: "-28.05",
    country: "PT",
    name: {
      en : "Graciosa"
    }
  },
  GRX : {
    lat: "37.1878",
    lon: "-3.78056",
    country: "ES",
    name: {
      en : "Granada"
    }
  },
  GRZ : {
    lat: "46.9933",
    lon: "15.44",
    country: "AT",
    name: {
      en : "Thalerhof"
    }
  },
  GSE : {
    lat: "57.7683",
    lon: "11.8678",
    country: "SE",
    city: "GOT",
    name: {
      en : "Saeve"
    }
  },
  GSM : {
    country: "IR",
    name: {
      en : "GSM"
    }
  },
  GSO : {
    lat: "36.0919",
    lon: "-79.9428",
    country: "US",
    name: {
      en : "Piedmont Triad"
    }
  },
  GSP : {
    lat: "34.905",
    lon: "-82.21",
    country: "US",
    name: {
      en : "Greenville Spartanburg"
    }
  },
  GST : {
    lat: "58.4275",
    lon: "-135.705",
    country: "US",
    name: {
      en : "Gustavus"
    }
  },
  GSV : {
    lat: "51.73",
    lon: "46.13",
    country: "RU",
    city: "RTW",
    name: {
      en : "Gagarin"
    }
  },
  GTA : {
    country: "SB",
    name: {
      en : "GTA"
    }
  },
  GTE : {
    country: "AU",
    name: {
      en : "Alyangula Arpt"
    }
  },
  GTF : {
    lat: "47.4856",
    lon: "-111.367",
    country: "US",
    name: {
      en : "Great Falls"
    }
  },
  GTO : {
    country: "ID",
    name: {
      en : "GTO"
    }
  },
  GTR : {
    lat: "33.45",
    lon: "-88.6",
    country: "US",
    city: "UBS",
    name: {
      en : "Golden"
    }
  },
  GTS : {
    country: "AU",
    name: {
      en : "GTS"
    }
  },
  GUA : {
    lat: "14.5819",
    lon: "-90.5275",
    country: "GT",
    name: {
      en : "La Aurora"
    }
  },
  GUC : {
    lat: "38.5339",
    lon: "-106.939",
    country: "US",
    name: {
      en : "Gunnison Cty"
    }
  },
  GUM : {
    lat: "13.48",
    lon: "144.791",
    country: "GU",
    name: {
      en : "Antonio B Won Pat"
    }
  },
  GUR : {
    lat: "-10.3108",
    lon: "150.339",
    country: "PG",
    name: {
      en : "Gurney"
    }
  },
  GUW : {
    lat: "47.1167",
    lon: "51.9",
    country: "KZ",
    name: {
      en : "Atyrau"
    }
  },
  GVA : {
    lat: "46.2394",
    lon: "6.11028",
    country: "CH",
    popularity: 372,
    name: {
      en : "Geneve Cointrin"
    }
  },
  GVN : {
    country: "RU",
    name: {
      en : "Sovetskaya Gavan"
    }
  },
  GVR : {
    country: "BR",
    name: {
      en : "Governador Valadares Arpt"
    }
  },
  GWD : {
    country: "PK",
    name: {
      en : "GWD"
    }
  },
  GWL : {
    country: "IN",
    name: {
      en : "Gwalior Airport"
    }
  },
  GWT : {
    lat: "54.9153",
    lon: "8.34306",
    country: "DE",
    name: {
      en : "Westerland"
    }
  },
  GWY : {
    lat: "53.2833",
    lon: "-9.03333",
    country: "IE",
    name: {
      en : "Carnmore"
    }
  },
  GXF : {
    country: "YE",
    name: {
      en : "GXF"
    }
  },
  GYA : {
    country: "BO",
    name: {
      en : "GYA"
    }
  },
  GYD : {
    lat: "40.5",
    lon: "49.9833",
    country: "AZ",
    city: "BAK",
    popularity: 1,
    name: {
      en : "Heydar Aliyev"
    }
  },
  GYE : {
    lat: "-2.15444",
    lon: "-79.8756",
    country: "EC",
    name: {
      en : "José Joaquín de Olmedo"
    }
  },
  GYI : {
    lat: "-1.68333",
    lon: "29.25",
    country: "RW",
    name: {
      en : "Gisenyi"
    }
  },
  GYL : {
    country: "AU",
    name: {
      en : "GYL"
    }
  },
  GYM : {
    lat: "27.9556",
    lon: "-110.931",
    country: "MX",
    name: {
      en : "Gen Jose M Yanez"
    }
  },
  GYN : {
    lat: "-16.6383",
    lon: "-49.2108",
    country: "BR",
    name: {
      en : "Santa Genoveva"
    }
  },
  GYS : {
    country: "CN",
    name: {
      en : "Guang Yuan Arpt"
    }
  },
  GYU : {
    country: "CN",
    name: {
      en : "Guyuan Liupanshan"
    }
  },
  GZO : {
    lat: "-8.11667",
    lon: "156.833",
    country: "SB",
    name: {
      en : "Gizo"
    }
  },
  GZP : {
    lat: "36.3",
    lon: "32.3",
    country: "TR",
    popularity: 12000,
    name: {
      en : "Gazipasa"
    }
  },
  GZT : {
    lat: "37.0667",
    lon: "37.3333",
    country: "TR",
    name: {
      en : "Gaziantep"
    }
  },
  HAA : {
    country: "NO",
    name: {
      en : "HAA"
    }
  },
  HAC : {
    lat: "33.1133",
    lon: "139.791",
    country: "JP",
    name: {
      en : "Hachijo Jima"
    }
  },
  HAD : {
    lat: "56.6833",
    lon: "12.8194",
    country: "SE",
    name: {
      en : "Halmstad"
    }
  },
  HAE : {
    country: "US",
    name: {
      en : "HAVASUPAI ARPT"
    }
  },
  HAH : {
    lat: "-11.5333",
    lon: "43.2667",
    country: "KM",
    city: "YVA",
    name: {
      en : "Prince Said Ibrahim In"
    }
  },
  HAJ : {
    lat: "52.4617",
    lon: "9.68472",
    country: "DE",
    popularity: 4,
    name: {
      en : "Hanover"
    }
  },
  HAK : {
    lat: "20.1",
    lon: "110.35",
    country: "CN",
    name: {
      en : "Haikou"
    }
  },
  HAM : {
    lat: "53.6339",
    lon: "9.995",
    country: "DE",
    popularity: 27,
    name: {
      en : "Fuhlsbuettel"
    }
  },
  HAN : {
    lat: "21.0358",
    lon: "105.89",
    country: "VN",
    popularity: 11,
    name: {
      en : "Noibai"
    }
  },
  HAQ : {
    country: "MV",
    name: {
      en : "HAQ"
    }
  },
  HAS : {
    lat: "27.55",
    lon: "41.3833",
    country: "SA",
    name: {
      en : "Hail"
    }
  },
  HAU : {
    lat: "59.4056",
    lon: "5.27917",
    country: "NO",
    name: {
      en : "Karmoy"
    }
  },
  HAV : {
    lat: "22.9894",
    lon: "-82.4075",
    country: "CU",
    popularity: 106,
    name: {
      en : "Jose Marti"
    }
  },
  HBA : {
    lat: "-42.8333",
    lon: "147.483",
    country: "AU",
    name: {
      en : "Hobart"
    }
  },
  HBE : {
    lat: "30.9",
    lon: "29.6833",
    country: "EG",
    city: "ALY",
    name: {
      en : "Borg El Arab"
    }
  },
  HBT : {
    lat: "27.8944",
    lon: "45.5264",
    country: "SA",
    name: {
      en : "Hafr Albatin"
    }
  },
  HBX : {
    country: "IN",
    name: {
      en : "Hubli Arpt"
    }
  },
  HBZ : {
    country: "DE",
    name: {
      en : "HBZ"
    }
  },
  HCN : {
    lat: "21.9333",
    lon: "120.833",
    country: "TW",
    name: {
      en : "Hengchun"
    }
  },
  HCR : {
    country: "US",
    name: {
      en : "HCR"
    }
  },
  HDD : {
    lat: "25.3222",
    lon: "68.3639",
    country: "PK",
    name: {
      en : "Hyderabad"
    }
  },
  HDF : {
    country: "DE",
    name: {
      en : "Heringsdorf Arpt"
    }
  },
  HDG : {
    country: "CN",
    name: {
      en : "HDG"
    }
  },
  HDM : {
    country: "IR",
    name: {
      en : "HDM"
    }
  },
  HDN : {
    lat: "40.4833",
    lon: "-107.217",
    country: "US",
    name: {
      en : "Hayden"
    }
  },
  HDS : {
    country: "ZA",
    name: {
      en : "Hoedspruit Arpt"
    }
  },
  HDY : {
    lat: "6.93333",
    lon: "100.417",
    country: "TH",
    name: {
      en : "Hat Yai"
    }
  },
  HEA : {
    country: "AF",
    name: {
      en : "Herat Arpt"
    }
  },
  HEH : {
    lat: "20.7439",
    lon: "96.7944",
    country: "MM",
    name: {
      en : "Heho"
    }
  },
  HEK : {
    country: "CN",
    name: {
      en : "HEK"
    }
  },
  HEL : {
    lat: "60.3256",
    lon: "24.9717",
    country: "FI",
    popularity: 184,
    name: {
      en : "Helsinki"
    }
  },
  HER : {
    lat: "35.3403",
    lon: "25.1833",
    country: "GR",
    popularity: 7,
    name: {
      en : "N Kazantzakis"
    }
  },
  HET : {
    lat: "40.8533",
    lon: "111.822",
    country: "CN",
    name: {
      en : "Hohhot"
    }
  },
  HFA : {
    lat: "32.8111",
    lon: "35.0417",
    country: "IL",
    popularity: 6,
    name: {
      en : "Haifa"
    }
  },
  HFD : {
    lat: "41.7331",
    lon: "-72.65",
    country: "US",
    name: {
      en : "Brainard"
    }
  },
  HFE : {
    lat: "31.85",
    lon: "117.283",
    country: "CN",
    name: {
      en : "Hefei"
    }
  },
  HFS : {
    country: "SE",
    name: {
      en : "HFS"
    }
  },
  HFT : {
    lat: "70.6794",
    lon: "23.6683",
    country: "NO",
    name: {
      en : "Hammerfest"
    }
  },
  HGA : {
    country: "SO",
    name: {
      en : "Hargeisa Arpt"
    }
  },
  HGD : {
    lat: "-20.8189",
    lon: "144.224",
    country: "AU",
    name: {
      en : "Hughenden"
    }
  },
  HGH : {
    lat: "30.3333",
    lon: "120.233",
    country: "CN",
    name: {
      en : "Hangzhou"
    }
  },
  HGL : {
    country: "DE",
    name: {
      en : "Helgoland Arpt"
    }
  },
  HGN : {
    lat: "19.2989",
    lon: "97.9764",
    country: "TH",
    name: {
      en : "Mae Hong Son"
    }
  },
  HGO : {
    country: "CI",
    name: {
      en : "HGO"
    }
  },
  HGR : {
    country: "US",
    name: {
      en : "Washington Cty Regional"
    }
  },
  HGU : {
    lat: "-5.82722",
    lon: "144.295",
    country: "PG",
    name: {
      en : "Kagamuga"
    }
  },
  HHH : {
    lat: "32.2167",
    lon: "-80.6833",
    country: "US",
    name: {
      en : "Hilton Head"
    }
  },
  HHN : {
    lat: "49.95",
    lon: "7.26667",
    country: "DE",
    city: "FRA",
    name: {
      en : "Hahn"
    }
  },
  HHQ : {
    lat: "12.6306",
    lon: "99.9544",
    country: "TH",
    name: {
      en : "Hua Hin"
    }
  },
  HHZ : {
    country: "PF",
    name: {
      en : "HHZ"
    }
  },
  HIA : {
    country: "CN",
    name: {
      en : "HIA"
    }
  },
  HIB : {
    lat: "47.3886",
    lon: "-92.8386",
    country: "US",
    name: {
      en : "Hibbing Chisolm"
    }
  },
  HID : {
    lat: "-10.5833",
    lon: "142.283",
    country: "AU",
    name: {
      en : "Horn Island"
    }
  },
  HII : {
    lat: "34.5683",
    lon: "-114.355",
    country: "US",
    name: {
      en : "Lake Havasu City Airport"
    }
  },
  HIJ : {
    lat: "34.4328",
    lon: "132.925",
    country: "JP",
    name: {
      en : "Hiroshima"
    }
  },
  HIL : {
    country: "ET",
    name: {
      en : "HIL"
    }
  },
  HIN : {
    lat: "35.0881",
    lon: "128.078",
    country: "KR",
    name: {
      en : "Sacheon"
    }
  },
  HIR : {
    lat: "-9.42528",
    lon: "160.046",
    country: "SB",
    name: {
      en : "Henderson"
    }
  },
  HIS : {
    country: "AU",
    name: {
      en : "Hayman Island Arpt"
    }
  },
  HJJ : {
    country: "CN",
    name: {
      en : "HJJ"
    }
  },
  HJR : {
    lat: "24.8242",
    lon: "79.9228",
    country: "IN",
    name: {
      en : "Khajuraho"
    }
  },
  HKB : {
    lat: "63.8667",
    lon: "-148.967",
    country: "US",
    name: {
      en : "Healy Lake"
    }
  },
  HKD : {
    lat: "41.7689",
    lon: "140.82",
    country: "JP",
    name: {
      en : "Hakodate"
    }
  },
  HKG : {
    lat: "22.3167",
    lon: "113.917",
    country: "CN",
    popularity: 48,
    name: {
      en : "Hong Kong"
    }
  },
  HKK : {
    lat: "-42.7161",
    lon: "170.987",
    country: "NZ",
    name: {
      en : "Hokitika"
    }
  },
  HKN : {
    lat: "-5.47528",
    lon: "150.417",
    country: "PG",
    name: {
      en : "Hoskins"
    }
  },
  HKT : {
    lat: "8.11056",
    lon: "98.3125",
    country: "TH",
    popularity: 9,
    name: {
      en : "Phuket Intl"
    }
  },
  HLA : {
    lat: "-26.0833",
    lon: "27.5833",
    country: "ZA",
    city: "JNB",
    name: {
      en : "Lanseria"
    }
  },
  HLD : {
    lat: "49.2",
    lon: "119.7",
    country: "CN",
    name: {
      en : "Hailer"
    }
  },
  HLE : {
    country: "GB",
    name: {
      en : "Saint Helena Airport"
    }
  },
  HLH : {
    country: "CN",
    name: {
      en : "HLH"
    }
  },
  HLN : {
    lat: "46.6067",
    lon: "-111.982",
    country: "US",
    name: {
      en : "Helena"
    }
  },
  HLP : {
    country: "ID",
    city: "JKT",
    name: {
      en : "Halim Perdana Kusuma Arpt"
    }
  },
  HLZ : {
    lat: "-37.8611",
    lon: "175.333",
    country: "NZ",
    name: {
      en : "Hamilton"
    }
  },
  HMA : {
    lat: "61.0186",
    lon: "69.0839",
    country: "RU",
    name: {
      en : "Khanty Mansiysk"
    }
  },
  HMB : {
    country: "EG",
    name: {
      en : "HMB"
    }
  },
  HME : {
    lat: "31.6739",
    lon: "6.14278",
    country: "DZ",
    name: {
      en : "Oued Irara"
    }
  },
  HMI : {
    country: "CN",
    name: {
      en : "Hami Airport"
    }
  },
  HMO : {
    lat: "29.0964",
    lon: "-111.046",
    country: "MX",
    popularity: 3,
    name: {
      en : "Gen Ignacio Pesqueira Garcia"
    }
  },
  HMV : {
    lat: "65.7278",
    lon: "15.2731",
    country: "SE",
    name: {
      en : "Hemavan Flyg"
    }
  },
  HNA : {
    lat: "39.7333",
    lon: "141.117",
    country: "JP",
    name: {
      en : "Hanamaki"
    }
  },
  HND : {
    lat: "35.5536",
    lon: "139.766",
    country: "JP",
    city: "TYO",
    name: {
      en : "Haneda"
    }
  },
  HNH : {
    lat: "58.0981",
    lon: "-135.403",
    country: "US",
    name: {
      en : "Hoonah"
    }
  },
  HNL : {
    lat: "21.3258",
    lon: "-157.922",
    country: "US",
    popularity: 21,
    name: {
      en : "Honolulu"
    }
  },
  HNM : {
    lat: "20.7958",
    lon: "-156.019",
    country: "US",
    name: {
      en : "Hana"
    }
  },
  HNS : {
    lat: "59.2458",
    lon: "-135.519",
    country: "US",
    name: {
      en : "Haines"
    }
  },
  HOB : {
    lat: "32.6886",
    lon: "-103.217",
    country: "US",
    name: {
      en : "Lea County"
    }
  },
  HOD : {
    lat: "14.7472",
    lon: "42.9828",
    country: "YE",
    name: {
      en : "Hodeidah"
    }
  },
  HOE : {
    country: "LA",
    name: {
      en : "HOE"
    }
  },
  HOF : {
    lat: "25.5",
    lon: "49.8333",
    country: "SA",
    name: {
      en : "Alahsa"
    }
  },
  HOG : {
    lat: "20.7853",
    lon: "-76.315",
    country: "CU",
    popularity: 2,
    name: {
      en : "Frank Pias"
    }
  },
  HOI : {
    country: "PF",
    name: {
      en : "Hao Island Arpt"
    }
  },
  HOM : {
    lat: "59.6453",
    lon: "-151.476",
    country: "US",
    name: {
      en : "Homer"
    }
  },
  HON : {
    lat: "44.3836",
    lon: "-98.2264",
    country: "US",
    name: {
      en : "Huron"
    }
  },
  HOP : {
    lat: "36.8667",
    lon: "-87.4833",
    country: "US",
    name: {
      en : "Hopkinsville Christian Country"
    }
  },
  HOQ : {
    lat: "50.2892",
    lon: "11.8622",
    country: "DE",
    name: {
      en : "Hof Pirk"
    }
  },
  HOR : {
    lat: "38.52",
    lon: "-28.7172",
    country: "PT",
    name: {
      en : "Horta"
    }
  },
  HOT : {
    country: "US",
    name: {
      en : "Memorial Field"
    }
  },
  HOU : {
    lat: "29.645",
    lon: "-95.2786",
    country: "US",
    popularity: 61,
    name: {
      en : "Houston Hobby"
    }
  },
  HOV : {
    lat: "62.1833",
    lon: "6.15",
    country: "NO",
    name: {
      en : "Hovden"
    }
  },
  HPA : {
    lat: "-19.8167",
    lon: "-174.333",
    country: "TO",
    name: {
      en : "Salote Pilolevu"
    }
  },
  HPB : {
    country: "US",
    name: {
      en : "HPB"
    }
  },
  HPH : {
    lat: "20.8167",
    lon: "106.567",
    country: "VN",
    name: {
      en : "Cat Bi"
    }
  },
  HPN : {
    lat: "41.0689",
    lon: "-73.7078",
    country: "US",
    name: {
      en : "Westchester County"
    }
  },
  HRB : {
    lat: "45.75",
    lon: "126.667",
    country: "CN",
    name: {
      en : "Harbin"
    }
  },
  HRE : {
    lat: "-17.9228",
    lon: "31.1014",
    country: "ZW",
    name: {
      en : "Harare"
    }
  },
  HRG : {
    lat: "27.2",
    lon: "33.8667",
    country: "EG",
    popularity: 26,
    name: {
      en : "Hurghada"
    }
  },
  HRI : {
    lat: "6.283889",
    lon: "81.123886",
    country: "LK",
    name: {
      en : "Hambantota Mattala Rajapaksa"
    }
  },
  HRK : {
    lat: "49.9333",
    lon: "36.2833",
    country: "UA",
    popularity: 5,
    name: {
      en : "Kharkov"
    }
  },
  HRL : {
    lat: "26.2333",
    lon: "-97.65",
    country: "US",
    name: {
      en : "Rio Grande Valley"
    }
  },
  HRO : {
    lat: "36.2617",
    lon: "-93.1556",
    country: "US",
    name: {
      en : "Boone County"
    }
  },
  HSA : {
    country: "KZ",
    name: {
      en : "Hazret Sultan"
    }
  },
  HSG : {
    lat: "33.1464",
    lon: "130.304",
    country: "JP",
    name: {
      en : "Saga"
    }
  },
  HSL : {
    lat: "65.7025",
    lon: "-156.375",
    country: "US",
    name: {
      en : "Huslia"
    }
  },
  HSN : {
    lat: "28.0833",
    lon: "122.367",
    country: "CN",
    name: {
      en : "Zhoushan"
    }
  },
  HSV : {
    lat: "34.6428",
    lon: "-86.7756",
    country: "US",
    name: {
      en : "Huntsville"
    }
  },
  HTA : {
    lat: "52.0333",
    lon: "113.3",
    country: "RU",
    popularity: 3,
    name: {
      en : "Chita"
    }
  },
  HTI : {
    lat: "-20.35",
    lon: "148.967",
    country: "AU",
    name: {
      en : "Hamilton Island"
    }
  },
  HTN : {
    country: "CN",
    name: {
      en : "HTN"
    }
  },
  HTS : {
    lat: "38.3669",
    lon: "-82.5561",
    country: "US",
    name: {
      en : "Tri State Milton"
    }
  },
  HTY : {
    lat: "0",
    lon: "0",
    country: "TR",
    name: {
      en : "Hatay"
    }
  },
  HUE : {
    country: "ET",
    name: {
      en : "HUE"
    }
  },
  HUH : {
    lat: "-16.7167",
    lon: "-151.05",
    country: "PF",
    name: {
      en : "Huahine"
    }
  },
  HUI : {
    lat: "16.3992",
    lon: "107.703",
    country: "VN",
    name: {
      en : "Phu Bai"
    }
  },
  HUN : {
    lat: "24.0222",
    lon: "121.613",
    country: "TW",
    popularity: 1,
    name: {
      en : "Hualien"
    }
  },
  HUQ : {
    country: "LY",
    name: {
      en : "HUQ"
    }
  },
  HUS : {
    lat: "66.0406",
    lon: "-154.263",
    country: "US",
    name: {
      en : "Hughes"
    }
  },
  HUU : {
    country: "PE",
    name: {
      en : "Huanuco Arpt"
    }
  },
  HUX : {
    lat: "15.7683",
    lon: "-96.2356",
    country: "MX",
    name: {
      en : "Bahia De Huatulco"
    }
  },
  HUY : {
    lat: "53.5833",
    lon: "-0.35",
    country: "GB",
    popularity: 2,
    name: {
      en : "Humberside"
    }
  },
  HUZ : {
    lat: "23.055126065525133",
    lon: "114.61039279518492",
    country: "CN",
    name: {
      en : "Huizhou"
    }
  },
  HVB : {
    lat: "-25",
    lon: "153",
    country: "AU",
    name: {
      en : "Hervey Bay"
    }
  },
  HVD : {
    country: "MN",
    name: {
      en : "HVD"
    }
  },
  HVG : {
    lat: "70.9833",
    lon: "25.8333",
    country: "NO",
    name: {
      en : "Valan"
    }
  },
  HVN : {
    lat: "41.2653",
    lon: "-72.8883",
    country: "US",
    name: {
      en : "Tweed New Haven"
    }
  },
  HVR : {
    lat: "48.5444",
    lon: "-109.761",
    country: "US",
    name: {
      en : "City County"
    }
  },
  HYA : {
    lat: "41.6658",
    lon: "-70.2806",
    country: "US",
    name: {
      en : "Barnstable Cty"
    }
  },
  HYD : {
    lat: "17.25",
    lon: "78.4167",
    country: "IN",
    name: {
      en : "Rajiv Gandhi International Airport"
    }
  },
  HYG : {
    country: "US",
    name: {
      en : "HYG"
    }
  },
  HYL : {
    country: "US",
    name: {
      en : "Sea Plane Base"
    }
  },
  HYN : {
    lat: "28.4167",
    lon: "122.367",
    country: "CN",
    name: {
      en : "Huangyan"
    }
  },
  HYS : {
    lat: "38.8461",
    lon: "-99.2742",
    country: "US",
    name: {
      en : "Hays"
    }
  },
  HZG : {
    country: "CN",
    name: {
      en : "HZG"
    }
  },
  HZH : {
    country: "CN",
    name: {
      en : "HZH"
    }
  },
  IAA : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Igarka"
    }
  },
  IAD : {
    lat: "38.95",
    lon: "-77.45",
    country: "US",
    city: "WAS",
    popularity: 17,
    name: {
      en : "Washington Dulles"
    }
  },
  IAG : {
    lat: "43.1",
    lon: "-78.95",
    country: "US",
    name: {
      en : "Niagara Falls"
    }
  },
  IAH : {
    lat: "29.9833",
    lon: "-95.34",
    country: "US",
    city: "HOU",
    popularity: 1,
    name: {
      en : "George Bush Intercontinental"
    }
  },
  IAM : {
    country: "DZ",
    name: {
      en : "IAM"
    }
  },
  IAN : {
    country: "US",
    name: {
      en : "IAN"
    }
  },
  IAO : {
    country: "PH",
    name: {
      en : "IAO"
    }
  },
  IAR : {
    lat: "57.560556",
    lon: "40.157500",
    country: "RU",
    popularity: 19,
    name: {
      en : "Tunoshna"
    }
  },
  IAS : {
    lat: "47.1833",
    lon: "27.6",
    country: "RO",
    name: {
      en : "Iasi"
    }
  },
  IBE : {
    country: "CO",
    name: {
      en : "Ibague Arpt"
    }
  },
  IBR : {
    country: "JP",
    name: {
      en : "IBR"
    }
  },
  IBZ : {
    lat: "38.8736",
    lon: "1.37278",
    country: "ES",
    popularity: 8,
    name: {
      en : "Ibiza"
    }
  },
  ICN : {
    lat: "37.425",
    lon: "126.375",
    country: "KR",
    city: "SEL",
    name: {
      en : "Incheon"
    }
  },
  ICT : {
    lat: "37.6525",
    lon: "-97.4283",
    country: "US",
    name: {
      en : "Mid Continent"
    }
  },
  IDA : {
    lat: "43.5161",
    lon: "-112.065",
    country: "US",
    name: {
      en : "Fanning Field"
    }
  },
  IDR : {
    lat: "22.7231",
    lon: "75.8056",
    country: "IN",
    name: {
      en : "Indore"
    }
  },
  IEG : {
    lat: "0",
    lon: "0",
    country: "PL",
    name: {
      en : "Zielona Gora"
    }
  },
  IEV : {
    lat: "50.4019",
    lon: "30.4508",
    country: "UA",
    popularity: 489,
    name: {
      en : "Zhulhany"
    }
  },
  IFJ : {
    lat: "66.0597",
    lon: "-23.1328",
    country: "IS",
    name: {
      en : "Isafjordur"
    }
  },
  IFN : {
    lat: "32.75",
    lon: "51.85",
    country: "IR",
    name: {
      en : "Isfahan"
    }
  },
  IFO : {
    lat: "48.8833",
    lon: "24.6833",
    country: "UA",
    name: {
      en : "Ivano Frankovsk"
    }
  },
  IFP : {
    lat: "35.1833",
    lon: "-114.583",
    country: "US",
    name: {
      en : "Laughlin Bullhead"
    }
  },
  IGA : {
    country: "BS",
    name: {
      en : "IGA"
    }
  },
  IGD : {
    country: "TR",
    name: {
      en : "Igdir Airport"
    }
  },
  IGG : {
    country: "US",
    name: {
      en : "IGG"
    }
  },
  IGM : {
    lat: "35.2567",
    lon: "-113.94",
    country: "US",
    name: {
      en : "Mohave County"
    }
  },
  IGR : {
    lat: "-25.7417",
    lon: "-54.4658",
    country: "AR",
    name: {
      en : "Iguazu"
    }
  },
  IGS : {
    country: "DE",
    name: {
      en : "IGS"
    }
  },
  IGT : {
    lat: "43.3193",
    lon: "45.013",
    country: "RU",
    name: {
      en : "Magas"
    }
  },
  IGU : {
    lat: "-25.6",
    lon: "-54.4833",
    country: "BR",
    name: {
      en : "Cataratas"
    }
  },
  IHR : {
    country: "IR",
    name: {
      en : "IHR"
    }
  },
  IIL : {
    country: "IR",
    name: {
      en : "IIL"
    }
  },
  IJK : {
    lat: "56.49",
    lon: "53.27",
    country: "RU",
    name: {
      en : "Izhevsk"
    }
  },
  IKA : {
    lat: "35.4097",
    lon: "51.1508",
    country: "IR",
    city: "THR",
    name: {
      en : "Imam Khomeini"
    }
  },
  IKI : {
    country: "JP",
    name: {
      en : "IKI"
    }
  },
  IKO : {
    country: "US",
    name: {
      en : "Nikolski Afs"
    }
  },
  IKS : {
    country: "RU",
    name: {
      en : "IKS"
    }
  },
  IKT : {
    lat: "52.2667",
    lon: "104.417",
    country: "RU",
    popularity: 9,
    name: {
      en : "Irkutsk"
    }
  },
  IKU : {
    lat: "42.58",
    lon: "76.71",
    country: "KG",
    popularity: 3,
    name: {
      en : "Issyk-Kul"
    }
  },
  ILD : {
    lat: "0",
    lon: "0",
    country: "ES",
    name: {
      en : "Lleida–Alguaire"
    }
  },
  ILF : {
    country: "CA",
    name: {
      en : "Ilford Rail Station"
    }
  },
  ILG : {
    lat: "39.6783",
    lon: "-75.6075",
    country: "US",
    name: {
      en : "Greater Wilmington New Castle"
    }
  },
  ILI : {
    country: "US",
    name: {
      en : "ILI"
    }
  },
  ILM : {
    lat: "34.2669",
    lon: "-77.9039",
    country: "US",
    name: {
      en : "New Hanover Cty"
    }
  },
  ILO : {
    lat: "10.7144",
    lon: "122.544",
    country: "PH",
    name: {
      en : "Mandurriao"
    }
  },
  ILP : {
    lat: "-22.5897",
    lon: "167.447",
    country: "NC",
    name: {
      en : "Ile Des Pins"
    }
  },
  ILY : {
    lat: "55.6819",
    lon: "-6.25417",
    country: "GB",
    name: {
      en : "Islay"
    }
  },
  ILZ : {
    lat: "49.2333",
    lon: "18.7667",
    country: "SK",
    name: {
      en : "Zilina"
    }
  },
  IMF : {
    country: "IN",
    name: {
      en : "Tulihal Arpt"
    }
  },
  IMK : {
    country: "NP",
    name: {
      en : "IMK"
    }
  },
  IMP : {
    lat: "-5.53194",
    lon: "-47.4806",
    country: "BR",
    name: {
      en : "Imperatriz"
    }
  },
  IMT : {
    lat: "45.8156",
    lon: "-88.1142",
    country: "US",
    name: {
      en : "Ford"
    }
  },
  INC : {
    lat: "38.35",
    lon: "106.35",
    country: "CN",
    name: {
      en : "Yinchuan"
    }
  },
  IND : {
    lat: "39.7289",
    lon: "-86.2817",
    country: "US",
    popularity: 1,
    name: {
      en : "Indianapolis"
    }
  },
  INH : {
    country: "MZ",
    name: {
      en : "INH"
    }
  },
  INI : {
    lat: "43.3339",
    lon: "21.8517",
    country: "RS",
    name: {
      en : "Nis"
    }
  },
  INL : {
    lat: "48.5631",
    lon: "-93.4042",
    country: "US",
    name: {
      en : "Intl Falls"
    }
  },
  INN : {
    lat: "47.2608",
    lon: "11.3472",
    country: "AT",
    popularity: 5,
    name: {
      en : "Kranebitten"
    }
  },
  INT : {
    lat: "36.1353",
    lon: "-80.2256",
    country: "US",
    name: {
      en : "Smith Reynolds"
    }
  },
  INU : {
    lat: "-0.533333",
    lon: "166.917",
    country: "NR",
    name: {
      en : "Nauru"
    }
  },
  INV : {
    lat: "57.5425",
    lon: "-4.04833",
    country: "GB",
    name: {
      en : "Inverness"
    }
  },
  INZ : {
    country: "DZ",
    name: {
      en : "INZ"
    }
  },
  IOA : {
    lat: "39.6967",
    lon: "20.8258",
    country: "GR",
    name: {
      en : "Ioannina"
    }
  },
  IOM : {
    lat: "54.0825",
    lon: "-4.62778",
    country: "GB",
    name: {
      en : "Ronaldsway"
    }
  },
  IOS : {
    lat: "-14.8139",
    lon: "-39.03",
    country: "BR",
    name: {
      en : "Eduardo Gomes"
    }
  },
  IPA : {
    country: "VU",
    name: {
      en : "IPA"
    }
  },
  IPC : {
    lat: "-27.1167",
    lon: "-109.367",
    country: "CL",
    popularity: 6,
    name: {
      en : "Mataveri"
    }
  },
  IPH : {
    country: "MY",
    name: {
      en : "Ipoh Arpt"
    }
  },
  IPI : {
    lat: "0.866389",
    lon: "-77.7117",
    country: "CO",
    name: {
      en : "San Luis"
    }
  },
  IPL : {
    lat: "32.8372",
    lon: "-115.575",
    country: "US",
    name: {
      en : "Imperial County"
    }
  },
  IPN : {
    country: "BR",
    name: {
      en : "Usiminas Arpt"
    }
  },
  IPT : {
    lat: "41.2422",
    lon: "-76.9206",
    country: "US",
    name: {
      en : "Williamsport Lycoming"
    }
  },
  IQA : {
    country: "IQ",
    name: {
      en : "IQA"
    }
  },
  IQM : {
    country: "CN",
    name: {
      en : "IQM"
    }
  },
  IQN : {
    country: "CN",
    name: {
      en : "IQN"
    }
  },
  IQQ : {
    lat: "-20.2167",
    lon: "-70.15",
    country: "CL",
    name: {
      en : "Cavancha Chucumata"
    }
  },
  IQT : {
    lat: "-3.75",
    lon: "-73.2",
    country: "PE",
    name: {
      en : "C F Secada"
    }
  },
  IRA : {
    country: "SB",
    name: {
      en : "IRA"
    }
  },
  IRC : {
    country: "US",
    name: {
      en : "Circle City Arpt"
    }
  },
  IRG : {
    country: "AU",
    name: {
      en : "Lockhart River Arpt"
    }
  },
  IRJ : {
    lat: "-29.3833",
    lon: "-66.7833",
    country: "AR",
    name: {
      en : "La Rioja"
    }
  },
  IRK : {
    country: "US",
    name: {
      en : "Kirksville Municipal"
    }
  },
  IRM : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Igrim"
    }
  },
  ISA : {
    lat: "-20.6558",
    lon: "139.479",
    country: "AU",
    name: {
      en : "Mount Isa"
    }
  },
  ISB : {
    lat: "33.6139",
    lon: "73.1042",
    country: "PK",
    popularity: 2,
    name: {
      en : "Islamabad"
    }
  },
  ISC : {
    lat: "49.9",
    lon: "-6.4",
    country: "GB",
    name: {
      en : "St Marys"
    }
  },
  ISE : {
    country: "TR",
    name: {
      en : "ISE"
    }
  },
  ISG : {
    lat: "24.3369",
    lon: "124.169",
    country: "JP",
    name: {
      en : "Ishigaki"
    }
  },
  ISK : {
    country: "IN",
    name: {
      en : "Gandhinagar Airport"
    }
  },
  ISM : {
    lat: "28.45",
    lon: "-81.3333",
    country: "US",
    name: {
      en : "Kissimmee"
    }
  },
  ISN : {
    lat: "48.1761",
    lon: "-103.636",
    country: "US",
    name: {
      en : "Sloulin Field"
    }
  },
  ISP : {
    lat: "40.9024",
    lon: "-73.1021",
    country: "US",
    name: {
      en : "Long Island Macarthur"
    }
  },
  IST : {
    lat: "41.1631",
    lon: "28.4507",
    country: "TR",
    popularity: 247,
    name: {
      en : "Istanbul Airport"
    }
  },
  ISU : {
    country: "IQ",
    name: {
      en : "ISU"
    }
  },
  ITB : {
    country: "BR",
    name: {
      en : "ITB"
    }
  },
  ITH : {
    lat: "42.4903",
    lon: "-76.4581",
    country: "US",
    name: {
      en : "Tomkins County"
    }
  },
  ITM : {
    lat: "34.7817",
    lon: "135.442",
    country: "JP",
    city: "OSA",
    name: {
      en : "Itami"
    }
  },
  ITO : {
    lat: "19.7236",
    lon: "-155.058",
    country: "US",
    popularity: 2,
    name: {
      en : "Hilo Hawaii"
    }
  },
  ITU : {
    lat: "45.255313",
    lon: "147.958681",
    country: "RU",
    name: {
      en : "Iturup"
    }
  },
  IUE : {
    lat: "-19.0833",
    lon: "-169.933",
    country: "NU",
    name: {
      en : "Hanan"
    }
  },
  IVC : {
    lat: "-46.4125",
    lon: "168.321",
    country: "NZ",
    name: {
      en : "Invercargill"
    }
  },
  IVL : {
    lat: "68.6111",
    lon: "27.4156",
    country: "FI",
    name: {
      en : "Ivalo"
    }
  },
  IVR : {
    lat: "-29.89",
    lon: "151.145",
    country: "AU",
    name: {
      en : "Inverell"
    }
  },
  IWA : {
    lat: "57",
    lon: "41",
    country: "RU",
    name: {
      en : "Ivanovo"
    }
  },
  IWD : {
    lat: "46.5256",
    lon: "-90.1317",
    country: "US",
    name: {
      en : "Ironwood"
    }
  },
  IWJ : {
    lat: "34.6731",
    lon: "131.793",
    country: "JP",
    name: {
      en : "Iwami"
    }
  },
  IWK : {
    country: "JP",
    name: {
      en : "Marine Corps Air Station Iwakuni"
    }
  },
  IXA : {
    country: "IN",
    name: {
      en : "Singerbhil Arpt"
    }
  },
  IXB : {
    lat: "26.6833",
    lon: "88.3333",
    country: "IN",
    popularity: 1,
    name: {
      en : "Bagdogra"
    }
  },
  IXC : {
    lat: "30.6719",
    lon: "76.7906",
    country: "IN",
    name: {
      en : "Chandigarh"
    }
  },
  IXD : {
    lat: "25.4397",
    lon: "81.7361",
    country: "IN",
    name: {
      en : "Bamrauli"
    }
  },
  IXE : {
    lat: "12.9639",
    lon: "74.8939",
    country: "IN",
    name: {
      en : "Bajpe"
    }
  },
  IXI : {
    lat: "27.2903",
    lon: "94.0889",
    country: "IN",
    name: {
      en : "Lilabari"
    }
  },
  IXJ : {
    lat: "32.6903",
    lon: "74.8389",
    country: "IN",
    name: {
      en : "Satwari"
    }
  },
  IXL : {
    lat: "34.1667",
    lon: "77.5833",
    country: "IN",
    popularity: 6,
    name: {
      en : "Leh"
    }
  },
  IXM : {
    lat: "9.8325",
    lon: "78.0881",
    country: "IN",
    popularity: 1,
    name: {
      en : "Madurai"
    }
  },
  IXP : {
    country: "IN",
    name: {
      en : "Pathankot Arpt"
    }
  },
  IXR : {
    lat: "23.3144",
    lon: "85.3236",
    country: "IN",
    name: {
      en : "Ranchi"
    }
  },
  IXS : {
    country: "IN",
    name: {
      en : "Kumbhigram Arpt"
    }
  },
  IXU : {
    lat: "19.8636",
    lon: "75.4011",
    country: "IN",
    name: {
      en : "Chikkalthana"
    }
  },
  IXY : {
    country: "IN",
    name: {
      en : "Kandla Arpt"
    }
  },
  IXZ : {
    lat: "11.6483",
    lon: "92.7436",
    country: "IN",
    name: {
      en : "Port Blair"
    }
  },
  IYK : {
    lat: "35.6567",
    lon: "-117.829",
    country: "US",
    name: {
      en : "Kern Cty"
    }
  },
  IZO : {
    lat: "35.4094",
    lon: "132.889",
    country: "JP",
    name: {
      en : "Izumo"
    }
  },
  JAC : {
    lat: "43.6067",
    lon: "-110.737",
    country: "US",
    name: {
      en : "Jackson Hole"
    }
  },
  JAE : {
    country: "PE",
    name: {
      en : "Jaén"
    }
  },
  JAI : {
    lat: "26.8217",
    lon: "75.8061",
    country: "IN",
    popularity: 1,
    name: {
      en : "Sanganeer"
    }
  },
  JAL : {
    lat: "19.4722",
    lon: "-96.7819",
    country: "MX",
    name: {
      en : "Jalapa"
    }
  },
  JAN : {
    lat: "32.4118",
    lon: "-90.1589",
    country: "US",
    name: {
      en : "Jackson Evers"
    }
  },
  JAU : {
    country: "PE",
    name: {
      en : "JAU"
    }
  },
  JAV : {
    lat: "69.2344",
    lon: "-51.0511",
    country: "GL",
    name: {
      en : "Ilulissat"
    }
  },
  JAX : {
    lat: "30.4925",
    lon: "-81.6897",
    country: "US",
    name: {
      en : "Jacksonville"
    }
  },
  JBB : {
    country: "ID",
    name: {
      en : "Notohadinegoro"
    }
  },
  JBQ : {
    country: "DO",
    name: {
      en : "Dr Joaquin Balaguer"
    }
  },
  JBR : {
    country: "US",
    name: {
      en : "Jonesboro Municipal"
    }
  },
  JCA : {
    country: "FR",
    city: "CEQ",
    name: {
      en : "Croisette Heliport"
    }
  },
  JCB : {
    country: "BR",
    name: {
      en : "Joacaba Arpt"
    }
  },
  JCH : {
    country: "GL",
    name: {
      en : "JCH"
    }
  },
  JCK : {
    lat: "-20.5833",
    lon: "141.7",
    country: "AU",
    name: {
      en : "Julia Creek"
    }
  },
  JCU : {
    country: "ES",
    name: {
      en : "JCU"
    }
  },
  JDF : {
    lat: "-21.75",
    lon: "-43.3333",
    country: "BR",
    name: {
      en : "Francisco De Assis"
    }
  },
  JDH : {
    lat: "26.2606",
    lon: "73.0478",
    country: "IN",
    name: {
      en : "Jodhpur"
    }
  },
  JDO : {
    lat: "-7.2",
    lon: "-39.3167",
    country: "BR",
    name: {
      en : "Regional Do Cariri"
    }
  },
  JDR : {
    country: "BR",
    name: {
      en : "JDR"
    }
  },
  JDZ : {
    lat: "29.2667",
    lon: "117.183",
    country: "CN",
    name: {
      en : "Jingdezhen"
    }
  },
  JED : {
    lat: "21.6833",
    lon: "39.15",
    country: "SA",
    popularity: 2,
    name: {
      en : "King Abdulaziz"
    }
  },
  JEG : {
    lat: "68.7",
    lon: "-52.75",
    country: "GL",
    name: {
      en : "Aasiaat"
    }
  },
  JEJ : {
    country: "MH",
    name: {
      en : "JEJ"
    }
  },
  JER : {
    lat: "49.2111",
    lon: "-2.21667",
    country: "GB",
    name: {
      en : "States"
    }
  },
  JFK : {
    lat: "40.6386",
    lon: "-73.7769",
    country: "US",
    city: "NYC",
    popularity: 520,
    name: {
      en : "John F Kennedy"
    }
  },
  JFR : {
    country: "GL",
    name: {
      en : "JFR"
    }
  },
  JGA : {
    lat: "22.4633",
    lon: "70.0119",
    country: "IN",
    name: {
      en : "Govardhanpur"
    }
  },
  JGC : {
    country: "US",
    city: "GCN",
    name: {
      en : "Grand Canyon Heliport"
    }
  },
  JGD : {
    country: "CN",
    name: {
      en : "Jiagedaqi"
    }
  },
  JGN : {
    lat: "39.8333",
    lon: "98.4167",
    country: "CN",
    name: {
      en : "Jiayuguan"
    }
  },
  JGO : {
    country: "GL",
    name: {
      en : "JGO"
    }
  },
  JGS : {
    country: "CN",
    name: {
      en : "JGS"
    }
  },
  JHB : {
    lat: "1.63889",
    lon: "103.671",
    country: "MY",
    name: {
      en : "Sultan Ismail"
    }
  },
  JHG : {
    lat: "22.0167",
    lon: "100.8",
    country: "CN",
    name: {
      en : "Jinghong"
    }
  },
  JHM : {
    lat: "20.9647",
    lon: "-156.677",
    country: "US",
    name: {
      en : "Kapalua"
    }
  },
  JHS : {
    lat: "66.9369",
    lon: "-53.7042",
    country: "GL",
    name: {
      en : "Sisimiut"
    }
  },
  JHW : {
    lat: "42.1506",
    lon: "-79.2581",
    country: "US",
    name: {
      en : "Chautauqua Cty"
    }
  },
  JIB : {
    lat: "11.5467",
    lon: "43.1589",
    country: "DJ",
    name: {
      en : "Ambouli"
    }
  },
  JIC : {
    country: "CN",
    name: {
      en : "Jinchang Jinchuan"
    }
  },
  JIJ : {
    country: "ET",
    name: {
      en : "JIJ"
    }
  },
  JIK : {
    lat: "37.6667",
    lon: "26.3333",
    country: "GR",
    name: {
      en : "Ikaria"
    }
  },
  JIM : {
    lat: "7.65444",
    lon: "36.8211",
    country: "ET",
    name: {
      en : "Jimma"
    }
  },
  JIU : {
    lat: "29.7",
    lon: "115.967",
    country: "CN",
    name: {
      en : "Jiujiang"
    }
  },
  JJD : {
    country: "BR",
    name: {
      en : "Jericoacoara"
    }
  },
  JJN : {
    lat: "24.8833",
    lon: "118.6",
    country: "CN",
    name: {
      en : "Jinjiang"
    }
  },
  JJU : {
    lat: "60.7167",
    lon: "-46.0333",
    country: "GL",
    name: {
      en : "Qaqortoq"
    }
  },
  JKG : {
    lat: "57.7586",
    lon: "14.0719",
    country: "SE",
    name: {
      en : "Axamo"
    }
  },
  JKH : {
    lat: "38.345",
    lon: "26.1417",
    country: "GR",
    popularity: 3,
    name: {
      en : "Chios"
    }
  },
  JKL : {
    country: "GR",
    name: {
      en : "Kalymnos Arpt"
    }
  },
  JKR : {
    country: "NP",
    name: {
      en : "JKR"
    }
  },
  JLN : {
    lat: "37.1497",
    lon: "-94.4978",
    country: "US",
    name: {
      en : "Joplin"
    }
  },
  JLR : {
    country: "IN",
    name: {
      en : "Jabalpur Airport"
    }
  },
  JMJ : {
    country: "CN",
    name: {
      en : "Lancang Jingmai"
    }
  },
  JMK : {
    lat: "37.4361",
    lon: "25.3444",
    country: "GR",
    popularity: 2,
    name: {
      en : "Mykonos Greece"
    }
  },
  JMO : {
    country: "NP",
    name: {
      en : "JMO"
    }
  },
  JMS : {
    lat: "46.93",
    lon: "-98.6783",
    country: "US",
    name: {
      en : "Jamestown"
    }
  },
  JMU : {
    country: "CN",
    name: {
      en : "JMU"
    }
  },
  JNB : {
    lat: "-26.1333",
    lon: "28.25",
    country: "ZA",
    name: {
      en : "O R Tambo"
    }
  },
  JNG : {
    country: "CN",
    name: {
      en : "JNG"
    }
  },
  JNN : {
    lat: "60.1342",
    lon: "-45.2336",
    country: "GL",
    name: {
      en : "Nanortalik"
    }
  },
  JNS : {
    lat: "60.9167",
    lon: "-46.05",
    country: "GL",
    name: {
      en : "Narsaq Heleport"
    }
  },
  JNU : {
    lat: "58.3556",
    lon: "-134.575",
    country: "US",
    name: {
      en : "Juneau"
    }
  },
  JNX : {
    lat: "37.1",
    lon: "25.3833",
    country: "GR",
    name: {
      en : "Naxos"
    }
  },
  JNZ : {
    lat: "41.1167",
    lon: "121.017",
    country: "CN",
    name: {
      en : "Jinzhou"
    }
  },
  JOE : {
    lat: "62.6625",
    lon: "29.6089",
    country: "FI",
    name: {
      en : "Joensuu"
    }
  },
  JOG : {
    lat: "-7.78972",
    lon: "110.431",
    country: "ID",
    name: {
      en : "Adisutjipto"
    }
  },
  JOI : {
    lat: "-26.2333",
    lon: "-48.7833",
    country: "BR",
    name: {
      en : "Cubatao"
    }
  },
  JOK : {
    lat: "56.7",
    lon: "47.9",
    country: "RU",
    name: {
      en : "Joshkar-Ola"
    }
  },
  JOS : {
    country: "NG",
    name: {
      en : "JOS"
    }
  },
  JPA : {
    lat: "-7.14639",
    lon: "-34.9519",
    country: "BR",
    name: {
      en : "Castro Pinto"
    }
  },
  JPR : {
    lat: "-8.05",
    lon: "-62.8667",
    country: "BR",
    name: {
      en : "Ji Parana"
    }
  },
  JQA : {
    lat: "70.7319",
    lon: "-52.7028",
    country: "GL",
    name: {
      en : "Qaarsut"
    }
  },
  JQE : {
    country: "PA",
    name: {
      en : "JQE"
    }
  },
  JRB : {
    lat: "40.7",
    lon: "-74.01",
    country: "US",
    city: "NYC",
    name: {
      en : "Downtown Manhattan H/p"
    }
  },
  JRH : {
    country: "IN",
    name: {
      en : "Rowriah Arpt"
    }
  },
  JRO : {
    lat: "-3.43333",
    lon: "37.0667",
    country: "TZ",
    name: {
      en : "Kilimanjaro"
    }
  },
  JSH : {
    country: "GR",
    name: {
      en : "Sitia Municipal Airport"
    }
  },
  JSI : {
    lat: "39.1806",
    lon: "23.5056",
    country: "GR",
    name: {
      en : "Skiathos"
    }
  },
  JSJ : {
    country: "CN",
    name: {
      en : "Jiansanjiang"
    }
  },
  JSR : {
    country: "BD",
    name: {
      en : "JSR"
    }
  },
  JST : {
    lat: "40.3167",
    lon: "-78.8344",
    country: "US",
    name: {
      en : "Johnstown Cambria"
    }
  },
  JSU : {
    lat: "65.4167",
    lon: "-52.9",
    country: "GL",
    name: {
      en : "Maniitsoq Heleport"
    }
  },
  JSY : {
    lat: "37.4236",
    lon: "24.95",
    country: "GR",
    name: {
      en : "Syros Island"
    }
  },
  JSZ : {
    country: "FR",
    city: "LTT",
    name: {
      en : "St Tropez Hlpt"
    }
  },
  JTC : {
    country: "BR",
    name: {
      en : "Arealva Airport"
    }
  },
  JTR : {
    lat: "36.4",
    lon: "25.4833",
    country: "GR",
    name: {
      en : "Santorin"
    }
  },
  JTY : {
    lat: "36.5667",
    lon: "26.3667",
    country: "GR",
    popularity: 1,
    name: {
      en : "Astypalaia"
    }
  },
  JUB : {
    country: "SD",
    name: {
      en : "Juba Arpt"
    }
  },
  JUH : {
    country: "CN",
    name: {
      en : "Chizhou Jiuhuashan"
    }
  },
  JUI : {
    country: "DE",
    name: {
      en : "Juist Arpt"
    }
  },
  JUJ : {
    lat: "-24.4",
    lon: "-65.0833",
    country: "AR",
    name: {
      en : "El Cadillal"
    }
  },
  JUL : {
    lat: "-15.4642",
    lon: "-70.1544",
    country: "PE",
    name: {
      en : "Juliaca"
    }
  },
  JUM : {
    country: "NP",
    name: {
      en : "JUM"
    }
  },
  JUV : {
    country: "GL",
    name: {
      en : "JUV"
    }
  },
  JUZ : {
    country: "CN",
    name: {
      en : "Juzhou Arpt"
    }
  },
  JWN : {
    lat: "36.7747",
    lon: "48.3592",
    country: "IR",
    name: {
      en : "Zanjan"
    }
  },
  JXA : {
    country: "CN",
    name: {
      en : "JXA"
    }
  },
  JXN : {
    country: "US",
    name: {
      en : "Jackson Reynolds Municipal"
    }
  },
  JYV : {
    lat: "62.3992",
    lon: "25.6819",
    country: "FI",
    name: {
      en : "Jyvaskyla"
    }
  },
  JZH : {
    lat: "32.8567",
    lon: "103.683",
    country: "CN",
    name: {
      en : "Jiu Zhai Huang Long"
    }
  },
  KAA : {
    country: "ZM",
    name: {
      en : "KAA"
    }
  },
  KAC : {
    country: "SY",
    name: {
      en : "KAC"
    }
  },
  KAD : {
    country: "NG",
    name: {
      en : "KAD"
    }
  },
  KAE : {
    lat: "56.9667",
    lon: "-133.95",
    country: "US",
    name: {
      en : "Kake"
    }
  },
  KAJ : {
    lat: "64.2778",
    lon: "27.6889",
    country: "FI",
    name: {
      en : "Kajaani"
    }
  },
  KAL : {
    country: "US",
    name: {
      en : "KAL"
    }
  },
  KAN : {
    lat: "12.0464",
    lon: "8.52389",
    country: "NG",
    name: {
      en : "Aminu Kano"
    }
  },
  KAO : {
    lat: "65.9903",
    lon: "29.2339",
    country: "FI",
    name: {
      en : "Kuusamo"
    }
  },
  KAT : {
    lat: "-35.0694",
    lon: "173.283",
    country: "NZ",
    name: {
      en : "Kaitaia"
    }
  },
  KAW : {
    country: "MM",
    name: {
      en : "KAW"
    }
  },
  KAX : {
    country: "AU",
    name: {
      en : "KAX"
    }
  },
  KAZ : {
    country: "ID",
    name: {
      en : "KAZ"
    }
  },
  KBC : {
    country: "US",
    name: {
      en : "KBC"
    }
  },
  KBL : {
    lat: "34.5639",
    lon: "69.2139",
    country: "AF",
    name: {
      en : "Khwaja Rawash"
    }
  },
  KBP : {
    lat: "50.35",
    lon: "30.9167",
    country: "UA",
    city: "IEV",
    popularity: 216,
    name: {
      en : "Borispol"
    }
  },
  KBR : {
    lat: "6.16528",
    lon: "102.294",
    country: "MY",
    popularity: 2,
    name: {
      en : "Pengkalan Chepa"
    }
  },
  KBU : {
    country: "ID",
    name: {
      en : "KBU"
    }
  },
  KBV : {
    lat: "8.02917",
    lon: "98.8042",
    country: "TH",
    name: {
      en : "Krabi"
    }
  },
  KCA : {
    country: "CN",
    name: {
      en : "KCA"
    }
  },
  KCC : {
    country: "US",
    name: {
      en : "KCC"
    }
  },
  KCF : {
    country: "PK",
    name: {
      en : "KCF"
    }
  },
  KCG : {
    country: "US",
    city: "KCL",
    name: {
      en : "Chignik Fisheries Arpt"
    }
  },
  KCH : {
    lat: "1.48417",
    lon: "110.341",
    country: "MY",
    name: {
      en : "Kuching"
    }
  },
  KCK : {
    country: "russian",
    name: {
      en : "Kirensk"
    }
  },
  KCL : {
    country: "US",
    name: {
      en : "Chignik Lagoon Arpt"
    }
  },
  KCM : {
    country: "TR",
    name: {
      en : "Kahramanmaras aRPT"
    }
  },
  KCO : {
    country: "TR",
    name: {
      en : "Cengiz Topel Naval Air Station"
    }
  },
  KCQ : {
    country: "US",
    city: "KCL",
    name: {
      en : "Chignik Airport"
    }
  },
  KCY : {
    lat: "56.17752057107931",
    lon: "92.52492428222244",
    country: "RU",
    city: "KJA",
    name: {
      en : "Cheremshanka"
    }
  },
  KCZ : {
    lat: "33.5411",
    lon: "133.677",
    country: "JP",
    name: {
      en : "Kochi"
    }
  },
  KDG : {
    lat: "42.067778",
    lon: "24.850833",
    country: "BG",
    name: {
      en : "Kardjali Airport"
    }
  },
  KDH : {
    country: "AF",
    name: {
      en : "KDH"
    }
  },
  KDI : {
    country: "ID",
    name: {
      en : "KDI"
    }
  },
  KDL : {
    country: "EE",
    name: {
      en : "KDL"
    }
  },
  KDM : {
    lat: "0",
    lon: "0",
    country: "MV",
    name: {
      en : "Kaadedhdhoo"
    }
  },
  KDO : {
    country: "MV",
    name: {
      en : "KDO"
    }
  },
  KDU : {
    country: "PK",
    name: {
      en : "Skardu Airport"
    }
  },
  KDV : {
    country: "FJ",
    name: {
      en : "KDV"
    }
  },
  KEB : {
    country: "US",
    name: {
      en : "Nanwalek Arpt"
    }
  },
  KEF : {
    lat: "63.985",
    lon: "-22.6061",
    country: "IS",
    city: "REK",
    popularity: 16,
    name: {
      en : "Keflavik"
    }
  },
  KEH : {
    country: "US",
    name: {
      en : "Kenmore Air Harbor"
    }
  },
  KEJ : {
    lat: "55.3333",
    lon: "86.0833",
    country: "RU",
    popularity: 9,
    name: {
      en : "Kemerovo"
    }
  },
  KEK : {
    country: "US",
    name: {
      en : "KEK"
    }
  },
  KEM : {
    lat: "65.78",
    lon: "24.5858",
    country: "FI",
    name: {
      en : "Kemi Tornio"
    }
  },
  KEO : {
    country: "CI",
    name: {
      en : "KEO"
    }
  },
  KEP : {
    country: "NP",
    name: {
      en : "KEP"
    }
  },
  KER : {
    lat: "30.2633",
    lon: "56.9575",
    country: "IR",
    name: {
      en : "Kerman"
    }
  },
  KET : {
    country: "MM",
    name: {
      en : "KET"
    }
  },
  KEW : {
    country: "CA",
    name: {
      en : "KEW"
    }
  },
  KFP : {
    country: "US",
    name: {
      en : "KFP"
    }
  },
  KGA : {
    country: "CD",
    name: {
      en : "KGA"
    }
  },
  KGC : {
    lat: "-35",
    lon: "137.167",
    country: "AU",
    name: {
      en : "Kingscote"
    }
  },
  KGD : {
    lat: "54.8874302",
    lon: "20.5855763",
    country: "RU",
    popularity: 43,
    name: {
      en : "Kaliningrad"
    }
  },
  KGE : {
    country: "SB",
    name: {
      en : "KGE"
    }
  },
  KGF : {
    lat: "49.8333",
    lon: "73.1667",
    country: "KZ",
    popularity: 4,
    name: {
      en : "Karaganda"
    }
  },
  KGI : {
    lat: "-30.7667",
    lon: "121.467",
    country: "AU",
    name: {
      en : "Kalgoorlie"
    }
  },
  KGJ : {
    country: "MW",
    name: {
      en : "KGJ"
    }
  },
  KGK : {
    country: "US",
    name: {
      en : "KGK"
    }
  },
  KGL : {
    lat: "-1.96778",
    lon: "30.14",
    country: "RW",
    name: {
      en : "Kayibanda"
    }
  },
  KGP : {
    country: "RU",
    name: {
      en : "KGP"
    }
  },
  KGS : {
    lat: "36.7931",
    lon: "27.0953",
    country: "GR",
    name: {
      en : "Kos"
    }
  },
  KGT : {
    country: "CN",
    name: {
      en : "KGT"
    }
  },
  KGX : {
    country: "US",
    name: {
      en : "KGX"
    }
  },
  KHD : {
    country: "IR",
    name: {
      en : "Khorramabad Arpt"
    }
  },
  KHG : {
    country: "CN",
    name: {
      en : "Kashi Arpt"
    }
  },
  KHH : {
    lat: "22.5725",
    lon: "120.345",
    country: "TW",
    name: {
      en : "Kaohsiung"
    }
  },
  KHI : {
    lat: "24.9056",
    lon: "67.1569",
    country: "PK",
    popularity: 2,
    name: {
      en : "Quaid E Azam"
    }
  },
  KHM : {
    country: "MM",
    name: {
      en : "KHM"
    }
  },
  KHN : {
    lat: "28.6833",
    lon: "115.883",
    country: "CN",
    name: {
      en : "Nanchang"
    }
  },
  KHR : {
    country: "MN",
    name: {
      en : "KHR"
    }
  },
  KHS : {
    country: "OM",
    name: {
      en : "KHS"
    }
  },
  KHV : {
    lat: "48.5167",
    lon: "135.183",
    country: "RU",
    popularity: 3,
    name: {
      en : "Novyy"
    }
  },
  KHY : {
    country: "IR",
    name: {
      en : "KHY"
    }
  },
  KHZ : {
    country: "PF",
    name: {
      en : "KHZ"
    }
  },
  KID : {
    lat: "55.9194",
    lon: "14.0889",
    country: "SE",
    name: {
      en : "Kristianstad"
    }
  },
  KIF : {
    country: "CA",
    name: {
      en : "KIF"
    }
  },
  KIH : {
    country: "IR",
    name: {
      en : "KIH"
    }
  },
  KIJ : {
    lat: "37.9533",
    lon: "139.123",
    country: "JP",
    name: {
      en : "Niigata"
    }
  },
  KIK : {
    country: "IQ",
    name: {
      en : "KIK"
    }
  },
  KIM : {
    lat: "-28.8058",
    lon: "24.7664",
    country: "ZA",
    name: {
      en : "Kimberley"
    }
  },
  KIN : {
    lat: "17.95",
    lon: "-76.7333",
    country: "JM",
    popularity: 9,
    name: {
      en : "Norman Manly"
    }
  },
  KIR : {
    lat: "52.05",
    lon: "-9.5",
    country: "IE",
    name: {
      en : "Kerry County"
    }
  },
  KIS : {
    lat: "-0.085556",
    lon: "34.7286",
    country: "KE",
    name: {
      en : "Kisumu"
    }
  },
  KIT : {
    lat: "36.2917",
    lon: "23.025",
    country: "GR",
    name: {
      en : "Kithira"
    }
  },
  KIV : {
    lat: "46.9167",
    lon: "28.9333",
    country: "MD",
    popularity: 220,
    name: {
      en : "Chisinau"
    }
  },
  KIX : {
    lat: "34.4239",
    lon: "135.247",
    country: "JP",
    city: "OSA",
    name: {
      en : "Kansai"
    }
  },
  KJA : {
    lat: "56.0167",
    lon: "92.8333",
    country: "RU",
    popularity: 5,
    name: {
      en : "Krasnojarsk"
    }
  },
  KJI : {
    country: "CN",
    name: {
      en : "KJI"
    }
  },
  KKA : {
    country: "US",
    name: {
      en : "KKA"
    }
  },
  KKB : {
    country: "US",
    name: {
      en : "KKB"
    }
  },
  KKC : {
    lat: "16.465",
    lon: "102.787",
    country: "TH",
    name: {
      en : "Khon Kaen"
    }
  },
  KKE : {
    lat: "-35.2167",
    lon: "173.95",
    country: "NZ",
    name: {
      en : "Kerikeri"
    }
  },
  KKH : {
    country: "US",
    name: {
      en : "KKH"
    }
  },
  KKI : {
    country: "US",
    name: {
      en : "KKI"
    }
  },
  KKJ : {
    lat: "33.8331",
    lon: "130.949",
    country: "JP",
    name: {
      en : "Kokura"
    }
  },
  KKN : {
    lat: "69.7228",
    lon: "29.8933",
    country: "NO",
    name: {
      en : "Hoeybuktmoen"
    }
  },
  KKQ : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Krasnoselkup"
    }
  },
  KKR : {
    country: "PF",
    name: {
      en : "KKR"
    }
  },
  KKU : {
    country: "US",
    name: {
      en : "KKU"
    }
  },
  KLF : {
    lat: "54.548333",
    lon: "36.371111",
    country: "RU",
    popularity: 19,
    name: {
      en : "Grabtsevo"
    }
  },
  KLG : {
    lat: "61.5383",
    lon: "-160.324",
    country: "US",
    name: {
      en : "Kalskag"
    }
  },
  KLH : {
    country: "IN",
    name: {
      en : "KLH"
    }
  },
  KLL : {
    country: "US",
    name: {
      en : "KLL"
    }
  },
  KLN : {
    country: "US",
    name: {
      en : "KLN"
    }
  },
  KLO : {
    lat: "11.6828",
    lon: "122.377",
    country: "PH",
    popularity: 1,
    name: {
      en : "Kalibo"
    }
  },
  KLR : {
    lat: "56.685",
    lon: "16.2872",
    country: "SE",
    name: {
      en : "Kalmar"
    }
  },
  KLU : {
    lat: "46.6431",
    lon: "14.3417",
    country: "AT",
    name: {
      en : "Klagenfurt"
    }
  },
  KLV : {
    lat: "50.2",
    lon: "12.9167",
    country: "CZ",
    popularity: 27,
    name: {
      en : "Karlovy Vary"
    }
  },
  KLW : {
    lat: "55.555",
    lon: "-133.1",
    country: "US",
    name: {
      en : "Klawock"
    }
  },
  KLX : {
    lat: "37.0694",
    lon: "22.0278",
    country: "GR",
    name: {
      en : "Kalamata"
    }
  },
  KMA : {
    country: "PG",
    name: {
      en : "KMA"
    }
  },
  KMC : {
    lat: "27.9003",
    lon: "45.5186",
    country: "SA",
    name: {
      en : "King Khalid Military"
    }
  },
  KME : {
    country: "RW",
    name: {
      en : "KME"
    }
  },
  KMG : {
    lat: "25.0167",
    lon: "102.683",
    country: "CN",
    name: {
      en : "Kunming"
    }
  },
  KMI : {
    lat: "31.8744",
    lon: "131.444",
    country: "JP",
    name: {
      en : "Miyazaki"
    }
  },
  KMJ : {
    lat: "32.8319",
    lon: "130.852",
    country: "JP",
    name: {
      en : "Kumamoto"
    }
  },
  KMN : {
    country: "CD",
    name: {
      en : "KMN"
    }
  },
  KMO : {
    country: "US",
    name: {
      en : "KMO"
    }
  },
  KMQ : {
    lat: "36.3939",
    lon: "136.417",
    country: "JP",
    name: {
      en : "Komatsu"
    }
  },
  KMS : {
    country: "GH",
    name: {
      en : "KMS"
    }
  },
  KMV : {
    country: "MM",
    name: {
      en : "KMV"
    }
  },
  KMW : {
    country: "RU",
    name: {
      en : "Kostroma Airport"
    }
  },
  KMY : {
    country: "US",
    name: {
      en : "KMY"
    }
  },
  KND : {
    country: "CD",
    name: {
      en : "KND"
    }
  },
  KNG : {
    country: "ID",
    name: {
      en : "KNG"
    }
  },
  KNH : {
    lat: "24.4206",
    lon: "118.344",
    country: "TW",
    name: {
      en : "Shang Yi"
    }
  },
  KNK : {
    country: "US",
    name: {
      en : "Kakhonak Arpt"
    }
  },
  KNO : {
    country: "ID",
    name: {
      en : "Kualanamu International Airport"
    }
  },
  KNQ : {
    country: "NC",
    name: {
      en : "KNQ"
    }
  },
  KNS : {
    lat: "-39.8833",
    lon: "143.883",
    country: "AU",
    name: {
      en : "King Island"
    }
  },
  KNU : {
    country: "IN",
    name: {
      en : "Chakeri Arpt"
    }
  },
  KNW : {
    country: "US",
    name: {
      en : "KNW"
    }
  },
  KNX : {
    lat: "-15.785",
    lon: "128.708",
    country: "AU",
    name: {
      en : "Kununurra"
    }
  },
  KNY : {
    lat: "58.47909599379531",
    lon: "99.10186241134099",
    country: "RU",
    name: {
      en : "Kodinsk"
    }
  },
  KOA : {
    lat: "19.7333",
    lon: "-156.05",
    country: "US",
    name: {
      en : "Keahole"
    }
  },
  KOC : {
    lat: "-20.5",
    lon: "164.417",
    country: "NC",
    name: {
      en : "Koumac"
    }
  },
  KOE : {
    country: "ID",
    name: {
      en : "KOE"
    }
  },
  KOI : {
    lat: "58.9586",
    lon: "-2.96667",
    country: "GB",
    name: {
      en : "Kirkwall"
    }
  },
  KOJ : {
    lat: "31.8019",
    lon: "130.72",
    country: "JP",
    name: {
      en : "Kagoshima"
    }
  },
  KOK : {
    lat: "63.7167",
    lon: "23.15",
    country: "FI",
    name: {
      en : "Kokkola"
    }
  },
  KOP : {
    lat: "17.4",
    lon: "104.75",
    country: "TH",
    name: {
      en : "Nakhon Phanom"
    }
  },
  KOS : {
    country: "KH",
    name: {
      en : "Sihanoukville"
    }
  },
  KOT : {
    country: "US",
    name: {
      en : "KOT"
    }
  },
  KOV : {
    country: "KZ",
    name: {
      en : "KOV"
    }
  },
  KOW : {
    lat: "25.9",
    lon: "114.917",
    country: "CN",
    name: {
      en : "Ganzhou"
    }
  },
  KOY : {
    country: "US",
    name: {
      en : "KOY"
    }
  },
  KOZ : {
    country: "US",
    name: {
      en : "KOZ"
    }
  },
  KPB : {
    country: "US",
    name: {
      en : "Point Baker Arpt"
    }
  },
  KPC : {
    country: "US",
    name: {
      en : "KPC"
    }
  },
  KPN : {
    country: "US",
    name: {
      en : "KPN"
    }
  },
  KPO : {
    lat: "35.9861",
    lon: "129.42",
    country: "KR",
    name: {
      en : "Pohang"
    }
  },
  KPR : {
    country: "US",
    name: {
      en : "KPR"
    }
  },
  KPV : {
    country: "US",
    name: {
      en : "KPV"
    }
  },
  KPW : {
    lat: "67.846944",
    lon: "166.135278",
    country: "RU",
    name: {
      en : "Keperveem"
    }
  },
  KPY : {
    country: "US",
    name: {
      en : "KPY"
    }
  },
  KQA : {
    country: "US",
    name: {
      en : "KQA"
    }
  },
  KQT : {
    lat: "37.86639",
    lon: "68.864441",
    country: "TJ",
    name: {
      en : "Qurghonteppa"
    }
  },
  KRC : {
    country: "ID",
    name: {
      en : "KRC"
    }
  },
  KRF : {
    lat: "63.0494",
    lon: "17.7728",
    country: "SE",
    name: {
      en : "Kramfors"
    }
  },
  KRK : {
    lat: "50.1773",
    lon: "19.7984",
    country: "PL",
    popularity: 2,
    name: {
      en : "John Paul 11 Balice"
    }
  },
  KRL : {
    country: "CN",
    name: {
      en : "KRL"
    }
  },
  KRN : {
    lat: "67.8222",
    lon: "20.3458",
    country: "SE",
    name: {
      en : "Kiruna"
    }
  },
  KRO : {
    lat: "55.48",
    lon: "65.42",
    country: "RU",
    name: {
      en : "Kurgan"
    }
  },
  KRP : {
    lat: "56.3",
    lon: "9.11667",
    country: "DK",
    name: {
      en : "Karup"
    }
  },
  KRR : {
    lat: "45.034138",
    lon: "39.139004",
    country: "RU",
    popularity: 26,
    name: {
      en : "Krasnodar"
    }
  },
  KRS : {
    lat: "58.2031",
    lon: "8.08417",
    country: "NO",
    name: {
      en : "Kjevik"
    }
  },
  KRT : {
    lat: "15.5994",
    lon: "32.5561",
    country: "SD",
    name: {
      en : "Civil"
    }
  },
  KRY : {
    country: "CN",
    name: {
      en : "KRY"
    }
  },
  KSA : {
    country: "FM",
    name: {
      en : "KSA"
    }
  },
  KSC : {
    lat: "48.6667",
    lon: "21.25",
    country: "SK",
    name: {
      en : "Barca"
    }
  },
  KSD : {
    lat: "59.3617",
    lon: "13.4694",
    country: "SE",
    name: {
      en : "Karlstad"
    }
  },
  KSF : {
    country: "DE",
    name: {
      en : "Kassel Calden Arpt"
    }
  },
  KSH : {
    lat: "34.35",
    lon: "47.15",
    country: "IR",
    name: {
      en : "Kermanshah"
    }
  },
  KSJ : {
    country: "GR",
    name: {
      en : "KSJ"
    }
  },
  KSL : {
    country: "SD",
    name: {
      en : "KSL"
    }
  },
  KSM : {
    country: "US",
    name: {
      en : "KSM"
    }
  },
  KSN : {
    lat: "53.2",
    lon: "63.55",
    country: "KZ",
    name: {
      en : "Kostanay"
    }
  },
  KSO : {
    lat: "40.4508",
    lon: "21.2733",
    country: "GR",
    name: {
      en : "Aristoteles"
    }
  },
  KSQ : {
    country: "UZ",
    name: {
      en : "KSQ"
    }
  },
  KSU : {
    lat: "63.1147",
    lon: "7.84444",
    country: "NO",
    name: {
      en : "Kvernberget"
    }
  },
  KSY : {
    lat: "40.5517",
    lon: "43.0858",
    country: "TR",
    name: {
      en : "Kars"
    }
  },
  KSZ : {
    country: "RU",
    name: {
      en : "KOTLAS"
    }
  },
  KTA : {
    lat: "-20.71",
    lon: "116.767",
    country: "AU",
    name: {
      en : "Karratha"
    }
  },
  KTB : {
    country: "US",
    name: {
      en : "KTB"
    }
  },
  KTE : {
    lat: "4.53833",
    lon: "103.428",
    country: "MY",
    name: {
      en : "Kertech"
    }
  },
  KTG : {
    country: "ID",
    name: {
      en : "KTG"
    }
  },
  KTI : {
    lat: "11.362917",
    lon: "104.916611",
    country: "KH",
    city: "PNH",
    popularity: 1,
    name: {
      en : "Techo International Airport"
    }
  },
  KTL : {
    country: "KE",
    name: {
      en : "KTL"
    }
  },
  KTM : {
    lat: "27.7006",
    lon: "85.3631",
    country: "NP",
    popularity: 4,
    name: {
      en : "Tribuvan"
    }
  },
  KTN : {
    lat: "55.35",
    lon: "-131.583",
    country: "US",
    name: {
      en : "Ketchikan"
    }
  },
  KTS : {
    lat: "65.3294",
    lon: "-166.472",
    country: "US",
    name: {
      en : "Brevig Mission"
    }
  },
  KTT : {
    lat: "67.6667",
    lon: "24.9",
    country: "FI",
    popularity: 6,
    name: {
      en : "Kittila"
    }
  },
  KTW : {
    lat: "50.4833",
    lon: "19.0833",
    country: "PL",
    name: {
      en : "Pyrzowice"
    }
  },
  KUA : {
    lat: "3.77222",
    lon: "103.21",
    country: "MY",
    name: {
      en : "Kuantan"
    }
  },
  KUB : {
    country: "BN",
    name: {
      en : "Kuala Belait"
    }
  },
  KUD : {
    country: "MY",
    name: {
      en : "Kudat Arpt"
    }
  },
  KUF : {
    lat: "53.5",
    lon: "50.15",
    country: "RU",
    popularity: 76,
    name: {
      en : "Samara"
    }
  },
  KUH : {
    lat: "43.0397",
    lon: "144.204",
    country: "JP",
    name: {
      en : "Kushiro"
    }
  },
  KUK : {
    country: "US",
    name: {
      en : "Kasigluk Arpt"
    }
  },
  KUL : {
    lat: "2.74333",
    lon: "101.693",
    country: "MY",
    popularity: 17,
    name: {
      en : "Kuala Lumpur"
    }
  },
  KUN : {
    lat: "54.9",
    lon: "23.9167",
    country: "LT",
    popularity: 2,
    name: {
      en : "Kaunas"
    }
  },
  KUO : {
    lat: "63.0056",
    lon: "27.7983",
    country: "FI",
    name: {
      en : "Kuopio"
    }
  },
  KUS : {
    lat: "65.5667",
    lon: "-37.1167",
    country: "GL",
    name: {
      en : "Kulusuk"
    }
  },
  KUT : {
    country: "GE",
    name: {
      en : "KUT"
    }
  },
  KUU : {
    lat: "31.9833",
    lon: "77.1",
    country: "IN",
    name: {
      en : "Bhuntar"
    }
  },
  KUV : {
    lat: "35.9833",
    lon: "126.75",
    country: "KR",
    name: {
      en : "Kunsan"
    }
  },
  KVA : {
    lat: "40.9728",
    lon: "24.3419",
    country: "GR",
    name: {
      en : "Megas Alexandros"
    }
  },
  KVB : {
    lat: "58.45",
    lon: "13.9667",
    country: "SE",
    name: {
      en : "Skovde"
    }
  },
  KVC : {
    country: "US",
    name: {
      en : "KVC"
    }
  },
  KVD : {
    lat: "40.74",
    lon: "46.32",
    country: "AZ",
    city: "",
    name: {
      en : "GANJA"
    }
  },
  KVG : {
    lat: "-2.57778",
    lon: "150.816",
    country: "PG",
    name: {
      en : "Kavieng"
    }
  },
  KVK : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Khibiny"
    }
  },
  KVL : {
    country: "US",
    name: {
      en : "KVL"
    }
  },
  KVO : {
    country: "RS",
    popularity: 90,
    name: {
      en : "Morava Airport"
    }
  },
  KVR : {
    country: "RU",
    name: {
      en : "KVR"
    }
  },
  KVX : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Kirov"
    }
  },
  KWA : {
    lat: "8.71667",
    lon: "167.733",
    country: "MH",
    name: {
      en : "Kwajalein"
    }
  },
  KWE : {
    lat: "26.5833",
    lon: "106.717",
    country: "CN",
    name: {
      en : "Guiyang"
    }
  },
  KWF : {
    country: "US",
    name: {
      en : "Waterfall Spb"
    }
  },
  KWG : {
    lat: "48.05",
    lon: "32.2167",
    country: "UA",
    name: {
      en : "Krivoy Rog"
    }
  },
  KWI : {
    lat: "29.2303",
    lon: "47.9753",
    country: "KW",
    popularity: 2,
    name: {
      en : "Kuwait"
    }
  },
  KWJ : {
    lat: "35.1233",
    lon: "126.811",
    country: "KR",
    name: {
      en : "Gwangju Airport"
    }
  },
  KWK : {
    country: "US",
    name: {
      en : "KWK"
    }
  },
  KWL : {
    lat: "25.1333",
    lon: "110.317",
    country: "CN",
    name: {
      en : "Guilin"
    }
  },
  KWM : {
    country: "AU",
    name: {
      en : "KWM"
    }
  },
  KWN : {
    country: "US",
    name: {
      en : "KWN"
    }
  },
  KWP : {
    country: "US",
    name: {
      en : "KWP"
    }
  },
  KWT : {
    country: "US",
    name: {
      en : "KWT"
    }
  },
  KWZ : {
    country: "CD",
    name: {
      en : "KWZ"
    }
  },
  KXA : {
    country: "US",
    name: {
      en : "KXA"
    }
  },
  KXK : {
    lat: "50.4",
    lon: "136.95",
    country: "RU",
    popularity: 5,
    name: {
      en : "Komsomolsk Na Amure"
    }
  },
  KXU : {
    country: "PF",
    name: {
      en : "KXU"
    }
  },
  KYA : {
    lat: "37.9792",
    lon: "32.5622",
    country: "TR",
    name: {
      en : "Konya"
    }
  },
  KYK : {
    country: "US",
    name: {
      en : "KYK"
    }
  },
  KYP : {
    country: "MM",
    name: {
      en : "KYP"
    }
  },
  KYS : {
    country: "ML",
    name: {
      en : "KYS"
    }
  },
  KYU : {
    country: "US",
    name: {
      en : "KYU"
    }
  },
  KYZ : {
    lat: "51.669444",
    lon: "94.400556",
    country: "RU",
    popularity: 19,
    name: {
      en : "Kyzyl"
    }
  },
  KZB : {
    country: "US",
    name: {
      en : "KZB"
    }
  },
  KZD : {
    country: "KH",
    name: {
      en : "KZD"
    }
  },
  KZI : {
    country: "GR",
    name: {
      en : "KZI"
    }
  },
  KZN : {
    lat: "55.7833",
    lon: "49.2167",
    country: "RU",
    popularity: 22,
    name: {
      en : "Kazan"
    }
  },
  KZO : {
    lat: "44.8333",
    lon: "65.8333",
    country: "KZ",
    name: {
      en : "Kzyl Orda"
    }
  },
  KZR : {
    country: "TR",
    name: {
      en : "Zafer Airport"
    }
  },
  KZS : {
    lat: "36.0833",
    lon: "29.3333",
    country: "GR",
    name: {
      en : "Kastelorizo"
    }
  },
  LAD : {
    lat: "-8.85306",
    lon: "13.2361",
    country: "AO",
    name: {
      en : "Four De Fevereiro"
    }
  },
  LAE : {
    lat: "-6.73722",
    lon: "146.995",
    country: "PG",
    name: {
      en : "Nadzab"
    }
  },
  LAI : {
    lat: "48.7542",
    lon: "-3.48194",
    country: "FR",
    name: {
      en : "Servel"
    }
  },
  LAK : {
    country: "CA",
    name: {
      en : "LAK"
    }
  },
  LAL : {
    lat: "27.9889",
    lon: "-82.0147",
    country: "US",
    name: {
      en : "Lakeland"
    }
  },
  LAN : {
    lat: "42.7792",
    lon: "-84.5883",
    country: "US",
    name: {
      en : "Lansing"
    }
  },
  LAO : {
    lat: "18.1836",
    lon: "120.53",
    country: "PH",
    name: {
      en : "Laoag"
    }
  },
  LAP : {
    lat: "24.1256",
    lon: "-110.298",
    country: "MX",
    name: {
      en : "Aeropuerto Gen Marquez De Leon"
    }
  },
  LAQ : {
    country: "LY",
    name: {
      en : "LAQ"
    }
  },
  LAR : {
    lat: "41.3136",
    lon: "-105.673",
    country: "US",
    name: {
      en : "General Brees Fld"
    }
  },
  LAS : {
    lat: "36.0801",
    lon: "-115.152",
    country: "US",
    popularity: 22,
    name: {
      en : "McCarran"
    }
  },
  LAU : {
    lat: "-2.25",
    lon: "40.9117",
    country: "KE",
    name: {
      en : "Lamu"
    }
  },
  LAW : {
    lat: "34.5697",
    lon: "-98.4161",
    country: "US",
    name: {
      en : "Lawton"
    }
  },
  LAX : {
    lat: "33.9422",
    lon: "-118.407",
    country: "US",
    popularity: 141,
    name: {
      en : "Los Angeles"
    }
  },
  LBA : {
    lat: "53.8653",
    lon: "-1.65472",
    country: "GB",
    name: {
      en : "Leeds Bradford"
    }
  },
  LBB : {
    lat: "33.6622",
    lon: "-101.823",
    country: "US",
    name: {
      en : "Lubbock Preston Smith"
    }
  },
  LBC : {
    lat: "53.8061",
    lon: "10.7206",
    country: "DE",
    city: "HAM",
    name: {
      en : "Blankensee"
    }
  },
  LBD : {
    lat: "40.22",
    lon: "69.69",
    country: "TJ",
    name: {
      en : "Khudzhand"
    }
  },
  LBE : {
    lat: "40.2764",
    lon: "-79.4028",
    country: "US",
    name: {
      en : "Westmorland County"
    }
  },
  LBF : {
    lat: "41.1283",
    lon: "-100.697",
    country: "US",
    name: {
      en : "Lee Bird Field"
    }
  },
  LBG : {
    lat: "48.9719",
    lon: "2.4425",
    country: "FR",
    city: "PAR",
    name: {
      en : "Le Bourget"
    }
  },
  LBJ : {
    country: "ID",
    name: {
      en : "LBJ"
    }
  },
  LBL : {
    lat: "37.0444",
    lon: "-100.961",
    country: "US",
    name: {
      en : "Liberal"
    }
  },
  LBP : {
    country: "MY",
    name: {
      en : "Long Banga Airfield Arpt"
    }
  },
  LBR : {
    country: "BR",
    name: {
      en : "LBR"
    }
  },
  LBS : {
    lat: "-16.4647",
    lon: "179.341",
    country: "FJ",
    name: {
      en : "Labasa"
    }
  },
  LBU : {
    lat: "5.30056",
    lon: "115.248",
    country: "MY",
    name: {
      en : "Labuan"
    }
  },
  LBV : {
    lat: "0.459167",
    lon: "9.41528",
    country: "GA",
    name: {
      en : "Libreville"
    }
  },
  LCA : {
    lat: "34.8778",
    lon: "33.6306",
    country: "CY",
    popularity: 143,
    name: {
      en : "Larnaca"
    }
  },
  LCE : {
    lat: "15.7406",
    lon: "-86.8572",
    country: "HN",
    name: {
      en : "Goloson"
    }
  },
  LCG : {
    lat: "43.2994",
    lon: "-8.37917",
    country: "ES",
    name: {
      en : "La Coruna"
    }
  },
  LCH : {
    lat: "30.1311",
    lon: "-93.2256",
    country: "US",
    name: {
      en : "Lake Charles"
    }
  },
  LCJ : {
    lat: "51.7219",
    lon: "19.3983",
    country: "PL",
    name: {
      en : "Lodz Lublinek"
    }
  },
  LCK : {
    lat: "39.8167",
    lon: "-82.9333",
    country: "US",
    city: "CMH",
    name: {
      en : "Rickenbacker"
    }
  },
  LCR : {
    country: "CO",
    name: {
      en : "La Chorrera Arpt"
    }
  },
  LCX : {
    country: "CN",
    name: {
      en : "LCX"
    }
  },
  LCY : {
    lat: "51.5",
    lon: "0.05",
    country: "GB",
    city: "LON",
    popularity: 1186,
    name: {
      en : "London City"
    }
  },
  LDB : {
    lat: "-23.3319",
    lon: "-51.1319",
    country: "BR",
    name: {
      en : "Londrina"
    }
  },
  LDE : {
    lat: "43.1819",
    lon: "-0.003611",
    country: "FR",
    name: {
      en : "Tarbes"
    }
  },
  LDG : {
    country: "RU",
    name: {
      en : "LDG"
    }
  },
  LDH : {
    lat: "-31.5375",
    lon: "159.08",
    country: "AU",
    name: {
      en : "Lord Howe Island"
    }
  },
  LDN : {
    country: "NP",
    name: {
      en : "LDN"
    }
  },
  LDS : {
    country: "CN",
    name: {
      en : "LDS"
    }
  },
  LDU : {
    country: "MY",
    name: {
      en : "Lahad Datu Arpt"
    }
  },
  LDY : {
    lat: "55.0433",
    lon: "-7.15333",
    country: "GB",
    popularity: 88,
    name: {
      en : "Eglinton"
    }
  },
  LEA : {
    lat: "-22.235",
    lon: "114.082",
    country: "AU",
    name: {
      en : "Learmonth"
    }
  },
  LEB : {
    lat: "43.6281",
    lon: "-72.3058",
    country: "US",
    name: {
      en : "Lebanon Regional"
    }
  },
  LEC : {
    country: "BR",
    name: {
      en : "Chapada Diamantina Arpt"
    }
  },
  LED : {
    lat: "59.80027778",
    lon: "30.26250000",
    country: "RU",
    popularity: 409,
    name: {
      en : "Pulkovo"
    }
  },
  LEH : {
    lat: "49.5389",
    lon: "0.088611",
    country: "FR",
    popularity: 2,
    name: {
      en : "Octeville"
    }
  },
  LEI : {
    lat: "36.8444",
    lon: "-2.37222",
    country: "ES",
    popularity: 2,
    name: {
      en : "Almeria"
    }
  },
  LEJ : {
    lat: "51.4167",
    lon: "12.2333",
    country: "DE",
    name: {
      en : "Leipzig"
    }
  },
  LEN : {
    lat: "42.5844",
    lon: "-5.65083",
    country: "ES",
    name: {
      en : "Leon"
    }
  },
  LEQ : {
    country: "GB",
    name: {
      en : "St Just Arpt"
    }
  },
  LER : {
    lat: "-27.8333",
    lon: "120.617",
    country: "AU",
    name: {
      en : "Leinster"
    }
  },
  LET : {
    lat: "-4.19639",
    lon: "-69.9394",
    country: "CO",
    name: {
      en : "General A V Cobo"
    }
  },
  LEV : {
    country: "FJ",
    name: {
      en : "LEV"
    }
  },
  LEX : {
    lat: "38.0397",
    lon: "-84.6022",
    country: "US",
    name: {
      en : "Blue Grass Field"
    }
  },
  LFM : {
    country: "IR",
    name: {
      en : "LFM"
    }
  },
  LFR : {
    country: "VE",
    name: {
      en : "LFR"
    }
  },
  LFT : {
    lat: "30.2047",
    lon: "-91.9875",
    country: "US",
    name: {
      en : "Lafayette"
    }
  },
  LFW : {
    lat: "6.1625",
    lon: "1.25417",
    country: "TG",
    name: {
      en : "Lome"
    }
  },
  LGA : {
    lat: "40.7794",
    lon: "-73.8758",
    country: "US",
    city: "NYC",
    name: {
      en : "La Guardia"
    }
  },
  LGB : {
    lat: "33.8175",
    lon: "-118.151",
    country: "US",
    name: {
      en : "Long Beach"
    }
  },
  LGG : {
    lat: "50.6361",
    lon: "5.44167",
    country: "BE",
    name: {
      en : "Bierset"
    }
  },
  LGI : {
    lat: "23.1794",
    lon: "-75.0905",
    country: "BS",
    name: {
      en : "Deadmans Cay"
    }
  },
  LGK : {
    lat: "6.33333",
    lon: "99.7333",
    country: "MY",
    name: {
      en : "Langkawi"
    }
  },
  LGL : {
    country: "MY",
    name: {
      en : "Long Lellang Arpt"
    }
  },
  LGP : {
    lat: "13.1569",
    lon: "123.73",
    country: "PH",
    name: {
      en : "Legaspi"
    }
  },
  LGQ : {
    country: "EC",
    name: {
      en : "LGQ"
    }
  },
  LGW : {
    lat: "51.1481",
    lon: "-0.196667",
    country: "GB",
    city: "LON",
    popularity: 89,
    name: {
      en : "Gatwick"
    }
  },
  LHE : {
    lat: "31.5208",
    lon: "74.4028",
    country: "PK",
    popularity: 2,
    name: {
      en : "Lahore"
    }
  },
  LHR : {
    lat: "51.4714",
    lon: "-0.452778",
    country: "GB",
    city: "LON",
    popularity: 229,
    name: {
      en : "Heathrow"
    }
  },
  LHT : {
    country: "HU",
    city: "   ",
    name: {
      en : "LHT"
    }
  },
  LHW : {
    lat: "36.0333",
    lon: "103.867",
    country: "CN",
    name: {
      en : "Lanzhou"
    }
  },
  LIF : {
    lat: "-20.7667",
    lon: "167.25",
    country: "NC",
    name: {
      en : "Lifou"
    }
  },
  LIG : {
    lat: "45.8619",
    lon: "1.18222",
    country: "FR",
    name: {
      en : "Bellegarde"
    }
  },
  LIH : {
    lat: "21.9792",
    lon: "-159.346",
    country: "US",
    name: {
      en : "Lihue"
    }
  },
  LIL : {
    lat: "50.5644",
    lon: "3.08806",
    country: "FR",
    name: {
      en : "Lesquin"
    }
  },
  LIM : {
    lat: "-12.0267",
    lon: "-77.1228",
    country: "PE",
    popularity: 25,
    name: {
      en : "Jorge Chavez"
    }
  },
  LIN : {
    lat: "45.4417",
    lon: "9.27778",
    country: "IT",
    city: "MIL",
    name: {
      en : "Linate"
    }
  },
  LIO : {
    lat: "9.95583",
    lon: "-83.0211",
    country: "CR",
    name: {
      en : "Limon"
    }
  },
  LIR : {
    lat: "10.5897",
    lon: "-85.55",
    country: "CR",
    name: {
      en : "Liberia"
    }
  },
  LIS : {
    lat: "38.7819",
    lon: "-9.13333",
    country: "PT",
    popularity: 191,
    name: {
      en : "Lisboa"
    }
  },
  LIT : {
    lat: "34.7292",
    lon: "-92.2344",
    country: "US",
    name: {
      en : "Little Rock Regional"
    }
  },
  LIW : {
    country: "MM",
    name: {
      en : "LIW"
    }
  },
  LJG : {
    lat: "26.6833",
    lon: "100.25",
    country: "CN",
    name: {
      en : "Lijiang"
    }
  },
  LJU : {
    lat: "46.2247",
    lon: "14.4608",
    country: "SI",
    popularity: 115,
    name: {
      en : "Brnik"
    }
  },
  LKA : {
    country: "ID",
    name: {
      en : "LKA"
    }
  },
  LKB : {
    country: "FJ",
    name: {
      en : "LKB"
    }
  },
  LKE : {
    lat: "47.6275",
    lon: "-122.332",
    country: "US",
    city: "SEA",
    name: {
      en : "Lake Union Seaplane Base"
    }
  },
  LKG : {
    lat: "4.23333",
    lon: "34.35",
    country: "KE",
    name: {
      en : "Lokichoggio"
    }
  },
  LKH : {
    country: "MY",
    name: {
      en : "Long Akah Arpt"
    }
  },
  LKL : {
    lat: "70.0678",
    lon: "24.9736",
    country: "NO",
    name: {
      en : "Banak"
    }
  },
  LKN : {
    lat: "68.1536",
    lon: "13.6089",
    country: "NO",
    name: {
      en : "Leknes"
    }
  },
  LKO : {
    lat: "26.7603",
    lon: "80.8803",
    country: "IN",
    name: {
      en : "Amausi"
    }
  },
  LKY : {
    country: "TZ",
    name: {
      en : "LKY"
    }
  },
  LLA : {
    lat: "65.5447",
    lon: "22.1278",
    country: "SE",
    name: {
      en : "Kallax"
    }
  },
  LLB : {
    country: "CN",
    name: {
      en : "LLB"
    }
  },
  LLF : {
    lat: "26.7008",
    lon: "111.958",
    country: "CN",
    name: {
      en : "Ling Ling"
    }
  },
  LLI : {
    country: "ET",
    name: {
      en : "LLI"
    }
  },
  LLK : {
    country: "AZ",
    name: {
      en : "LLK"
    }
  },
  LLU : {
    lat: "60.4642",
    lon: "-45.5689",
    country: "GL",
    name: {
      en : "Alluitsup Paa"
    }
  },
  LLV : {
    country: "CN",
    name: {
      en : "Lüliang"
    }
  },
  LLW : {
    lat: "-13.7833",
    lon: "33.7833",
    country: "MW",
    name: {
      en : "Lilongwe"
    }
  },
  LMA : {
    country: "US",
    name: {
      en : "LMA"
    }
  },
  LMC : {
    country: "CO",
    name: {
      en : "Lamacarena Arpt"
    }
  },
  LMJ : {
    country: "JP",
    name: {
      en : "LMJ"
    }
  },
  LMM : {
    lat: "25.8167",
    lon: "-108.983",
    country: "MX",
    name: {
      en : "Federal Los Mochis"
    }
  },
  LMN : {
    country: "MY",
    name: {
      en : "Limbang Arpt"
    }
  },
  LMP : {
    lat: "35.5",
    lon: "12.6167",
    country: "IT",
    name: {
      en : "Lampedusa"
    }
  },
  LMT : {
    lat: "42.1631",
    lon: "-121.736",
    country: "US",
    name: {
      en : "Kingsley Field"
    }
  },
  LMY : {
    country: "PG",
    name: {
      en : "LMY"
    }
  },
  LNB : {
    country: "VU",
    name: {
      en : "LNB"
    }
  },
  LNE : {
    country: "VU",
    name: {
      en : "LNE"
    }
  },
  LNJ : {
    country: "CN",
    name: {
      en : "LNJ"
    }
  },
  LNK : {
    lat: "40.8458",
    lon: "-96.7614",
    country: "US",
    name: {
      en : "Lincoln"
    }
  },
  LNO : {
    lat: "-28.8833",
    lon: "121.3",
    country: "AU",
    name: {
      en : "Leonora"
    }
  },
  LNS : {
    country: "US",
    name: {
      en : "Lancaster Arpt"
    }
  },
  LNV : {
    lat: "-3.06667",
    lon: "152.617",
    country: "PG",
    name: {
      en : "Lihir Island"
    }
  },
  LNY : {
    lat: "20.7847",
    lon: "-156.949",
    country: "US",
    name: {
      en : "Lanai"
    }
  },
  LNZ : {
    lat: "48.2344",
    lon: "14.1936",
    country: "AT",
    name: {
      en : "Hoersching"
    }
  },
  LOD : {
    country: "VU",
    name: {
      en : "LOD"
    }
  },
  LOH : {
    country: "EC",
    name: {
      en : "Aeropuerto Camilo Enriquez"
    }
  },
  LOK : {
    country: "KE",
    name: {
      en : "LOK"
    }
  },
  LOO : {
    country: "DZ",
    name: {
      en : "LOO"
    }
  },
  LOP : {
    country: "ID",
    name: {
      en : "Lombok International Airport"
    }
  },
  LOS : {
    lat: "6.58889",
    lon: "3.32639",
    country: "NG",
    name: {
      en : "Murtala Muhammed"
    }
  },
  LPA : {
    lat: "27.9325",
    lon: "-15.3847",
    country: "ES",
    popularity: 2,
    name: {
      en : "Aeropuerto De Gran Canaria"
    }
  },
  LPB : {
    lat: "-16.5069",
    lon: "-68.2014",
    country: "BO",
    name: {
      en : "El Alto"
    }
  },
  LPD : {
    country: "CO",
    name: {
      en : "La Pedrera Arpt"
    }
  },
  LPI : {
    lat: "58.4",
    lon: "15.5167",
    country: "SE",
    name: {
      en : "Saab"
    }
  },
  LPK : {
    lat: "52.697909",
    lon: "39.524542",
    country: "RU",
    name: {
      en : "Lipetsk Arpt"
    }
  },
  LPL : {
    lat: "53.3383",
    lon: "-2.86667",
    country: "GB",
    name: {
      en : "Liverpool"
    }
  },
  LPM : {
    country: "VU",
    name: {
      en : "LPM"
    }
  },
  LPP : {
    lat: "61.0461",
    lon: "28.1567",
    country: "FI",
    name: {
      en : "Lappeenranta"
    }
  },
  LPQ : {
    lat: "19.8958",
    lon: "102.164",
    country: "LA",
    name: {
      en : "Louangphrabang"
    }
  },
  LPS : {
    lat: "48.4828",
    lon: "-122.936",
    country: "US",
    name: {
      en : "Lopez Island"
    }
  },
  LPT : {
    lat: "18.2742",
    lon: "99.5072",
    country: "TH",
    name: {
      en : "Lampang"
    }
  },
  LPX : {
    lat: "56.5167",
    lon: "21.1",
    country: "LV",
    name: {
      en : "Liepaya"
    }
  },
  LPY : {
    lat: "45.0833",
    lon: "3.76667",
    country: "FR",
    name: {
      en : "Loudes"
    }
  },
  LQM : {
    country: "CO",
    name: {
      en : "Puerto Leguizamo Arpt"
    }
  },
  LQN : {
    country: "AF",
    name: {
      en : "LQN"
    }
  },
  LRD : {
    lat: "27.5447",
    lon: "-99.4611",
    country: "US",
    name: {
      en : "Laredo"
    }
  },
  LRE : {
    lat: "-23.4372",
    lon: "144.276",
    country: "AU",
    name: {
      en : "Longreach"
    }
  },
  LRH : {
    lat: "46.1806",
    lon: "-1.18583",
    country: "FR",
    name: {
      en : "Laleu"
    }
  },
  LRM : {
    lat: "18.4167",
    lon: "-68.9",
    country: "DO",
    name: {
      en : "La Romana"
    }
  },
  LRR : {
    country: "IR",
    name: {
      en : "LRR"
    }
  },
  LRS : {
    lat: "37.5167",
    lon: "26.7833",
    country: "GR",
    name: {
      en : "Leros"
    }
  },
  LRT : {
    lat: "47.7611",
    lon: "-3.43917",
    country: "FR",
    name: {
      en : "Lann Bihoue"
    }
  },
  LSA : {
    country: "PG",
    name: {
      en : "LSA"
    }
  },
  LSC : {
    lat: "-29.9133",
    lon: "-71.1978",
    country: "CL",
    name: {
      en : "La Florida"
    }
  },
  LSE : {
    lat: "43.8772",
    lon: "-91.2564",
    country: "US",
    name: {
      en : "La Crosse"
    }
  },
  LSH : {
    country: "MM",
    name: {
      en : "LSH"
    }
  },
  LSI : {
    lat: "59.8811",
    lon: "-1.29306",
    country: "GB",
    city: "SDZ",
    name: {
      en : "Sumburgh"
    }
  },
  LSP : {
    lat: "11.7211",
    lon: "-70.1889",
    country: "VE",
    name: {
      en : "Josefa Camejo"
    }
  },
  LST : {
    lat: "-41.5458",
    lon: "147.21",
    country: "AU",
    name: {
      en : "Launceston"
    }
  },
  LSW : {
    country: "ID",
    name: {
      en : "LSW"
    }
  },
  LSY : {
    lat: "-28.8333",
    lon: "153.267",
    country: "AU",
    name: {
      en : "Lismore"
    }
  },
  LTD : {
    country: "LY",
    name: {
      en : "LTD"
    }
  },
  LTI : {
    country: "MN",
    name: {
      en : "LTI"
    }
  },
  LTK : {
    lat: "35.5167",
    lon: "35.7833",
    country: "SY",
    name: {
      en : "Hmelmin"
    }
  },
  LTN : {
    lat: "51.8833",
    lon: "-0.351667",
    country: "GB",
    city: "LON",
    name: {
      en : "Luton"
    }
  },
  LTO : {
    lat: "25.9833",
    lon: "-111.35",
    country: "MX",
    name: {
      en : "Loreto"
    }
  },
  LTQ : {
    country: "FR",
    name: {
      en : "Le Touquet Arpt"
    }
  },
  LTT : {
    country: "FR",
    name: {
      en : "La Mole Arpt"
    }
  },
  LTU : {
    country: "IN",
    name: {
      en : "Latur Arpt"
    }
  },
  LTX : {
    lat: "-0.901111",
    lon: "-78.6025",
    country: "EC",
    name: {
      en : "Cotapaxi"
    }
  },
  LUA : {
    country: "NP",
    name: {
      en : "LUA"
    }
  },
  LUD : {
    lat: "-26.6864",
    lon: "15.2439",
    country: "NA",
    name: {
      en : "Luderitz"
    }
  },
  LUG : {
    lat: "46.0167",
    lon: "8.96667",
    country: "CH",
    popularity: 2,
    name: {
      en : "Agno"
    }
  },
  LUH : {
    country: "IN",
    name: {
      en : "Ludhiana Arpt"
    }
  },
  LUK : {
    lat: "39.0333",
    lon: "-84.6667",
    country: "US",
    city: "CVG",
    name: {
      en : "Cincinnati"
    }
  },
  LUM : {
    lat: "0",
    lon: "0",
    country: "CN",
    name: {
      en : "Dehong Mangshi"
    }
  },
  LUN : {
    lat: "-15.3292",
    lon: "28.4528",
    country: "ZM",
    name: {
      en : "Lusaka"
    }
  },
  LUO : {
    country: "AO",
    name: {
      en : "LUO"
    }
  },
  LUP : {
    lat: "21.2111",
    lon: "-156.974",
    country: "US",
    name: {
      en : "Kalaupapa"
    }
  },
  LUQ : {
    lat: "-33.2744",
    lon: "-66.3586",
    country: "AR",
    name: {
      en : "San Luis Cty"
    }
  },
  LUR : {
    country: "US",
    name: {
      en : "LUR"
    }
  },
  LUV : {
    country: "ID",
    name: {
      en : "LUV"
    }
  },
  LUX : {
    lat: "49.6278",
    lon: "6.20667",
    country: "LU",
    popularity: 103,
    name: {
      en : "Luxembourg"
    }
  },
  LUZ : {
    lat: "51.14",
    lon: "22.42",
    country: "PL",
    popularity: 2,
    name: {
      en : "Lublin Airport"
    }
  },
  LVI : {
    lat: "-17.8206",
    lon: "25.8222",
    country: "ZM",
    name: {
      en : "Livingstone"
    }
  },
  LVO : {
    lat: "-28.6333",
    lon: "122.367",
    country: "AU",
    name: {
      en : "Laverton"
    }
  },
  LWB : {
    lat: "37.8597",
    lon: "-80.3986",
    country: "US",
    name: {
      en : "Greenbrier Valley"
    }
  },
  LWE : {
    country: "ID",
    name: {
      en : "LWE"
    }
  },
  LWK : {
    country: "GB",
    city: "SDZ",
    name: {
      en : "Tingwall Arpt"
    }
  },
  LWN : {
    lat: "0",
    lon: "0",
    country: "AM",
    name: {
      en : "Shirak"
    }
  },
  LWO : {
    lat: "49.8167",
    lon: "23.85",
    country: "UA",
    popularity: 13,
    name: {
      en : "Sknilow"
    }
  },
  LWS : {
    lat: "46.3747",
    lon: "-117.014",
    country: "US",
    name: {
      en : "Lewiston Nez Pierce"
    }
  },
  LWT : {
    lat: "47.0511",
    lon: "-109.471",
    country: "US",
    name: {
      en : "Lewistown"
    }
  },
  LWY : {
    country: "MY",
    name: {
      en : "Lawas Arpt"
    }
  },
  LXA : {
    lat: "29.6667",
    lon: "91.15",
    country: "CN",
    popularity: 4,
    name: {
      en : "Lhasa"
    }
  },
  LXG : {
    country: "LA",
    name: {
      en : "LXG"
    }
  },
  LXR : {
    lat: "25.6731",
    lon: "32.7075",
    country: "EG",
    popularity: 2,
    name: {
      en : "Luxor"
    }
  },
  LXS : {
    lat: "39.9167",
    lon: "25.25",
    country: "GR",
    name: {
      en : "Limnos"
    }
  },
  LYA : {
    lat: "34.6833",
    lon: "112.467",
    country: "CN",
    name: {
      en : "Luoyang"
    }
  },
  LYB : {
    lat: "19.6667",
    lon: "-80.0833",
    country: "KY",
    name: {
      en : "Little Cayman"
    }
  },
  LYC : {
    lat: "64.5333",
    lon: "18.7167",
    country: "SE",
    name: {
      en : "Hedlunda"
    }
  },
  LYG : {
    lat: "34.6667",
    lon: "119.183",
    country: "CN",
    name: {
      en : "Lianyungang"
    }
  },
  LYH : {
    lat: "37.3269",
    lon: "-79.2011",
    country: "US",
    name: {
      en : "Lynchburg"
    }
  },
  LYI : {
    lat: "35.0667",
    lon: "118.367",
    country: "CN",
    name: {
      en : "Linyi"
    }
  },
  LYP : {
    country: "PK",
    name: {
      en : "Faisalabad International Arpt"
    }
  },
  LYR : {
    lat: "78.2089",
    lon: "15.8",
    country: "NO",
    name: {
      en : "Svalbard"
    }
  },
  LYS : {
    lat: "45.7256",
    lon: "5.08167",
    country: "FR",
    popularity: 19,
    name: {
      en : "Lyon Saint Exupery"
    }
  },
  LYX : {
    country: "GB",
    name: {
      en : "Lydd Intl Arpt"
    }
  },
  LZC : {
    lat: "18",
    lon: "-102.217",
    country: "MX",
    name: {
      en : "Lazaro Cardenas"
    }
  },
  LZH : {
    lat: "24.3667",
    lon: "109.533",
    country: "CN",
    name: {
      en : "Liuzhou"
    }
  },
  LZN : {
    country: "TW",
    name: {
      en : "LZN"
    }
  },
  LZO : {
    lat: "28.8833",
    lon: "105.35",
    country: "CN",
    name: {
      en : "Luzhou"
    }
  },
  LZU : {
    country: "US",
    name: {
      en : "LZU"
    }
  },
  LZY : {
    country: "CN",
    name: {
      en : "LZY"
    }
  },
  MAA : {
    lat: "12.9933",
    lon: "80.1769",
    country: "IN",
    name: {
      en : "Chennai"
    }
  },
  MAB : {
    lat: "-5.36667",
    lon: "-49.1667",
    country: "BR",
    name: {
      en : "Maraba"
    }
  },
  MAD : {
    lat: "40.4722",
    lon: "-3.56333",
    country: "ES",
    popularity: 957,
    name: {
      en : "Barajas"
    }
  },
  MAF : {
    lat: "31.9408",
    lon: "-102.201",
    country: "US",
    name: {
      en : "Midland"
    }
  },
  MAG : {
    lat: "-5.20917",
    lon: "145.782",
    country: "PG",
    popularity: 1,
    name: {
      en : "Madang"
    }
  },
  MAH : {
    lat: "39.8614",
    lon: "4.21528",
    country: "ES",
    name: {
      en : "Aerop De Menorca"
    }
  },
  MAJ : {
    lat: "7.06361",
    lon: "171.27",
    country: "MH",
    name: {
      en : "Amata Kabua"
    }
  },
  MAK : {
    country: "SD",
    name: {
      en : "Malakal Arpt"
    }
  },
  MAM : {
    lat: "25.7703",
    lon: "-97.5236",
    country: "MX",
    name: {
      en : "Servando Canales"
    }
  },
  MAN : {
    lat: "53.3533",
    lon: "-2.27667",
    country: "GB",
    popularity: 80,
    name: {
      en : "Manchester"
    }
  },
  MAO : {
    lat: "-3.03333",
    lon: "-60.05",
    country: "BR",
    name: {
      en : "Intl Eduardo Gomes"
    }
  },
  MAR : {
    lat: "10.5667",
    lon: "-71.7333",
    country: "VE",
    name: {
      en : "La Chinita"
    }
  },
  MAS : {
    lat: "-2.05667",
    lon: "147.424",
    country: "PG",
    name: {
      en : "Momote"
    }
  },
  MAT : {
    country: "CD",
    name: {
      en : "MAT"
    }
  },
  MAU : {
    country: "PF",
    name: {
      en : "MAU"
    }
  },
  MAZ : {
    lat: "18.2578",
    lon: "-67.1489",
    country: "US",
    name: {
      en : "Eugenio M De Hostos"
    }
  },
  MBA : {
    lat: "-4.03139",
    lon: "39.5931",
    country: "KE",
    popularity: 2,
    name: {
      en : "Moi"
    }
  },
  MBD : {
    lat: "-25.8167",
    lon: "25.5",
    country: "ZA",
    name: {
      en : "Mmabatho"
    }
  },
  MBE : {
    country: "JP",
    name: {
      en : "MBE"
    }
  },
  MBI : {
    country: "TZ",
    name: {
      en : "MBI"
    }
  },
  MBJ : {
    lat: "18.5019",
    lon: "-77.9125",
    country: "JM",
    popularity: 16,
    name: {
      en : "Sangster"
    }
  },
  MBL : {
    lat: "44.2739",
    lon: "-86.2533",
    country: "US",
    name: {
      en : "Manistee"
    }
  },
  MBS : {
    lat: "43.5333",
    lon: "-84.0833",
    country: "US",
    name: {
      en : "Saginaw"
    }
  },
  MBT : {
    country: "PH",
    name: {
      en : "Murfreesboro Municipal Arpt"
    }
  },
  MCE : {
    lat: "37.2847",
    lon: "-120.513",
    country: "US",
    name: {
      en : "Merced"
    }
  },
  MCG : {
    country: "US",
    name: {
      en : "MCG"
    }
  },
  MCI : {
    lat: "39.2928",
    lon: "-94.7267",
    country: "US",
    city: "MKC",
    name: {
      en : "Kansas City"
    }
  },
  MCK : {
    lat: "40.2639",
    lon: "-100.668",
    country: "US",
    name: {
      en : "McCook"
    }
  },
  MCM : {
    lat: "43.7333",
    lon: "7.41667",
    country: "MC",
    popularity: 4,
    name: {
      en : "Hel De Monte Carlo"
    }
  },
  MCN : {
    lat: "32.6956",
    lon: "-83.6478",
    country: "US",
    name: {
      en : "Lewis B Wilson"
    }
  },
  MCO : {
    lat: "28.4319",
    lon: "-81.3247",
    country: "US",
    city: "ORL",
    name: {
      en : "Orlando"
    }
  },
  MCP : {
    lat: "0.05",
    lon: "-51.0667",
    country: "BR",
    name: {
      en : "Macapa"
    }
  },
  MCT : {
    lat: "23.5917",
    lon: "58.2792",
    country: "OM",
    popularity: 2,
    name: {
      en : "Seeb"
    }
  },
  MCV : {
    country: "AU",
    name: {
      en : "McArthur River Arpt"
    }
  },
  MCW : {
    lat: "43.1569",
    lon: "-93.3294",
    country: "US",
    name: {
      en : "Mason City"
    }
  },
  MCX : {
    lat: "42.820758",
    lon: "47.655908",
    country: "RU",
    name: {
      en : "Uytash"
    }
  },
  MCY : {
    lat: "-26.6042",
    lon: "153.09",
    country: "AU",
    name: {
      en : "Maroochydore"
    }
  },
  MCZ : {
    lat: "-9.51528",
    lon: "-35.7958",
    country: "BR",
    name: {
      en : "Palmeres"
    }
  },
  MDC : {
    lat: "1.48333",
    lon: "124.85",
    country: "ID",
    name: {
      en : "Samratulang"
    }
  },
  MDE : {
    lat: "6.22083",
    lon: "-75.5931",
    country: "CO",
    name: {
      en : "Jose Marie Cordova"
    }
  },
  MDG : {
    lat: "44.5833",
    lon: "129.6",
    country: "CN",
    name: {
      en : "Mudanjiang"
    }
  },
  MDK : {
    country: "CD",
    name: {
      en : "MDK"
    }
  },
  MDL : {
    lat: "21.9392",
    lon: "96.0914",
    country: "MM",
    name: {
      en : "Annisaton"
    }
  },
  MDQ : {
    lat: "-37.9347",
    lon: "-57.5722",
    country: "AR",
    name: {
      en : "Mar Del Plata"
    }
  },
  MDT : {
    lat: "40.1931",
    lon: "-76.7622",
    country: "US",
    city: "HAR",
    name: {
      en : "Harrisburg"
    }
  },
  MDU : {
    lat: "-6.15861",
    lon: "143.65",
    country: "PG",
    name: {
      en : "Mendi"
    }
  },
  MDW : {
    lat: "41.785",
    lon: "-87.7519",
    country: "US",
    city: "CHI",
    popularity: 16,
    name: {
      en : "Midway"
    }
  },
  MDZ : {
    lat: "-32.8319",
    lon: "-68.7847",
    country: "AR",
    name: {
      en : "El Plumerillo"
    }
  },
  MEB : {
    country: "AU",
    city: "MEL",
    name: {
      en : "Essendon Arpt"
    }
  },
  MEC : {
    lat: "-0.95",
    lon: "-80.6833",
    country: "EC",
    name: {
      en : "Manta"
    }
  },
  MED : {
    lat: "24.545",
    lon: "39.7211",
    country: "SA",
    name: {
      en : "Prince Mohammad Bin Abdulaziz"
    }
  },
  MEE : {
    country: "NC",
    name: {
      en : "MEE"
    }
  },
  MEH : {
    lat: "71.0333",
    lon: "27.8333",
    country: "NO",
    name: {
      en : "Mehamn"
    }
  },
  MEI : {
    lat: "32.3372",
    lon: "-88.7492",
    country: "US",
    name: {
      en : "Key Field"
    }
  },
  MEL : {
    lat: "-37.6617",
    lon: "144.833",
    country: "AU",
    popularity: 10,
    name: {
      en : "Tullamarine"
    }
  },
  MEM : {
    lat: "35.0497",
    lon: "-89.9789",
    country: "US",
    popularity: 16,
    name: {
      en : "Memphis"
    }
  },
  MEQ : {
    country: "ID",
    name: {
      en : "MEQ"
    }
  },
  MES : {
    lat: "3.56111",
    lon: "98.6728",
    country: "ID",
    name: {
      en : "Polonia"
    }
  },
  MEX : {
    lat: "19.4353",
    lon: "-99.0728",
    country: "MX",
    popularity: 27,
    name: {
      en : "Juarez"
    }
  },
  MEY : {
    country: "NP",
    name: {
      en : "MEY"
    }
  },
  MFE : {
    lat: "26.2583",
    lon: "-98.2861",
    country: "US",
    name: {
      en : "Miller"
    }
  },
  MFK : {
    lat: "26.1667",
    lon: "119.917",
    country: "TW",
    name: {
      en : "Matsu"
    }
  },
  MFM : {
    lat: "22.2333",
    lon: "113.583",
    country: "MO",
    popularity: 1,
    name: {
      en : "Macau"
    }
  },
  MFR : {
    lat: "42.3736",
    lon: "-122.872",
    country: "US",
    name: {
      en : "Medford Jackson Cty"
    }
  },
  MFU : {
    country: "ZM",
    name: {
      en : "MFU"
    }
  },
  MGA : {
    lat: "12.1411",
    lon: "-86.1686",
    country: "NI",
    popularity: 2,
    name: {
      en : "Augusto C Sandino"
    }
  },
  MGB : {
    lat: "-37.7542",
    lon: "140.781",
    country: "AU",
    name: {
      en : "Mount Gambier"
    }
  },
  MGF : {
    lat: "-23.3836",
    lon: "-51.9333",
    country: "BR",
    name: {
      en : "Regional De Maringa"
    }
  },
  MGH : {
    lat: "-30.9167",
    lon: "30.25",
    country: "ZA",
    name: {
      en : "Margate"
    }
  },
  MGM : {
    lat: "32.3",
    lon: "-86.3911",
    country: "US",
    name: {
      en : "Dannelly Field"
    }
  },
  MGQ : {
    country: "SO",
    name: {
      en : "MGQ"
    }
  },
  MGS : {
    country: "CK",
    name: {
      en : "MGS"
    }
  },
  MGT : {
    country: "AU",
    name: {
      en : "MGT"
    }
  },
  MGW : {
    lat: "39.6428",
    lon: "-79.9158",
    country: "US",
    name: {
      en : "Morgantown"
    }
  },
  MGZ : {
    country: "MM",
    name: {
      en : "MGZ"
    }
  },
  MHD : {
    lat: "36.2367",
    lon: "59.6417",
    country: "IR",
    name: {
      en : "Mashad"
    }
  },
  MHG : {
    lat: "49.5",
    lon: "8.46667",
    country: "DE",
    name: {
      en : "Mannheim Neuostheim"
    }
  },
  MHH : {
    lat: "26.5111",
    lon: "-77.0847",
    country: "BS",
    name: {
      en : "Marsh Harbour"
    }
  },
  MHK : {
    lat: "39.1422",
    lon: "-96.6689",
    country: "US",
    name: {
      en : "Manhattan"
    }
  },
  MHP : {
    lat: "0",
    lon: "0",
    country: "BY",
    city: "MSQ",
    name: {
      en : "Minsk Intl 1"
    }
  },
  MHQ : {
    lat: "60.1233",
    lon: "19.8967",
    country: "FI",
    name: {
      en : "Mariehamn"
    }
  },
  MHR : {
    lat: "38.05",
    lon: "-121.933",
    country: "US",
    city: "SAC",
    name: {
      en : "Mather Air Force Base"
    }
  },
  MHT : {
    lat: "42.9383",
    lon: "-71.4389",
    country: "US",
    name: {
      en : "Manchester"
    }
  },
  MHU : {
    country: "AU",
    name: {
      en : "Mount Hotham Arpt"
    }
  },
  MIA : {
    lat: "25.7925",
    lon: "-80.2861",
    country: "US",
    popularity: 32,
    name: {
      en : "Miami"
    }
  },
  MID : {
    lat: "20.9333",
    lon: "-89.65",
    country: "MX",
    name: {
      en : "Merida"
    }
  },
  MIG : {
    lat: "31.4311",
    lon: "104.738",
    country: "CN",
    name: {
      en : "Mian Yang"
    }
  },
  MII : {
    lat: "-22.2",
    lon: "-49.9333",
    country: "BR",
    name: {
      en : "Dr Gastao Vidigal"
    }
  },
  MIM : {
    lat: "-36.9083",
    lon: "149.92",
    country: "AU",
    name: {
      en : "Merimbula"
    }
  },
  MIR : {
    lat: "35.7569",
    lon: "10.7528",
    country: "TN",
    popularity: 5,
    name: {
      en : "Habib Bourguiba"
    }
  },
  MIS : {
    country: "PG",
    name: {
      en : "MIS"
    }
  },
  MJA : {
    country: "MG",
    name: {
      en : "MJA"
    }
  },
  MJD : {
    lat: "27.3364",
    lon: "68.1417",
    country: "PK",
    name: {
      en : "Mohenjodaro"
    }
  },
  MJF : {
    lat: "65.8333",
    lon: "13.2",
    country: "NO",
    popularity: 7,
    name: {
      en : "Kjaerstad"
    }
  },
  MJI : {
    lat: "0",
    lon: "0",
    country: "LY",
    city: "TIP",
    name: {
      en : "Mitiga"
    }
  },
  MJK : {
    lat: "-25.8964",
    lon: "113.577",
    country: "AU",
    name: {
      en : "Shark Bay"
    }
  },
  MJM : {
    country: "CD",
    name: {
      en : "MJM"
    }
  },
  MJN : {
    lat: "-15.6658",
    lon: "46.3531",
    country: "MG",
    name: {
      en : "Amborovy"
    }
  },
  MJT : {
    lat: "39.0561",
    lon: "26.5994",
    country: "GR",
    name: {
      en : "Mytilene"
    }
  },
  MJU : {
    country: "ID",
    name: {
      en : "MJU"
    }
  },
  MJV : {
    lat: "37.7747",
    lon: "-0.811111",
    country: "ES",
    popularity: 34,
    name: {
      en : "San Javier"
    }
  },
  MJY : {
    lat: "58.1817",
    lon: "94.7450",
    country: "RU",
    name: {
      en : "Motygino Airport"
    }
  },
  MJZ : {
    country: "RU",
    name: {
      en : "MJZ"
    }
  },
  MKC : {
    lat: "39.1242",
    lon: "-94.5919",
    country: "US",
    popularity: 3,
    name: {
      en : "Kansas City"
    }
  },
  MKE : {
    lat: "42.9503",
    lon: "-87.8972",
    country: "US",
    popularity: 16,
    name: {
      en : "General Mitchell"
    }
  },
  MKG : {
    lat: "43.1706",
    lon: "-86.2375",
    country: "US",
    name: {
      en : "Muskegon Cty"
    }
  },
  MKK : {
    lat: "21.1528",
    lon: "-157.1",
    country: "US",
    name: {
      en : "Molokai"
    }
  },
  MKL : {
    country: "US",
    name: {
      en : "McKellar Fld"
    }
  },
  MKM : {
    country: "MY",
    name: {
      en : "Mukah Arpt"
    }
  },
  MKP : {
    country: "PF",
    name: {
      en : "MKP"
    }
  },
  MKQ : {
    country: "ID",
    name: {
      en : "MKQ"
    }
  },
  MKR : {
    lat: "-26.6",
    lon: "118.55",
    country: "AU",
    name: {
      en : "Meekatharra"
    }
  },
  MKW : {
    country: "ID",
    name: {
      en : "Rendani Arpt"
    }
  },
  MKX : {
    country: "YE",
    name: {
      en : "Mukalla Arpt"
    }
  },
  MKY : {
    lat: "-21.1728",
    lon: "149.181",
    country: "AU",
    name: {
      en : "Mackay"
    }
  },
  MKZ : {
    country: "MY",
    name: {
      en : "Batu Berendum Arpt"
    }
  },
  MLA : {
    lat: "35.9",
    lon: "14.5167",
    country: "MT",
    popularity: 29,
    name: {
      en : "Luqa"
    }
  },
  MLB : {
    lat: "28.1025",
    lon: "-80.6303",
    country: "US",
    name: {
      en : "Melbourne Regional"
    }
  },
  MLE : {
    lat: "4.20139",
    lon: "73.5244",
    country: "MV",
    popularity: 17,
    name: {
      en : "Male"
    }
  },
  MLG : {
    country: "ID",
    name: {
      en : "MLG"
    }
  },
  MLH : {
    lat: "47.65",
    lon: "7.64167",
    country: "FR",
    city: "EAP",
    name: {
      en : "Mulhouse EuroAirport French"
    }
  },
  MLI : {
    lat: "41.4489",
    lon: "-90.505",
    country: "US",
    name: {
      en : "Quad City"
    }
  },
  MLL : {
    country: "US",
    name: {
      en : "MLL"
    }
  },
  MLM : {
    lat: "19.8508",
    lon: "-101.024",
    country: "MX",
    name: {
      en : "Michoacan"
    }
  },
  MLN : {
    lat: "35.28",
    lon: "-2.95556",
    country: "ES",
    name: {
      en : "Melilla"
    }
  },
  MLO : {
    country: "GR",
    name: {
      en : "MLO"
    }
  },
  MLS : {
    lat: "46.4306",
    lon: "-105.881",
    country: "US",
    name: {
      en : "Miles City"
    }
  },
  MLU : {
    lat: "32.5111",
    lon: "-92.0389",
    country: "US",
    name: {
      en : "Monroe Regional"
    }
  },
  MLW : {
    country: "LR",
    name: {
      en : "Sprigg Payne Arpt"
    }
  },
  MLX : {
    lat: "38.3544",
    lon: "38.2536",
    country: "TR",
    name: {
      en : "Malatya"
    }
  },
  MLY : {
    country: "US",
    name: {
      en : "MLY"
    }
  },
  MMA : {
    country: "SE",
    popularity: 1,
    name: {
      en : "Malmo Metropolitan Area"
    }
  },
  MMB : {
    lat: "43.9",
    lon: "144.167",
    country: "JP",
    name: {
      en : "Memanbetsu"
    }
  },
  MME : {
    lat: "54.5167",
    lon: "-1.41667",
    country: "GB",
    name: {
      en : "Durham Tees Valley"
    }
  },
  MMG : {
    lat: "-28.0833",
    lon: "117.85",
    country: "AU",
    name: {
      en : "Mount Magnet"
    }
  },
  MMH : {
    lat: "37.6311",
    lon: "-118.851",
    country: "US",
    name: {
      en : "Mammoth Lakes"
    }
  },
  MMJ : {
    country: "JP",
    name: {
      en : "Matsumoto Arpt"
    }
  },
  MMK : {
    lat: "68.9667",
    lon: "33.3667",
    country: "RU",
    popularity: 1,
    name: {
      en : "Murmansk"
    }
  },
  MML : {
    lat: "44.4472",
    lon: "-95.8175",
    country: "US",
    name: {
      en : "Marshall"
    }
  },
  MMM : {
    lat: "-22.8025",
    lon: "148.705",
    country: "AU",
    name: {
      en : "Middlemount"
    }
  },
  MMO : {
    lat: "15.25",
    lon: "-23.1667",
    country: "CV",
    name: {
      en : "Vila Do Maio"
    }
  },
  MMU : {
    lat: "40.7992",
    lon: "-74.4158",
    country: "US",
    name: {
      en : "Morristown"
    }
  },
  MMX : {
    lat: "55.5278",
    lon: "13.3686",
    country: "SE",
    city: "MMA",
    name: {
      en : "Sturup"
    }
  },
  MMY : {
    lat: "24.7808",
    lon: "125.297",
    country: "JP",
    name: {
      en : "Miyako"
    }
  },
  MMZ : {
    country: "AF",
    name: {
      en : "MMZ"
    }
  },
  MNA : {
    country: "ID",
    name: {
      en : "MNA"
    }
  },
  MNB : {
    country: "CD",
    name: {
      en : "MNB"
    }
  },
  MNF : {
    country: "FJ",
    name: {
      en : "MNF"
    }
  },
  MNG : {
    country: "AU",
    name: {
      en : "MNG"
    }
  },
  MNI : {
    country: "MS",
    name: {
      en : "Bramble Arpt"
    }
  },
  MNL : {
    lat: "14.51",
    lon: "121.018",
    country: "PH",
    popularity: 17,
    name: {
      en : "Ninoy Aquino"
    }
  },
  MNS : {
    country: "ZM",
    name: {
      en : "MNS"
    }
  },
  MNT : {
    country: "US",
    name: {
      en : "MNT"
    }
  },
  MNU : {
    country: "MM",
    name: {
      en : "MNU"
    }
  },
  MOA : {
    country: "CU",
    name: {
      en : "MOA"
    }
  },
  MOB : {
    lat: "30.6883",
    lon: "-88.2408",
    country: "US",
    name: {
      en : "Mobile"
    }
  },
  MOC : {
    country: "BR",
    name: {
      en : "Montes Claros Arpt"
    }
  },
  MOD : {
    lat: "37.6269",
    lon: "-120.955",
    country: "US",
    popularity: 1,
    name: {
      en : "Harry Sham Fld"
    }
  },
  MOF : {
    country: "ID",
    name: {
      en : "MOF"
    }
  },
  MOG : {
    country: "MM",
    name: {
      en : "MOG"
    }
  },
  MOI : {
    lat: "-19.5",
    lon: "-158",
    country: "CK",
    name: {
      en : "Mitiaro Island"
    }
  },
  MOL : {
    lat: "62.7486",
    lon: "7.27111",
    country: "NO",
    name: {
      en : "Aro"
    }
  },
  MOQ : {
    lat: "-20.2836",
    lon: "44.3183",
    country: "MG",
    name: {
      en : "Morondava"
    }
  },
  MOT : {
    lat: "48.2597",
    lon: "-101.281",
    country: "US",
    name: {
      en : "Minot"
    }
  },
  MOU : {
    lat: "62.0894",
    lon: "-163.717",
    country: "US",
    name: {
      en : "Mountain Village"
    }
  },
  MOV : {
    lat: "-22.1167",
    lon: "149.533",
    country: "AU",
    popularity: 2,
    name: {
      en : "Moranbah"
    }
  },
  MOZ : {
    lat: "-17.4833",
    lon: "-149.767",
    country: "PF",
    name: {
      en : "Temae"
    }
  },
  MPA : {
    country: "NA",
    name: {
      en : "MPA"
    }
  },
  MPH : {
    lat: "11.9258",
    lon: "121.952",
    country: "PH",
    name: {
      en : "Malay"
    }
  },
  MPI : {
    country: "PA",
    name: {
      en : "MPI"
    }
  },
  MPL : {
    lat: "43.5808",
    lon: "3.9675",
    country: "FR",
    name: {
      en : "Frejorgues"
    }
  },
  MPM : {
    lat: "-25.9167",
    lon: "32.5667",
    country: "MZ",
    name: {
      en : "Maputo"
    }
  },
  MPN : {
    lat: "-51.8167",
    lon: "-58.45",
    country: "FK",
    name: {
      en : "Mount Pleasant"
    }
  },
  MQF : {
    lat: "53.45",
    lon: "59.0667",
    country: "RU",
    popularity: 2,
    name: {
      en : "Magnitogorsk"
    }
  },
  MQJ : {
    lat: "66.45",
    lon: "143.25",
    country: "RU",
    name: {
      en : "Moma"
    }
  },
  MQL : {
    lat: "-34.2275",
    lon: "142.085",
    country: "AU",
    name: {
      en : "Mildura"
    }
  },
  MQM : {
    lat: "40.6231",
    lon: "37.2153",
    country: "TR",
    name: {
      en : "Mardin"
    }
  },
  MQN : {
    lat: "66.3667",
    lon: "14.3",
    country: "NO",
    name: {
      en : "Rossvoll"
    }
  },
  MQP : {
    lat: "-25.3908",
    lon: "31.0994",
    country: "ZA",
    name: {
      en : "Kruger Mpumalanga"
    }
  },
  MQT : {
    lat: "46.5342",
    lon: "-87.5583",
    country: "US",
    name: {
      en : "Sawyer Intl"
    }
  },
  MQX : {
    country: "ET",
    name: {
      en : "MQX"
    }
  },
  MRA : {
    country: "LY",
    name: {
      en : "MRA"
    }
  },
  MRB : {
    country: "US",
    name: {
      en : "Martinsburgh Regional Arpt"
    }
  },
  MRD : {
    lat: "8.58333",
    lon: "-71.1578",
    country: "VE",
    name: {
      en : "Alberto Carnevalli"
    }
  },
  MRE : {
    lat: "-1.18333",
    lon: "35.0833",
    country: "KE",
    name: {
      en : "Mara Lodges"
    }
  },
  MRO : {
    lat: "-40.95",
    lon: "175.65",
    country: "NZ",
    name: {
      en : "Masterton"
    }
  },
  MRQ : {
    country: "PH",
    name: {
      en : "MRQ"
    }
  },
  MRS : {
    lat: "43.4356",
    lon: "5.21639",
    country: "FR",
    popularity: 44,
    name: {
      en : "Marseille Provence"
    }
  },
  MRU : {
    lat: "-20.4275",
    lon: "57.6764",
    country: "MU",
    popularity: 8,
    name: {
      en : "Plaisancet"
    }
  },
  MRV : {
    lat: "44.2167",
    lon: "43.1",
    country: "RU",
    popularity: 8,
    name: {
      en : "Mineralnye Vody"
    }
  },
  MRX : {
    country: "IR",
    name: {
      en : "MRX"
    }
  },
  MRY : {
    lat: "36.5881",
    lon: "-121.848",
    country: "US",
    name: {
      en : "Monterey Peninsula"
    }
  },
  MRZ : {
    lat: "-29.4983",
    lon: "149.846",
    country: "AU",
    name: {
      en : "Moree"
    }
  },
  MSA : {
    country: "CA",
    name: {
      en : "MSA"
    }
  },
  MSE : {
    lat: "51.35",
    lon: "1.35",
    country: "GB",
    name: {
      en : "Kent"
    }
  },
  MSJ : {
    lat: "40.7003",
    lon: "141.372",
    country: "JP",
    name: {
      en : "Misawa"
    }
  },
  MSL : {
    lat: "34.7486",
    lon: "-87.6161",
    country: "US",
    name: {
      en : "Muscle Shoals"
    }
  },
  MSN : {
    lat: "43.0833",
    lon: "-89.3667",
    country: "US",
    popularity: 3,
    name: {
      en : "Dane County Regional"
    }
  },
  MSO : {
    lat: "46.9156",
    lon: "-114.088",
    country: "US",
    name: {
      en : "Missoula"
    }
  },
  MSP : {
    lat: "44.8861",
    lon: "-93.2178",
    country: "US",
    popularity: 3,
    name: {
      en : "Minneapolis St Paul"
    }
  },
  MSQ : {
    lat: "53.88",
    lon: "28.03",
    country: "BY",
    name: {
      en : "Minsk"
    }
  },
  MSR : {
    lat: "38.725",
    lon: "41.625",
    country: "TR",
    name: {
      en : "Mus"
    }
  },
  MSS : {
    lat: "44.9378",
    lon: "-74.8467",
    country: "US",
    popularity: 1,
    name: {
      en : "Richards Field"
    }
  },
  MST : {
    lat: "50.9111",
    lon: "5.77361",
    country: "NL",
    name: {
      en : "Maastricht Aachen"
    }
  },
  MSU : {
    lat: "-29.3014",
    lon: "27.5056",
    country: "LS",
    popularity: 1,
    name: {
      en : "Moshoeshoe"
    }
  },
  MSW : {
    country: "ER",
    name: {
      en : "MSW"
    }
  },
  MSY : {
    lat: "29.9911",
    lon: "-90.2514",
    country: "US",
    popularity: 12,
    name: {
      en : "Louis Armstrong"
    }
  },
  MSZ : {
    country: "AO",
    name: {
      en : "MSZ"
    }
  },
  MTH : {
    lat: "24.7194",
    lon: "-81.0514",
    country: "US",
    name: {
      en : "Marathon"
    }
  },
  MTJ : {
    lat: "38.5006",
    lon: "-107.895",
    country: "US",
    name: {
      en : "Montrose County"
    }
  },
  MTM : {
    country: "US",
    name: {
      en : "MTM"
    }
  },
  MTR : {
    lat: "8.74583",
    lon: "-75.8814",
    country: "CO",
    name: {
      en : "S Jeronimo"
    }
  },
  MTS : {
    lat: "-26.5242",
    lon: "31.3114",
    country: "SZ",
    name: {
      en : "Matsapha"
    }
  },
  MTT : {
    lat: "17.9833",
    lon: "-94.5167",
    country: "MX",
    name: {
      en : "Minatitlan"
    }
  },
  MTV : {
    country: "VU",
    name: {
      en : "MTV"
    }
  },
  MTY : {
    lat: "25.7667",
    lon: "-100.1",
    country: "MX",
    popularity: 9,
    name: {
      en : "Escobedo"
    }
  },
  MUA : {
    country: "SB",
    name: {
      en : "Munda Arpt"
    }
  },
  MUB : {
    lat: "-19.9708",
    lon: "23.4306",
    country: "BW",
    name: {
      en : "Maun"
    }
  },
  MUC : {
    lat: "48.35",
    lon: "11.7833",
    country: "DE",
    popularity: 264,
    name: {
      en : "Munich"
    }
  },
  MUE : {
    lat: "20.0125",
    lon: "-155.673",
    country: "US",
    name: {
      en : "Waimea"
    }
  },
  MUH : {
    country: "EG",
    name: {
      en : "MUH"
    }
  },
  MUK : {
    country: "CK",
    name: {
      en : "MUK"
    }
  },
  MUN : {
    lat: "9.74583",
    lon: "-63.1542",
    country: "VE",
    name: {
      en : "Quiriquire"
    }
  },
  MUR : {
    country: "MY",
    name: {
      en : "Marudi Arpt"
    }
  },
  MUX : {
    country: "PK",
    name: {
      en : "MUX"
    }
  },
  MUZ : {
    country: "TZ",
    name: {
      en : "Musoma Arpt"
    }
  },
  MVB : {
    lat: "-1.65",
    lon: "13.4333",
    country: "GA",
    name: {
      en : "Franceville Mvengue"
    }
  },
  MVD : {
    lat: "-34.8333",
    lon: "-56.0333",
    country: "UY",
    name: {
      en : "Carrasco"
    }
  },
  MVP : {
    country: "CO",
    name: {
      en : "Mitu Arpt"
    }
  },
  MVT : {
    country: "PF",
    name: {
      en : "MVT"
    }
  },
  MVY : {
    lat: "41.3928",
    lon: "-70.6167",
    country: "US",
    name: {
      en : "Dukes County"
    }
  },
  MWA : {
    lat: "37.7519",
    lon: "-89.0164",
    country: "US",
    name: {
      en : "Williamson County"
    }
  },
  MWF : {
    country: "VU",
    name: {
      en : "MWF"
    }
  },
  MWH : {
    lat: "47.205",
    lon: "-119.316",
    country: "US",
    name: {
      en : "Grant County"
    }
  },
  MWK : {
    country: "ID",
    name: {
      en : "MWK"
    }
  },
  MWQ : {
    country: "MM",
    name: {
      en : "MWQ"
    }
  },
  MWX : {
    lat: "0",
    lon: "0",
    country: "KR",
    name: {
      en : "Muan International Airport"
    }
  },
  MWZ : {
    lat: "-2.44472",
    lon: "32.9281",
    country: "TZ",
    name: {
      en : "Mwanza"
    }
  },
  MXH : {
    country: "PG",
    name: {
      en : "MXH"
    }
  },
  MXL : {
    lat: "32.6333",
    lon: "-115.233",
    country: "MX",
    name: {
      en : "Rodolfg Sachez Taboada"
    }
  },
  MXM : {
    country: "MG",
    name: {
      en : "MXM"
    }
  },
  MXN : {
    lat: "48.6",
    lon: "-3.81667",
    country: "FR",
    name: {
      en : "Morlaix"
    }
  },
  MXP : {
    lat: "45.6333",
    lon: "8.71667",
    country: "IT",
    city: "MIL",
    name: {
      en : "Malpensa"
    }
  },
  MXS : {
    country: "WS",
    name: {
      en : "Maota Arpt"
    }
  },
  MXT : {
    country: "MG",
    name: {
      en : "MXT"
    }
  },
  MXV : {
    country: "MN",
    name: {
      en : "MXV"
    }
  },
  MXX : {
    lat: "61",
    lon: "14.55",
    country: "SE",
    name: {
      en : "Mora"
    }
  },
  MXZ : {
    lat: "24.35",
    lon: "116.133",
    country: "CN",
    name: {
      en : "Meixian"
    }
  },
  MYA : {
    lat: "-35.9017",
    lon: "150.147",
    country: "AU",
    name: {
      en : "Moruya"
    }
  },
  MYD : {
    lat: "-3.22611",
    lon: "40.1006",
    country: "KE",
    name: {
      en : "Malindi"
    }
  },
  MYE : {
    country: "JP",
    name: {
      en : "MYE"
    }
  },
  MYG : {
    country: "BS",
    name: {
      en : "MYG"
    }
  },
  MYJ : {
    lat: "33.8222",
    lon: "132.704",
    country: "JP",
    name: {
      en : "Matsuyama"
    }
  },
  MYR : {
    lat: "33.6792",
    lon: "-78.9297",
    country: "US",
    name: {
      en : "Myrtle Beach Jetway"
    }
  },
  MYT : {
    country: "MM",
    name: {
      en : "MYT"
    }
  },
  MYU : {
    country: "US",
    name: {
      en : "MYU"
    }
  },
  MYV : {
    lat: "39.0981",
    lon: "-121.57",
    country: "US",
    name: {
      en : "Yuba County"
    }
  },
  MYW : {
    lat: "-10.3389",
    lon: "40.1936",
    country: "TZ",
    name: {
      en : "Mtwara"
    }
  },
  MYY : {
    lat: "4.45528",
    lon: "114.001",
    country: "MY",
    name: {
      en : "Miri"
    }
  },
  MZG : {
    lat: "23.5692",
    lon: "119.619",
    country: "TW",
    name: {
      en : "Makung"
    }
  },
  MZH : {
    country: "TR",
    name: {
      en : "MZH"
    }
  },
  MZI : {
    lat: "14.5083",
    lon: "-4.085",
    country: "ML",
    name: {
      en : "Mopti"
    }
  },
  MZL : {
    lat: "5.09028",
    lon: "-75.6811",
    country: "CO",
    name: {
      en : "Santaguida"
    }
  },
  MZO : {
    lat: "20.325",
    lon: "-77.1289",
    country: "CU",
    name: {
      en : "Sierra Maestra"
    }
  },
  MZR : {
    country: "AF",
    name: {
      en : "Mazar I Sharif Arpt"
    }
  },
  MZT : {
    lat: "23.15",
    lon: "-106.25",
    country: "MX",
    name: {
      en : "Buelina"
    }
  },
  MZV : {
    country: "MY",
    name: {
      en : "Mulu Arpt"
    }
  },
  MZW : {
    country: "DZ",
    name: {
      en : "MZW"
    }
  },
  NAA : {
    lat: "-30.3",
    lon: "149.833",
    country: "AU",
    name: {
      en : "Narrabri"
    }
  },
  NAG : {
    lat: "21.0911",
    lon: "79.0497",
    country: "IN",
    name: {
      en : "Sonegaon"
    }
  },
  NAH : {
    country: "ID",
    name: {
      en : "NAH"
    }
  },
  NAJ : {
    country: "AZ",
    name: {
      en : "NAJ"
    }
  },
  NAL : {
    lat: "43.5333",
    lon: "43.7",
    country: "RU",
    name: {
      en : "Nalchik"
    }
  },
  NAN : {
    lat: "-17.7531",
    lon: "177.448",
    country: "FJ",
    name: {
      en : "Nadi"
    }
  },
  NAO : {
    country: "CN",
    name: {
      en : "NAO"
    }
  },
  NAP : {
    lat: "40.8861",
    lon: "14.2917",
    country: "IT",
    popularity: 2,
    name: {
      en : "Capodichino"
    }
  },
  NAQ : {
    country: "GL",
    name: {
      en : "NAQ"
    }
  },
  NAS : {
    lat: "25.0406",
    lon: "-77.472",
    country: "BS",
    popularity: 16,
    name: {
      en : "Nassau"
    }
  },
  NAT : {
    lat: "-5.91056",
    lon: "-35.2436",
    country: "BR",
    name: {
      en : "Augusto Severo"
    }
  },
  NAU : {
    country: "PF",
    name: {
      en : "NAU"
    }
  },
  NAV : {
    lat: "38.6333",
    lon: "34.7167",
    country: "TR",
    name: {
      en : "Nevsehir"
    }
  },
  NAW : {
    lat: "6.51667",
    lon: "101.75",
    country: "TH",
    name: {
      en : "Narathiwat"
    }
  },
  NAY : {
    lat: "40.0736",
    lon: "116.608",
    country: "CN",
    city: "BJS",
    name: {
      en : "Nanyuan"
    }
  },
  NBC : {
    lat: "55.5667",
    lon: "52.1",
    country: "RU",
    name: {
      en : "Nijnekamsk"
    }
  },
  NBE : {
    lat: "0",
    lon: "0",
    country: "TN",
    name: {
      en : "Zine El Abidine Ben Ali"
    }
  },
  NBJ : {
    lat: "-9.046778",
    lon: "13.507194",
    country: "AO",
    city: "LAD",
    name: {
      en : "Dr. Antonio Agostinho Neto"
    }
  },
  NBO : {
    lat: "-1.31667",
    lon: "36.9308",
    country: "KE",
    popularity: 7,
    name: {
      en : "Jomo Kenyatta"
    }
  },
  NBS : {
    lat: "0",
    lon: "0",
    country: "CN",
    name: {
      en : "Changbaishan Airport"
    }
  },
  NBW : {
    country: "CU",
    city: "GAO",
    name: {
      en : "Guantanamo NAS"
    }
  },
  NBX : {
    country: "ID",
    name: {
      en : "NBX"
    }
  },
  NCA : {
    lat: "21.9333",
    lon: "-71.9833",
    country: "TC",
    name: {
      en : "North Caicos"
    }
  },
  NCE : {
    lat: "43.6639",
    lon: "7.2175",
    country: "FR",
    popularity: 404,
    name: {
      en : "Cote D Azur"
    }
  },
  NCL : {
    lat: "55.0378",
    lon: "-1.68667",
    country: "GB",
    popularity: 15,
    name: {
      en : "Newcastle"
    }
  },
  NCN : {
    country: "US",
    name: {
      en : "NCN"
    }
  },
  NCU : {
    country: "UZ",
    name: {
      en : "NCU"
    }
  },
  NCY : {
    lat: "45.9306",
    lon: "6.10083",
    country: "FR",
    name: {
      en : "Annecy Meythet"
    }
  },
  NDB : {
    lat: "20.9342",
    lon: "-17.0283",
    country: "MR",
    name: {
      en : "Nouadhibou"
    }
  },
  NDC : {
    country: "IN",
    name: {
      en : "Nanded Airport"
    }
  },
  NDG : {
    lat: "47.3167",
    lon: "123.917",
    country: "CN",
    name: {
      en : "Qiqihar"
    }
  },
  NDJ : {
    lat: "12.135",
    lon: "15.0361",
    country: "TD",
    name: {
      en : "N Djamena"
    }
  },
  NDR : {
    lat: "35.15",
    lon: "-2.91667",
    country: "MA",
    name: {
      en : "Nador"
    }
  },
  NDY : {
    lat: "59.25",
    lon: "-2.58333",
    country: "GB",
    name: {
      en : "Sanday"
    }
  },
  NER : {
    lat: "56.65",
    lon: "124.6",
    country: "RU",
    name: {
      en : "Neryungri"
    }
  },
  NEV : {
    lat: "17.205",
    lon: "-62.5925",
    country: "KN",
    name: {
      en : "Nevis"
    }
  },
  NEW : {
    lat: "30.0394",
    lon: "-90.0267",
    country: "US",
    city: "MSY",
    name: {
      en : "New Lakefront"
    }
  },
  NGB : {
    lat: "29.8667",
    lon: "121.517",
    country: "CN",
    name: {
      en : "Ningbo"
    }
  },
  NGK : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "NGK"
    }
  },
  NGO : {
    lat: "35.3049",
    lon: "136.994",
    country: "JP",
    popularity: 1,
    name: {
      en : "Nagoya Chubu Centrair"
    }
  },
  NGQ : {
    country: "CN",
    name: {
      en : "NGQ"
    }
  },
  NGS : {
    lat: "32.9119",
    lon: "129.917",
    country: "JP",
    name: {
      en : "Nagasaki"
    }
  },
  NHA : {
    lat: "12.2278",
    lon: "109.194",
    country: "VN",
    name: {
      en : "Nha Trang"
    }
  },
  NHV : {
    country: "PF",
    name: {
      en : "NHV"
    }
  },
  NIB : {
    country: "US",
    name: {
      en : "NIB"
    }
  },
  NIM : {
    lat: "13.4833",
    lon: "2.17083",
    country: "NE",
    name: {
      en : "Niamey"
    }
  },
  NIU : {
    country: "PF",
    name: {
      en : "NIU"
    }
  },
  NJC : {
    lat: "60.95",
    lon: "76.4833",
    country: "RU",
    popularity: 4,
    name: {
      en : "Nizhnevartovsk"
    }
  },
  NJF : {
    country: "IQ",
    name: {
      en : "Najaf International Arpt"
    }
  },
  NKC : {
    lat: "18.0919",
    lon: "-15.9519",
    country: "MR",
    name: {
      en : "Nouakchott"
    }
  },
  NKG : {
    lat: "31.9953",
    lon: "118.812",
    country: "CN",
    name: {
      en : "Nanjing"
    }
  },
  NKI : {
    country: "US",
    name: {
      en : "NKI"
    }
  },
  NKM : {
    lat: "35.255",
    lon: "136.924",
    country: "JP",
    city: "NGO",
    name: {
      en : "Nagoya Komaki"
    }
  },
  NKT : {
    country: "TR",
    name: {
      en : "Sirnak Airport"
    }
  },
  NLA : {
    lat: "-12.9958",
    lon: "28.6631",
    country: "ZM",
    name: {
      en : "Ndola"
    }
  },
  NLD : {
    lat: "27.4347",
    lon: "-99.5667",
    country: "MX",
    name: {
      en : "Quetzalcoatl"
    }
  },
  NLG : {
    country: "US",
    name: {
      en : "Nelson Lagoon Arpt"
    }
  },
  NLI : {
    country: "RU",
    popularity: 405,
    name: {
      en : "Nikolayevsk-on-Amur"
    }
  },
  NLK : {
    lat: "-29.0425",
    lon: "167.939",
    country: "NF",
    name: {
      en : "Norfolk Island"
    }
  },
  NLO : {
    country: "CD",
    city: "FIH",
    name: {
      en : "N Dolo Airport"
    }
  },
  NLT : {
    country: "CN",
    name: {
      en : "NLT"
    }
  },
  NLU : {
    country: "MX",
    city: "MEX",
    name: {
      en : "Felipe Ángeles International Airport"
    }
  },
  NLV : {
    lat: "47.05",
    lon: "31.9167",
    country: "UA",
    name: {
      en : "Nikolaev"
    }
  },
  NMA : {
    lat: "40.98",
    lon: "71.56",
    country: "UZ",
    name: {
      en : "Namangan"
    }
  },
  NME : {
    country: "US",
    name: {
      en : "NME"
    }
  },
  NNB : {
    country: "SB",
    name: {
      en : "NNB"
    }
  },
  NNG : {
    lat: "22.5833",
    lon: "108.133",
    country: "CN",
    name: {
      en : "Nanning"
    }
  },
  NNL : {
    country: "US",
    name: {
      en : "Nondalton Arpt"
    }
  },
  NNM : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Naryan-Mar"
    }
  },
  NNT : {
    lat: "18.8",
    lon: "100.783",
    country: "TH",
    name: {
      en : "Nan"
    }
  },
  NNY : {
    country: "CN",
    name: {
      en : "NNY"
    }
  },
  NOB : {
    country: "CR",
    name: {
      en : "NOB"
    }
  },
  NOC : {
    lat: "53.9167",
    lon: "-8.81667",
    country: "IE",
    name: {
      en : "Knock"
    }
  },
  NOJ : {
    lat: "63.5",
    lon: "75",
    country: "RU",
    name: {
      en : "Nojabrxsk"
    }
  },
  NOP : {
    country: "TR",
    name: {
      en : "Sinop"
    }
  },
  NOS : {
    lat: "-13.3111",
    lon: "48.3139",
    country: "MG",
    name: {
      en : "Fascene"
    }
  },
  NOU : {
    lat: "-22.0169",
    lon: "166.211",
    country: "NC",
    name: {
      en : "Tontouta"
    }
  },
  NOV : {
    country: "AO",
    name: {
      en : "NOV"
    }
  },
  NOZ : {
    lat: "53.75",
    lon: "87.1667",
    country: "RU",
    name: {
      en : "Novokuznetsk"
    }
  },
  NPE : {
    lat: "-39.4681",
    lon: "176.865",
    country: "NZ",
    name: {
      en : "Hawkes Bay"
    }
  },
  NPL : {
    lat: "-39.01",
    lon: "174.176",
    country: "NZ",
    name: {
      en : "New Plymouth"
    }
  },
  NQN : {
    lat: "-38.95",
    lon: "-68.1522",
    country: "AR",
    name: {
      en : "Neuquen"
    }
  },
  NQU : {
    country: "CO",
    name: {
      en : "Nuqui Arpt"
    }
  },
  NQY : {
    lat: "50.4394",
    lon: "-4.99472",
    country: "GB",
    name: {
      en : "Newquay Civil"
    }
  },
  NQZ : {
    lat: "51.1667",
    lon: "71.5",
    country: "KZ",
    popularity: 30,
    name: {
      en : "Nursultan Nazarbayev International Airport"
    }
  },
  NRA : {
    lat: "-34.7017",
    lon: "146.525",
    country: "AU",
    name: {
      en : "Narrandera"
    }
  },
  NRK : {
    lat: "58.5833",
    lon: "16.25",
    country: "SE",
    name: {
      en : "Kungsangen"
    }
  },
  NRL : {
    lat: "59.3703",
    lon: "-2.43333",
    country: "GB",
    name: {
      en : "North Ronaldsay"
    }
  },
  NRN : {
    lat: "51.6056",
    lon: "6.15",
    country: "DE",
    city: "DUS",
    name: {
      en : "Niederrhein"
    }
  },
  NRT : {
    lat: "35.7639",
    lon: "140.391",
    country: "JP",
    city: "TYO",
    popularity: 4,
    name: {
      en : "Narita"
    }
  },
  NSH : {
    country: "IR",
    name: {
      en : "NSH"
    }
  },
  NSI : {
    lat: "3.70222",
    lon: "11.5503",
    country: "CM",
    city: "YAO",
    name: {
      en : "Nsimalen"
    }
  },
  NSK : {
    lat: "69.3167",
    lon: "87.3167",
    country: "RU",
    name: {
      en : "Alykel"
    }
  },
  NSN : {
    lat: "-41.3",
    lon: "173.219",
    country: "NZ",
    name: {
      en : "Nelson"
    }
  },
  NST : {
    lat: "8.46667",
    lon: "99.95",
    country: "TH",
    name: {
      en : "Nakhon Si Thammarat"
    }
  },
  NSZ : {
    country: "CN",
    name: {
      en : "NSZ"
    }
  },
  NTE : {
    lat: "47.1583",
    lon: "-1.60972",
    country: "FR",
    popularity: 4,
    name: {
      en : "Nantes Atlantique"
    }
  },
  NTG : {
    lat: "32.0667",
    lon: "120.967",
    country: "CN",
    name: {
      en : "Nantong"
    }
  },
  NTL : {
    lat: "-32.7958",
    lon: "151.833",
    country: "AU",
    name: {
      en : "Williamtown"
    }
  },
  NTN : {
    lat: "-17.6883",
    lon: "141.07",
    country: "AU",
    name: {
      en : "Normanton"
    }
  },
  NTQ : {
    country: "JP",
    name: {
      en : "NTQ"
    }
  },
  NTX : {
    country: "ID",
    name: {
      en : "NTX"
    }
  },
  NUE : {
    lat: "49.5",
    lon: "11.0833",
    country: "DE",
    popularity: 117,
    name: {
      en : "Nuremberg"
    }
  },
  NUI : {
    country: "US",
    name: {
      en : "NUI"
    }
  },
  NUK : {
    country: "PF",
    name: {
      en : "NUK"
    }
  },
  NUL : {
    lat: "64.7278",
    lon: "-158.077",
    country: "US",
    name: {
      en : "Nulato"
    }
  },
  NUP : {
    country: "US",
    name: {
      en : "NUP"
    }
  },
  NUS : {
    country: "VU",
    name: {
      en : "NUS"
    }
  },
  NUX : {
    lat: "66.07",
    lon: "76.52",
    country: "RU",
    name: {
      en : "Novy Urengoy"
    }
  },
  NVA : {
    country: "CO",
    name: {
      en : "Aeropuerto Benito Sales"
    }
  },
  NVI : {
    country: "UZ",
    name: {
      en : "NVI"
    }
  },
  NVK : {
    lat: "68.425",
    lon: "17.425",
    country: "NO",
    name: {
      en : "Framnes"
    }
  },
  NVT : {
    lat: "-26.8667",
    lon: "-48.6333",
    country: "BR",
    name: {
      en : "Navegantes"
    }
  },
  NWI : {
    lat: "52.6833",
    lon: "1.28333",
    country: "GB",
    name: {
      en : "Norwich"
    }
  },
  NYA : {
    country: "RU",
    name: {
      en : "Nyagan"
    }
  },
  NYI : {
    country: "GH",
    name: {
      en : "NYI"
    }
  },
  NYK : {
    lat: "0.016667",
    lon: "37.0667",
    country: "KE",
    name: {
      en : "Nanyuki"
    }
  },
  NYM : {
    country: "RU",
    name: {
      en : "NYM"
    }
  },
  NYO : {
    lat: "58.75",
    lon: "17",
    country: "SE",
    city: "STO",
    name: {
      en : "Skavsta"
    }
  },
  NYR : {
    country: "RU",
    name: {
      en : "NYURBA"
    }
  },
  NYU : {
    lat: "21.1814",
    lon: "94.9347",
    country: "MM",
    name: {
      en : "Nyaung U"
    }
  },
  NZE : {
    country: "GN",
    name: {
      en : "NZE"
    }
  },
  NZG : {
    lat: "55.80216499676456",
    lon: "109.59888002926456",
    country: "RU",
    name: {
      en : "Nizhneangarsk"
    }
  },
  NZH : {
    country: "CN",
    name: {
      en : "Manzhouliarpt"
    }
  },
  OAG : {
    lat: "-33.3792",
    lon: "149.123",
    country: "AU",
    name: {
      en : "Springhill"
    }
  },
  OAI : {
    country: "AF",
    name: {
      en : "OAI"
    }
  },
  OAJ : {
    lat: "34.8303",
    lon: "-77.6117",
    country: "US",
    name: {
      en : "Albert J Ellis"
    }
  },
  OAK : {
    lat: "37.7236",
    lon: "-122.216",
    country: "US",
    name: {
      en : "Metro Oakland"
    }
  },
  OAL : {
    lat: "-11.4339",
    lon: "-61.4825",
    country: "BR",
    name: {
      en : "Cacoal"
    }
  },
  OAM : {
    lat: "-44.9694",
    lon: "171.083",
    country: "NZ",
    name: {
      en : "Oamaru"
    }
  },
  OAX : {
    lat: "17",
    lon: "-96.7333",
    country: "MX",
    name: {
      en : "Xoxocotlan"
    }
  },
  OAZ : {
    country: "AF",
    name: {
      en : "OAZ"
    }
  },
  OBN : {
    country: "GB",
    name: {
      en : "Connel Airport"
    }
  },
  OBO : {
    lat: "42.8906",
    lon: "143.164",
    country: "JP",
    name: {
      en : "Obihiro"
    }
  },
  OBU : {
    country: "US",
    name: {
      en : "OBU"
    }
  },
  OBX : {
    country: "PG",
    name: {
      en : "OBX"
    }
  },
  OBZ : {
    country: "DE",
    name: {
      en : "OBZ"
    }
  },
  OCC : {
    country: "EC",
    name: {
      en : "Aeropuerto Francisco De Orellana"
    }
  },
  OCV : {
    country: "CO",
    name: {
      en : "Aguasclaras Arpt"
    }
  },
  ODN : {
    country: "MY",
    name: {
      en : "Long Seridan Arpt"
    }
  },
  ODO : {
    lat: "57.8635008",
    lon: "114.2386734",
    country: "RU",
    name: {
      en : "Bodaybo"
    }
  },
  ODS : {
    lat: "46.4333",
    lon: "30.6833",
    country: "UA",
    popularity: 120,
    name: {
      en : "Central"
    }
  },
  ODW : {
    lat: "48.2514",
    lon: "-122.686",
    country: "US",
    name: {
      en : "Oak Harbour"
    }
  },
  ODY : {
    country: "LA",
    name: {
      en : "ODY"
    }
  },
  OER : {
    lat: "63.4083",
    lon: "18.9917",
    country: "SE",
    name: {
      en : "Ornskoldsvik"
    }
  },
  OGG : {
    lat: "20.9006",
    lon: "-156.434",
    country: "US",
    name: {
      en : "Kahului"
    }
  },
  OGN : {
    country: "JP",
    name: {
      en : "Yonaguni Jima Airport"
    }
  },
  OGS : {
    lat: "44.6817",
    lon: "-75.4658",
    country: "US",
    name: {
      en : "Ogdensburg"
    }
  },
  OGU : {
    lat: "40.966667",
    lon: "38.080000",
    country: "TR",
    name: {
      en : "Ordu–Giresun"
    }
  },
  OGX : {
    country: "DZ",
    name: {
      en : "OGX"
    }
  },
  OGZ : {
    lat: "43.2",
    lon: "44.6",
    country: "RU",
    name: {
      en : "Vladikavkaz"
    }
  },
  OHD : {
    country: "MK",
    name: {
      en : "Ohrid Arpt"
    }
  },
  OHE : {
    country: "CN",
    name: {
      en : "OHE"
    }
  },
  OHH : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Okha"
    }
  },
  OHO : {
    lat: "59,24",
    lon: "143,03",
    country: "RU",
    name: {
      en : "Okhotsk"
    }
  },
  OIA : {
    lat: "-6.77583",
    lon: "-51.06",
    country: "BR",
    name: {
      en : "Ourilandia"
    }
  },
  OIM : {
    lat: "34.7792",
    lon: "139.365",
    country: "JP",
    name: {
      en : "Oshima"
    }
  },
  OIT : {
    lat: "33.4833",
    lon: "131.733",
    country: "JP",
    name: {
      en : "Oita"
    }
  },
  OKA : {
    lat: "26.2",
    lon: "127.65",
    country: "JP",
    name: {
      en : "Naha Field"
    }
  },
  OKC : {
    lat: "35.3922",
    lon: "-97.6017",
    country: "US",
    name: {
      en : "Will Rogers World"
    }
  },
  OKD : {
    lat: "43.1156",
    lon: "141.385",
    country: "JP",
    city: "SPK",
    name: {
      en : "Okadama"
    }
  },
  OKI : {
    country: "JP",
    name: {
      en : "OKI"
    }
  },
  OKJ : {
    lat: "34.5867",
    lon: "133.936",
    country: "JP",
    name: {
      en : "Okayama"
    }
  },
  OKO : {
    lat: "35.75",
    lon: "139.35",
    country: "JP",
    city: "TYO",
    name: {
      en : "Yokota Afb"
    }
  },
  OLA : {
    country: "NO",
    name: {
      en : "OLA"
    }
  },
  OLB : {
    lat: "40.8664",
    lon: "9.50028",
    country: "IT",
    popularity: 6,
    name: {
      en : "Costa Smeralda"
    }
  },
  OLF : {
    country: "US",
    name: {
      en : "OLF"
    }
  },
  OLH : {
    country: "US",
    name: {
      en : "OLH"
    }
  },
  OLJ : {
    country: "VU",
    name: {
      en : "OLJ"
    }
  },
  OLM : {
    lat: "46.9736",
    lon: "-122.903",
    country: "US",
    name: {
      en : "Olympia"
    }
  },
  OLP : {
    lat: "-31",
    lon: "136",
    country: "AU",
    name: {
      en : "Olympic Dam"
    }
  },
  OLS : {
    lat: "31.4167",
    lon: "-110.85",
    country: "US",
    name: {
      en : "International"
    }
  },
  OLZ : {
    country: "RU",
    name: {
      en : "Olyokminsk"
    }
  },
  OMA : {
    lat: "41.3025",
    lon: "-95.8942",
    country: "US",
    name: {
      en : "Eppley Airfield"
    }
  },
  OMC : {
    country: "PH",
    name: {
      en : "OMC"
    }
  },
  OMD : {
    lat: "-28.5833",
    lon: "16.45",
    country: "NA",
    name: {
      en : "Oranjemund"
    }
  },
  OME : {
    lat: "64.5114",
    lon: "-165.442",
    country: "US",
    name: {
      en : "Nome"
    }
  },
  OMH : {
    country: "IR",
    name: {
      en : "OMH"
    }
  },
  OMO : {
    lat: "43.2856",
    lon: "17.8467",
    country: "BA",
    popularity: 7,
    name: {
      en : "Mostar"
    }
  },
  OMR : {
    lat: "47.0275",
    lon: "21.9031",
    country: "RO",
    name: {
      en : "Oradea"
    }
  },
  OMS : {
    lat: "54.9667",
    lon: "73.3",
    country: "RU",
    popularity: 33,
    name: {
      en : "Omsk"
    }
  },
  OND : {
    country: "NA",
    name: {
      en : "Ondangwa Arpt"
    }
  },
  ONG : {
    lat: "-16.5833",
    lon: "139.3",
    country: "AU",
    name: {
      en : "Mornington"
    }
  },
  ONJ : {
    lat: "40.1892",
    lon: "140.375",
    country: "JP",
    name: {
      en : "Odate Noshiro"
    }
  },
  ONK : {
    country: "RU",
    name: {
      en : "Olenyok"
    }
  },
  ONP : {
    lat: "44.6333",
    lon: "-124.05",
    country: "US",
    name: {
      en : "Newport"
    }
  },
  ONT : {
    lat: "34.0572",
    lon: "-117.608",
    country: "US",
    name: {
      en : "Ontario"
    }
  },
  OOK : {
    country: "US",
    name: {
      en : "OOK"
    }
  },
  OOL : {
    lat: "-28.1644",
    lon: "153.505",
    country: "AU",
    name: {
      en : "Gold Coast"
    }
  },
  OOM : {
    country: "AU",
    name: {
      en : "Cooma Airport"
    }
  },
  OPF : {
    lat: "25.9",
    lon: "-80.2833",
    country: "US",
    city: "MIA",
    name: {
      en : "Opa Locka"
    }
  },
  OPO : {
    lat: "41.1678",
    lon: "-8.66667",
    country: "PT",
    popularity: 38,
    name: {
      en : "Francisco Sa Carneiro"
    }
  },
  OPS : {
    country: "BR",
    name: {
      en : "OPS"
    }
  },
  OPU : {
    country: "PG",
    name: {
      en : "OPU"
    }
  },
  ORB : {
    lat: "59.2833",
    lon: "15.2167",
    country: "SE",
    name: {
      en : "Orebro Bofors"
    }
  },
  ORD : {
    lat: "41.9781",
    lon: "-87.9061",
    country: "US",
    city: "CHI",
    popularity: 19,
    name: {
      en : "O'Hare"
    }
  },
  ORF : {
    lat: "36.8958",
    lon: "-76.2014",
    country: "US",
    name: {
      en : "Norfolk"
    }
  },
  ORI : {
    country: "US",
    name: {
      en : "ORI"
    }
  },
  ORK : {
    lat: "51.8433",
    lon: "-8.49028",
    country: "IE",
    popularity: 16,
    name: {
      en : "Cork"
    }
  },
  ORL : {
    lat: "28.5442",
    lon: "-81.3356",
    country: "US",
    popularity: 2,
    name: {
      en : "Herndon"
    }
  },
  ORN : {
    lat: "35.6278",
    lon: "-0.610556",
    country: "DZ",
    popularity: 38,
    name: {
      en : "Es Senia"
    }
  },
  ORU : {
    country: "BO",
    name: {
      en : "Juan Mendoza"
    }
  },
  ORV : {
    country: "US",
    name: {
      en : "ORV"
    }
  },
  ORY : {
    lat: "48.7289",
    lon: "2.35722",
    country: "FR",
    city: "PAR",
    popularity: 1131,
    name: {
      en : "Orly"
    }
  },
  OSD : {
    lat: "63.1986",
    lon: "14.4944",
    country: "SE",
    name: {
      en : "Froesoe"
    }
  },
  OSI : {
    country: "HR",
    name: {
      en : "Osijek Arpt"
    }
  },
  OSK : {
    lat: "57.2667",
    lon: "16.4333",
    country: "SE",
    name: {
      en : "Oskarshamn"
    }
  },
  OSL : {
    lat: "60.2",
    lon: "11.0833",
    country: "NO",
    popularity: 152,
    name: {
      en : "Oslo"
    }
  },
  OSM : {
    country: "IQ",
    name: {
      en : "OSM"
    }
  },
  OSR : {
    lat: "49.7",
    lon: "18.1333",
    country: "CZ",
    popularity: 1,
    name: {
      en : "Mosnov"
    }
  },
  OSS : {
    lat: "40.6077",
    lon: "72.7865",
    country: "KG",
    name: {
      en : "Osh"
    }
  },
  OST : {
    lat: "51.1997",
    lon: "2.86361",
    country: "BE",
    name: {
      en : "Ostend"
    }
  },
  OSU : {
    lat: "40.0781",
    lon: "-83.0733",
    country: "US",
    city: "CMH",
    name: {
      en : "Ohio State Univ"
    }
  },
  OSW : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Orsk"
    }
  },
  OSY : {
    lat: "64.4667",
    lon: "11.6",
    country: "NO",
    name: {
      en : "Namsos"
    }
  },
  OTD : {
    country: "PA",
    name: {
      en : "OTD"
    }
  },
  OTH : {
    lat: "43.4189",
    lon: "-124.24",
    country: "US",
    name: {
      en : "North Bend"
    }
  },
  OTP : {
    lat: "44.5667",
    lon: "26.1",
    country: "RO",
    city: "BUH",
    popularity: 140,
    name: {
      en : "Otopeni"
    }
  },
  OTZ : {
    lat: "66.8881",
    lon: "-162.606",
    country: "US",
    name: {
      en : "Ralph Wien Memorial"
    }
  },
  OUA : {
    lat: "12.3528",
    lon: "-1.51278",
    country: "BF",
    name: {
      en : "Ouagadougou"
    }
  },
  OUD : {
    lat: "34.7833",
    lon: "-1.93333",
    country: "MA",
    name: {
      en : "Les Angades"
    }
  },
  OUK : {
    country: "GB",
    name: {
      en : "OUK"
    }
  },
  OUL : {
    lat: "64.9292",
    lon: "25.3583",
    country: "FI",
    name: {
      en : "Oulu"
    }
  },
  OUZ : {
    lat: "22.7333",
    lon: "-12.35",
    country: "MR",
    name: {
      en : "Zouerate"
    }
  },
  OVB : {
    lat: "55.0167",
    lon: "82.6167",
    country: "RU",
    popularity: 36,
    name: {
      en : "Tolmachevo"
    }
  },
  OVD : {
    lat: "43.5667",
    lon: "-6.03333",
    country: "ES",
    name: {
      en : "Asturias"
    }
  },
  OVS : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Sovetsky"
    }
  },
  OWB : {
    country: "US",
    name: {
      en : "Daviess County Arpt"
    }
  },
  OWD : {
    lat: "42",
    lon: "-71",
    country: "US",
    name: {
      en : "Norwood Ma"
    }
  },
  OXB : {
    lat: "11.8889",
    lon: "-15.6572",
    country: "GW",
    name: {
      en : "Airport Osvaldo Viera"
    }
  },
  OXR : {
    lat: "34.2011",
    lon: "-119.206",
    country: "US",
    name: {
      en : "Oxnard Ventura"
    }
  },
  OYE : {
    country: "GA",
    name: {
      en : "OYE"
    }
  },
  OYG : {
    country: "UG",
    name: {
      en : "OYG"
    }
  },
  OZC : {
    country: "PH",
    name: {
      en : "Labo Airport"
    }
  },
  OZH : {
    lat: "47.8675",
    lon: "35.3158",
    country: "UA",
    name: {
      en : "Zaporozhye"
    }
  },
  OZZ : {
    lat: "30.9167",
    lon: "-6.91667",
    country: "MA",
    name: {
      en : "Ourzazate"
    }
  },
  PAC : {
    country: "PA",
    city: "PTY",
    name: {
      en : "Paitilla Arpt"
    }
  },
  PAD : {
    lat: "51.615",
    lon: "8.62111",
    country: "DE",
    name: {
      en : "Paderborn"
    }
  },
  PAE : {
    lat: "47.9097",
    lon: "-122.284",
    country: "US",
    name: {
      en : "Snohomish Cty"
    }
  },
  PAG : {
    country: "PH",
    name: {
      en : "PAG"
    }
  },
  PAH : {
    lat: "37.0611",
    lon: "-88.7725",
    country: "US",
    name: {
      en : "Barkley Regional"
    }
  },
  PAP : {
    lat: "18.5606",
    lon: "-72.3289",
    country: "HT",
    name: {
      en : "Mais Gate"
    }
  },
  PAS : {
    lat: "37.0667",
    lon: "25.1",
    country: "GR",
    name: {
      en : "Paros Community"
    }
  },
  PAT : {
    lat: "25.5906",
    lon: "85.09",
    country: "IN",
    name: {
      en : "Patna"
    }
  },
  PAZ : {
    lat: "20.5167",
    lon: "-97.4672",
    country: "MX",
    name: {
      en : "Tajin"
    }
  },
  PBC : {
    lat: "19.135",
    lon: "-98.3675",
    country: "MX",
    name: {
      en : "Huejostingo"
    }
  },
  PBD : {
    lat: "21.6472",
    lon: "69.6569",
    country: "IN",
    name: {
      en : "Porbandar"
    }
  },
  PBG : {
    country: "US",
    name: {
      en : "PBG"
    }
  },
  PBH : {
    lat: "27.4333",
    lon: "89.4167",
    country: "BT",
    name: {
      en : "Paro"
    }
  },
  PBI : {
    lat: "26.6822",
    lon: "-80.0942",
    country: "US",
    name: {
      en : "Palm Beach"
    }
  },
  PBJ : {
    country: "VU",
    name: {
      en : "PBJ"
    }
  },
  PBM : {
    lat: "5.45139",
    lon: "-55.1911",
    country: "SR",
    name: {
      en : "Zanderij"
    }
  },
  PBO : {
    lat: "-23.1667",
    lon: "117.75",
    country: "AU",
    name: {
      en : "Paraburdoo"
    }
  },
  PBP : {
    country: "CR",
    name: {
      en : "PBP"
    }
  },
  PBU : {
    country: "MM",
    name: {
      en : "PBU"
    }
  },
  PCE : {
    country: "US",
    name: {
      en : "PCE"
    }
  },
  PCL : {
    lat: "-8.33333",
    lon: "-74.6333",
    country: "PE",
    name: {
      en : "Capitan Rolden"
    }
  },
  PCP : {
    lat: "0",
    lon: "0",
    country: "ST",
    name: {
      en : "Príncipe Airport Aeroporto de Príncipe"
    }
  },
  PCR : {
    country: "CO",
    name: {
      en : "Puerto Carreno Arpt"
    }
  },
  PDA : {
    country: "CO",
    name: {
      en : "Puerto Inirida Arpt"
    }
  },
  PDB : {
    country: "US",
    name: {
      en : "PDB"
    }
  },
  PDG : {
    lat: "-0.875556",
    lon: "100.35",
    country: "ID",
    name: {
      en : "Tabing"
    }
  },
  PDK : {
    lat: "33.8833",
    lon: "-84.25",
    country: "US",
    city: "ATL",
    name: {
      en : "Dekalb Peachtree"
    }
  },
  PDL : {
    lat: "37.7472",
    lon: "-25.6819",
    country: "PT",
    name: {
      en : "Nordela"
    }
  },
  PDP : {
    lat: "-34.9144",
    lon: "-54.9192",
    country: "UY",
    name: {
      en : "Cap Curbelo"
    }
  },
  PDT : {
    lat: "45.6983",
    lon: "-118.836",
    country: "US",
    name: {
      en : "Pendleton"
    }
  },
  PDV : {
    lat: "42.3",
    lon: "24.7167",
    country: "BG",
    name: {
      en : "Plovdiv"
    }
  },
  PDX : {
    lat: "45.5892",
    lon: "-122.595",
    country: "US",
    popularity: 1,
    name: {
      en : "Portland"
    }
  },
  PEC : {
    country: "US",
    name: {
      en : "PEC"
    }
  },
  PED : {
    country: "CZ",
    name: {
      en : "Pardubice Arpt"
    }
  },
  PEE : {
    lat: "57.917617",
    lon: "56.008188",
    country: "RU",
    popularity: 21,
    name: {
      en : "Perm"
    }
  },
  PEG : {
    lat: "43.1333",
    lon: "12.3667",
    country: "IT",
    name: {
      en : "Sant Egidio"
    }
  },
  PEI : {
    lat: "4.81528",
    lon: "-75.7422",
    country: "CO",
    name: {
      en : "Matecana"
    }
  },
  PEK : {
    lat: "40.0667",
    lon: "116.6",
    country: "CN",
    city: "BJS",
    popularity: 5,
    name: {
      en : "Beijing Capital"
    }
  },
  PEM : {
    lat: "-12.5833",
    lon: "-69.2333",
    country: "PE",
    name: {
      en : "Puerto Maldonado"
    }
  },
  PEN : {
    lat: "5.28972",
    lon: "100.272",
    country: "MY",
    name: {
      en : "Penang"
    }
  },
  PER : {
    lat: "-31.9317",
    lon: "115.968",
    country: "AU",
    name: {
      en : "Perth"
    }
  },
  PES : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Petrozavodsk"
    }
  },
  PET : {
    country: "BR",
    name: {
      en : "Pelotas Federal Arpt"
    }
  },
  PEU : {
    country: "HN",
    name: {
      en : "PEU"
    }
  },
  PEV : {
    country: "HU",
    name: {
      en : "Pecs"
    }
  },
  PEW : {
    lat: "34",
    lon: "71.5",
    country: "PK",
    name: {
      en : "Peshawar"
    }
  },
  PEX : {
    country: "RU",
    city: "",
    name: {
      en : "PECHORA"
    }
  },
  PEZ : {
    lat: "53.2167",
    lon: "45",
    country: "RU",
    popularity: 1,
    name: {
      en : "Penza"
    }
  },
  PFB : {
    lat: "-28.25",
    lon: "-52.3333",
    country: "BR",
    name: {
      en : "Passo Fundo"
    }
  },
  PFN : {
    lat: "30.2125",
    lon: "-85.6819",
    country: "US",
    name: {
      en : "Bay County"
    }
  },
  PFO : {
    lat: "34.7167",
    lon: "32.4833",
    country: "CY",
    popularity: 15,
    name: {
      en : "Paphos Intl"
    }
  },
  PFQ : {
    country: "IR",
    name: {
      en : "PFQ"
    }
  },
  PGA : {
    lat: "36.9264",
    lon: "-111.447",
    country: "US",
    name: {
      en : "Page"
    }
  },
  PGF : {
    lat: "42.7408",
    lon: "2.87167",
    country: "FR",
    name: {
      en : "Llabanere"
    }
  },
  PGH : {
    country: "IN",
    name: {
      en : "PGH"
    }
  },
  PGK : {
    country: "ID",
    name: {
      en : "PGK"
    }
  },
  PGM : {
    country: "US",
    name: {
      en : "Port Graham Arpt"
    }
  },
  PGU : {
    country: "IR",
    name: {
      en : "PGU"
    }
  },
  PGV : {
    lat: "35.6333",
    lon: "-77.3853",
    country: "US",
    name: {
      en : "Pitt Greenville"
    }
  },
  PGX : {
    lat: "45.1833",
    lon: "0.716667",
    country: "FR",
    name: {
      en : "Perigueux"
    }
  },
  PHC : {
    lat: "5.01667",
    lon: "6.95",
    country: "NG",
    name: {
      en : "Port Harcourt"
    }
  },
  PHE : {
    lat: "-20.3833",
    lon: "118.633",
    country: "AU",
    name: {
      en : "Port Hedland "
    }
  },
  PHF : {
    lat: "37.1308",
    lon: "-76.4939",
    country: "US",
    name: {
      en : "Williamsburg"
    }
  },
  PHG : {
    lat: "5.03333",
    lon: "6.83333",
    country: "NG",
    name: {
      en : "Port Harcourt City"
    }
  },
  PHL : {
    lat: "39.8717",
    lon: "-75.2422",
    country: "US",
    popularity: 20,
    name: {
      en : "Philadelphia"
    }
  },
  PHO : {
    country: "US",
    name: {
      en : "PHO"
    }
  },
  PHS : {
    lat: "16.7883",
    lon: "100.279",
    country: "TH",
    name: {
      en : "Phitsanulok"
    }
  },
  PHW : {
    lat: "-23.9336",
    lon: "31.1561",
    country: "ZA",
    name: {
      en : "Phalaborwa"
    }
  },
  PHX : {
    lat: "33.4353",
    lon: "-112.012",
    country: "US",
    name: {
      en : "Sky Harbor"
    }
  },
  PIA : {
    lat: "40.6614",
    lon: "-89.6872",
    country: "US",
    name: {
      en : "Greater Peoria"
    }
  },
  PIB : {
    lat: "31.4675",
    lon: "-89.3367",
    country: "US",
    city: "LUL",
    name: {
      en : "Hattiesburg Laurel Regional"
    }
  },
  PIE : {
    lat: "27.9167",
    lon: "-82.6833",
    country: "US",
    city: "TPA",
    name: {
      en : "St Petersburg Clearwater"
    }
  },
  PIF : {
    country: "TW",
    name: {
      en : "PIF"
    }
  },
  PIH : {
    lat: "42.9133",
    lon: "-112.594",
    country: "US",
    name: {
      en : "Pocatello"
    }
  },
  PIK : {
    lat: "55.5031",
    lon: "-4.57556",
    country: "GB",
    city: "GLA",
    name: {
      en : "Prestwick"
    }
  },
  PIN : {
    country: "BR",
    name: {
      en : "PIN"
    }
  },
  PIO : {
    country: "PE",
    name: {
      en : "Pisco Airport"
    }
  },
  PIP : {
    country: "US",
    name: {
      en : "Pilot Point Airport"
    }
  },
  PIR : {
    lat: "44.3836",
    lon: "-100.284",
    country: "US",
    name: {
      en : "Pierre"
    }
  },
  PIS : {
    lat: "46.5861",
    lon: "0.306389",
    country: "FR",
    name: {
      en : "Biard"
    }
  },
  PIT : {
    lat: "40.4967",
    lon: "-80.2358",
    country: "US",
    popularity: 2,
    name: {
      en : "Pittsburgh"
    }
  },
  PIU : {
    lat: "-5.20167",
    lon: "-80.6133",
    country: "PE",
    name: {
      en : "Piura"
    }
  },
  PIW : {
    country: "CA",
    name: {
      en : "Pikwitonei Rail Station"
    }
  },
  PIX : {
    lat: "38.4667",
    lon: "-28.3",
    country: "PT",
    name: {
      en : "Pico"
    }
  },
  PIZ : {
    lat: "69.75",
    lon: "-163.167",
    country: "US",
    popularity: 64,
    name: {
      en : "Dew Station"
    }
  },
  PJA : {
    lat: "67.2467",
    lon: "23.075",
    country: "SE",
    name: {
      en : "Pajala"
    }
  },
  PJB : {
    lat: "34.2611",
    lon: "-111.342",
    country: "US",
    name: {
      en : "Payson"
    }
  },
  PJG : {
    country: "PK",
    name: {
      en : "PJG"
    }
  },
  PJM : {
    country: "CR",
    name: {
      en : "PJM"
    }
  },
  PKA : {
    country: "US",
    name: {
      en : "PKA"
    }
  },
  PKB : {
    lat: "39.3456",
    lon: "-81.4389",
    country: "US",
    name: {
      en : "Wood County"
    }
  },
  PKC : {
    lat: "53.1692",
    lon: "158.427",
    country: "RU",
    popularity: 233,
    name: {
      en : "Petropavlovsk Kamchatskiy"
    }
  },
  PKE : {
    lat: "-33.1308",
    lon: "148.243",
    country: "AU",
    name: {
      en : "Parkes"
    }
  },
  PKG : {
    lat: "4.21667",
    lon: "100.7",
    country: "MY",
    name: {
      en : "Pangkor"
    }
  },
  PKK : {
    country: "MM",
    name: {
      en : "PKK"
    }
  },
  PKN : {
    country: "ID",
    name: {
      en : "PKN"
    }
  },
  PKP : {
    country: "PF",
    name: {
      en : "PKP"
    }
  },
  PKR : {
    lat: "28.1972",
    lon: "83.9861",
    country: "NP",
    name: {
      en : "Pokhara"
    }
  },
  PKU : {
    lat: "0.466667",
    lon: "101.45",
    country: "ID",
    name: {
      en : "Simpang Tiga"
    }
  },
  PKV : {
    lat: "57.8167",
    lon: "28.3",
    country: "RU",
    popularity: 1,
    name: {
      en : "Pskov"
    }
  },
  PKX : {
    country: "CN",
    city: "BJS",
    name: {
      en : "Beijing Daxing International Airport"
    }
  },
  PKY : {
    country: "ID",
    name: {
      en : "PKY"
    }
  },
  PKZ : {
    country: "LA",
    name: {
      en : "Pakse Arpt"
    }
  },
  PLD : {
    country: "CR",
    name: {
      en : "PLD"
    }
  },
  PLH : {
    lat: "50.4167",
    lon: "-4.11667",
    country: "GB",
    name: {
      en : "Roborough"
    }
  },
  PLJ : {
    lat: "16.5333",
    lon: "-88.3528",
    country: "BZ",
    name: {
      en : "Placencia"
    }
  },
  PLM : {
    lat: "-2.9",
    lon: "104.699",
    country: "ID",
    name: {
      en : "Mahmud Badaruddin Li"
    }
  },
  PLN : {
    lat: "45.5708",
    lon: "-84.7928",
    country: "US",
    name: {
      en : "Emmet Cty"
    }
  },
  PLO : {
    lat: "-34.6061",
    lon: "135.881",
    country: "AU",
    name: {
      en : "Port Lincoln"
    }
  },
  PLP : {
    country: "PA",
    name: {
      en : "PLP"
    }
  },
  PLQ : {
    lat: "55.95",
    lon: "21.0833",
    country: "LT",
    name: {
      en : "Palanga"
    }
  },
  PLS : {
    lat: "21.7692",
    lon: "-72.2683",
    country: "TC",
    name: {
      en : "Providenciales"
    }
  },
  PLU : {
    country: "BR",
    city: "BHZ",
    name: {
      en : "Pampulha Arpt"
    }
  },
  PLW : {
    country: "ID",
    name: {
      en : "Mutiara Arpt"
    }
  },
  PLX : {
    country: "KZ",
    name: {
      en : "PLX"
    }
  },
  PLZ : {
    lat: "-33.9861",
    lon: "25.6139",
    country: "ZA",
    name: {
      en : "Port Elizabeth"
    }
  },
  PMA : {
    country: "TZ",
    name: {
      en : "PMA"
    }
  },
  PMC : {
    lat: "-41.4333",
    lon: "-73.1",
    country: "CL",
    name: {
      en : "Tepual"
    }
  },
  PMF : {
    lat: "44.8",
    lon: "10.3333",
    country: "IT",
    city: "MIL",
    name: {
      en : "Parma"
    }
  },
  PMI : {
    lat: "39.5536",
    lon: "2.72778",
    country: "ES",
    popularity: 143,
    name: {
      en : "Palma Mallorca"
    }
  },
  PMK : {
    country: "AU",
    name: {
      en : "Palm Island Arpt"
    }
  },
  PML : {
    country: "US",
    name: {
      en : "PML"
    }
  },
  PMO : {
    lat: "38.1667",
    lon: "13.1",
    country: "IT",
    name: {
      en : "Punta Raisi"
    }
  },
  PMQ : {
    country: "AR",
    name: {
      en : "PMQ"
    }
  },
  PMR : {
    lat: "-40.3222",
    lon: "175.617",
    country: "NZ",
    name: {
      en : "Palmerston North"
    }
  },
  PMV : {
    lat: "11.0583",
    lon: "-64.1",
    country: "VE",
    name: {
      en : "Delcaribe Gen S Marino"
    }
  },
  PMW : {
    lat: "-10.2417",
    lon: "-48.3528",
    country: "BR",
    name: {
      en : "Palmas"
    }
  },
  PMY : {
    lat: "-42.7333",
    lon: "-65.0667",
    country: "AR",
    name: {
      en : "El Tehuelche"
    }
  },
  PMZ : {
    country: "CR",
    name: {
      en : "PMZ"
    }
  },
  PNA : {
    lat: "42.7694",
    lon: "-1.64444",
    country: "ES",
    name: {
      en : "Pamplona Noain"
    }
  },
  PND : {
    country: "BZ",
    name: {
      en : "PND"
    }
  },
  PNE : {
    lat: "40.0803",
    lon: "-75.0125",
    country: "US",
    city: "PHL",
    name: {
      en : "N Philadelphia"
    }
  },
  PNH : {
    lat: "11.5461",
    lon: "104.848",
    country: "KH",
    popularity: 1,
    name: {
      en : "Pochentong"
    }
  },
  PNI : {
    lat: "7.01667",
    lon: "158.236",
    country: "FM",
    name: {
      en : "Pohnpei"
    }
  },
  PNK : {
    country: "ID",
    name: {
      en : "Supadio Arpt"
    }
  },
  PNL : {
    country: "IT",
    name: {
      en : "Pantelleria Airport"
    }
  },
  PNP : {
    country: "PG",
    name: {
      en : "Girua Arpt"
    }
  },
  PNQ : {
    lat: "18.5814",
    lon: "73.9206",
    country: "IN",
    popularity: 1,
    name: {
      en : "Lohegaon"
    }
  },
  PNR : {
    lat: "-4.81056",
    lon: "11.8858",
    country: "CG",
    name: {
      en : "Pointe Noire"
    }
  },
  PNS : {
    lat: "30.4725",
    lon: "-87.1883",
    country: "US",
    name: {
      en : "Pensacola Regional"
    }
  },
  PNT : {
    lat: "-51.6833",
    lon: "-72.5167",
    country: "CL",
    name: {
      en : "Teniente Julio Gallardo"
    }
  },
  PNZ : {
    lat: "-9.39333",
    lon: "-40.4906",
    country: "BR",
    name: {
      en : "Petrolina Internacional"
    }
  },
  POA : {
    lat: "-29.9933",
    lon: "-51.1708",
    country: "BR",
    name: {
      en : "Porto Alegre"
    }
  },
  POG : {
    lat: "-0.7125",
    lon: "8.75583",
    country: "GA",
    name: {
      en : "Port Gentil"
    }
  },
  POJ : {
    country: "BR",
    name: {
      en : "POJ"
    }
  },
  POL : {
    country: "MZ",
    name: {
      en : "Pemba Arpt"
    }
  },
  POM : {
    lat: "-9.445",
    lon: "147.21",
    country: "PG",
    name: {
      en : "Jackson Field"
    }
  },
  POP : {
    lat: "19.8",
    lon: "-70.6667",
    country: "DO",
    name: {
      en : "La Union"
    }
  },
  POR : {
    lat: "61.4631",
    lon: "21.7972",
    country: "FI",
    name: {
      en : "Pori"
    }
  },
  POS : {
    lat: "10.6",
    lon: "-61.35",
    country: "TT",
    name: {
      en : "Piarco"
    }
  },
  POW : {
    country: "SI",
    name: {
      en : "Portoroz Airport"
    }
  },
  POZ : {
    lat: "52.4169",
    lon: "16.8833",
    country: "PL",
    name: {
      en : "Lawica"
    }
  },
  PPB : {
    lat: "-22.1",
    lon: "-51.45",
    country: "BR",
    name: {
      en : "A De Barros"
    }
  },
  PPG : {
    lat: "-14.3264",
    lon: "-170.696",
    country: "AS",
    popularity: 1,
    name: {
      en : "Pago Pago"
    }
  },
  PPK : {
    lat: "54.7833",
    lon: "69.1833",
    country: "KZ",
    name: {
      en : "Petropavlovsk"
    }
  },
  PPL : {
    lat: "27.5167",
    lon: "86.6",
    country: "NP",
    popularity: 1,
    name: {
      en : "Phaplu"
    }
  },
  PPN : {
    lat: "2.45",
    lon: "-76.6089",
    country: "CO",
    name: {
      en : "Machangara"
    }
  },
  PPP : {
    lat: "-20.4961",
    lon: "148.557",
    country: "AU",
    name: {
      en : "Whitsunday Coast"
    }
  },
  PPQ : {
    lat: "-40.90575",
    lon: "174.9909",
    country: "NZ",
    city: "",
    name: {
      en : "Paraparaumu"
    }
  },
  PPS : {
    lat: "9.74222",
    lon: "118.754",
    country: "PH",
    name: {
      en : "Puerto Princesa"
    }
  },
  PPT : {
    lat: "-17.5472",
    lon: "-149.614",
    country: "PF",
    name: {
      en : "Intl Tahiti Faaa"
    }
  },
  PPV : {
    country: "US",
    name: {
      en : "Port Protection Arpt"
    }
  },
  PPW : {
    lat: "59.4167",
    lon: "-2.9",
    country: "GB",
    name: {
      en : "Papa Westray"
    }
  },
  PQC : {
    lat: "10.2333",
    lon: "103.967",
    country: "VN",
    name: {
      en : "Duong Dang"
    }
  },
  PQI : {
    lat: "46.685",
    lon: "-68.0475",
    country: "US",
    name: {
      en : "Northern Maine Regional"
    }
  },
  PQQ : {
    lat: "-31.4333",
    lon: "152.867",
    country: "AU",
    name: {
      en : "Port Macquarie"
    }
  },
  PQS : {
    country: "US",
    name: {
      en : "PQS"
    }
  },
  PRB : {
    lat: "35.6706",
    lon: "-120.626",
    country: "US",
    name: {
      en : "Paso Robles Cty"
    }
  },
  PRC : {
    lat: "34.65",
    lon: "-112.424",
    country: "US",
    name: {
      en : "Prescott"
    }
  },
  PRG : {
    lat: "50.1",
    lon: "14.2667",
    country: "CZ",
    popularity: 327,
    name: {
      en : "Ruzyne"
    }
  },
  PRI : {
    lat: "-4.31917",
    lon: "55.6928",
    country: "SC",
    popularity: 2,
    name: {
      en : "Praslin Island"
    }
  },
  PRN : {
    lat: "42.5736",
    lon: "21.0356",
    country: "RS",
    popularity: 4,
    name: {
      en : "Pristina"
    }
  },
  PSA : {
    lat: "43.6806",
    lon: "10.3928",
    country: "IT",
    popularity: 2,
    name: {
      en : "Gal Galilei"
    }
  },
  PSC : {
    lat: "46.2639",
    lon: "-119.115",
    country: "US",
    name: {
      en : "Tri Cities"
    }
  },
  PSE : {
    lat: "18.0108",
    lon: "-66.5636",
    country: "US",
    name: {
      en : "Mercedita"
    }
  },
  PSG : {
    lat: "56.8042",
    lon: "-132.943",
    country: "US",
    popularity: 6,
    name: {
      en : "Petersburg"
    }
  },
  PSM : {
    lat: "43.1796",
    lon: "-70.8827",
    country: "US",
    name: {
      en : "Portsmouth Pease"
    }
  },
  PSO : {
    lat: "1.46667",
    lon: "-77.25",
    country: "CO",
    name: {
      en : "Cano"
    }
  },
  PSP : {
    lat: "33.8267",
    lon: "-116.505",
    country: "US",
    name: {
      en : "Palm Springs"
    }
  },
  PSR : {
    lat: "42.4339",
    lon: "14.1844",
    country: "IT",
    name: {
      en : "Liberi"
    }
  },
  PSS : {
    lat: "-27.3839",
    lon: "-55.9675",
    country: "AR",
    name: {
      en : "Posadas"
    }
  },
  PSU : {
    country: "ID",
    name: {
      en : "PSU"
    }
  },
  PSV : {
    country: "GB",
    name: {
      en : "PSV"
    }
  },
  PSZ : {
    country: "BO",
    name: {
      en : "PSZ"
    }
  },
  PTA : {
    country: "US",
    name: {
      en : "PTA"
    }
  },
  PTF : {
    country: "FJ",
    name: {
      en : "Malololailai Arpt"
    }
  },
  PTG : {
    lat: "-23.9167",
    lon: "29.9667",
    country: "ZA",
    popularity: 2,
    name: {
      en : "Pietersburg"
    }
  },
  PTH : {
    country: "US",
    name: {
      en : "PTH"
    }
  },
  PTJ : {
    country: "AU",
    name: {
      en : "Portland Arpt"
    }
  },
  PTK : {
    lat: "42.6647",
    lon: "-83.4114",
    country: "US",
    name: {
      en : "Oakland Pontiac"
    }
  },
  PTP : {
    lat: "16.2675",
    lon: "-61.5264",
    country: "GP",
    name: {
      en : "Le Raizet"
    }
  },
  PTU : {
    country: "US",
    name: {
      en : "PTU"
    }
  },
  PTW : {
    lat: "40.25",
    lon: "-75.6333",
    country: "US",
    name: {
      en : "Pottstown Limerick"
    }
  },
  PTY : {
    lat: "9.08333",
    lon: "-79.3833",
    country: "PA",
    popularity: 1,
    name: {
      en : "Tocumen"
    }
  },
  PUB : {
    lat: "38.2928",
    lon: "-104.496",
    country: "US",
    name: {
      en : "Pueblo"
    }
  },
  PUF : {
    lat: "43.38",
    lon: "-0.417778",
    country: "FR",
    name: {
      en : "Uzein"
    }
  },
  PUG : {
    country: "AU",
    name: {
      en : "Port Augusta Arpt"
    }
  },
  PUJ : {
    lat: "18.5667",
    lon: "-68.3833",
    country: "DO",
    popularity: 4,
    name: {
      en : "Punta Cana"
    }
  },
  PUK : {
    country: "PF",
    name: {
      en : "PUK"
    }
  },
  PUM : {
    country: "ID",
    name: {
      en : "PUM"
    }
  },
  PUQ : {
    lat: "-53.1264",
    lon: "-70.8775",
    country: "CL",
    name: {
      en : "Presidente Ibanez"
    }
  },
  PUS : {
    lat: "35.1708",
    lon: "129.131",
    country: "KR",
    name: {
      en : "Kimhae"
    }
  },
  PUU : {
    country: "CO",
    name: {
      en : "Puerto Asis Arpt"
    }
  },
  PUW : {
    lat: "46.7447",
    lon: "-117.105",
    country: "US",
    popularity: 1,
    name: {
      en : "Pullman Moscow"
    }
  },
  PUY : {
    lat: "44.8917",
    lon: "13.9236",
    country: "HR",
    popularity: 3,
    name: {
      en : "Pula"
    }
  },
  PVA : {
    country: "CO",
    name: {
      en : "Providencia Arpt"
    }
  },
  PVC : {
    lat: "42.0719",
    lon: "-70.2217",
    country: "US",
    name: {
      en : "Provincetown"
    }
  },
  PVD : {
    lat: "41.7283",
    lon: "-71.4261",
    country: "US",
    name: {
      en : "T F Green St"
    }
  },
  PVE : {
    country: "PA",
    name: {
      en : "PVE"
    }
  },
  PVG : {
    lat: "31.15",
    lon: "121.783",
    country: "CN",
    city: "SHA",
    name: {
      en : "Pu Dong"
    }
  },
  PVH : {
    lat: "-8.73333",
    lon: "-63.9",
    country: "BR",
    name: {
      en : "Belmonte"
    }
  },
  PVK : {
    lat: "38.9264",
    lon: "20.7658",
    country: "GR",
    name: {
      en : "Aktion"
    }
  },
  PVR : {
    lat: "20.6867",
    lon: "-105.265",
    country: "MX",
    name: {
      en : "Ordaz"
    }
  },
  PVU : {
    country: "US",
    name: {
      en : "Provo Arpt"
    }
  },
  PWE : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Pevek"
    }
  },
  PWK : {
    lat: "41.9808",
    lon: "-87.9089",
    country: "US",
    city: "CHI",
    name: {
      en : "Pal Waukee"
    }
  },
  PWM : {
    lat: "43.6444",
    lon: "-70.3036",
    country: "US",
    popularity: 1,
    name: {
      en : "Portland Jetport"
    }
  },
  PWQ : {
    lat: "52.1833",
    lon: "77.0667",
    country: "KZ",
    popularity: 6,
    name: {
      en : "Pavlodar"
    }
  },
  PXM : {
    lat: "15.85",
    lon: "-97.0833",
    country: "MX",
    name: {
      en : "Puerto Escondido"
    }
  },
  PXO : {
    lat: "33.0669",
    lon: "-16.3456",
    country: "PT",
    name: {
      en : "Porto Santo"
    }
  },
  PXU : {
    lat: "14.0031",
    lon: "108.021",
    country: "VN",
    name: {
      en : "Pleiku"
    }
  },
  PYC : {
    country: "PA",
    name: {
      en : "PYC"
    }
  },
  PYH : {
    country: "VE",
    name: {
      en : "PYH"
    }
  },
  PYJ : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Polyarnyj"
    }
  },
  PYY : {
    country: "TH",
    name: {
      en : "Pai Arpt"
    }
  },
  PZB : {
    lat: "-29.6461",
    lon: "30.3994",
    country: "ZA",
    popularity: 1,
    name: {
      en : "Pietermaritzburg"
    }
  },
  PZE : {
    lat: "50.1119",
    lon: "-5.51611",
    country: "GB",
    popularity: 1,
    name: {
      en : "Penzance"
    }
  },
  PZH : {
    country: "PK",
    name: {
      en : "PZH"
    }
  },
  PZI : {
    country: "CN",
    name: {
      en : "Pan Zhi Hua Bao An Ying Arpt"
    }
  },
  PZO : {
    lat: "8.305",
    lon: "-62.7344",
    country: "VE",
    name: {
      en : "Puerto Ordaz"
    }
  },
  PZU : {
    country: "SD",
    name: {
      en : "Port Sudan New intl Arpt"
    }
  },
  QBC : {
    lat: "52.3333",
    lon: "-126.667",
    country: "CA",
    name: {
      en : "Bella Colla"
    }
  },
  QBF : {
    country: "US",
    city: "EGE",
    name: {
      en : "Vail Van Service"
    }
  },
  QCE : {
    lat: "49.3",
    lon: "-1.5",
    country: "US",
    name: {
      en : "Copper Mountain Van Service"
    }
  },
  QFB : {
    country: "DE",
    name: {
      en : "QFB"
    }
  },
  QJX : {
    country: "TH",
    city: "BKK",
    name: {
      en : "QJX"
    }
  },
  QKB : {
    lat: "-28.8333",
    lon: "22.6167",
    country: "US",
    name: {
      en : "Breckenridge Van Service"
    }
  },
  QKL : {
    country: "DE",
    city: "CGN",
    name: {
      en : "Cologne Railroad Station"
    }
  },
  QKS : {
    country: "US",
    name: {
      en : "Keystone Van Service"
    }
  },
  QLE : {
    country: "AU",
    name: {
      en : "Leeton"
    }
  },
  QLQ : {
    country: "ES",
    name: {
      en : "QLQ"
    }
  },
  QNT : {
    country: "BR",
    name: {
      en : "Niteroi"
    }
  },
  QOR : {
    lat: "38.0687895",
    lon: "40.9671805",
    country: "TR",
    city: "OGU",
    name: {
      en : "Gulyali"
    }
  },
  QOW : {
    country: "NG",
    name: {
      en : "QOW"
    }
  },
  QQP : {
    country: "GB",
    city: "LON",
    name: {
      en : "London - Paddington Rail Service"
    }
  },
  QQS : {
    country: "GB",
    city: "LON",
    name: {
      en : "QQS St Pancras Intl Rail St"
    }
  },
  QRO : {
    lat: "20.6",
    lon: "-100.383",
    country: "MX",
    name: {
      en : "Queretaro"
    }
  },
  QRV : {
    country: "FR",
    name: {
      en : "Arras"
    }
  },
  QRW : {
    country: "NG",
    name: {
      en : "QRW"
    }
  },
  QSF : {
    country: "DZ",
    name: {
      en : "Setif Arpt"
    }
  },
  QSR : {
    lat: "40.62035441617942",
    lon: "14.920579879720334",
    country: "IT",
    name: {
      en : "Salerno"
    }
  },
  QUB : {
    country: "LY",
    name: {
      en : "QUB"
    }
  },
  QUO : {
    country: "NG",
    city: "UYO",
    name: {
      en : "Akwa Ibom"
    }
  },
  QWF : {
    lat: "19.8333",
    lon: "-72.5",
    country: "US",
    city: "FNL",
    name: {
      en : "Fort Collins Bus Service"
    }
  },
  QWH : {
    country: "US",
    city: "FNL",
    name: {
      en : "Loveland Bus Service"
    }
  },
  QWM : {
    country: "US",
    city: "DEN",
    name: {
      en : "Longmont Bus Service"
    }
  },
  QWU : {
    country: "DE",
    name: {
      en : "QWU"
    }
  },
  QWY : {
    country: "US",
    city: "CVO",
    name: {
      en : "Albany Bus Service"
    }
  },
  QXG : {
    country: "FR",
    city: "ANE",
    name: {
      en : "Angers Railway Stattion"
    }
  },
  QYG : {
    country: "DE",
    name: {
      en : "QYG"
    }
  },
  QYO : {
    country: "PL",
    name: {
      en : "Olsztyn"
    }
  },
  RAB : {
    lat: "-4.33333",
    lon: "152.367",
    country: "PG",
    name: {
      en : "Lakunai"
    }
  },
  RAE : {
    country: "SA",
    name: {
      en : "RAE"
    }
  },
  RAH : {
    country: "SA",
    name: {
      en : "RAH"
    }
  },
  RAI : {
    lat: "14.9253",
    lon: "-23.5031",
    country: "CV",
    name: {
      en : "Francisco Mendes"
    }
  },
  RAJ : {
    lat: "22.3058",
    lon: "70.7808",
    country: "IN",
    name: {
      en : "Rajkot Civil"
    }
  },
  RAK : {
    lat: "31.6083",
    lon: "-8.03833",
    country: "MA",
    popularity: 3,
    name: {
      en : "Menara"
    }
  },
  RAO : {
    lat: "-21.1358",
    lon: "-47.7733",
    country: "BR",
    name: {
      en : "Leite Lopes"
    }
  },
  RAP : {
    lat: "44.0433",
    lon: "-103.057",
    country: "US",
    name: {
      en : "Rapid City Regional"
    }
  },
  RAR : {
    lat: "-21.2003",
    lon: "-159.8",
    country: "CK",
    name: {
      en : "Rarotonga"
    }
  },
  RAS : {
    country: "IR",
    name: {
      en : "RAS"
    }
  },
  RBA : {
    lat: "34.05",
    lon: "-6.75694",
    country: "MA",
    name: {
      en : "Sale"
    }
  },
  RBG : {
    lat: "43.2389",
    lon: "-123.36",
    country: "US",
    name: {
      en : "Roseburg"
    }
  },
  RBH : {
    country: "US",
    name: {
      en : "RBH"
    }
  },
  RBL : {
    lat: "40.1566",
    lon: "-122.273",
    country: "US",
    city: "RDD",
    name: {
      en : "Flight Service Station"
    }
  },
  RBQ : {
    country: "BO",
    name: {
      en : "RBQ"
    }
  },
  RBR : {
    lat: "-9.96667",
    lon: "-67.8",
    country: "BR",
    name: {
      en : "Pres Medici"
    }
  },
  RBV : {
    country: "SB",
    name: {
      en : "RBV"
    }
  },
  RBX : {
    country: "SD",
    name: {
      en : "RBX"
    }
  },
  RBY : {
    country: "US",
    name: {
      en : "RBY"
    }
  },
  RCB : {
    country: "ZA",
    name: {
      en : "Richards Bay Arpt"
    }
  },
  RCE : {
    lat: "48.5833",
    lon: "-123.167",
    country: "US",
    name: {
      en : "Roche Harbor"
    }
  },
  RCH : {
    country: "CO",
    name: {
      en : "RCH"
    }
  },
  RCL : {
    country: "VU",
    name: {
      en : "RCL"
    }
  },
  RCM : {
    country: "AU",
    name: {
      en : "Richmond Arpt"
    }
  },
  RCP : {
    country: "US",
    name: {
      en : "RCP"
    }
  },
  RCU : {
    lat: "-33.0851",
    lon: "-64.2613",
    country: "AR",
    name: {
      en : "Rio Cuarto"
    }
  },
  RDB : {
    country: "US",
    name: {
      en : "RDB"
    }
  },
  RDD : {
    lat: "40.5083",
    lon: "-122.292",
    country: "US",
    name: {
      en : "Redding"
    }
  },
  RDG : {
    lat: "40.3786",
    lon: "-75.9639",
    country: "US",
    name: {
      en : "Reading"
    }
  },
  RDM : {
    lat: "44.2544",
    lon: "-121.151",
    country: "US",
    name: {
      en : "Roberts Field"
    }
  },
  RDN : {
    lat: "5.76528",
    lon: "103.007",
    country: "MY",
    name: {
      en : "Lts Pulau Redang"
    }
  },
  RDO : {
    lat: "51.388889",
    lon: "21.211667",
    country: "PL",
    name: {
      en : "Radom"
    }
  },
  RDP : {
    lat: "23.6244",
    lon: "87.2425",
    country: "IN",
    name: {
      en : "Durgapur"
    }
  },
  RDU : {
    lat: "35.8753",
    lon: "-78.7819",
    country: "US",
    popularity: 16,
    name: {
      en : "Raleigh Durham"
    }
  },
  RDV : {
    country: "US",
    name: {
      en : "RDV"
    }
  },
  RDZ : {
    lat: "44.3667",
    lon: "2.51667",
    country: "FR",
    name: {
      en : "Marcillac"
    }
  },
  REA : {
    country: "PF",
    name: {
      en : "REA"
    }
  },
  REC : {
    lat: "-8.12583",
    lon: "-34.9239",
    country: "BR",
    name: {
      en : "Recife"
    }
  },
  REG : {
    lat: "38.0753",
    lon: "15.6508",
    country: "IT",
    name: {
      en : "Tito Menniti"
    }
  },
  REL : {
    lat: "-43.2333",
    lon: "-65.3233",
    country: "AR",
    name: {
      en : "Trelew"
    }
  },
  REN : {
    lat: "51.8",
    lon: "55.46",
    country: "RU",
    name: {
      en : "Orenburg"
    }
  },
  REP : {
    lat: "13.4",
    lon: "103.817",
    country: "KH",
    popularity: 1,
    name: {
      en : "Siem Reap"
    }
  },
  RES : {
    lat: "-27.4514",
    lon: "-59.0508",
    country: "AR",
    name: {
      en : "Resistencia"
    }
  },
  RET : {
    country: "NO",
    name: {
      en : "RET"
    }
  },
  REU : {
    lat: "41.15",
    lon: "1.16944",
    country: "ES",
    name: {
      en : "Reus"
    }
  },
  REX : {
    lat: "26.0125",
    lon: "-98.23",
    country: "MX",
    name: {
      en : "General Lucio Blanco"
    }
  },
  RFD : {
    lat: "42.3036",
    lon: "-89.2221",
    country: "US",
    city: "CHI",
    name: {
      en : "Chicago Rockford"
    }
  },
  RFP : {
    lat: "-16.7167",
    lon: "-151.467",
    country: "PF",
    name: {
      en : "Raiatea"
    }
  },
  RGA : {
    lat: "-53.7792",
    lon: "-67.75",
    country: "AR",
    name: {
      en : "Rio Grande"
    }
  },
  RGI : {
    lat: "-14.9667",
    lon: "-147.667",
    country: "PF",
    name: {
      en : "Rangiroa"
    }
  },
  RGK : {
    lat: "51.949503",
    lon: "85.950508",
    country: "RU",
    name: {
      en : "Gorno-Altaisk"
    }
  },
  RGL : {
    lat: "-51.6167",
    lon: "-69.2833",
    country: "AR",
    name: {
      en : "Rio Gallegos Internacional"
    }
  },
  RGN : {
    lat: "16.9064",
    lon: "96.1389",
    country: "MM",
    name: {
      en : "Yangon"
    }
  },
  RGS : {
    country: "ES",
    name: {
      en : "Burgos Arpt"
    }
  },
  RHI : {
    lat: "45.6314",
    lon: "-89.4575",
    country: "US",
    name: {
      en : "Oneida County"
    }
  },
  RHO : {
    lat: "36.3847",
    lon: "28.1183",
    country: "GR",
    name: {
      en : "Diagoras"
    }
  },
  RHP : {
    country: "NP",
    name: {
      en : "RHP"
    }
  },
  RIA : {
    country: "BR",
    name: {
      en : "Base Aerea Arpt"
    }
  },
  RIB : {
    country: "BO",
    name: {
      en : "RIB"
    }
  },
  RIC : {
    lat: "37.5061",
    lon: "-77.3225",
    country: "US",
    name: {
      en : "Richmond"
    }
  },
  RIG : {
    country: "BR",
    name: {
      en : "Rio Grande Airport"
    }
  },
  RIL : {
    lat: "39.5333",
    lon: "-107.783",
    country: "US",
    name: {
      en : "Garfield Cty"
    }
  },
  RIS : {
    country: "JP",
    name: {
      en : "RIS"
    }
  },
  RIW : {
    lat: "43.0644",
    lon: "-108.457",
    country: "US",
    name: {
      en : "Riverton"
    }
  },
  RIX : {
    lat: "56.925",
    lon: "23.9722",
    country: "LV",
    popularity: 132,
    name: {
      en : "Riga"
    }
  },
  RIY : {
    lat: "14.6472",
    lon: "49.3222",
    country: "YE",
    name: {
      en : "Riyan Mukalla"
    }
  },
  RIZ : {
    country: "CN",
    name: {
      en : "Rizhao Shanzihe"
    }
  },
  RJA : {
    country: "IN",
    name: {
      en : "Rajahmundry Arpt"
    }
  },
  RJH : {
    country: "BD",
    name: {
      en : "Shah Makhdum"
    }
  },
  RJK : {
    country: "HR",
    name: {
      en : "Rijeka Arpt"
    }
  },
  RJL : {
    lat: "42.4569",
    lon: "-2.32361",
    country: "ES",
    name: {
      en : "Agoncillo"
    }
  },
  RKA : {
    country: "PF",
    name: {
      en : "RKA"
    }
  },
  RKD : {
    lat: "44.0592",
    lon: "-69.0981",
    country: "US",
    name: {
      en : "Rockland"
    }
  },
  RKS : {
    lat: "41.5964",
    lon: "-109.066",
    country: "US",
    name: {
      en : "Rock Springs"
    }
  },
  RKT : {
    lat: "25.75",
    lon: "56",
    country: "AE",
    name: {
      en : "Ras Al Khaimah"
    }
  },
  RKV : {
    lat: "64.1333",
    lon: "-21.95",
    country: "IS",
    city: "REK",
    name: {
      en : "Reykjavik Domestic"
    }
  },
  RLG : {
    lat: "53.92",
    lon: "12.2667",
    country: "DE",
    name: {
      en : "Laage"
    }
  },
  RLK : {
    country: "CN",
    name: {
      en : "Bayannur Tianjitai"
    }
  },
  RMA : {
    lat: "-26.5472",
    lon: "148.773",
    country: "AU",
    name: {
      en : "Roma"
    }
  },
  RME : {
    country: "US",
    name: {
      en : "RME"
    }
  },
  RMF : {
    lat: "25.6333",
    lon: "34.5694",
    country: "EG",
    popularity: 7,
    name: {
      en : "Marsa Alam"
    }
  },
  RMI : {
    lat: "44.0208",
    lon: "12.6122",
    country: "IT",
    popularity: 3,
    name: {
      en : "Miramare"
    }
  },
  RMO : {
    lat: "46.9167",
    lon: "28.9333",
    country: "MD",
    popularity: 220,
    name: {
      en : "Chisinau"
    }
  },
  RMP : {
    country: "US",
    name: {
      en : "RMP"
    }
  },
  RMQ : {
    lat: "24.265",
    lon: "120.621",
    country: "TW",
    name: {
      en : "Ching Chuan Kang"
    }
  },
  RMS : {
    lat: "49.45",
    lon: "7.55",
    country: "DE",
    name: {
      en : "Ramsteim"
    }
  },
  RMT : {
    lat: "0",
    lon: "0",
    country: "PF",
    name: {
      en : "Rimatara"
    }
  },
  RMZ : {
    lat: "58.2",
    lon: "68.2667",
    country: "RU",
    city: "TOX",
    name: {
      en : "Remezov"
    }
  },
  RNA : {
    country: "SB",
    name: {
      en : "RNA"
    }
  },
  RNB : {
    lat: "56.2583",
    lon: "15.2611",
    country: "SE",
    name: {
      en : "Kallinge"
    }
  },
  RNL : {
    country: "SB",
    name: {
      en : "RNL"
    }
  },
  RNN : {
    lat: "55.0656",
    lon: "14.7578",
    country: "DK",
    name: {
      en : "Bornholm"
    }
  },
  RNO : {
    lat: "39.4978",
    lon: "-119.768",
    country: "US",
    name: {
      en : "Reno Tahoe"
    }
  },
  RNP : {
    country: "MH",
    name: {
      en : "RNP"
    }
  },
  RNS : {
    lat: "48.0686",
    lon: "-1.73139",
    country: "FR",
    popularity: 4,
    name: {
      en : "Saint Jacques"
    }
  },
  ROA : {
    lat: "37.3247",
    lon: "-79.9764",
    country: "US",
    name: {
      en : "Roanoke Regional"
    }
  },
  ROB : {
    lat: "6.23972",
    lon: "-10.3589",
    country: "LR",
    city: "MLW",
    name: {
      en : "Roberts"
    }
  },
  ROC : {
    lat: "43.1214",
    lon: "-77.6708",
    country: "US",
    name: {
      en : "Monroe Cty New York"
    }
  },
  ROI : {
    lat: "16.1153",
    lon: "103.777",
    country: "TH",
    name: {
      en : "Roi Et"
    }
  },
  ROK : {
    lat: "-23.3772",
    lon: "150.475",
    country: "AU",
    name: {
      en : "Rockhampton"
    }
  },
  ROO : {
    country: "BR",
    name: {
      en : "Rondonopolis Arpt"
    }
  },
  ROP : {
    lat: "14.1683",
    lon: "145.249",
    country: "MP",
    name: {
      en : "Rota"
    }
  },
  ROR : {
    lat: "7.36444",
    lon: "134.553",
    country: "PW",
    name: {
      en : "Airai"
    }
  },
  ROS : {
    lat: "-32.9333",
    lon: "-60.7833",
    country: "AR",
    name: {
      en : "Fisherton"
    }
  },
  ROT : {
    lat: "-38.1111",
    lon: "176.317",
    country: "NZ",
    name: {
      en : "Rotorua"
    }
  },
  ROV : {
    lat: "47.4885",
    lon: "39.9289",
    country: "RU",
    popularity: 244,
    name: {
      en : "Platov"
    }
  },
  ROW : {
    lat: "33.2997",
    lon: "-104.53",
    country: "US",
    name: {
      en : "Industrial Aircenter"
    }
  },
  RPR : {
    lat: "21.1667",
    lon: "82.0083",
    country: "IN",
    name: {
      en : "Raipur"
    }
  },
  RQW : {
    country: "IQ",
    name: {
      en : "RQW"
    }
  },
  RRG : {
    lat: "-19.75",
    lon: "63.35",
    country: "MU",
    name: {
      en : "Rodrigues Island"
    }
  },
  RRR : {
    lat: "0",
    lon: "0",
    country: "PF",
    name: {
      en : "Raroia"
    }
  },
  RRS : {
    lat: "62.5792",
    lon: "11.3456",
    country: "NO",
    name: {
      en : "Roros"
    }
  },
  RSA : {
    country: "AR",
    name: {
      en : "Santa Rosa Arpt"
    }
  },
  RSD : {
    lat: "24.8917",
    lon: "-76.1781",
    country: "BS",
    name: {
      en : "S Eleuthera"
    }
  },
  RSH : {
    lat: "61.7831",
    lon: "-161.319",
    country: "US",
    name: {
      en : "Russian Seaplane Base"
    }
  },
  RSI : {
    lat: "25.63028",
    lon: "37.07833",
    country: "SA",
    city: "",
    name: {
      en : "Red Sea International Airport "
    }
  },
  RSJ : {
    country: "US",
    name: {
      en : "Rosario Seaplane Base"
    }
  },
  RST : {
    lat: "43.9103",
    lon: "-92.4964",
    country: "US",
    name: {
      en : "Rochester"
    }
  },
  RSU : {
    lat: "34.7411",
    lon: "127.73",
    country: "KR",
    name: {
      en : "Yeosu"
    }
  },
  RSW : {
    lat: "26.5362",
    lon: "-81.7552",
    country: "US",
    city: "FMY",
    name: {
      en : "Regional Southwest"
    }
  },
  RTB : {
    lat: "16.3167",
    lon: "-86.5167",
    country: "HN",
    name: {
      en : "Roatan"
    }
  },
  RTG : {
    country: "ID",
    name: {
      en : "RTG"
    }
  },
  RTM : {
    lat: "51.9583",
    lon: "4.44444",
    country: "NL",
    popularity: 5,
    name: {
      en : "Rotterdam"
    }
  },
  RTW : {
    lat: "51.5667",
    lon: "46.0667",
    country: "RU",
    popularity: 6,
    name: {
      en : "Saratov"
    }
  },
  RUA : {
    country: "UG",
    name: {
      en : "RUA"
    }
  },
  RUD : {
    country: "IR",
    name: {
      en : "RUD"
    }
  },
  RUE : {
    country: "CD",
    name: {
      en : "RUE"
    }
  },
  RUH : {
    lat: "24.9667",
    lon: "46.7",
    country: "SA",
    popularity: 2,
    name: {
      en : "King Khaled"
    }
  },
  RUM : {
    country: "NP",
    name: {
      en : "RUM"
    }
  },
  RUN : {
    lat: "-20.8772",
    lon: "55.5214",
    country: "RE",
    name: {
      en : "Gillot"
    }
  },
  RUR : {
    country: "PF",
    name: {
      en : "RUR"
    }
  },
  RUS : {
    country: "SB",
    name: {
      en : "RUS"
    }
  },
  RUT : {
    lat: "43.5294",
    lon: "-72.9483",
    country: "US",
    name: {
      en : "Rutland"
    }
  },
  RVD : {
    country: "BR",
    name: {
      en : "RVD"
    }
  },
  RVE : {
    country: "CO",
    name: {
      en : "Saravena Arpt"
    }
  },
  RVI : {
    lat: "47.2552",
    lon: "39.8038",
    country: "RU",
    city: "",
    popularity: 500,
    name: {
      en : "RVI"
    }
  },
  RVK : {
    lat: "64.8833",
    lon: "11.2333",
    country: "NO",
    name: {
      en : "Ryumsjoen"
    }
  },
  RVN : {
    lat: "66.5631",
    lon: "25.8267",
    country: "FI",
    name: {
      en : "Rovaniemi"
    }
  },
  RVT : {
    lat: "-33.7856",
    lon: "120.201",
    country: "AU",
    name: {
      en : "Ravensthorpe"
    }
  },
  RVV : {
    country: "PF",
    name: {
      en : "RVV"
    }
  },
  RWN : {
    lat: "50.607142",
    lon: "26.141622",
    country: "UA",
    city: "",
    popularity: 1,
    name: {
      en : "RWN"
    }
  },
  RXS : {
    lat: "11.6",
    lon: "122.751",
    country: "PH",
    name: {
      en : "Roxas City"
    }
  },
  RYG : {
    lat: "0",
    lon: "0",
    country: "NO",
    city: "OSL",
    name: {
      en : "Rygge"
    }
  },
  RYK : {
    country: "PK",
    name: {
      en : "RYK"
    }
  },
  RYL : {
    country: "ZM",
    name: {
      en : "Royal Airstrip Airport"
    }
  },
  RZE : {
    lat: "50.1167",
    lon: "22.0167",
    country: "PL",
    name: {
      en : "Jasionka"
    }
  },
  RZH : {
    country: "RU",
    city: "",
    name: {
      en : "Preobrazheniye"
    }
  },
  RZR : {
    country: "IR",
    name: {
      en : "RZR"
    }
  },
  RZS : {
    country: "PK",
    name: {
      en : "RZS"
    }
  },
  RZV : {
    country: "TR",
    name: {
      en : "Rize-Artvin"
    }
  },
  SAB : {
    lat: "17.65",
    lon: "-63.2167",
    country: "AN",
    name: {
      en : "Juancho Yraus Quinl"
    }
  },
  SAC : {
    lat: "38.05",
    lon: "-121.933",
    country: "US",
    name: {
      en : "Sacramento Executive"
    }
  },
  SAF : {
    country: "US",
    name: {
      en : "Santa Fe Municipal"
    }
  },
  SAG : {
    country: "IN",
    name: {
      en : "Shirdi"
    }
  },
  SAH : {
    lat: "15.4786",
    lon: "44.2192",
    country: "YE",
    name: {
      en : "Sanaa Intl"
    }
  },
  SAI : {
    lat: "13.375882",
    lon: "104.220455",
    country: "KH",
    name: {
      en : "Siem Reap Angkor"
    }
  },
  SAL : {
    lat: "13.6936",
    lon: "-89.1181",
    country: "SV",
    name: {
      en : "Comalapa"
    }
  },
  SAN : {
    lat: "32.7328",
    lon: "-117.187",
    country: "US",
    name: {
      en : "Lindbergh"
    }
  },
  SAP : {
    lat: "15.4",
    lon: "-86.9333",
    country: "HN",
    name: {
      en : "Ramon Villeda Morales"
    }
  },
  SAT : {
    lat: "29.5383",
    lon: "-98.472",
    country: "US",
    name: {
      en : "San Antonio"
    }
  },
  SAV : {
    lat: "32.1272",
    lon: "-81.1994",
    country: "US",
    name: {
      en : "Savannah"
    }
  },
  SAW : {
    lat: "40.8994",
    lon: "29.3092",
    country: "TR",
    city: "IST",
    name: {
      en : "Sabiha Gokcen"
    }
  },
  SAX : {
    country: "PA",
    name: {
      en : "SAX"
    }
  },
  SBA : {
    lat: "34.4278",
    lon: "-119.839",
    country: "US",
    name: {
      en : "Santa Barbara"
    }
  },
  SBH : {
    lat: "17.9",
    lon: "-62.85",
    country: "GP",
    popularity: 2,
    name: {
      en : "St Jean"
    }
  },
  SBN : {
    lat: "41.7044",
    lon: "-86.3125",
    country: "US",
    name: {
      en : "Michiana Regional"
    }
  },
  SBP : {
    lat: "35.2367",
    lon: "-120.639",
    country: "US",
    city: "CSL",
    name: {
      en : "San Luis Obispo County"
    }
  },
  SBT : {
    country: "RU",
    name: {
      en : "Sabetta"
    }
  },
  SBW : {
    lat: "2.34167",
    lon: "111.838",
    country: "MY",
    name: {
      en : "Sibu"
    }
  },
  SBY : {
    lat: "38.3386",
    lon: "-75.51",
    country: "US",
    name: {
      en : "Wicomico Regional"
    }
  },
  SBZ : {
    lat: "45.7833",
    lon: "24.0833",
    country: "RO",
    name: {
      en : "Sibiu"
    }
  },
  SCC : {
    lat: "70.2",
    lon: "-148.467",
    country: "US",
    name: {
      en : "Prudhoe Bay Deadhorse"
    }
  },
  SCE : {
    lat: "40.7708",
    lon: "-77.8814",
    country: "US",
    name: {
      en : "University Park"
    }
  },
  SCF : {
    lat: "33.6167",
    lon: "-111.917",
    country: "US",
    name: {
      en : "Scottsdale"
    }
  },
  SCK : {
    country: "US",
    city: "SAC",
    name: {
      en : "Stockton Metro Arpt"
    }
  },
  SCL : {
    lat: "-33.3833",
    lon: "-70.7833",
    country: "CL",
    popularity: 64,
    name: {
      en : "Arturo Merino Benitez"
    }
  },
  SCM : {
    country: "US",
    name: {
      en : "SCM"
    }
  },
  SCN : {
    lat: "49.2333",
    lon: "6.98333",
    country: "DE",
    name: {
      en : "Ensheim"
    }
  },
  SCO : {
    lat: "43.8667",
    lon: "51.1",
    country: "KZ",
    name: {
      en : "Aktau"
    }
  },
  SCQ : {
    lat: "42.9",
    lon: "-8.41667",
    country: "ES",
    name: {
      en : "Santiago"
    }
  },
  SCS : {
    lat: "60.1333",
    lon: "-1.13333",
    country: "GB",
    city: "SDZ",
    name: {
      en : "Scatsta"
    }
  },
  SCT : {
    country: "YE",
    name: {
      en : "SCT"
    }
  },
  SCU : {
    lat: "19.9692",
    lon: "-75.8358",
    country: "CU",
    popularity: 6,
    name: {
      en : "Antonio Maceo"
    }
  },
  SCV : {
    lat: "47.6894",
    lon: "26.3561",
    country: "RO",
    name: {
      en : "Salcea"
    }
  },
  SCW : {
    lat: "61.6667",
    lon: "50.7667",
    country: "RU",
    name: {
      en : "Syktyvkar"
    }
  },
  SCX : {
    lat: "16.1667",
    lon: "-95.2",
    country: "MX",
    name: {
      en : "Salina Cruz"
    }
  },
  SCY : {
    lat: "-0.833333",
    lon: "-89.4333",
    country: "EC",
    name: {
      en : "San Cristobal"
    }
  },
  SCZ : {
    country: "SB",
    name: {
      en : "SCZ"
    }
  },
  SDA : {
    lat: "33.2667",
    lon: "44.5",
    country: "IQ",
    city: "BGW",
    name: {
      en : "Baghdad"
    }
  },
  SDD : {
    country: "AO",
    name: {
      en : "SDD"
    }
  },
  SDE : {
    lat: "-27.7653",
    lon: "-64.3222",
    country: "AR",
    name: {
      en : "Santiago Des Estero"
    }
  },
  SDF : {
    lat: "38.1797",
    lon: "-85.7386",
    country: "US",
    popularity: 1,
    name: {
      en : "Louisville"
    }
  },
  SDG : {
    country: "IR",
    name: {
      en : "SDG"
    }
  },
  SDJ : {
    lat: "38.1356",
    lon: "140.924",
    country: "JP",
    name: {
      en : "Sendai"
    }
  },
  SDK : {
    lat: "5.9",
    lon: "118.06",
    country: "MY",
    name: {
      en : "Sandakan"
    }
  },
  SDL : {
    lat: "62.5333",
    lon: "17.45",
    country: "SE",
    name: {
      en : "Sundsvall"
    }
  },
  SDN : {
    lat: "61.7667",
    lon: "6.21667",
    country: "NO",
    name: {
      en : "Anda"
    }
  },
  SDP : {
    lat: "55.3167",
    lon: "-160.514",
    country: "US",
    name: {
      en : "Sand Point"
    }
  },
  SDQ : {
    lat: "18.4292",
    lon: "-69.6692",
    country: "DO",
    popularity: 8,
    name: {
      en : "Las Americas"
    }
  },
  SDR : {
    lat: "43.4292",
    lon: "-3.82639",
    country: "ES",
    name: {
      en : "Santander"
    }
  },
  SDU : {
    lat: "-22.9",
    lon: "-43.1667",
    country: "BR",
    city: "RIO",
    name: {
      en : "Santos Dumont"
    }
  },
  SDV : {
    lat: "32.1108",
    lon: "34.7794",
    country: "IL",
    city: "TLV",
    name: {
      en : "Dov Hoz"
    }
  },
  SDY : {
    lat: "47.7069",
    lon: "-104.192",
    country: "US",
    popularity: 1,
    name: {
      en : "Sindey Richland"
    }
  },
  SEA : {
    lat: "47.4472",
    lon: "-122.306",
    country: "US",
    popularity: 4,
    name: {
      en : "Seattle Tacoma"
    }
  },
  SEB : {
    country: "LY",
    name: {
      en : "SEB"
    }
  },
  SEK : {
    country: "RU",
    name: {
      en : "Srednekolymsk"
    }
  },
  SEN : {
    country: "GB",
    name: {
      en : "Southend Municipal Arpt"
    }
  },
  SES : {
    lat: "66.842731",
    lon: "88.409902",
    country: "RU",
    popularity: 1,
    name: {
      en : "Svetlogorsk"
    }
  },
  SEU : {
    country: "TZ",
    name: {
      en : "SEU"
    }
  },
  SEY : {
    country: "MR",
    name: {
      en : "Selibaby Arpt"
    }
  },
  SEZ : {
    lat: "-4.67222",
    lon: "55.5225",
    country: "SC",
    popularity: 8,
    name: {
      en : "Seychelles"
    }
  },
  SFA : {
    lat: "34.7167",
    lon: "10.6833",
    country: "TN",
    name: {
      en : "El Maou"
    }
  },
  SFB : {
    lat: "28.8",
    lon: "-81.2667",
    country: "US",
    city: "ORL",
    name: {
      en : "Orlando Sanford"
    }
  },
  SFF : {
    lat: "47.6667",
    lon: "-117.4",
    country: "US",
    city: "GEG",
    name: {
      en : "Felts Field"
    }
  },
  SFG : {
    country: "MF",
    name: {
      en : "Esperance Airport"
    }
  },
  SFJ : {
    lat: "67.0122",
    lon: "-50.7197",
    country: "GL",
    name: {
      en : "Sondre Stromfjord"
    }
  },
  SFL : {
    lat: "14.9",
    lon: "-24.5167",
    country: "CV",
    name: {
      en : "Sao Filipe"
    }
  },
  SFN : {
    lat: "-31.7167",
    lon: "-60.8167",
    country: "AR",
    name: {
      en : "Santa Fe"
    }
  },
  SFO : {
    lat: "37.619",
    lon: "-122.375",
    country: "US",
    popularity: 99,
    name: {
      en : "San Francisco"
    }
  },
  SFQ : {
    country: "TR",
    city: "GNY",
    name: {
      en : "SANLIURFA"
    }
  },
  SFT : {
    lat: "64.625",
    lon: "21.0783",
    country: "SE",
    popularity: 2,
    name: {
      en : "Skelleftea"
    }
  },
  SGC : {
    lat: "61.2333",
    lon: "73.3333",
    country: "RU",
    popularity: 1,
    name: {
      en : "Surgut"
    }
  },
  SGD : {
    lat: "54.9303",
    lon: "9.79472",
    country: "DK",
    name: {
      en : "Sonderborg"
    }
  },
  SGF : {
    lat: "37.24",
    lon: "-93.385",
    country: "US",
    name: {
      en : "Springfield Branson Regional"
    }
  },
  SGK : {
    country: "PG",
    name: {
      en : "SGK"
    }
  },
  SGN : {
    lat: "10.8172",
    lon: "106.658",
    country: "VN",
    popularity: 1,
    name: {
      en : "Tan Son Nhut"
    }
  },
  SGO : {
    lat: "-28.0533",
    lon: "148.594",
    country: "AU",
    name: {
      en : "St George"
    }
  },
  SGR : {
    lat: "29.6989",
    lon: "-95.4078",
    country: "US",
    name: {
      en : "Hull Field"
    }
  },
  SGU : {
    lat: "37.0931",
    lon: "-113.592",
    country: "US",
    name: {
      en : "Saint George"
    }
  },
  SGY : {
    lat: "59.4606",
    lon: "-135.316",
    country: "US",
    name: {
      en : "Skagway Minicipal"
    }
  },
  SHA : {
    lat: "31.2",
    lon: "121.333",
    country: "CN",
    popularity: 5,
    name: {
      en : "Hongqiao"
    }
  },
  SHB : {
    lat: "43.5667",
    lon: "144.967",
    country: "JP",
    name: {
      en : "Nakashibetsu"
    }
  },
  SHC : {
    country: "ET",
    name: {
      en : "SHC"
    }
  },
  SHD : {
    lat: "38.2639",
    lon: "-78.8967",
    country: "US",
    name: {
      en : "Shenandoah Valley"
    }
  },
  SHE : {
    lat: "41.8167",
    lon: "123.5",
    country: "CN",
    name: {
      en : "Shenyang"
    }
  },
  SHF : {
    country: "CN",
    name: {
      en : "Shihezi Huayuan"
    }
  },
  SHG : {
    country: "US",
    name: {
      en : "SHG"
    }
  },
  SHH : {
    country: "US",
    name: {
      en : "SHH"
    }
  },
  SHI : {
    lat: "24.7808",
    lon: "125.297",
    country: "JP",
    city: "MMY",
    name: {
      en : "Shimojishima"
    }
  },
  SHJ : {
    lat: "25.3458",
    lon: "55.3958",
    country: "AE",
    name: {
      en : "Sharjah"
    }
  },
  SHL : {
    country: "IN",
    name: {
      en : "Shillong Airport"
    }
  },
  SHM : {
    country: "JP",
    name: {
      en : "SHM"
    }
  },
  SHP : {
    lat: "39.9333",
    lon: "119.5",
    country: "CN",
    name: {
      en : "Qinhuangdao"
    }
  },
  SHR : {
    lat: "44.7742",
    lon: "-106.977",
    country: "US",
    name: {
      en : "Sheridan Cty"
    }
  },
  SHV : {
    lat: "32.4469",
    lon: "-93.75",
    country: "US",
    name: {
      en : "Shreveport Regional"
    }
  },
  SHW : {
    lat: "17.4167",
    lon: "47.1",
    country: "SA",
    name: {
      en : "Sharurah"
    }
  },
  SHX : {
    country: "US",
    name: {
      en : "SHX"
    }
  },
  SHY : {
    country: "TZ",
    name: {
      en : "Shinyanga Arpt"
    }
  },
  SIC : {
    country: "TR",
    name: {
      en : "Sinop Arpt"
    }
  },
  SID : {
    lat: "16.745",
    lon: "-22.9517",
    country: "CV",
    popularity: 4,
    name: {
      en : "Amilcar Cabral"
    }
  },
  SIF : {
    country: "NP",
    name: {
      en : "SIF"
    }
  },
  SIG : {
    lat: "18.4589",
    lon: "-66.1028",
    country: "US",
    name: {
      en : "SIG Isla Grande"
    }
  },
  SIN : {
    lat: "1.35806",
    lon: "103.911",
    country: "SG",
    popularity: 33,
    name: {
      en : "Changi"
    }
  },
  SIP : {
    lat: "45.0167",
    lon: "34",
    country: "AK",
    popularity: 69,
    name: {
      en : "Simferopol"
    }
  },
  SIQ : {
    country: "ID",
    name: {
      en : "SIQ"
    }
  },
  SIR : {
    country: "CH",
    name: {
      en : "Sion Arpt"
    }
  },
  SIT : {
    lat: "57.0486",
    lon: "-135.233",
    country: "US",
    name: {
      en : "Sitka"
    }
  },
  SJC : {
    lat: "37.3611",
    lon: "-121.926",
    country: "US",
    name: {
      en : "San Jose"
    }
  },
  SJD : {
    lat: "23.1667",
    lon: "-109.7",
    country: "MX",
    name: {
      en : "Los Cabos"
    }
  },
  SJE : {
    country: "CO",
    name: {
      en : "San Jose Del Guaviaro Arpt"
    }
  },
  SJI : {
    country: "PH",
    name: {
      en : "SJI"
    }
  },
  SJJ : {
    lat: "43.8189",
    lon: "18.3381",
    country: "BA",
    name: {
      en : "Butmir"
    }
  },
  SJK : {
    country: "BR",
    name: {
      en : "Sao Jose Dos Campos Arpt"
    }
  },
  SJL : {
    country: "BR",
    name: {
      en : "SJL"
    }
  },
  SJO : {
    lat: "10",
    lon: "-84.2",
    country: "CR",
    popularity: 1,
    name: {
      en : "Juan Santa Maria"
    }
  },
  SJP : {
    lat: "-20.8167",
    lon: "-49.4167",
    country: "BR",
    name: {
      en : "Sao Jose Do Rio Preto"
    }
  },
  SJT : {
    lat: "31.3597",
    lon: "-100.494",
    country: "US",
    name: {
      en : "Mathis Field"
    }
  },
  SJU : {
    lat: "18.44",
    lon: "-66.0022",
    country: "US",
    name: {
      en : "Luiz Munoz Marin"
    }
  },
  SJW : {
    lat: "38.05",
    lon: "114.467",
    country: "CN",
    name: {
      en : "Daguocun"
    }
  },
  SJY : {
    lat: "62.6933",
    lon: "22.8317",
    country: "FI",
    name: {
      en : "Ilmajoki"
    }
  },
  SJZ : {
    lat: "38.65",
    lon: "-28.2333",
    country: "PT",
    name: {
      en : "Sao Jorge"
    }
  },
  SKB : {
    lat: "17.3081",
    lon: "-62.7214",
    country: "KN",
    name: {
      en : "Robert L Bradshaw"
    }
  },
  SKC : {
    country: "PG",
    name: {
      en : "SKC"
    }
  },
  SKD : {
    lat: "39.7",
    lon: "67",
    country: "UZ",
    name: {
      en : "Samarkand"
    }
  },
  SKE : {
    lat: "59.1828",
    lon: "9.5625",
    country: "NO",
    name: {
      en : "Skien"
    }
  },
  SKG : {
    lat: "40.5208",
    lon: "22.9722",
    country: "GR",
    popularity: 24,
    name: {
      en : "Makedonia Airport"
    }
  },
  SKH : {
    country: "NP",
    name: {
      en : "SKH"
    }
  },
  SKK : {
    country: "US",
    name: {
      en : "Shaktoolik Arpt"
    }
  },
  SKN : {
    lat: "68.5811",
    lon: "15.0272",
    country: "NO",
    name: {
      en : "Skagen"
    }
  },
  SKO : {
    country: "NG",
    name: {
      en : "SKO"
    }
  },
  SKP : {
    lat: "41.9667",
    lon: "21.6333",
    country: "MK",
    popularity: 7,
    name: {
      en : "Skopje"
    }
  },
  SKT : {
    lat: "32.5333",
    lon: "74.5",
    country: "PK",
    name: {
      en : "Sialkot"
    }
  },
  SKU : {
    country: "GR",
    name: {
      en : "Skiros Arpt"
    }
  },
  SKX : {
    country: "RU",
    name: {
      en : "Saransk"
    }
  },
  SKZ : {
    country: "PK",
    name: {
      en : "SKZ"
    }
  },
  SLA : {
    lat: "-24.855",
    lon: "-65.4722",
    country: "AR",
    name: {
      en : "General Belgrano"
    }
  },
  SLC : {
    lat: "40.7842",
    lon: "-111.967",
    country: "US",
    name: {
      en : "Salt Lake City"
    }
  },
  SLE : {
    lat: "44.9953",
    lon: "-123.025",
    country: "US",
    name: {
      en : "McNary Field"
    }
  },
  SLH : {
    country: "VU",
    name: {
      en : "SLH"
    }
  },
  SLI : {
    country: "ZM",
    name: {
      en : "SLI"
    }
  },
  SLK : {
    lat: "44.3828",
    lon: "-74.2067",
    country: "US",
    name: {
      en : "Adirondack"
    }
  },
  SLL : {
    lat: "17.0364",
    lon: "54.1017",
    country: "OM",
    name: {
      en : "Salalah"
    }
  },
  SLM : {
    lat: "40.9667",
    lon: "-5.65",
    country: "ES",
    name: {
      en : "Matacan"
    }
  },
  SLN : {
    lat: "38.7908",
    lon: "-97.6525",
    country: "US",
    name: {
      en : "Salina"
    }
  },
  SLP : {
    lat: "22.1772",
    lon: "-100.988",
    country: "MX",
    name: {
      en : "San Luis Potosi"
    }
  },
  SLQ : {
    country: "US",
    name: {
      en : "SLQ"
    }
  },
  SLU : {
    lat: "14.0192",
    lon: "-60.9928",
    country: "LC",
    name: {
      en : "Vigie Field"
    }
  },
  SLV : {
    lat: "31.1167",
    lon: "77.15",
    country: "IN",
    name: {
      en : "Simla"
    }
  },
  SLW : {
    lat: "25.55",
    lon: "-100.917",
    country: "MX",
    name: {
      en : "Saltillo"
    }
  },
  SLX : {
    country: "TC",
    name: {
      en : "SLX"
    }
  },
  SLY : {
    lat: "66.5833",
    lon: "66.6",
    country: "RU",
    name: {
      en : "Salekhard"
    }
  },
  SLZ : {
    lat: "-2.58333",
    lon: "-44.2333",
    country: "BR",
    name: {
      en : "Mal Cunha Machado"
    }
  },
  SMA : {
    lat: "36.9667",
    lon: "-25.1",
    country: "PT",
    name: {
      en : "Vilo Do Porto"
    }
  },
  SME : {
    lat: "37.0833",
    lon: "-84.6",
    country: "US",
    name: {
      en : "Pulaski County"
    }
  },
  SMF : {
    lat: "38.6956",
    lon: "-121.598",
    country: "US",
    city: "SAC",
    name: {
      en : "Sacramento"
    }
  },
  SMI : {
    lat: "37.6889",
    lon: "26.9139",
    country: "GR",
    popularity: 1,
    name: {
      en : "Samos"
    }
  },
  SMK : {
    country: "US",
    name: {
      en : "SMK"
    }
  },
  SML : {
    lat: "23.5833",
    lon: "-75.2681",
    country: "BS",
    name: {
      en : "Stella Maris"
    }
  },
  SMO : {
    lat: "34.0167",
    lon: "-118.5",
    country: "US",
    city: "LAX",
    name: {
      en : "Santa Monica"
    }
  },
  SMR : {
    lat: "11.1222",
    lon: "-74.2286",
    country: "CO",
    name: {
      en : "Simon Bolivar"
    }
  },
  SMS : {
    lat: "-17.0833",
    lon: "49.8167",
    country: "MG",
    name: {
      en : "St Marie"
    }
  },
  SMX : {
    lat: "34.905",
    lon: "-120.458",
    country: "US",
    name: {
      en : "Santa Maria Public"
    }
  },
  SNA : {
    lat: "33.6756",
    lon: "-117.867",
    country: "US",
    name: {
      en : "John Wayne"
    }
  },
  SNC : {
    country: "EC",
    name: {
      en : "General Ulpiano Paez"
    }
  },
  SNE : {
    lat: "16.5869",
    lon: "-24.2886",
    country: "CV",
    name: {
      en : "Preguica"
    }
  },
  SNN : {
    lat: "52.7006",
    lon: "-8.91861",
    country: "IE",
    name: {
      en : "Shannon"
    }
  },
  SNO : {
    lat: "17.2833",
    lon: "104.1",
    country: "TH",
    name: {
      en : "Sakon Nakhon"
    }
  },
  SNP : {
    country: "US",
    name: {
      en : "SNP"
    }
  },
  SNR : {
    lat: "47.2911",
    lon: "-2.18222",
    country: "FR",
    name: {
      en : "Montoir"
    }
  },
  SNS : {
    lat: "36.6667",
    lon: "-121.65",
    country: "US",
    name: {
      en : "Salinas"
    }
  },
  SNU : {
    lat: "22.4919",
    lon: "-79.9419",
    country: "CU",
    name: {
      en : "Santa Clara"
    }
  },
  SNW : {
    country: "MM",
    name: {
      en : "SNW"
    }
  },
  SOB : {
    lat: "0",
    lon: "0",
    country: "HU",
    name: {
      en : "Hévíz–Balaton"
    }
  },
  SOC : {
    lat: "-7.5",
    lon: "110",
    country: "ID",
    name: {
      en : "Adi Sumarno"
    }
  },
  SOF : {
    lat: "42.7",
    lon: "23.4",
    country: "BG",
    popularity: 11,
    name: {
      en : "Sofia Vrazhdebna"
    }
  },
  SOG : {
    lat: "61.1578",
    lon: "7.13694",
    country: "NO",
    name: {
      en : "Haukasen"
    }
  },
  SOJ : {
    country: "NO",
    name: {
      en : "SOJ"
    }
  },
  SOM : {
    lat: "8.94917",
    lon: "-64.1458",
    country: "VE",
    name: {
      en : "El Tigre"
    }
  },
  SON : {
    lat: "-15.5167",
    lon: "167.217",
    country: "VU",
    name: {
      en : "Pekoa"
    }
  },
  SOQ : {
    lat: "-0.933333",
    lon: "131.117",
    country: "ID",
    name: {
      en : "Jefman"
    }
  },
  SOU : {
    lat: "50.9517",
    lon: "-1.35194",
    country: "GB",
    name: {
      en : "Southampton"
    }
  },
  SOV : {
    lat: "59.45",
    lon: "-151.717",
    country: "US",
    name: {
      en : "Seldovia"
    }
  },
  SOW : {
    lat: "34.2644",
    lon: "-110.004",
    country: "US",
    name: {
      en : "Show Low"
    }
  },
  SOY : {
    lat: "59.1333",
    lon: "-2.63333",
    country: "GB",
    name: {
      en : "Stronsay"
    }
  },
  SPB : {
    country: "VI",
    city: "STT",
    name: {
      en : "Seaplane Base"
    }
  },
  SPC : {
    lat: "28.6208",
    lon: "-17.7542",
    country: "ES",
    name: {
      en : "La Palma"
    }
  },
  SPD : {
    country: "BD",
    name: {
      en : "Saidpur"
    }
  },
  SPI : {
    lat: "39.8442",
    lon: "-89.6789",
    country: "US",
    name: {
      en : "Capital"
    }
  },
  SPN : {
    lat: "15.1228",
    lon: "145.712",
    country: "MP",
    name: {
      en : "Saipan"
    }
  },
  SPP : {
    country: "AO",
    name: {
      en : "SPP"
    }
  },
  SPR : {
    lat: "17.9111",
    lon: "-87.9686",
    country: "BZ",
    name: {
      en : "San Pedro"
    }
  },
  SPS : {
    lat: "33.9883",
    lon: "-98.4919",
    country: "US",
    name: {
      en : "Wichita Falls"
    }
  },
  SPU : {
    lat: "43.525",
    lon: "16.2922",
    country: "HR",
    popularity: 4,
    name: {
      en : "Split"
    }
  },
  SPX : {
    lat: "30.1146173282724",
    lon: "30.88905461360174",
    country: "EG",
    city: "CAI",
    name: {
      en : "Sphinx International Airport"
    }
  },
  SPY : {
    country: "CI",
    name: {
      en : "San Pédro"
    }
  },
  SQD : {
    country: "CN",
    name: {
      en : "Shangrao Sanqingshan"
    }
  },
  SQO : {
    lat: "64.9622",
    lon: "17.8",
    country: "SE",
    popularity: 1,
    name: {
      en : "Gunnarn"
    }
  },
  SRA : {
    country: "BR",
    name: {
      en : "SRA"
    }
  },
  SRE : {
    lat: "-19.0078",
    lon: "-65.3017",
    country: "BO",
    name: {
      en : "Sucre"
    }
  },
  SRG : {
    lat: "-6.97583",
    lon: "110.38",
    country: "ID",
    name: {
      en : "Achmad Uani"
    }
  },
  SRJ : {
    country: "BO",
    name: {
      en : "SRJ"
    }
  },
  SRP : {
    lat: "59.8333",
    lon: "5.41667",
    country: "NO",
    name: {
      en : "Stord"
    }
  },
  SRQ : {
    lat: "27.3939",
    lon: "-82.5542",
    country: "US",
    name: {
      en : "Sarasota Bradenton"
    }
  },
  SRV : {
    country: "US",
    name: {
      en : "SRV"
    }
  },
  SRX : {
    country: "LY",
    name: {
      en : "SRX"
    }
  },
  SRY : {
    country: "IR",
    name: {
      en : "SRY"
    }
  },
  SRZ : {
    lat: "-17.8042",
    lon: "-63.1725",
    country: "BO",
    name: {
      en : "El Trompillo"
    }
  },
  SSA : {
    lat: "-12.9167",
    lon: "-38.3333",
    country: "BR",
    name: {
      en : "Luis E Magalhaes"
    }
  },
  SSB : {
    country: "VI",
    city: "STX",
    name: {
      en : "Soesterberg Seeplane Base"
    }
  },
  SSE : {
    country: "IN",
    name: {
      en : "Solapur Airport"
    }
  },
  SSG : {
    lat: "3.75278",
    lon: "8.70556",
    country: "GQ",
    name: {
      en : "Santa Isabel"
    }
  },
  SSH : {
    lat: "27.85",
    lon: "34.2667",
    country: "EG",
    popularity: 39,
    name: {
      en : "Ophira"
    }
  },
  SSJ : {
    lat: "65.9583",
    lon: "12.4714",
    country: "NO",
    name: {
      en : "Stokka"
    }
  },
  SSR : {
    country: "VU",
    name: {
      en : "SSR"
    }
  },
  STC : {
    lat: "45.55",
    lon: "-94.1667",
    country: "US",
    name: {
      en : "Saint Cloud"
    }
  },
  STD : {
    lat: "7.58333",
    lon: "-72.0667",
    country: "VE",
    name: {
      en : "Mayor Humberto Vivas Guerrero"
    }
  },
  STG : {
    lat: "0",
    lon: "0",
    country: "US",
    name: {
      en : "St George Island Arpt"
    }
  },
  STI : {
    lat: "19.4692",
    lon: "-70.7003",
    country: "DO",
    popularity: 2,
    name: {
      en : "Santiago"
    }
  },
  STL : {
    lat: "38.7472",
    lon: "-90.3644",
    country: "US",
    popularity: 16,
    name: {
      en : "Lambert St Louis"
    }
  },
  STM : {
    lat: "-2.43333",
    lon: "-54.7",
    country: "BR",
    name: {
      en : "Eduardo Gomes"
    }
  },
  STN : {
    lat: "51.8833",
    lon: "0.233333",
    country: "GB",
    city: "LON",
    name: {
      en : "Stansted"
    }
  },
  STP : {
    lat: "44.9333",
    lon: "-93.0667",
    country: "US",
    name: {
      en : "Downtown St Paul"
    }
  },
  STR : {
    lat: "48.6883",
    lon: "9.21",
    country: "DE",
    popularity: 3,
    name: {
      en : "Echterdingen"
    }
  },
  STS : {
    lat: "38.5089",
    lon: "-122.812",
    country: "US",
    name: {
      en : "Sonoma Cty"
    }
  },
  STT : {
    lat: "18.3375",
    lon: "-64.9694",
    country: "US",
    name: {
      en : "Cyril E King"
    }
  },
  STV : {
    country: "IN",
    name: {
      en : "Surat Airport"
    }
  },
  STW : {
    lat: "45.3333",
    lon: "42.0083",
    country: "RU",
    name: {
      en : "Stavropol"
    }
  },
  STX : {
    lat: "17.7019",
    lon: "-64.7986",
    country: "US",
    name: {
      en : "Alexander Hamilton"
    }
  },
  SUA : {
    lat: "27.2",
    lon: "-80.25",
    country: "US",
    name: {
      en : "Witham Field"
    }
  },
  SUB : {
    lat: "-7.21806",
    lon: "112.721",
    country: "ID",
    name: {
      en : "Juanda"
    }
  },
  SUF : {
    lat: "38.9",
    lon: "16.25",
    country: "IT",
    name: {
      en : "S Eufemia"
    }
  },
  SUG : {
    country: "PH",
    name: {
      en : "SUG"
    }
  },
  SUI : {
    lat: "42.5129",
    lon: "41.0741",
    country: "AB",
    name: {
      en : "Sukhumi"
    }
  },
  SUJ : {
    country: "RO",
    name: {
      en : "Satu Mare Arpt"
    }
  },
  SUK : {
    country: "RU",
    name: {
      en : "Sakkyryr"
    }
  },
  SUL : {
    country: "PK",
    name: {
      en : "SUL"
    }
  },
  SUN : {
    lat: "43.5042",
    lon: "-114.308",
    country: "US",
    name: {
      en : "Friedman Memorial"
    }
  },
  SUR : {
    country: "CA",
    name: {
      en : "SUR"
    }
  },
  SUS : {
    lat: "38.75",
    lon: "-90.3667",
    country: "US",
    city: "STL",
    name: {
      en : "Spirit Of St Louis"
    }
  },
  SUU : {
    lat: "38.2625",
    lon: "-121.927",
    country: "US",
    name: {
      en : "Travis AFB"
    }
  },
  SUV : {
    lat: "-18.0333",
    lon: "178.55",
    country: "FJ",
    popularity: 1,
    name: {
      en : "Nausori"
    }
  },
  SUX : {
    lat: "42.4019",
    lon: "-96.3842",
    country: "US",
    name: {
      en : "Sioux Gateway"
    }
  },
  SUY : {
    country: "RU",
    name: {
      en : "Suntar"
    }
  },
  SVA : {
    country: "US",
    name: {
      en : "SVA"
    }
  },
  SVB : {
    lat: "-14.2769",
    lon: "50.175",
    country: "MG",
    name: {
      en : "Sambava"
    }
  },
  SVC : {
    lat: "32.6319",
    lon: "-108.154",
    country: "US",
    name: {
      en : "Grant County"
    }
  },
  SVD : {
    lat: "13.1333",
    lon: "-61.2",
    country: "VC",
    name: {
      en : "Arnos Vale"
    }
  },
  SVG : {
    lat: "58.8797",
    lon: "5.63472",
    country: "NO",
    name: {
      en : "Sola"
    }
  },
  SVI : {
    country: "CO",
    name: {
      en : "San Vincente Del Caguan"
    }
  },
  SVJ : {
    lat: "68.2417",
    lon: "14.6722",
    country: "NO",
    name: {
      en : "Helle"
    }
  },
  SVL : {
    lat: "61.95",
    lon: "28.95",
    country: "FI",
    name: {
      en : "Savonlinna"
    }
  },
  SVO : {
    lat: "55.9833",
    lon: "37.4167",
    country: "RU",
    city: "MOW",
    popularity: 1142,
    name: {
      en : "Sheremetyevo"
    }
  },
  SVP : {
    country: "AO",
    name: {
      en : "SVP"
    }
  },
  SVQ : {
    lat: "37.415",
    lon: "-5.8975",
    country: "ES",
    popularity: 4,
    name: {
      en : "San Pablo"
    }
  },
  SVS : {
    country: "US",
    name: {
      en : "SVS"
    }
  },
  SVU : {
    lat: "-16.8028",
    lon: "179.344",
    country: "FJ",
    name: {
      en : "Savusavu"
    }
  },
  SVX : {
    lat: "56.85",
    lon: "60.6",
    country: "RU",
    popularity: 68,
    name: {
      en : "Koltsovo"
    }
  },
  SWA : {
    lat: "23.3833",
    lon: "116.683",
    country: "CN",
    name: {
      en : "Shantou"
    }
  },
  SWF : {
    lat: "41.5058",
    lon: "-74.0972",
    country: "US",
    name: {
      en : "Stewart"
    }
  },
  SWJ : {
    country: "VU",
    name: {
      en : "SWJ"
    }
  },
  SWO : {
    country: "US",
    name: {
      en : "Searcy Fld"
    }
  },
  SWQ : {
    country: "ID",
    name: {
      en : "Sumbawa"
    }
  },
  SWT : {
    lat: "60.708889",
    lon: "77.661111",
    country: "RU",
    popularity: 19,
    name: {
      en : "Strezhevoy"
    }
  },
  SWV : {
    lat: "61.9181622",
    lon: "159.229109",
    country: "RU",
    name: {
      en : "Evensk"
    }
  },
  SXB : {
    lat: "48.5333",
    lon: "7.63333",
    country: "FR",
    name: {
      en : "Enzheim"
    }
  },
  SXF : {
    lat: "52.3667",
    lon: "13.5",
    country: "DE",
    city: "BER",
    name: {
      en : "Schoenefeld"
    }
  },
  SXL : {
    lat: "54.2833",
    lon: "-8.46667",
    country: "IE",
    name: {
      en : "Collooney"
    }
  },
  SXM : {
    lat: "18.0436",
    lon: "-63.1119",
    country: "AN",
    name: {
      en : "Princess Juliana"
    }
  },
  SXP : {
    country: "US",
    name: {
      en : "SXP"
    }
  },
  SXR : {
    lat: "33.9881",
    lon: "74.7753",
    country: "IN",
    name: {
      en : "Srinagar"
    }
  },
  SXV : {
    country: "IN",
    name: {
      en : "Salem Arpt"
    }
  },
  SYB : {
    country: "US",
    name: {
      en : "SYB"
    }
  },
  SYD : {
    lat: "-33.9442",
    lon: "151.176",
    country: "AU",
    popularity: 62,
    name: {
      en : "Sydney Kingsford Smith"
    }
  },
  SYJ : {
    country: "IR",
    name: {
      en : "SYJ"
    }
  },
  SYM : {
    country: "CN",
    name: {
      en : "SYM"
    }
  },
  SYO : {
    lat: "38.8094",
    lon: "139.791",
    country: "JP",
    name: {
      en : "Shonai"
    }
  },
  SYQ : {
    country: "CR",
    city: "SJO",
    name: {
      en : "Tobias Bolanos Intl"
    }
  },
  SYR : {
    lat: "43.1106",
    lon: "-76.1025",
    country: "US",
    name: {
      en : "Hancock"
    }
  },
  SYS : {
    country: "RU",
    name: {
      en : "Saskylakh"
    }
  },
  SYX : {
    lat: "18.3",
    lon: "109.4",
    country: "CN",
    name: {
      en : "Sanya"
    }
  },
  SYY : {
    lat: "58.2161",
    lon: "-6.32917",
    country: "GB",
    name: {
      en : "Stornoway"
    }
  },
  SYZ : {
    lat: "29.5403",
    lon: "52.5908",
    country: "IR",
    name: {
      en : "Shiraz"
    }
  },
  SZB : {
    lat: "3.13333",
    lon: "101.55",
    country: "MY",
    city: "KUL",
    name: {
      en : "Sultan Abdul Aziz Shah"
    }
  },
  SZE : {
    country: "ET",
    name: {
      en : "Semera"
    }
  },
  SZF : {
    lat: "41.25",
    lon: "36.55",
    country: "TR",
    name: {
      en : "Carsamba"
    }
  },
  SZG : {
    lat: "47.7931",
    lon: "13.0056",
    country: "AT",
    popularity: 4,
    name: {
      en : "W A Mozart"
    }
  },
  SZK : {
    lat: "-24.96567943590338",
    lon: "31.59373237822914",
    country: "ZA",
    name: {
      en : "Skukuza"
    }
  },
  SZX : {
    lat: "22.5667",
    lon: "113.933",
    country: "CN",
    name: {
      en : "Shenzhen"
    }
  },
  SZZ : {
    lat: "53.5833",
    lon: "14.9",
    country: "PL",
    name: {
      en : "Goleniow"
    }
  },
  TAB : {
    lat: "11.1464",
    lon: "-60.8367",
    country: "TT",
    name: {
      en : "Crown Point"
    }
  },
  TAC : {
    lat: "11.2344",
    lon: "125.019",
    country: "PH",
    name: {
      en : "D Z Romualdez"
    }
  },
  TAE : {
    lat: "35.8833",
    lon: "128.667",
    country: "KR",
    name: {
      en : "Daegu International Airport "
    }
  },
  TAG : {
    country: "PH",
    name: {
      en : "Tagbilaran Arpt"
    }
  },
  TAH : {
    lat: "-19.3333",
    lon: "169.25",
    country: "VU",
    name: {
      en : "Tanna"
    }
  },
  TAI : {
    country: "YE",
    name: {
      en : "TAI"
    }
  },
  TAK : {
    lat: "34.2903",
    lon: "134.073",
    country: "JP",
    name: {
      en : "Takamatsu"
    }
  },
  TAL : {
    lat: "65.175",
    lon: "-152.108",
    country: "US",
    popularity: 1,
    name: {
      en : "Ralph Calhoun"
    }
  },
  TAM : {
    lat: "22.2744",
    lon: "-97.8017",
    country: "MX",
    name: {
      en : "General F Javier Mina"
    }
  },
  TAO : {
    lat: "36.1",
    lon: "120.317",
    country: "CN",
    name: {
      en : "Jiaodong International"
    }
  },
  TAP : {
    lat: "14.9097",
    lon: "-92.2531",
    country: "MX",
    name: {
      en : "Tapachula"
    }
  },
  TAR : {
    lat: "40.5178",
    lon: "17.4019",
    country: "IT",
    name: {
      en : "M A Grottag"
    }
  },
  TAS : {
    lat: "41.25",
    lon: "69.2833",
    country: "UZ",
    popularity: 15,
    name: {
      en : "Islam Karimov Tashkent International Airport"
    }
  },
  TAT : {
    lat: "49.0719",
    lon: "20.2403",
    country: "SK",
    name: {
      en : "Poprad–Tatry"
    }
  },
  TAY : {
    country: "EE",
    name: {
      en : "Tartu Arpt"
    }
  },
  TBB : {
    lat: "13.0442",
    lon: "109.34",
    country: "VN",
    name: {
      en : "Tuy Hoa"
    }
  },
  TBG : {
    lat: "-5.38333",
    lon: "141.317",
    country: "PG",
    name: {
      en : "Tabubil"
    }
  },
  TBH : {
    country: "PH",
    name: {
      en : "TBH"
    }
  },
  TBI : {
    country: "BS",
    name: {
      en : "TBI"
    }
  },
  TBJ : {
    country: "TN",
    name: {
      en : "Tabarka Arpt"
    }
  },
  TBN : {
    lat: "37.7414",
    lon: "-92.1406",
    country: "US",
    name: {
      en : "Forney Field"
    }
  },
  TBO : {
    country: "TZ",
    name: {
      en : "Tabora Arpt"
    }
  },
  TBP : {
    lat: "-3.56667",
    lon: "-80.4167",
    country: "PE",
    name: {
      en : "Tumbes"
    }
  },
  TBS : {
    lat: "41.6667",
    lon: "44.95",
    country: "GE",
    popularity: 7,
    name: {
      en : "Tbilisi International Airport"
    }
  },
  TBT : {
    country: "BR",
    name: {
      en : "Tabatinga Intl Arpt"
    }
  },
  TBU : {
    lat: "-21.25",
    lon: "-175.15",
    country: "TO",
    name: {
      en : "Tongatapu"
    }
  },
  TBW : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Donskoye"
    }
  },
  TBZ : {
    country: "IR",
    name: {
      en : "Tabriz International Arpt"
    }
  },
  TCB : {
    lat: "26.735",
    lon: "-77.3722",
    country: "BS",
    name: {
      en : "Treasure Cay"
    }
  },
  TCD : {
    country: "CO",
    name: {
      en : "Tarapaca Arpt"
    }
  },
  TCG : {
    country: "CN",
    name: {
      en : "TCG"
    }
  },
  TCO : {
    country: "CO",
    name: {
      en : "TCO"
    }
  },
  TCP : {
    lat: "29.55",
    lon: "34.9167",
    country: "EG",
    name: {
      en : "Ras An Naqb"
    }
  },
  TCQ : {
    country: "PE",
    name: {
      en : "TCQ"
    }
  },
  TCR : {
    country: "IN",
    name: {
      en : "Tuticorin Arpt"
    }
  },
  TCT : {
    country: "US",
    name: {
      en : "TCT"
    }
  },
  TCX : {
    country: "IR",
    name: {
      en : "TCX"
    }
  },
  TCZ : {
    country: "CN",
    name: {
      en : "TCZ"
    }
  },
  TDD : {
    lat: "-14.6833",
    lon: "-64.8333",
    country: "BO",
    name: {
      en : "Trinidad"
    }
  },
  TDX : {
    lat: "12.2681",
    lon: "102.317",
    country: "TH",
    name: {
      en : "Trat"
    }
  },
  TEB : {
    lat: "40.8497",
    lon: "-74.0622",
    country: "US",
    name: {
      en : "Teterboro"
    }
  },
  TEE : {
    country: "DZ",
    name: {
      en : "TEE"
    }
  },
  TEK : {
    country: "US",
    name: {
      en : "Tatitlek Arpt"
    }
  },
  TEN : {
    lat: "27.6333",
    lon: "109.05",
    country: "CN",
    name: {
      en : "Tongren"
    }
  },
  TEQ : {
    country: "TR",
    name: {
      en : "Corlu Airport"
    }
  },
  TER : {
    lat: "38.7567",
    lon: "-27.0942",
    country: "PT",
    name: {
      en : "Lajes"
    }
  },
  TET : {
    lat: "-16.1033",
    lon: "33.6389",
    country: "MZ",
    name: {
      en : "Matunda"
    }
  },
  TEX : {
    lat: "37.9333",
    lon: "-107.817",
    country: "US",
    name: {
      en : "Telluride"
    }
  },
  TEZ : {
    country: "IN",
    name: {
      en : "Salonibari Airport"
    }
  },
  TFF : {
    country: "BR",
    name: {
      en : "Tefe Arpt"
    }
  },
  TFI : {
    country: "PG",
    name: {
      en : "TFI"
    }
  },
  TFN : {
    lat: "28.4731",
    lon: "-16.3328",
    country: "ES",
    city: "TCI",
    popularity: 4,
    name: {
      en : "Tenerife Norte Los Rodeos"
    }
  },
  TFS : {
    lat: "28.05",
    lon: "-16.5667",
    country: "ES",
    city: "TCI",
    name: {
      en : "Reina Sofia"
    }
  },
  TFU : {
    country: "CN",
    city: "CTU",
    popularity: 198,
    name: {
      en : "Chengdu Tianfu Airport"
    }
  },
  TGC : {
    country: "MY",
    name: {
      en : "TGC"
    }
  },
  TGD : {
    lat: "42.3583",
    lon: "19.2519",
    country: "ME",
    popularity: 32,
    name: {
      en : "Golubovci"
    }
  },
  TGG : {
    lat: "5.38111",
    lon: "103.11",
    country: "MY",
    name: {
      en : "Sultan Mahmood"
    }
  },
  TGH : {
    country: "VU",
    name: {
      en : "TGH"
    }
  },
  TGJ : {
    country: "NC",
    name: {
      en : "TGJ"
    }
  },
  TGK : {
    lat: "47.24",
    lon: "38.84",
    country: "RU",
    name: {
      en : "Yuzhny"
    }
  },
  TGM : {
    lat: "46.5333",
    lon: "24.5333",
    country: "RO",
    name: {
      en : "Tirgu Mures"
    }
  },
  TGO : {
    country: "CN",
    name: {
      en : "Tongliao Arpt"
    }
  },
  TGP : {
    country: "RU",
    name: {
      en : "Podkamennaya Tunguska"
    }
  },
  TGR : {
    country: "DZ",
    name: {
      en : "TGR"
    }
  },
  TGU : {
    lat: "14.0597",
    lon: "-87.2175",
    country: "HN",
    name: {
      en : "Toncontin"
    }
  },
  TGZ : {
    lat: "16.7333",
    lon: "-93.1833",
    country: "MX",
    name: {
      en : "Llano San Juan"
    }
  },
  THD : {
    country: "VN",
    name: {
      en : "Tho Xuan"
    }
  },
  THE : {
    lat: "-5.06528",
    lon: "-42.8178",
    country: "BR",
    name: {
      en : "Teresina"
    }
  },
  THL : {
    country: "MM",
    name: {
      en : "THL"
    }
  },
  THN : {
    lat: "58.2667",
    lon: "12.3",
    country: "SE",
    name: {
      en : "Trollhattan"
    }
  },
  THQ : {
    country: "CN",
    name: {
      en : "THQ"
    }
  },
  THR : {
    lat: "35.6897",
    lon: "51.3158",
    country: "IR",
    name: {
      en : "Mehrabad"
    }
  },
  THS : {
    lat: "17.2231",
    lon: "99.8222",
    country: "TH",
    name: {
      en : "Sukhothai"
    }
  },
  THU : {
    country: "GL",
    name: {
      en : "THU"
    }
  },
  THX : {
    country: "RU",
    name: {
      en : "Turukhansk Airport"
    }
  },
  TIA : {
    lat: "41.4169",
    lon: "19.7167",
    country: "AL",
    popularity: 4,
    name: {
      en : "Rinas"
    }
  },
  TID : {
    country: "DZ",
    name: {
      en : "TID"
    }
  },
  TIF : {
    lat: "21.4883",
    lon: "40.5433",
    country: "SA",
    name: {
      en : "Taif"
    }
  },
  TIH : {
    lat: "-15",
    lon: "-147.75",
    country: "PF",
    name: {
      en : "Tikehau"
    }
  },
  TII : {
    country: "AF",
    name: {
      en : "TII"
    }
  },
  TIJ : {
    lat: "32.5414",
    lon: "-116.97",
    country: "MX",
    name: {
      en : "Gen Abelardo Rodriguez"
    }
  },
  TIM : {
    lat: "-4.53333",
    lon: "136.917",
    country: "ID",
    name: {
      en : "Timika"
    }
  },
  TIN : {
    country: "DZ",
    name: {
      en : "TIN"
    }
  },
  TIP : {
    lat: "32.9056",
    lon: "13.2773",
    country: "LY",
    popularity: 37,
    name: {
      en : "Tripoli"
    }
  },
  TIQ : {
    lat: "15.0019",
    lon: "145.625",
    country: "MP",
    name: {
      en : "Tinian"
    }
  },
  TIR : {
    lat: "13.6333",
    lon: "79.55",
    country: "IN",
    name: {
      en : "Tirupati"
    }
  },
  TIU : {
    lat: "-44.3028",
    lon: "171.225",
    country: "NZ",
    name: {
      en : "Timaru"
    }
  },
  TIV : {
    lat: "42.4036",
    lon: "18.7256",
    country: "ME",
    popularity: 33,
    name: {
      en : "Tivat"
    }
  },
  TIW : {
    lat: "47.2706",
    lon: "-122.573",
    country: "US",
    name: {
      en : "Tacoma Industrial"
    }
  },
  TIZ : {
    lat: "-5.86056",
    lon: "142.941",
    country: "PG",
    name: {
      en : "Tari"
    }
  },
  TJA : {
    lat: "-21.5542",
    lon: "-64.7458",
    country: "BO",
    name: {
      en : "Tarija"
    }
  },
  TJM : {
    lat: "57.1833",
    lon: "65.4833",
    country: "RU",
    popularity: 10,
    name: {
      en : "Tyumen"
    }
  },
  TJN : {
    country: "PF",
    name: {
      en : "TJN"
    }
  },
  TJQ : {
    lat: "-2.75",
    lon: "107.65",
    country: "ID",
    name: {
      en : "Bulutumbang"
    }
  },
  TJU : {
    country: "TJ",
    name: {
      en : "TJU"
    }
  },
  TKD : {
    country: "GH",
    name: {
      en : "TKD"
    }
  },
  TKE : {
    country: "US",
    name: {
      en : "TKE"
    }
  },
  TKG : {
    lat: "-5.53333",
    lon: "105.117",
    country: "ID",
    name: {
      en : "Bandar Lampung"
    }
  },
  TKJ : {
    lat: "63.3",
    lon: "-143",
    country: "US",
    name: {
      en : "Tok"
    }
  },
  TKK : {
    lat: "7.46667",
    lon: "151.85",
    country: "FM",
    name: {
      en : "Truk"
    }
  },
  TKM : {
    lat: "56.367141342161446",
    lon: "114.92919055723384",
    country: "RU",
    name: {
      en : "Taksimo"
    }
  },
  TKN : {
    lat: "27.8333",
    lon: "128.883",
    country: "JP",
    name: {
      en : "Tokunoshima"
    }
  },
  TKP : {
    country: "PF",
    name: {
      en : "TKP"
    }
  },
  TKQ : {
    country: "TZ",
    name: {
      en : "Kigoma Arpt"
    }
  },
  TKS : {
    lat: "34.1297",
    lon: "134.602",
    country: "JP",
    name: {
      en : "Tokushima"
    }
  },
  TKU : {
    lat: "60.5142",
    lon: "22.2706",
    country: "FI",
    name: {
      en : "Turku"
    }
  },
  TKV : {
    country: "PF",
    name: {
      en : "TKV"
    }
  },
  TKX : {
    country: "PF",
    name: {
      en : "TKX"
    }
  },
  TLA : {
    country: "US",
    name: {
      en : "TLA"
    }
  },
  TLC : {
    lat: "19.2833",
    lon: "-99.6667",
    country: "MX",
    city: "MEX",
    name: {
      en : "Toluca International Airport"
    }
  },
  TLE : {
    lat: "-23.3897",
    lon: "43.7242",
    country: "MG",
    name: {
      en : "Tulear"
    }
  },
  TLH : {
    lat: "30.3997",
    lon: "-84.3519",
    country: "US",
    name: {
      en : "Tallahassee"
    }
  },
  TLJ : {
    country: "US",
    name: {
      en : "TLJ"
    }
  },
  TLK : {
    lat: "59.881667",
    lon: "111.04555",
    country: "RU",
    popularity: 1,
    name: {
      en : "Talakan"
    }
  },
  TLL : {
    lat: "59.4167",
    lon: "24.75",
    country: "EE",
    popularity: 5,
    name: {
      en : "Ulemiste"
    }
  },
  TLM : {
    country: "DZ",
    name: {
      en : "TLM"
    }
  },
  TLN : {
    lat: "43.1",
    lon: "6.15",
    country: "FR",
    popularity: 6,
    name: {
      en : "Le Palyvestre"
    }
  },
  TLQ : {
    country: "CN",
    name: {
      en : "TLQ"
    }
  },
  TLS : {
    lat: "43.6303",
    lon: "1.365",
    country: "FR",
    name: {
      en : "Blagnac"
    }
  },
  TLT : {
    country: "US",
    name: {
      en : "TLT"
    }
  },
  TLV : {
    lat: "32.0122",
    lon: "34.8825",
    country: "IL",
    popularity: 220,
    name: {
      en : "Ben Gurion"
    }
  },
  TLY : {
    country: "RU",
    name: {
      en : "TLY"
    }
  },
  TMC : {
    country: "ID",
    name: {
      en : "TMC"
    }
  },
  TME : {
    country: "CO",
    name: {
      en : "TME"
    }
  },
  TMI : {
    country: "NP",
    name: {
      en : "TMI"
    }
  },
  TMJ : {
    country: "UZ",
    name: {
      en : "TMJ"
    }
  },
  TML : {
    country: "GH",
    name: {
      en : "Tamale Arpt"
    }
  },
  TMM : {
    lat: "-18.11",
    lon: "49.3922",
    country: "MG",
    name: {
      en : "Tamatave"
    }
  },
  TMP : {
    lat: "61.4639",
    lon: "23.7389",
    country: "FI",
    name: {
      en : "Tampere Pirkkala"
    }
  },
  TMR : {
    country: "DZ",
    name: {
      en : "TMR"
    }
  },
  TMS : {
    lat: "0",
    lon: "0",
    country: "ST",
    name: {
      en : "São Tomé International Airport"
    }
  },
  TMT : {
    country: "BR",
    name: {
      en : "Trombetas Arpt"
    }
  },
  TMU : {
    lat: "9.73333",
    lon: "-85.0167",
    country: "CR",
    name: {
      en : "Tambor"
    }
  },
  TMW : {
    lat: "-31.0819",
    lon: "150.846",
    country: "AU",
    name: {
      en : "Tamworth"
    }
  },
  TMX : {
    country: "DZ",
    name: {
      en : "TMX"
    }
  },
  TNA : {
    lat: "36.75",
    lon: "116.967",
    country: "CN",
    name: {
      en : "Jinan"
    }
  },
  TNC : {
    country: "US",
    name: {
      en : "TNC"
    }
  },
  TNG : {
    lat: "35.7167",
    lon: "-5.91667",
    country: "MA",
    name: {
      en : "Boukhalef"
    }
  },
  TNH : {
    country: "CN",
    name: {
      en : "Tonghua Sanyuanpu"
    }
  },
  TNJ : {
    country: "ID",
    name: {
      en : "TNJ"
    }
  },
  TNK : {
    country: "US",
    name: {
      en : "TNK"
    }
  },
  TNL : {
    country: "UA",
    name: {
      en : "TNL"
    }
  },
  TNN : {
    lat: "22.9519",
    lon: "120.2",
    country: "TW",
    name: {
      en : "Tainan"
    }
  },
  TNO : {
    lat: "10.9167",
    lon: "-85.45",
    country: "CR",
    name: {
      en : "Tamarindo"
    }
  },
  TNR : {
    lat: "-18.8",
    lon: "47.4833",
    country: "MG",
    name: {
      en : "Ivato"
    }
  },
  TOB : {
    country: "LY",
    name: {
      en : "Tobruk Arpt"
    }
  },
  TOD : {
    lat: "2.75",
    lon: "104.167",
    country: "MY",
    name: {
      en : "Tioman"
    }
  },
  TOE : {
    lat: "33.9167",
    lon: "8.13333",
    country: "TN",
    name: {
      en : "Tozeur"
    }
  },
  TOF : {
    lat: "56.5",
    lon: "84.9667",
    country: "RU",
    popularity: 5,
    name: {
      en : "Tomsk"
    }
  },
  TOG : {
    lat: "59.0567",
    lon: "-160.382",
    country: "US",
    name: {
      en : "Togiak Village"
    }
  },
  TOH : {
    country: "VU",
    name: {
      en : "Torres Airstrip"
    }
  },
  TOL : {
    lat: "41.5908",
    lon: "-83.8008",
    country: "US",
    name: {
      en : "Toledo Express"
    }
  },
  TOM : {
    country: "ML",
    name: {
      en : "TOM"
    }
  },
  TOS : {
    lat: "69.6814",
    lon: "18.9217",
    country: "NO",
    name: {
      en : "Tromso Langnes"
    }
  },
  TOU : {
    country: "NC",
    name: {
      en : "TOU"
    }
  },
  TOY : {
    lat: "36.6442",
    lon: "137.189",
    country: "JP",
    name: {
      en : "Toyama"
    }
  },
  TPA : {
    lat: "27.9731",
    lon: "-82.5353",
    country: "US",
    name: {
      en : "Tampa"
    }
  },
  TPE : {
    lat: "25.0771",
    lon: "121.232",
    country: "TW",
    popularity: 1,
    name: {
      en : "Chiang Kai Shek"
    }
  },
  TPI : {
    country: "PG",
    name: {
      en : "TPI"
    }
  },
  TPP : {
    country: "PE",
    name: {
      en : "TPP"
    }
  },
  TPQ : {
    lat: "21.5",
    lon: "-104.9",
    country: "MX",
    name: {
      en : "Tepic"
    }
  },
  TPS : {
    lat: "37.9117",
    lon: "12.4864",
    country: "IT",
    name: {
      en : "Birgi"
    }
  },
  TPU : {
    country: "NP",
    name: {
      en : "TPU"
    }
  },
  TQD : {
    country: "IQ",
    name: {
      en : "TQD"
    }
  },
  TQL : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Tarko-Sale"
    }
  },
  TQR : {
    lat: "42.1167",
    lon: "15.4833",
    country: "IT",
    name: {
      en : "San Domino Island"
    }
  },
  TRC : {
    lat: "25.5683",
    lon: "-103.411",
    country: "MX",
    name: {
      en : "Francisco Sarabia"
    }
  },
  TRD : {
    lat: "63.45",
    lon: "10.9333",
    country: "NO",
    name: {
      en : "Trondheim Vaernes"
    }
  },
  TRE : {
    lat: "56.5006",
    lon: "-6.87139",
    country: "GB",
    name: {
      en : "Tiree"
    }
  },
  TRF : {
    lat: "59.1833",
    lon: "10.2667",
    country: "NO",
    city: "OSL",
    name: {
      en : "Sandefjord"
    }
  },
  TRG : {
    lat: "-37.6708",
    lon: "176.194",
    country: "NZ",
    name: {
      en : "Tauranga"
    }
  },
  TRI : {
    lat: "36.5521",
    lon: "-82.4742",
    country: "US",
    name: {
      en : "Tri City Regional"
    }
  },
  TRK : {
    lat: "3.32722",
    lon: "117.565",
    country: "ID",
    name: {
      en : "Tarakan"
    }
  },
  TRN : {
    lat: "45.2011",
    lon: "7.64806",
    country: "IT",
    popularity: 8,
    name: {
      en : "Citta Di Torino"
    }
  },
  TRO : {
    lat: "-31.8167",
    lon: "152.65",
    country: "AU",
    name: {
      en : "Taree"
    }
  },
  TRS : {
    lat: "45.8333",
    lon: "13.4667",
    country: "IT",
    name: {
      en : "Ronchi Dei Legionari"
    }
  },
  TRU : {
    lat: "-8.09",
    lon: "-79.115",
    country: "PE",
    name: {
      en : "Trujillo"
    }
  },
  TRV : {
    lat: "8.47972",
    lon: "76.9197",
    country: "IN",
    popularity: 2,
    name: {
      en : "Thiruvananthapuram"
    }
  },
  TRW : {
    lat: "1.35833",
    lon: "172.942",
    country: "KI",
    name: {
      en : "Bairiki"
    }
  },
  TRZ : {
    lat: "10.765",
    lon: "78.7133",
    country: "IN",
    name: {
      en : "Tiruchirapally Civil"
    }
  },
  TSA : {
    lat: "25.0623",
    lon: "121.551",
    country: "TW",
    city: "TPE",
    name: {
      en : "Sung Shan"
    }
  },
  TSF : {
    lat: "45.6667",
    lon: "12.25",
    country: "IT",
    city: "VCE",
    name: {
      en : "Treviso"
    }
  },
  TSJ : {
    lat: "34.2833",
    lon: "129.317",
    country: "JP",
    name: {
      en : "Tsushima"
    }
  },
  TSN : {
    lat: "39.1189",
    lon: "117.347",
    country: "CN",
    name: {
      en : "Tianjin"
    }
  },
  TSO : {
    lat: "48.95",
    lon: "-6.25",
    country: "GB",
    city: "ISC",
    name: {
      en : "Tresco"
    }
  },
  TSR : {
    lat: "45.8167",
    lon: "21.3333",
    country: "RO",
    name: {
      en : "Timisoara"
    }
  },
  TSS : {
    lat: "40.7667",
    lon: "-74.1667",
    country: "US",
    city: "NYC",
    name: {
      en : "East 34th St Hlpt"
    }
  },
  TST : {
    lat: "7.5",
    lon: "99.6167",
    country: "TH",
    name: {
      en : "Trang"
    }
  },
  TSV : {
    lat: "-19.25",
    lon: "146.767",
    country: "AU",
    name: {
      en : "Townsville"
    }
  },
  TTA : {
    country: "MA",
    name: {
      en : "TTA"
    }
  },
  TTB : {
    country: "IT",
    name: {
      en : "Arbatax Arpt"
    }
  },
  TTE : {
    country: "ID",
    name: {
      en : "TTE"
    }
  },
  TTJ : {
    lat: "35.5267",
    lon: "134.17",
    country: "JP",
    name: {
      en : "Tottori"
    }
  },
  TTN : {
    lat: "40.2781",
    lon: "-74.8125",
    country: "US",
    name: {
      en : "Trenton Mercer"
    }
  },
  TTQ : {
    lat: "10.5667",
    lon: "-83.5167",
    country: "CR",
    name: {
      en : "Tortuquero"
    }
  },
  TTT : {
    lat: "22.75",
    lon: "121.1",
    country: "TW",
    name: {
      en : "Taitung"
    }
  },
  TTU : {
    lat: "0",
    lon: "0",
    country: "MA",
    name: {
      en : "Sania Ramel"
    }
  },
  TUB : {
    country: "PF",
    name: {
      en : "TUB"
    }
  },
  TUC : {
    lat: "-26.8333",
    lon: "-65.2",
    country: "AR",
    name: {
      en : "Benjamin Matienzo"
    }
  },
  TUE : {
    country: "PA",
    name: {
      en : "TUE"
    }
  },
  TUF : {
    lat: "47.4283",
    lon: "0.7275",
    country: "FR",
    name: {
      en : "Saint Symphorien"
    }
  },
  TUG : {
    country: "PH",
    name: {
      en : "Tuguegarao Arpt"
    }
  },
  TUI : {
    lat: "31.695",
    lon: "38.6317",
    country: "SA",
    name: {
      en : "Turaif"
    }
  },
  TUK : {
    lat: "25.9833",
    lon: "63.0667",
    country: "PK",
    name: {
      en : "Turbat"
    }
  },
  TUL : {
    lat: "36.1978",
    lon: "-95.8897",
    country: "US",
    name: {
      en : "Tulsa"
    }
  },
  TUN : {
    lat: "36.8525",
    lon: "10.2294",
    country: "TN",
    name: {
      en : "Carthage"
    }
  },
  TUO : {
    lat: "-38.7422",
    lon: "176.084",
    country: "NZ",
    name: {
      en : "Taupo"
    }
  },
  TUP : {
    lat: "34.2589",
    lon: "-88.7672",
    country: "US",
    name: {
      en : "C D Lemons"
    }
  },
  TUR : {
    country: "BR",
    name: {
      en : "Tucurui Arpt"
    }
  },
  TUS : {
    lat: "32.125",
    lon: "-110.949",
    country: "US",
    name: {
      en : "Tucson"
    }
  },
  TUU : {
    lat: "28.3722",
    lon: "36.6253",
    country: "SA",
    name: {
      en : "Tabuk"
    }
  },
  TUW : {
    country: "PA",
    name: {
      en : "TUW"
    }
  },
  TVC : {
    lat: "44.74",
    lon: "-85.5858",
    country: "US",
    name: {
      en : "Cherry Capital"
    }
  },
  TVF : {
    lat: "48.0661",
    lon: "-96.185",
    country: "US",
    name: {
      en : "Thief River Falls"
    }
  },
  TVS : {
    country: "CN",
    name: {
      en : "TVS"
    }
  },
  TVU : {
    lat: "-16.6931",
    lon: "179.874",
    country: "FJ",
    name: {
      en : "Matei"
    }
  },
  TVY : {
    country: "MM",
    name: {
      en : "TVY"
    }
  },
  TWA : {
    lat: "59.1667",
    lon: "-159.992",
    country: "US",
    name: {
      en : "Twin Hills"
    }
  },
  TWB : {
    country: "AU",
    name: {
      en : "Toowoomba Arpt"
    }
  },
  TWF : {
    lat: "42.4819",
    lon: "-114.487",
    country: "US",
    name: {
      en : "Twin Falls City County"
    }
  },
  TWU : {
    lat: "4.26417",
    lon: "117.885",
    country: "MY",
    name: {
      en : "Tawau"
    }
  },
  TXK : {
    lat: "33.4564",
    lon: "-93.9892",
    country: "US",
    name: {
      en : "Texarkana"
    }
  },
  TXL : {
    lat: "52.5606",
    lon: "13.2956",
    country: "DE",
    city: "BER",
    popularity: 212,
    name: {
      en : "Tegel"
    }
  },
  TXN : {
    lat: "29.7333",
    lon: "118.3",
    country: "CN",
    name: {
      en : "Tunxi"
    }
  },
  TYD : {
    lat: "55.2833",
    lon: "124.733",
    country: "RU",
    popularity: 324,
    name: {
      en : "Tynda"
    }
  },
  TYF : {
    country: "SE",
    name: {
      en : "Torsby Airport"
    }
  },
  TYN : {
    lat: "37.75",
    lon: "112.617",
    country: "CN",
    name: {
      en : "Taiyuan"
    }
  },
  TYR : {
    lat: "32.3547",
    lon: "-95.3989",
    country: "US",
    name: {
      en : "Pounds Field"
    }
  },
  TYS : {
    lat: "35.8122",
    lon: "-83.9925",
    country: "US",
    name: {
      en : "McGhee Tyson"
    }
  },
  TZA : {
    lat: "17.5333",
    lon: "-88.3",
    country: "BZ",
    city: "BZE",
    name: {
      en : "Belize City"
    }
  },
  TZN : {
    lat: "24.165",
    lon: "-77.5853",
    country: "BS",
    name: {
      en : "South Andros"
    }
  },
  TZX : {
    lat: "40.9986",
    lon: "39.7764",
    country: "TR",
    name: {
      en : "Trabzon"
    }
  },
  UAH : {
    country: "PF",
    name: {
      en : "UAH"
    }
  },
  UAK : {
    lat: "61.1667",
    lon: "-45.3167",
    country: "GL",
    name: {
      en : "Narsarsuaq"
    }
  },
  UAM : {
    lat: "13.4667",
    lon: "144.767",
    country: "GU",
    city: "GUM",
    name: {
      en : "Anderson Air Force Base"
    }
  },
  UAP : {
    country: "PF",
    name: {
      en : "UAP"
    }
  },
  UAQ : {
    lat: "-31.55",
    lon: "-68.5167",
    country: "AR",
    name: {
      en : "San Juan"
    }
  },
  UAS : {
    lat: "0.466667",
    lon: "37.55",
    country: "KE",
    name: {
      en : "Samburu Airstrip"
    }
  },
  UBA : {
    lat: "-19.7764",
    lon: "-47.9583",
    country: "BR",
    name: {
      en : "Uberaba"
    }
  },
  UBJ : {
    lat: "33.9258",
    lon: "131.274",
    country: "JP",
    name: {
      en : "Ube"
    }
  },
  UBN : {
    lat: "47.65",
    lon: "106.82",
    country: "MN",
    name: {
      en : "Chinggis Khaan"
    }
  },
  UBP : {
    lat: "15.2489",
    lon: "104.874",
    country: "TH",
    name: {
      en : "Muang Ubon"
    }
  },
  UCT : {
    country: "RU",
    name: {
      en : "UCT"
    }
  },
  UDI : {
    lat: "-18.9",
    lon: "-48.2333",
    country: "BR",
    name: {
      en : "Eduardo Gomes Airprt"
    }
  },
  UDJ : {
    lat: "48.6167",
    lon: "22.2833",
    country: "UA",
    name: {
      en : "Uzhgorod"
    }
  },
  UDR : {
    lat: "24.615",
    lon: "73.8961",
    country: "IN",
    name: {
      en : "Dabok"
    }
  },
  UEL : {
    country: "MZ",
    name: {
      en : "Quelimane Arpt"
    }
  },
  UEO : {
    lat: "26.3653",
    lon: "126.719",
    country: "JP",
    name: {
      en : "Kumejima"
    }
  },
  UET : {
    country: "PK",
    name: {
      en : "UET"
    }
  },
  UFA : {
    lat: "54.7333",
    lon: "55.9333",
    country: "RU",
    popularity: 25,
    name: {
      en : "Ufa"
    }
  },
  UGB : {
    country: "US",
    city: "PIP",
    name: {
      en : "Ugashik Bay"
    }
  },
  UGC : {
    lat: "41.65",
    lon: "60.5333",
    country: "UZ",
    name: {
      en : "Urgench"
    }
  },
  UGI : {
    country: "US",
    name: {
      en : "UGI"
    }
  },
  UGN : {
    lat: "42.3667",
    lon: "-87.8333",
    country: "US",
    name: {
      en : "Memorial"
    }
  },
  UIB : {
    country: "CO",
    name: {
      en : "Quibdo Arpt"
    }
  },
  UIH : {
    lat: "13.7661",
    lon: "109.226",
    country: "VN",
    name: {
      en : "Qui Nhon"
    }
  },
  UII : {
    country: "HN",
    name: {
      en : "UII"
    }
  },
  UIK : {
    country: "RU",
    name: {
      en : "Ust-Ilimsk"
    }
  },
  UIN : {
    lat: "39.9442",
    lon: "-91.1972",
    country: "US",
    name: {
      en : "Baldwin Field"
    }
  },
  UIO : {
    lat: "-0.137778",
    lon: "-78.4861",
    country: "EC",
    popularity: 24,
    name: {
      en : "Mariscal"
    }
  },
  UIP : {
    lat: "47.9744",
    lon: "-4.17083",
    country: "FR",
    name: {
      en : "Pluguffan"
    }
  },
  UKA : {
    country: "KE",
    name: {
      en : "UKA"
    }
  },
  UKB : {
    lat: "34.75",
    lon: "135.167",
    country: "JP",
    city: "OSA",
    name: {
      en : "Kobe"
    }
  },
  UKG : {
    country: "RU",
    name: {
      en : "Ust-Kuyga"
    }
  },
  UKI : {
    lat: "39.1267",
    lon: "-123.2",
    country: "US",
    name: {
      en : "Ukiah"
    }
  },
  UKK : {
    lat: "50.0333",
    lon: "82.5",
    country: "KZ",
    name: {
      en : "Ust Kamenogorsk"
    }
  },
  UKS : {
    lat: "44.6917",
    lon: "33.5767",
    country: "AK",
    name: {
      en : "Belbek"
    }
  },
  UKX : {
    country: "RU",
    name: {
      en : "UKX"
    }
  },
  ULB : {
    country: "VU",
    name: {
      en : "ULB"
    }
  },
  ULG : {
    country: "MN",
    name: {
      en : "ULG"
    }
  },
  ULH : {
    country: "SA",
    name: {
      en : "Al-Ula"
    }
  },
  ULK : {
    country: "RU",
    name: {
      en : "Lensk"
    }
  },
  ULN : {
    lat: "47.9",
    lon: "106.867",
    country: "MN",
    city: "UBN",
    popularity: 7,
    name: {
      en : "Buyant Uhaa"
    }
  },
  ULO : {
    country: "MN",
    name: {
      en : "ULO"
    }
  },
  ULP : {
    lat: "-26.6333",
    lon: "144.3",
    country: "AU",
    name: {
      en : "Quilpie"
    }
  },
  ULU : {
    country: "UG",
    name: {
      en : "ULU"
    }
  },
  ULV : {
    lat: "54.266666",
    lon: "48.216667",
    country: "RU",
    city: "ULY",
    name: {
      en : "Central"
    }
  },
  ULX : {
    country: "ZA",
    name: {
      en : "Ulusaba"
    }
  },
  ULY : {
    lat: "54.4",
    lon: "48.8",
    country: "RU",
    name: {
      en : "Vostochny"
    }
  },
  ULZ : {
    country: "MN",
    name: {
      en : "ULZ"
    }
  },
  UMD : {
    country: "GL",
    name: {
      en : "UMD"
    }
  },
  UME : {
    lat: "63.7936",
    lon: "20.2844",
    country: "SE",
    name: {
      en : "Umea"
    }
  },
  UMS : {
    country: "RU",
    name: {
      en : "Ust-Maya"
    }
  },
  UNA : {
    country: "BR",
    name: {
      en : "Una Airport"
    }
  },
  UND : {
    country: "AF",
    name: {
      en : "UND"
    }
  },
  UNG : {
    country: "PG",
    name: {
      en : "UNG"
    }
  },
  UNK : {
    lat: "63.8847",
    lon: "-160.794",
    country: "US",
    name: {
      en : "Unalakleet"
    }
  },
  UNN : {
    lat: "9.85278",
    lon: "98.6292",
    country: "TH",
    name: {
      en : "Ranong"
    }
  },
  UPB : {
    city: "undefined",
    name: {
      en : "UPB"
    }
  },
  UPG : {
    lat: "-5.06667",
    lon: "119.55",
    country: "ID",
    name: {
      en : "Hasanudin"
    }
  },
  UPN : {
    lat: "19.4111",
    lon: "-102.047",
    country: "MX",
    name: {
      en : "Uruapan"
    }
  },
  URA : {
    lat: "51.15",
    lon: "51.55",
    country: "KZ",
    name: {
      en : "Uralsk"
    }
  },
  URC : {
    lat: "43.9",
    lon: "87.4833",
    country: "CN",
    name: {
      en : "Urumqi"
    }
  },
  URE : {
    lat: "58.2167",
    lon: "22.5",
    country: "EE",
    name: {
      en : "Kuressaare"
    }
  },
  URG : {
    country: "BR",
    name: {
      en : "Ruben Berta Arpt"
    }
  },
  URJ : {
    country: "RU",
    name: {
      en : "URJ"
    }
  },
  URO : {
    lat: "49.3886",
    lon: "1.1875",
    country: "FR",
    name: {
      en : "Boos"
    }
  },
  URS : {
    lat: "51.75",
    lon: "36.2667",
    country: "RU",
    name: {
      en : "Kursk"
    }
  },
  URT : {
    lat: "9.13333",
    lon: "99.3167",
    country: "TH",
    name: {
      en : "Surat Thani"
    }
  },
  URY : {
    lat: "31.3333",
    lon: "37.3333",
    country: "SA",
    name: {
      en : "Gurayat"
    }
  },
  USH : {
    lat: "-54.8028",
    lon: "-68.3278",
    country: "AR",
    popularity: 1,
    name: {
      en : "Islas Malvinas"
    }
  },
  USJ : {
    country: "KZ",
    name: {
      en : "Usharal"
    }
  },
  USK : {
    lat: "65.95",
    lon: "57.4",
    country: "RU",
    name: {
      en : "Usinsk"
    }
  },
  USM : {
    lat: "9.55",
    lon: "100.067",
    country: "TH",
    popularity: 4,
    name: {
      en : "Ko Samui"
    }
  },
  USN : {
    lat: "32.5833",
    lon: "129.35",
    country: "KR",
    name: {
      en : "Ulsan"
    }
  },
  USQ : {
    country: "TR",
    name: {
      en : "USQ"
    }
  },
  USR : {
    country: "RU",
    name: {
      en : "Ust-Nera Airport"
    }
  },
  UST : {
    lat: "29.95",
    lon: "-81.3333",
    country: "US",
    name: {
      en : "St Augustine"
    }
  },
  USU : {
    lat: "0",
    lon: "0",
    country: "PH",
    name: {
      en : "Francisco B. Reyes Airport"
    }
  },
  UTH : {
    lat: "17.385",
    lon: "102.793",
    country: "TH",
    name: {
      en : "Udon Thani"
    }
  },
  UTM : {
    country: "US",
    name: {
      en : "Tunica Municipal Arpt"
    }
  },
  UTN : {
    lat: "-28.4006",
    lon: "21.2533",
    country: "ZA",
    name: {
      en : "Upington"
    }
  },
  UTP : {
    lat: "12.6833",
    lon: "101.017",
    country: "TH",
    name: {
      en : "U Tapao"
    }
  },
  UTS : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Ust-Tsilma"
    }
  },
  UTT : {
    lat: "-31.5833",
    lon: "28.7833",
    country: "ZA",
    name: {
      en : "K D Matanzima"
    }
  },
  UTU : {
    country: "PA",
    name: {
      en : "UTU"
    }
  },
  UUA : {
    lat: "0",
    lon: "0",
    country: "RU",
    name: {
      en : "Bugulma"
    }
  },
  UUD : {
    lat: "51.8333",
    lon: "107.5",
    country: "RU",
    popularity: 4,
    name: {
      en : "Ulan Ude"
    }
  },
  UUS : {
    lat: "46.9667",
    lon: "142.75",
    country: "RU",
    popularity: 1,
    name: {
      en : "Yuzhno Sakhalinsk"
    }
  },
  UVE : {
    country: "NC",
    name: {
      en : "UVE"
    }
  },
  UVF : {
    lat: "13.7356",
    lon: "-60.9522",
    country: "LC",
    city: "SLU",
    name: {
      en : "Hewanorra"
    }
  },
  UYL : {
    country: "SD",
    name: {
      en : "UYL"
    }
  },
  UYN : {
    country: "CN",
    name: {
      en : "Yulin Airport"
    }
  },
  UYU : {
    lat: "-20.467",
    lon: "-66.833",
    country: "BO",
    name: {
      en : "Joya Andina"
    }
  },
  VAA : {
    lat: "63.045",
    lon: "21.7614",
    country: "FI",
    name: {
      en : "Vaasa"
    }
  },
  VAI : {
    lat: "-2.69472",
    lon: "141.302",
    country: "PG",
    name: {
      en : "Vanimo"
    }
  },
  VAK : {
    country: "US",
    name: {
      en : "VAK"
    }
  },
  VAN : {
    lat: "38.4586",
    lon: "43.3322",
    country: "TR",
    name: {
      en : "Van"
    }
  },
  VAO : {
    country: "SB",
    name: {
      en : "VAO"
    }
  },
  VAR : {
    lat: "43.2325",
    lon: "27.8256",
    country: "BG",
    popularity: 5,
    name: {
      en : "Varna"
    }
  },
  VAS : {
    lat: "39.8139",
    lon: "36.9042",
    country: "TR",
    name: {
      en : "Sivas"
    }
  },
  VAV : {
    lat: "-18.5833",
    lon: "-173.967",
    country: "TO",
    name: {
      en : "Lupepau U"
    }
  },
  VAW : {
    lat: "70.3547",
    lon: "31.0456",
    country: "NO",
    name: {
      en : "Vardoe Luftan"
    }
  },
  VBM : {
    country: "US",
    name: {
      en : "VBM"
    }
  },
  VBS : {
    lat: "45.4286",
    lon: "10.3314",
    country: "IT",
    city: "VRN",
    name: {
      en : "Montichiari"
    }
  },
  VBV : {
    country: "FJ",
    name: {
      en : "VBV"
    }
  },
  VBY : {
    lat: "57.6631",
    lon: "18.3494",
    country: "SE",
    name: {
      en : "Visby"
    }
  },
  VCA : {
    lat: "10.0472",
    lon: "105.766",
    country: "VN",
    name: {
      en : "Can Tho"
    }
  },
  VCE : {
    lat: "45.5",
    lon: "12.35",
    country: "IT",
    popularity: 43,
    name: {
      en : "Marco Polo"
    }
  },
  VCL : {
    lat: "15.4222",
    lon: "108.704",
    country: "VN",
    name: {
      en : "Chulai"
    }
  },
  VCP : {
    lat: "-23",
    lon: "-47.1333",
    country: "BR",
    city: "SAO",
    name: {
      en : "Viracopos"
    }
  },
  VCS : {
    country: "VN",
    name: {
      en : "VCS"
    }
  },
  VCT : {
    lat: "28.8511",
    lon: "-96.9144",
    country: "US",
    name: {
      en : "Victoria Regional"
    }
  },
  VCV : {
    lat: "34.5333",
    lon: "-117.3",
    country: "US",
    name: {
      en : "George AFB"
    }
  },
  VDA : {
    lat: "29.9333",
    lon: "34.9472",
    country: "IL",
    name: {
      en : "Ovda"
    }
  },
  VDB : {
    lat: "61.0833",
    lon: "9.33333",
    country: "NO",
    name: {
      en : "Valdres"
    }
  },
  VDC : {
    country: "BR",
    name: {
      en : "Vitoria Da Conquista Arpt"
    }
  },
  VDE : {
    lat: "27.8128",
    lon: "-17.8853",
    country: "ES",
    name: {
      en : "Hierro"
    }
  },
  VDH : {
    country: "VN",
    name: {
      en : "VDH"
    }
  },
  VDM : {
    lat: "-40.85",
    lon: "-63.0167",
    country: "AR",
    name: {
      en : "Viedma"
    }
  },
  VDS : {
    lat: "70.065",
    lon: "29.8453",
    country: "NO",
    name: {
      en : "Vadso"
    }
  },
  VDZ : {
    lat: "61.1325",
    lon: "-146.239",
    country: "US",
    name: {
      en : "Valdez"
    }
  },
  VEE : {
    country: "US",
    name: {
      en : "VEE"
    }
  },
  VEL : {
    lat: "40.4389",
    lon: "-109.51",
    country: "US",
    name: {
      en : "Vernal"
    }
  },
  VEO : {
    lat: "60.373043",
    lon: "93.016361",
    country: "RU",
    name: {
      en : "Severo-Eniseysk"
    }
  },
  VER : {
    lat: "19.15",
    lon: "-96.1833",
    country: "MX",
    name: {
      en : "Las Bajadas General Heriberto Jara"
    }
  },
  VEY : {
    lat: "63.4264",
    lon: "-20.2778",
    country: "IS",
    name: {
      en : "Vestmannaeyjar"
    }
  },
  VFA : {
    lat: "-18.0931",
    lon: "25.8403",
    country: "ZW",
    name: {
      en : "Victoria Falls"
    }
  },
  VGA : {
    country: "IN",
    name: {
      en : "VGA"
    }
  },
  VGD : {
    lat: "59.281667",
    lon: "39.944722",
    country: "RU",
    popularity: 19,
    name: {
      en : "Vologda"
    }
  },
  VGO : {
    lat: "42.2264",
    lon: "-8.62778",
    country: "ES",
    name: {
      en : "Vigo"
    }
  },
  VGT : {
    lat: "36.0967",
    lon: "-115.169",
    country: "US",
    city: "LAS",
    name: {
      en : "Las Vegas North Air Terminal"
    }
  },
  VGZ : {
    country: "CO",
    name: {
      en : "Villagarzon Arpt"
    }
  },
  VHC : {
    country: "AO",
    name: {
      en : "VHC"
    }
  },
  VHM : {
    lat: "64.6167",
    lon: "16.65",
    country: "SE",
    name: {
      en : "Vilhelmina"
    }
  },
  VHV : {
    country: "RU",
    name: {
      en : "Verkhnevilyuysk"
    }
  },
  VHZ : {
    country: "PF",
    name: {
      en : "VHZ"
    }
  },
  VIE : {
    lat: "48.1111",
    lon: "16.5583",
    country: "AT",
    popularity: 210,
    name: {
      en : "Vienna"
    }
  },
  VIG : {
    lat: "8.63333",
    lon: "-71.65",
    country: "VE",
    name: {
      en : "El Vigia"
    }
  },
  VII : {
    lat: "18.7",
    lon: "105.633",
    country: "VN",
    name: {
      en : "Vinh City"
    }
  },
  VIJ : {
    lat: "18.5",
    lon: "-64.5",
    country: "VG",
    name: {
      en : "Virgin Gorda"
    }
  },
  VIK : {
    country: "US",
    name: {
      en : "VIK"
    }
  },
  VIL : {
    lat: "23.7133",
    lon: "-15.935",
    country: "MA",
    name: {
      en : "Dakhla"
    }
  },
  VIN : {
    lat: "49.243126",
    lon: "28.606482",
    country: "UA",
    city: "",
    name: {
      en : "Vinnytsia"
    }
  },
  VIS : {
    lat: "36.3194",
    lon: "-119.394",
    country: "US",
    name: {
      en : "Visalia"
    }
  },
  VIT : {
    lat: "42.8333",
    lon: "-2.5",
    country: "ES",
    name: {
      en : "Vitoria"
    }
  },
  VIX : {
    lat: "-20.2644",
    lon: "-40.2875",
    country: "BR",
    name: {
      en : "Eurico Sales"
    }
  },
  VKG : {
    lat: "10.0833",
    lon: "105.083",
    country: "VN",
    name: {
      en : "Rach Gia"
    }
  },
  VKO : {
    lat: "55.5833",
    lon: "37.2667",
    country: "RU",
    city: "MOW",
    popularity: 10,
    name: {
      en : "Vnukovo"
    }
  },
  VKT : {
    country: "RU",
    name: {
      en : "Vorkuta"
    }
  },
  VKV : {
    country: "RU",
    city: "ARH",
    name: {
      en : "Vaskovo"
    }
  },
  VLC : {
    lat: "39.4903",
    lon: "-0.478611",
    country: "ES",
    popularity: 43,
    name: {
      en : "Valencia"
    }
  },
  VLD : {
    lat: "30.7839",
    lon: "-83.2772",
    country: "US",
    name: {
      en : "Valdosta Regional"
    }
  },
  VLI : {
    lat: "-17.6667",
    lon: "168.237",
    country: "VU",
    name: {
      en : "Bauerfield"
    }
  },
  VLL : {
    lat: "41.7",
    lon: "-4.85",
    country: "ES",
    name: {
      en : "Valladolid"
    }
  },
  VLN : {
    lat: "10.1833",
    lon: "-68",
    country: "VE",
    name: {
      en : "Valenica"
    }
  },
  VLS : {
    country: "VU",
    name: {
      en : "VLS"
    }
  },
  VLV : {
    lat: "9.33917",
    lon: "-70.5858",
    country: "VE",
    name: {
      en : "Carvajal"
    }
  },
  VLY : {
    country: "GB",
    name: {
      en : "Anglesey"
    }
  },
  VNO : {
    lat: "54.6333",
    lon: "25.2833",
    country: "LT",
    popularity: 32,
    name: {
      en : "Vilnius"
    }
  },
  VNS : {
    lat: "25.4519",
    lon: "82.8631",
    country: "IN",
    name: {
      en : "Babatpur"
    }
  },
  VNX : {
    lat: "-22.0167",
    lon: "35.2833",
    country: "MZ",
    name: {
      en : "Vilanculos"
    }
  },
  VNY : {
    lat: "34.2",
    lon: "-118.5",
    country: "US",
    city: "LAX",
    name: {
      en : "Van Nuys"
    }
  },
  VOG : {
    lat: "48.75",
    lon: "44.5",
    country: "RU",
    popularity: 19,
    name: {
      en : "Volgograd"
    }
  },
  VOL : {
    country: "GR",
    name: {
      en : "Nea Anchialos Arpt"
    }
  },
  VOZ : {
    lat: "51.6667",
    lon: "39.2167",
    country: "RU",
    name: {
      en : "Voronezh"
    }
  },
  VPE : {
    country: "AO",
    name: {
      en : "VPE"
    }
  },
  VPS : {
    lat: "30.4894",
    lon: "-86.5272",
    country: "US",
    name: {
      en : "Ft Walton Beach"
    }
  },
  VPY : {
    country: "MZ",
    name: {
      en : "VPY"
    }
  },
  VQS : {
    lat: "18.1142",
    lon: "-65.4225",
    country: "US",
    name: {
      en : "Vieques"
    }
  },
  VRA : {
    lat: "23.1667",
    lon: "-81.2667",
    country: "CU",
    popularity: 5,
    name: {
      en : "Juan Gualberto Gomez"
    }
  },
  VRB : {
    lat: "27.6525",
    lon: "-80.4136",
    country: "US",
    name: {
      en : "Vero Beach"
    }
  },
  VRC : {
    country: "PH",
    name: {
      en : "VRC"
    }
  },
  VRK : {
    lat: "62.3",
    lon: "27.9333",
    country: "FI",
    name: {
      en : "Varkaus"
    }
  },
  VRL : {
    country: "PT",
    name: {
      en : "Vila Real Arpt"
    }
  },
  VRN : {
    lat: "45.4667",
    lon: "10.9333",
    country: "IT",
    popularity: 11,
    name: {
      en : "Verona"
    }
  },
  VRY : {
    country: "NO",
    name: {
      en : "VRY"
    }
  },
  VSA : {
    lat: "17.9667",
    lon: "-92.9333",
    country: "MX",
    name: {
      en : "Capt Carlos Rovirosa Perez"
    }
  },
  VST : {
    lat: "59.5892",
    lon: "16.6306",
    country: "SE",
    city: "STO",
    name: {
      en : "Hasslo"
    }
  },
  VTE : {
    lat: "17.9847",
    lon: "102.567",
    country: "LA",
    name: {
      en : "Wattay"
    }
  },
  VTU : {
    country: "CU",
    name: {
      en : "VTU"
    }
  },
  VTZ : {
    lat: "17.7211",
    lon: "83.2247",
    country: "IN",
    name: {
      en : "Vishakhapatnam"
    }
  },
  VUP : {
    country: "CO",
    name: {
      en : "Valledupar Arpt"
    }
  },
  VUS : {
    country: "RU",
    name: {
      en : "Velikij Ustyug"
    }
  },
  VVC : {
    country: "CO",
    name: {
      en : "La Vanguardia Arpt"
    }
  },
  VVI : {
    lat: "-17.6333",
    lon: "-63.1333",
    country: "BO",
    city: "SRZ",
    name: {
      en : "Viru Viru"
    }
  },
  VVO : {
    lat: "43.3986",
    lon: "132.152",
    country: "RU",
    popularity: 32,
    name: {
      en : "Vladivostok"
    }
  },
  VVZ : {
    country: "DZ",
    name: {
      en : "VVZ"
    }
  },
  VXC : {
    country: "MZ",
    name: {
      en : "VXC"
    }
  },
  VXE : {
    lat: "16.85",
    lon: "-24.9667",
    country: "CV",
    popularity: 1,
    name: {
      en : "San Pedro"
    }
  },
  VXO : {
    lat: "56.9333",
    lon: "14.7333",
    country: "SE",
    name: {
      en : "Vaxjo"
    }
  },
  WAA : {
    country: "US",
    name: {
      en : "WAA"
    }
  },
  WAE : {
    country: "SA",
    name: {
      en : "WAE"
    }
  },
  WAG : {
    lat: "-39.9667",
    lon: "175.024",
    country: "NZ",
    name: {
      en : "Wanganui"
    }
  },
  WAT : {
    lat: "52.1972",
    lon: "-7.08889",
    country: "IE",
    name: {
      en : "Waterford"
    }
  },
  WAW : {
    lat: "52.1667",
    lon: "20.9667",
    country: "PL",
    popularity: 128,
    name: {
      en : "Warsaw"
    }
  },
  WBB : {
    country: "US",
    name: {
      en : "WBB"
    }
  },
  WBM : {
    country: "PG",
    name: {
      en : "WBM"
    }
  },
  WBQ : {
    country: "US",
    name: {
      en : "WBQ"
    }
  },
  WDH : {
    lat: "-22.4833",
    lon: "17.4667",
    country: "NA",
    name: {
      en : "Hosea Kutako"
    }
  },
  WDS : {
    country: "CN",
    name: {
      en : "Shiyan Wudangshan"
    }
  },
  WEF : {
    lat: "36.75",
    lon: "119.217",
    country: "CN",
    name: {
      en : "Weifang"
    }
  },
  WEH : {
    lat: "37.5",
    lon: "122.083",
    country: "CN",
    name: {
      en : "Weihai Arpu"
    }
  },
  WEI : {
    lat: "-12.6836",
    lon: "141.883",
    country: "AU",
    name: {
      en : "Weipa"
    }
  },
  WGA : {
    lat: "-35.1667",
    lon: "147.464",
    country: "AU",
    name: {
      en : "Forrest Hill"
    }
  },
  WGP : {
    country: "ID",
    name: {
      en : "WGP"
    }
  },
  WHA : {
    lat: "31.108116937798663",
    lon: "118.66287853472342",
    country: "CN",
    city: "WHU",
    name: {
      en : "Wuhu Xuanzhou"
    }
  },
  WHK : {
    lat: "-37.9222",
    lon: "176.914",
    country: "NZ",
    name: {
      en : "Whakatane"
    }
  },
  WIC : {
    lat: "58.4569",
    lon: "-3.08667",
    country: "GB",
    name: {
      en : "Wick"
    }
  },
  WIL : {
    lat: "-1.31667",
    lon: "36.8167",
    country: "KE",
    city: "NBO",
    name: {
      en : "Wilson"
    }
  },
  WIN : {
    country: "AU",
    name: {
      en : "WIN"
    }
  },
  WJA : {
    country: "MH",
    name: {
      en : "WJA"
    }
  },
  WJR : {
    country: "KE",
    name: {
      en : "WJR"
    }
  },
  WJU : {
    country: "KR",
    name: {
      en : "WJU"
    }
  },
  WKA : {
    lat: "-44.7333",
    lon: "169.25",
    country: "NZ",
    name: {
      en : "Wanaka"
    }
  },
  WKJ : {
    lat: "45.4167",
    lon: "141.667",
    country: "JP",
    name: {
      en : "Hokkaido"
    }
  },
  WKK : {
    country: "US",
    name: {
      en : "WKK"
    }
  },
  WLG : {
    lat: "-41.3239",
    lon: "174.801",
    country: "NZ",
    popularity: 9,
    name: {
      en : "Wellington"
    }
  },
  WLH : {
    country: "VU",
    name: {
      en : "WLH"
    }
  },
  WLK : {
    lat: "66.6028",
    lon: "-159.983",
    country: "US",
    name: {
      en : "Selawik"
    }
  },
  WLS : {
    country: "WF",
    name: {
      en : "WLS"
    }
  },
  WMI : {
    lat: "52.44",
    lon: "20.64",
    country: "PL",
    city: "WAW",
    popularity: 10,
    name: {
      en : "Modlin"
    }
  },
  WMK : {
    country: "US",
    name: {
      en : "WMK"
    }
  },
  WMN : {
    country: "MG",
    name: {
      en : "WMN"
    }
  },
  WMO : {
    country: "US",
    name: {
      en : "WMO"
    }
  },
  WNA : {
    country: "US",
    name: {
      en : "WNA"
    }
  },
  WNH : {
    country: "CN",
    name: {
      en : "WNH"
    }
  },
  WNN : {
    country: "CA",
    name: {
      en : "WNN"
    }
  },
  WNP : {
    country: "PH",
    name: {
      en : "Naga Arpt"
    }
  },
  WNR : {
    lat: "-25.4167",
    lon: "142.667",
    country: "AU",
    name: {
      en : "Windorah"
    }
  },
  WNS : {
    lat: "26.2194",
    lon: "68.3922",
    country: "PK",
    name: {
      en : "Nawabshah"
    }
  },
  WNZ : {
    lat: "27.95",
    lon: "120.633",
    country: "CN",
    name: {
      en : "Wenzhou"
    }
  },
  WPM : {
    country: "PG",
    name: {
      en : "WPM"
    }
  },
  WRE : {
    lat: "-35.7722",
    lon: "174.361",
    country: "NZ",
    name: {
      en : "Whangarei"
    }
  },
  WRG : {
    lat: "56.4844",
    lon: "-132.367",
    country: "US",
    name: {
      en : "Wrangell Seaplane Base"
    }
  },
  WRL : {
    lat: "43.9675",
    lon: "-107.953",
    country: "US",
    name: {
      en : "Worland"
    }
  },
  WRO : {
    lat: "51.1",
    lon: "16.8833",
    country: "PL",
    name: {
      en : "Strachowice"
    }
  },
  WRY : {
    lat: "59.35",
    lon: "-2.95",
    country: "GB",
    name: {
      en : "Westray"
    }
  },
  WSN : {
    country: "US",
    name: {
      en : "WSN"
    }
  },
  WST : {
    lat: "41.3494",
    lon: "-71.8039",
    country: "US",
    name: {
      en : "Westerly"
    }
  },
  WSX : {
    country: "US",
    name: {
      en : "Westsound Seaplane Base"
    }
  },
  WSZ : {
    lat: "-41.7397",
    lon: "171.582",
    country: "NZ",
    name: {
      en : "Westport"
    }
  },
  WTB : {
    country: "AU",
    name: {
      en : "Toowoomba Wellcamp"
    }
  },
  WTK : {
    country: "US",
    name: {
      en : "WTK"
    }
  },
  WTL : {
    country: "US",
    name: {
      en : "WTL"
    }
  },
  WTP : {
    country: "PG",
    name: {
      en : "WTP"
    }
  },
  WUA : {
    country: "CN",
    name: {
      en : "WUA"
    }
  },
  WUH : {
    lat: "30.5",
    lon: "114.317",
    country: "CN",
    name: {
      en : "Wuhan"
    }
  },
  WUN : {
    lat: "-26.6333",
    lon: "120.217",
    country: "AU",
    name: {
      en : "Wiluna"
    }
  },
  WUS : {
    lat: "27.7167",
    lon: "117.967",
    country: "CN",
    name: {
      en : "Wuyishan"
    }
  },
  WUT : {
    country: "CN",
    name: {
      en : "Xinzhou Wutaishan"
    }
  },
  WUX : {
    lat: "31.5833",
    lon: "120.317",
    country: "CN",
    name: {
      en : "Wuxi"
    }
  },
  WUZ : {
    country: "CN",
    name: {
      en : "WUZ"
    }
  },
  WVB : {
    lat: "-22.9786",
    lon: "14.5172",
    country: "NA",
    name: {
      en : "Rooikop"
    }
  },
  WVL : {
    lat: "44.5339",
    lon: "-69.6758",
    country: "US",
    name: {
      en : "Robert La Fleur"
    }
  },
  WWK : {
    lat: "-3.58583",
    lon: "143.673",
    country: "PG",
    name: {
      en : "Boram"
    }
  },
  WWP : {
    country: "US",
    name: {
      en : "Whale Pass Arpt"
    }
  },
  WWT : {
    country: "US",
    name: {
      en : "WWT"
    }
  },
  WXN : {
    lat: "30.9",
    lon: "103.467",
    country: "CN",
    name: {
      en : "Wanxian"
    }
  },
  WYA : {
    lat: "-33.0606",
    lon: "137.511",
    country: "AU",
    name: {
      en : "Whyalla"
    }
  },
  WYS : {
    country: "US",
    name: {
      en : "West Yellowstone Arpt"
    }
  },
  WZ : {
    city: "",
    name: {
      en : "WZ"
    }
  },
  XAP : {
    lat: "-27.0886",
    lon: "-52.6297",
    country: "BR",
    name: {
      en : "Chapeco"
    }
  },
  XBE : {
    country: "CA",
    name: {
      en : "XBE"
    }
  },
  XBJ : {
    country: "IR",
    name: {
      en : "XBJ"
    }
  },
  XBR : {
    country: "CA",
    name: {
      en : "Brockville Arpt"
    }
  },
  XBW : {
    lat: "42.65",
    lon: "-80.8167",
    country: "CA",
    name: {
      en : "Killineq"
    }
  },
  XCH : {
    lat: "-10.5",
    lon: "105.667",
    country: "CX",
    name: {
      en : "Christmas Island"
    }
  },
  XCM : {
    lat: "42.4",
    lon: "-82.1833",
    country: "CA",
    name: {
      en : "Chatham"
    }
  },
  XCR : {
    lat: "0",
    lon: "0",
    country: "FR",
    city: "PAR",
    name: {
      en : "Vatry Arpt"
    }
  },
  XDB : {
    country: "FR",
    city: "LIL",
    name: {
      en : "Europe Railway Service"
    }
  },
  XDK : {
    country: "FR",
    name: {
      en : "Dunkerque"
    }
  },
  XED : {
    country: "FR",
    name: {
      en : "Railway Service"
    }
  },
  XER : {
    country: "FR",
    city: "SXB",
    name: {
      en : "Strasbourg Bus Service"
    }
  },
  XFF : {
    country: "FR",
    name: {
      en : "Frethun Railway Station"
    }
  },
  XFN : {
    lat: "32.05",
    lon: "112",
    country: "CN",
    name: {
      en : "Xiangfan"
    }
  },
  XFZ : {
    country: "CA",
    city: "YQB",
    name: {
      en : "Charny Rail Station"
    }
  },
  XGR : {
    lat: "58.5",
    lon: "-65.9833",
    country: "CA",
    name: {
      en : "Kangiqsualujjuaq"
    }
  },
  XHK : {
    country: "FR",
    name: {
      en : "Valence Railway Station"
    }
  },
  XIC : {
    country: "CN",
    name: {
      en : "XIC"
    }
  },
  XIL : {
    country: "CN",
    name: {
      en : "XIL"
    }
  },
  XIY : {
    lat: "34.4333",
    lon: "108.75",
    country: "CN",
    city: "SIA",
    name: {
      en : "Xianyang"
    }
  },
  XIZ : {
    country: "FR",
    name: {
      en : "Champagne Railway Station"
    }
  },
  XJF : {
    country: "SE",
    city: "XWF",
    name: {
      en : "Falun Bus Service"
    }
  },
  XJY : {
    country: "FR",
    city: "PAR",
    name: {
      en : "XJY"
    }
  },
  XKH : {
    lat: "19.3",
    lon: "103.367",
    country: "LA",
    name: {
      en : "Xieng Khouang"
    }
  },
  XKL : {
    country: "MY",
    city: "KUL",
    name: {
      en : "Sentral Railway Station"
    }
  },
  XKS : {
    country: "CA",
    name: {
      en : "XKS"
    }
  },
  XMH : {
    country: "PF",
    name: {
      en : "XMH"
    }
  },
  XMN : {
    lat: "24.4667",
    lon: "118.117",
    country: "CN",
    name: {
      en : "Xiamen Intl"
    }
  },
  XMY : {
    lat: "-10.4833",
    lon: "142.45",
    country: "AU",
    name: {
      en : "Yam Island"
    }
  },
  XNA : {
    lat: "36.2817",
    lon: "-94.3067",
    country: "US",
    city: "FYV",
    name: {
      en : "Northwest Arkansas Regional"
    }
  },
  XNC : {
    country: "IT",
    name: {
      en : "Cadorna Train Station Milan"
    }
  },
  XNN : {
    lat: "36.55",
    lon: "101.75",
    country: "CN",
    name: {
      en : "Xining"
    }
  },
  XNY : {
    country: "US",
    name: {
      en : "XNY"
    }
  },
  XOC : {
    lat: "40.4075",
    lon: "-3.691667",
    country: "ES",
    city: "MAD",
    name: {
      en : "XOC"
    }
  },
  XOJ : {
    country: "ES",
    name: {
      en : "XOJ"
    }
  },
  XPJ : {
    country: "FR",
    city: "MPL",
    name: {
      en : "Montpellier Railway Station"
    }
  },
  XQE : {
    country: "GB",
    city: "LON",
    name: {
      en : "XQE Ebbsfleet Kent Rail St"
    }
  },
  XQP : {
    lat: "9.45",
    lon: "-84.15",
    country: "CR",
    name: {
      en : "Quepos"
    }
  },
  XQU : {
    lat: "49.35",
    lon: "-124.45",
    country: "CA",
    name: {
      en : "Qualicum"
    }
  },
  XRJ : {
    lat: "41.966666666667",
    lon: "12.666666666667",
    country: "IT",
    city: "ROM",
    name: {
      en : "XRJ"
    }
  },
  XRY : {
    lat: "36.7453",
    lon: "-6.05889",
    country: "ES",
    name: {
      en : "La Parra"
    }
  },
  XSC : {
    country: "TC",
    name: {
      en : "South Caicos Intl Arpt"
    }
  },
  XSP : {
    country: "SG",
    city: "SIN",
    name: {
      en : "Seletar Airport"
    }
  },
  XTG : {
    lat: "-27.9667",
    lon: "143.767",
    country: "AU",
    name: {
      en : "Thargomindah"
    }
  },
  XUT : {
    country: "ES",
    name: {
      en : "XUT"
    }
  },
  XUZ : {
    lat: "34.2667",
    lon: "117.183",
    country: "CN",
    name: {
      en : "Xuzhou"
    }
  },
  XWC : {
    country: "AT",
    city: "VIE",
    name: {
      en : "XWC"
    }
  },
  XWG : {
    country: "FR",
    name: {
      en : "XWG"
    }
  },
  XWL : {
    lat: "57.7167",
    lon: "11.9667",
    country: "SE",
    city: "GOT",
    name: {
      en : "Gothenburg Rail"
    }
  },
  XWQ : {
    country: "SE",
    name: {
      en : "XWQ"
    }
  },
  XZF : {
    lat: "21.5169",
    lon: "39.2192",
    country: "SA",
    city: "DMM",
    name: {
      en : "Dammam Port"
    }
  },
  XZI : {
    country: "FR",
    name: {
      en : "Railway Station Metz"
    }
  },
  XZJ : {
    country: "JP",
    name: {
      en : "XZJ"
    }
  },
  XZU : {
    country: "US",
    name: {
      en : "XZU"
    }
  },
  XZV : {
    country: "FR",
    name: {
      en : "TGV Station Toulon"
    }
  },
  XZZ : {
    country: "ES",
    name: {
      en : "XZZ"
    }
  },
  YAA : {
    country: "CA",
    name: {
      en : "YAA"
    }
  },
  YAC : {
    country: "CA",
    name: {
      en : "YAC"
    }
  },
  YAG : {
    lat: "48.6528",
    lon: "-93.4472",
    country: "CA",
    name: {
      en : "Fort Frances"
    }
  },
  YAJ : {
    country: "CA",
    name: {
      en : "YAJ"
    }
  },
  YAK : {
    lat: "59.5092",
    lon: "-139.66",
    country: "US",
    name: {
      en : "Yakutat"
    }
  },
  YAM : {
    lat: "46.4836",
    lon: "-84.5078",
    country: "CA",
    name: {
      en : "Sault Ste Marie"
    }
  },
  YAP : {
    lat: "9.48222",
    lon: "138.076",
    country: "FM",
    name: {
      en : "Yap"
    }
  },
  YAT : {
    lat: "52.9417",
    lon: "-82.4",
    country: "CA",
    name: {
      en : "Attawapiskat"
    }
  },
  YAV : {
    country: "CA",
    name: {
      en : "YAV"
    }
  },
  YAX : {
    country: "CA",
    name: {
      en : "YAX"
    }
  },
  YAY : {
    lat: "51.3667",
    lon: "-55.5833",
    country: "CA",
    name: {
      en : "St Anthony"
    }
  },
  YBB : {
    lat: "68.8833",
    lon: "-89.85",
    country: "CA",
    name: {
      en : "Townsite"
    }
  },
  YBC : {
    lat: "49.2",
    lon: "-68.2667",
    country: "CA",
    name: {
      en : "Baie Comeau"
    }
  },
  YBG : {
    lat: "48.3222",
    lon: "-70.9886",
    country: "CA",
    name: {
      en : "Bagotville"
    }
  },
  YBK : {
    lat: "64.3",
    lon: "-96.0833",
    country: "CA",
    name: {
      en : "Baker Lake"
    }
  },
  YBL : {
    lat: "49.9464",
    lon: "-125.266",
    country: "CA",
    name: {
      en : "Campbell River"
    }
  },
  YBP : {
    lat: "28.8167",
    lon: "104.533",
    country: "CN",
    name: {
      en : "Yibin"
    }
  },
  YBR : {
    lat: "49.9",
    lon: "-99.95",
    country: "CA",
    name: {
      en : "Brandon"
    }
  },
  YBW : {
    lat: "48.75",
    lon: "-123.233",
    country: "CA",
    name: {
      en : "Bedwell Harbor"
    }
  },
  YBX : {
    lat: "51.4333",
    lon: "-57.2167",
    country: "CA",
    name: {
      en : "Blanc Sablon"
    }
  },
  YCA : {
    country: "CA",
    name: {
      en : "Courtenay Rail Station"
    }
  },
  YCB : {
    lat: "69.1",
    lon: "-105.133",
    country: "CA",
    name: {
      en : "Cambridge Bay"
    }
  },
  YCC : {
    lat: "45.1",
    lon: "-74.5667",
    country: "CA",
    name: {
      en : "Cornwall Regional"
    }
  },
  YCD : {
    lat: "49.05",
    lon: "-123.867",
    country: "CA",
    name: {
      en : "Nanaimo"
    }
  },
  YCF : {
    country: "CA",
    name: {
      en : "YCF"
    }
  },
  YCG : {
    lat: "49.2956",
    lon: "-117.632",
    country: "CA",
    name: {
      en : "Ralph West"
    }
  },
  YCH : {
    lat: "47.25",
    lon: "-65",
    country: "CA",
    name: {
      en : "Miramichi"
    }
  },
  YCK : {
    lat: "67.1667",
    lon: "-126",
    country: "CA",
    name: {
      en : "Colville"
    }
  },
  YCM : {
    country: "CA",
    name: {
      en : "YCM"
    }
  },
  YCO : {
    lat: "67.8333",
    lon: "-115.083",
    country: "CA",
    name: {
      en : "Kugluktuk"
    }
  },
  YCS : {
    lat: "63.3333",
    lon: "-90.7167",
    country: "CA",
    name: {
      en : "Chesterfield Inlet"
    }
  },
  YCU : {
    country: "CN",
    name: {
      en : "YCU"
    }
  },
  YCY : {
    lat: "70.4167",
    lon: "-68.5",
    country: "CA",
    name: {
      en : "Clyde River"
    }
  },
  YDA : {
    lat: "64.0417",
    lon: "-139.121",
    country: "CA",
    name: {
      en : "Dawson City"
    }
  },
  YDF : {
    lat: "49.2167",
    lon: "-57.4",
    country: "CA",
    name: {
      en : "Deer Lake"
    }
  },
  YDP : {
    lat: "56.5333",
    lon: "-61.6667",
    country: "CA",
    name: {
      en : "Nain"
    }
  },
  YDQ : {
    lat: "55.7333",
    lon: "-120.183",
    country: "CA",
    name: {
      en : "Dawson Creek"
    }
  },
  YDS : {
    country: "CA",
    name: {
      en : "YDS"
    }
  },
  YEB : {
    country: "CA",
    name: {
      en : "Bar River"
    }
  },
  YEG : {
    lat: "53.3042",
    lon: "-113.592",
    country: "CA",
    city: "YEA",
    name: {
      en : "Edmonton"
    }
  },
  YEH : {
    lat: "27.4811",
    lon: "52.6",
    country: "IR",
    name: {
      en : "Asaloyeh"
    }
  },
  YEI : {
    lat: "40.2333",
    lon: "29.55",
    country: "TR",
    name: {
      en : "Yenisehir"
    }
  },
  YEK : {
    lat: "61.1167",
    lon: "-94.05",
    country: "CA",
    popularity: 1,
    name: {
      en : "Arviat"
    }
  },
  YEL : {
    lat: "46.3522",
    lon: "-82.5631",
    country: "CA",
    name: {
      en : "Elliot Lake"
    }
  },
  YER : {
    country: "CA",
    name: {
      en : "Fort Severn Arpt"
    }
  },
  YES : {
    country: "IR",
    name: {
      en : "YES"
    }
  },
  YET : {
    lat: "53.5833",
    lon: "-116.467",
    country: "CA",
    name: {
      en : "Edson"
    }
  },
  YEV : {
    lat: "68.3",
    lon: "-133.483",
    country: "CA",
    name: {
      en : "Inuvik Mike Zubko"
    }
  },
  YFA : {
    country: "CA",
    name: {
      en : "YFA"
    }
  },
  YFB : {
    lat: "63.7522",
    lon: "-68.5639",
    country: "CA",
    name: {
      en : "Iqaluit"
    }
  },
  YFC : {
    lat: "45.8667",
    lon: "-66.5333",
    country: "CA",
    name: {
      en : "Fredericton"
    }
  },
  YFH : {
    country: "CA",
    name: {
      en : "YFH"
    }
  },
  YFJ : {
    country: "CA",
    name: {
      en : "YFJ"
    }
  },
  YFO : {
    lat: "54.6833",
    lon: "-101.683",
    country: "CA",
    name: {
      en : "Flin Flon"
    }
  },
  YFS : {
    country: "CA",
    name: {
      en : "YFS"
    }
  },
  YFT : {
    country: "MO",
    name: {
      en : "YFT"
    }
  },
  YFX : {
    country: "CA",
    name: {
      en : "Fox Harbour Arpt"
    }
  },
  YGB : {
    country: "CA",
    name: {
      en : "YGB"
    }
  },
  YGG : {
    country: "CA",
    name: {
      en : "YGG"
    }
  },
  YGH : {
    country: "CA",
    name: {
      en : "YGH"
    }
  },
  YGJ : {
    lat: "35.4914",
    lon: "133.242",
    country: "JP",
    name: {
      en : "Miho"
    }
  },
  YGK : {
    lat: "44.2236",
    lon: "-76.6069",
    country: "CA",
    name: {
      en : "Norman Rodgers"
    }
  },
  YGL : {
    lat: "53.6297",
    lon: "-77.7064",
    country: "CA",
    name: {
      en : "La Grande"
    }
  },
  YGN : {
    country: "CA",
    name: {
      en : "YGN"
    }
  },
  YGP : {
    lat: "48.7667",
    lon: "-64.4833",
    country: "CA",
    name: {
      en : "Gaspe"
    }
  },
  YGR : {
    lat: "47.3667",
    lon: "-61.9",
    country: "CA",
    name: {
      en : "House Harbour"
    }
  },
  YGT : {
    lat: "69.4",
    lon: "-81.8167",
    country: "CA",
    name: {
      en : "Igloolik"
    }
  },
  YGV : {
    lat: "50.25",
    lon: "-63.5833",
    country: "CA",
    name: {
      en : "Havre St Pierre"
    }
  },
  YGW : {
    lat: "55.2792",
    lon: "-77.7667",
    country: "CA",
    name: {
      en : "Kuujjuaraapik"
    }
  },
  YGZ : {
    country: "CA",
    name: {
      en : "YGZ"
    }
  },
  YHA : {
    lat: "52.5333",
    lon: "-56.3",
    country: "CA",
    name: {
      en : "Port Hope Simpson"
    }
  },
  YHB : {
    country: "CA",
    name: {
      en : "Hudson Bay Rail Station"
    }
  },
  YHD : {
    lat: "49.7833",
    lon: "-92.8333",
    country: "CA",
    name: {
      en : "Dryden"
    }
  },
  YHG : {
    lat: "52.7667",
    lon: "-56.1",
    country: "CA",
    name: {
      en : "Charlottetown"
    }
  },
  YHH : {
    country: "CA",
    city: "YBL",
    name: {
      en : "Harbor Airport"
    }
  },
  YHI : {
    country: "CA",
    name: {
      en : "YHI"
    }
  },
  YHK : {
    lat: "68.6333",
    lon: "-95.95",
    country: "CA",
    name: {
      en : "Gjoa Haven"
    }
  },
  YHM : {
    lat: "43.1669",
    lon: "-79.9306",
    country: "CA",
    city: "YTO",
    name: {
      en : "Civic"
    }
  },
  YHO : {
    lat: "55.4483",
    lon: "-60.2294",
    country: "CA",
    name: {
      en : "Hopedale"
    }
  },
  YHP : {
    country: "CA",
    name: {
      en : "YHP"
    }
  },
  YHR : {
    lat: "50.5",
    lon: "-59.5",
    country: "CA",
    name: {
      en : "Chevery"
    }
  },
  YHS : {
    lat: "49.4667",
    lon: "-123.75",
    country: "CA",
    name: {
      en : "Sechelt"
    }
  },
  YHU : {
    lat: "45.5",
    lon: "-73.6",
    country: "CA",
    city: "YMQ",
    name: {
      en : "St Hubert"
    }
  },
  YHY : {
    lat: "60.8456",
    lon: "-115.778",
    country: "CA",
    name: {
      en : "Hay River"
    }
  },
  YHZ : {
    lat: "44.8833",
    lon: "-63.5167",
    country: "CA",
    name: {
      en : "Halifax"
    }
  },
  YIF : {
    lat: "51.2167",
    lon: "-58.6667",
    country: "CA",
    name: {
      en : "Pakuashipi"
    }
  },
  YIH : {
    lat: "30.7",
    lon: "111.183",
    country: "CN",
    name: {
      en : "Yichang"
    }
  },
  YIK : {
    lat: "62.4167",
    lon: "-76.0833",
    country: "CA",
    name: {
      en : "Ivujivik"
    }
  },
  YIN : {
    country: "CN",
    name: {
      en : "Yining Arpt"
    }
  },
  YIO : {
    country: "CA",
    name: {
      en : "Pond Inlet Arpt"
    }
  },
  YIP : {
    lat: "42.2333",
    lon: "-83.5333",
    country: "US",
    city: "DTT",
    name: {
      en : "Willow Run"
    }
  },
  YIW : {
    lat: "29.2667",
    lon: "120.05",
    country: "CN",
    name: {
      en : "Yiwu"
    }
  },
  YJB : {
    lat: "41.378889",
    lon: "2.14",
    country: "ES",
    city: "BCN",
    name: {
      en : "YJB"
    }
  },
  YJT : {
    lat: "48.5333",
    lon: "-58.55",
    country: "CA",
    name: {
      en : "Stephenville"
    }
  },
  YKA : {
    lat: "50.6992",
    lon: "-120.438",
    country: "CA",
    name: {
      en : "Davie Fulton"
    }
  },
  YKF : {
    lat: "43.45",
    lon: "-80.4833",
    country: "CA",
    name: {
      en : "Kitchener Waterloo Regional"
    }
  },
  YKG : {
    lat: "60",
    lon: "-70",
    country: "CA",
    name: {
      en : "Kangirsuk"
    }
  },
  YKH : {
    country: "CN",
    name: {
      en : "Yingkou Lanqi"
    }
  },
  YKL : {
    lat: "54.7833",
    lon: "-64.8167",
    country: "CA",
    name: {
      en : "Schefferville"
    }
  },
  YKM : {
    lat: "46.5669",
    lon: "-120.538",
    country: "US",
    name: {
      en : "Yakima Terminal"
    }
  },
  YKO : {
    country: "TR",
    name: {
      en : "Hakkari–Yüksekova"
    }
  },
  YKQ : {
    lat: "51.4875",
    lon: "-78.75",
    country: "CA",
    name: {
      en : "Waskaganish"
    }
  },
  YKS : {
    lat: "62.0833",
    lon: "129.767",
    country: "RU",
    name: {
      en : "Yakutsk"
    }
  },
  YKT : {
    country: "CA",
    name: {
      en : "YKT"
    }
  },
  YKU : {
    lat: "53.8333",
    lon: "-79",
    country: "CA",
    name: {
      en : "Chisasibi"
    }
  },
  YLC : {
    lat: "62.85",
    lon: "-69.8833",
    country: "CA",
    name: {
      en : "Kimmirut Lake Harbour"
    }
  },
  YLE : {
    country: "CA",
    name: {
      en : "YLE"
    }
  },
  YLH : {
    country: "CA",
    name: {
      en : "YLH"
    }
  },
  YLL : {
    lat: "53.3",
    lon: "-110",
    country: "CA",
    name: {
      en : "Lloydminster"
    }
  },
  YLQ : {
    country: "CA",
    name: {
      en : "La Tuque Rail Station"
    }
  },
  YLW : {
    lat: "49.8833",
    lon: "-119.483",
    country: "CA",
    name: {
      en : "Ellison Field"
    }
  },
  YMF : {
    country: "CA",
    name: {
      en : "YMF"
    }
  },
  YMH : {
    country: "CA",
    name: {
      en : "Marys Harbour Arpt"
    }
  },
  YMK : {
    country: "RU",
    name: {
      en : "YMK"
    }
  },
  YMM : {
    lat: "56.6778",
    lon: "-111.267",
    country: "CA",
    name: {
      en : "Ft McMurray"
    }
  },
  YMN : {
    lat: "55.1667",
    lon: "-59.1667",
    country: "CA",
    name: {
      en : "Makkovik"
    }
  },
  YMO : {
    lat: "51.2911",
    lon: "-80.6042",
    country: "CA",
    name: {
      en : "Moosonee"
    }
  },
  YMP : {
    country: "CA",
    name: {
      en : "YMP"
    }
  },
  YMT : {
    lat: "49.9167",
    lon: "-74.3667",
    country: "CA",
    name: {
      en : "Chibougamau"
    }
  },
  YMU : {
    country: "CA",
    name: {
      en : "YMU"
    }
  },
  YMX : {
    lat: "45.6667",
    lon: "-74.03",
    country: "CA",
    city: "YMQ",
    name: {
      en : "Mirabel"
    }
  },
  YNA : {
    lat: "50.1833",
    lon: "-61.8",
    country: "CA",
    name: {
      en : "Natashquan"
    }
  },
  YNB : {
    lat: "24.1167",
    lon: "38.0667",
    country: "SA",
    name: {
      en : "Yanbo"
    }
  },
  YNC : {
    country: "CA",
    name: {
      en : "YNC"
    }
  },
  YND : {
    lat: "45.4833",
    lon: "-75.6333",
    country: "CA",
    name: {
      en : "Gatineau Hull"
    }
  },
  YNJ : {
    lat: "42.65",
    lon: "129.5",
    country: "CN",
    name: {
      en : "Yanji"
    }
  },
  YNO : {
    country: "CA",
    name: {
      en : "YNO"
    }
  },
  YNP : {
    lat: "55.9139",
    lon: "-61.1844",
    country: "CA",
    name: {
      en : "Natuashish"
    }
  },
  YNS : {
    country: "CA",
    name: {
      en : "YNS"
    }
  },
  YNT : {
    lat: "37.55",
    lon: "121.333",
    country: "CN",
    name: {
      en : "Yantai Penglai"
    }
  },
  YNY : {
    country: "KR",
    name: {
      en : "YNY"
    }
  },
  YNZ : {
    country: "CN",
    name: {
      en : "YNZ"
    }
  },
  YOC : {
    country: "CA",
    name: {
      en : "YOC"
    }
  },
  YOD : {
    lat: "54.4667",
    lon: "-110.25",
    country: "CA",
    name: {
      en : "Cold Lake"
    }
  },
  YOG : {
    country: "CA",
    name: {
      en : "YOG"
    }
  },
  YOJ : {
    lat: "58.6183",
    lon: "-117.168",
    country: "CA",
    name: {
      en : "Footner Lake"
    }
  },
  YOO : {
    country: "CA",
    name: {
      en : "Oshawa Municipal Arpt"
    }
  },
  YOP : {
    lat: "58.5",
    lon: "-119.4",
    country: "CA",
    name: {
      en : "Rainbow Lake"
    }
  },
  YOW : {
    lat: "45.3208",
    lon: "-75.6728",
    country: "CA",
    popularity: 1,
    name: {
      en : "Ottawa"
    }
  },
  YPB : {
    lat: "49.2333",
    lon: "-124.8",
    country: "CA",
    name: {
      en : "Port Alberni"
    }
  },
  YPC : {
    country: "CA",
    name: {
      en : "YPC"
    }
  },
  YPE : {
    lat: "56.2278",
    lon: "-117.44",
    country: "CA",
    name: {
      en : "Municipal Peace River"
    }
  },
  YPH : {
    lat: "58.4333",
    lon: "-78.1667",
    country: "CA",
    name: {
      en : "Inukjuak"
    }
  },
  YPJ : {
    lat: "59.3",
    lon: "-69.6667",
    country: "CA",
    name: {
      en : "Aupaluk"
    }
  },
  YPL : {
    lat: "51.2083",
    lon: "-90.2083",
    country: "CA",
    name: {
      en : "Provincial"
    }
  },
  YPM : {
    lat: "51.8167",
    lon: "-94",
    country: "CA",
    name: {
      en : "Pikangikum"
    }
  },
  YPO : {
    country: "CA",
    name: {
      en : "YPO"
    }
  },
  YPR : {
    lat: "54.2872",
    lon: "-130.441",
    country: "CA",
    name: {
      en : "Digby Island"
    }
  },
  YPT : {
    country: "CA",
    name: {
      en : "YPT"
    }
  },
  YPW : {
    lat: "49.8167",
    lon: "-124.5",
    country: "CA",
    name: {
      en : "Westview"
    }
  },
  YPX : {
    lat: "60.0333",
    lon: "-77.1667",
    country: "CA",
    name: {
      en : "Povungnituk"
    }
  },
  YPZ : {
    country: "CA",
    name: {
      en : "Burns Lake Rail Station"
    }
  },
  YQB : {
    lat: "46.7892",
    lon: "-71.3981",
    country: "CA",
    popularity: 1,
    name: {
      en : "Quebec"
    }
  },
  YQC : {
    lat: "61.3333",
    lon: "-69.6333",
    country: "CA",
    name: {
      en : "Quaqtaq"
    }
  },
  YQD : {
    lat: "53.9667",
    lon: "-101.1",
    country: "CA",
    name: {
      en : "The Pas"
    }
  },
  YQF : {
    lat: "52.1769",
    lon: "-113.893",
    country: "CA",
    city: "YYC",
    name: {
      en : "Red Deer"
    }
  },
  YQG : {
    lat: "42.2742",
    lon: "-82.9639",
    country: "CA",
    name: {
      en : "Windsor"
    }
  },
  YQI : {
    lat: "43.8333",
    lon: "-66.0833",
    country: "CA",
    name: {
      en : "Municipal Yarmouth"
    }
  },
  YQJ : {
    country: "CA",
    name: {
      en : "YQJ"
    }
  },
  YQK : {
    lat: "49.7875",
    lon: "-94.3583",
    country: "CA",
    name: {
      en : "Kenora"
    }
  },
  YQL : {
    lat: "49.6319",
    lon: "-112.792",
    country: "CA",
    name: {
      en : "Lethbridge"
    }
  },
  YQM : {
    lat: "46.1167",
    lon: "-64.6833",
    country: "CA",
    name: {
      en : "Moncton"
    }
  },
  YQQ : {
    lat: "49.7167",
    lon: "-124.893",
    country: "CA",
    name: {
      en : "Royal Canadian Air Force Station"
    }
  },
  YQR : {
    lat: "50.4333",
    lon: "-104.653",
    country: "CA",
    name: {
      en : "Regina"
    }
  },
  YQT : {
    lat: "48.3833",
    lon: "-89.25",
    country: "CA",
    name: {
      en : "Thunder Bay"
    }
  },
  YQU : {
    lat: "55.1842",
    lon: "-118.894",
    country: "CA",
    name: {
      en : "Grande Prairie"
    }
  },
  YQX : {
    lat: "48.9467",
    lon: "-54.5633",
    country: "CA",
    name: {
      en : "Gander"
    }
  },
  YQY : {
    lat: "46.1667",
    lon: "-60.05",
    country: "CA",
    name: {
      en : "Sydney"
    }
  },
  YQZ : {
    lat: "53.0267",
    lon: "-122.51",
    country: "CA",
    name: {
      en : "Quesnel"
    }
  },
  YRA : {
    country: "CA",
    name: {
      en : "YRA"
    }
  },
  YRB : {
    country: "CA",
    name: {
      en : "Resolute Arpt"
    }
  },
  YRC : {
    country: "CA",
    name: {
      en : "YRC"
    }
  },
  YRF : {
    lat: "53.7167",
    lon: "-57",
    country: "CA",
    name: {
      en : "Cartwright"
    }
  },
  YRG : {
    country: "CA",
    name: {
      en : "Rigolet Arpt"
    }
  },
  YRJ : {
    lat: "48.5167",
    lon: "-72.2167",
    country: "CA",
    name: {
      en : "Roberval"
    }
  },
  YRL : {
    lat: "51.05",
    lon: "-93.8167",
    country: "CA",
    name: {
      en : "Federal Red Lake"
    }
  },
  YRR : {
    country: "CA",
    name: {
      en : "YRR"
    }
  },
  YRT : {
    lat: "62.8114",
    lon: "-92.1158",
    country: "CA",
    name: {
      en : "Rankin Inlet"
    }
  },
  YSB : {
    lat: "46.6333",
    lon: "-80.8",
    country: "CA",
    name: {
      en : "Sudbury"
    }
  },
  YSC : {
    lat: "45.4167",
    lon: "-71.9",
    country: "CA",
    name: {
      en : "Sherbrooke"
    }
  },
  YSG : {
    country: "CA",
    name: {
      en : "YSG"
    }
  },
  YSH : {
    country: "CA",
    name: {
      en : "Smith Falls Rail Station"
    }
  },
  YSJ : {
    lat: "45.3167",
    lon: "-65.8833",
    country: "CA",
    name: {
      en : "St John"
    }
  },
  YSK : {
    lat: "56.55",
    lon: "-79.2167",
    country: "CA",
    name: {
      en : "Sanikiluaq"
    }
  },
  YSL : {
    lat: "47.1833",
    lon: "-67.9",
    country: "CA",
    name: {
      en : "Edmunston"
    }
  },
  YSM : {
    lat: "60.0167",
    lon: "-111.967",
    country: "CA",
    name: {
      en : "Ft Smith"
    }
  },
  YSO : {
    lat: "54.9167",
    lon: "-59.9667",
    country: "CA",
    name: {
      en : "Postville"
    }
  },
  YSQ : {
    country: "CN",
    name: {
      en : "Songyuan Chaganhu"
    }
  },
  YSR : {
    country: "CA",
    name: {
      en : "YSR"
    }
  },
  YST : {
    lat: "53.85",
    lon: "-94.65",
    country: "CA",
    name: {
      en : "St Therese Pt"
    }
  },
  YSY : {
    country: "CA",
    name: {
      en : "YSY"
    }
  },
  YTD : {
    country: "CA",
    name: {
      en : "Thicket Portage Rail Station"
    }
  },
  YTE : {
    lat: "64.2333",
    lon: "-76.5333",
    country: "CA",
    name: {
      en : "Cape Dorset"
    }
  },
  YTF : {
    country: "CA",
    name: {
      en : "Alma Municipal Arpt"
    }
  },
  YTG : {
    country: "CA",
    name: {
      en : "YTG"
    }
  },
  YTH : {
    lat: "55.8",
    lon: "-97.8667",
    country: "CA",
    name: {
      en : "Thompson"
    }
  },
  YTL : {
    country: "CA",
    name: {
      en : "Big Trout Arpt"
    }
  },
  YTM : {
    lat: "46.5156",
    lon: "-74.7553",
    country: "CA",
    name: {
      en : "International"
    }
  },
  YTQ : {
    lat: "53.6667",
    lon: "-69.9167",
    country: "CA",
    name: {
      en : "Tasiujaq"
    }
  },
  YTS : {
    lat: "48.5667",
    lon: "-81.3667",
    country: "CA",
    name: {
      en : "Timmins"
    }
  },
  YTY : {
    country: "CN",
    name: {
      en : "Yangzhou Taizhou"
    }
  },
  YTZ : {
    lat: "43.65",
    lon: "-79.3833",
    country: "CA",
    city: "YTO",
    name: {
      en : "Toronto City Centre"
    }
  },
  YUB : {
    country: "CA",
    name: {
      en : "Tuktoyaktuk Airport"
    }
  },
  YUD : {
    lat: "56.55",
    lon: "-76.55",
    country: "CA",
    name: {
      en : "Umiujaq"
    }
  },
  YUL : {
    lat: "45.4639",
    lon: "-73.75",
    country: "CA",
    city: "YMQ",
    popularity: 16,
    name: {
      en : "Pierre Elliott Trudeau"
    }
  },
  YUM : {
    lat: "32.6542",
    lon: "-114.607",
    country: "US",
    name: {
      en : "Yuma"
    }
  },
  YUS : {
    country: "CN",
    name: {
      en : "YUS"
    }
  },
  YUT : {
    country: "CA",
    name: {
      en : "YUT"
    }
  },
  YUX : {
    lat: "68.7833",
    lon: "-81.25",
    country: "CA",
    name: {
      en : "Hall Beach"
    }
  },
  YUY : {
    lat: "48.2056",
    lon: "-78.8306",
    country: "CA",
    name: {
      en : "Rouyn Noranda"
    }
  },
  YVA : {
    lat: "-11.5319",
    lon: "43.2611",
    country: "KM",
    name: {
      en : "Iconi"
    }
  },
  YVB : {
    lat: "48.05",
    lon: "-65.4833",
    country: "CA",
    name: {
      en : "Municipal Bonaventure"
    }
  },
  YVG : {
    lat: "53.35",
    lon: "-110.817",
    country: "CA",
    name: {
      en : "Vermilion"
    }
  },
  YVM : {
    country: "CA",
    name: {
      en : "Qikiqtarjuaq Arpt"
    }
  },
  YVO : {
    lat: "48.0528",
    lon: "-77.7828",
    country: "CA",
    name: {
      en : "Val d Or"
    }
  },
  YVP : {
    lat: "58.1019",
    lon: "-68.4067",
    country: "CA",
    name: {
      en : "Kuujjuaq"
    }
  },
  YVQ : {
    lat: "65.2833",
    lon: "-126.8",
    country: "CA",
    name: {
      en : "Norman Wells"
    }
  },
  YVR : {
    lat: "49.1872",
    lon: "-123.185",
    country: "CA",
    popularity: 6,
    name: {
      en : "Vancouver"
    }
  },
  YVZ : {
    lat: "52.6667",
    lon: "-94.5",
    country: "CA",
    name: {
      en : "Deer Lake"
    }
  },
  YWB : {
    lat: "61.6",
    lon: "-71.95",
    country: "CA",
    name: {
      en : "Kangiqsujuaq"
    }
  },
  YWG : {
    lat: "49.9",
    lon: "-97.2333",
    country: "CA",
    name: {
      en : "Winnipeg"
    }
  },
  YWH : {
    lat: "48.4167",
    lon: "-123.367",
    country: "CA",
    city: "YYJ",
    name: {
      en : "Inner Harbor Sea Plane"
    }
  },
  YWJ : {
    country: "CA",
    name: {
      en : "YWJ"
    }
  },
  YWK : {
    lat: "52.95",
    lon: "-66.9",
    country: "CA",
    name: {
      en : "Wabush"
    }
  },
  YWL : {
    lat: "52.1847",
    lon: "-122.044",
    country: "CA",
    name: {
      en : "Williams Lake"
    }
  },
  YWM : {
    country: "CA",
    name: {
      en : "YWM"
    }
  },
  YWP : {
    country: "CA",
    name: {
      en : "YWP"
    }
  },
  YXC : {
    lat: "49.6122",
    lon: "-115.782",
    country: "CA",
    name: {
      en : "Cranbrook"
    }
  },
  YXD : {
    lat: "53.5667",
    lon: "-113.517",
    country: "CA",
    city: "YEA",
    name: {
      en : "Edmonton"
    }
  },
  YXE : {
    lat: "52.1667",
    lon: "-106.683",
    country: "CA",
    name: {
      en : "Saskatoon"
    }
  },
  YXH : {
    lat: "50.0158",
    lon: "-110.721",
    country: "CA",
    name: {
      en : "Medicine Hat"
    }
  },
  YXJ : {
    lat: "56.2333",
    lon: "-120.733",
    country: "CA",
    name: {
      en : "Ft St John"
    }
  },
  YXL : {
    lat: "50.1167",
    lon: "-91.9028",
    country: "CA",
    name: {
      en : "Sioux Lookout"
    }
  },
  YXN : {
    lat: "62.2333",
    lon: "-92.6",
    country: "CA",
    name: {
      en : "Whale Cove"
    }
  },
  YXP : {
    lat: "66.1333",
    lon: "-65.7333",
    country: "CA",
    name: {
      en : "Pangnirtung"
    }
  },
  YXS : {
    lat: "53.8917",
    lon: "-122.675",
    country: "CA",
    name: {
      en : "Prince George"
    }
  },
  YXT : {
    lat: "54.4656",
    lon: "-128.574",
    country: "CA",
    name: {
      en : "Terrace"
    }
  },
  YXU : {
    lat: "43.0333",
    lon: "-81.15",
    country: "CA",
    popularity: 5,
    name: {
      en : "London"
    }
  },
  YXX : {
    lat: "49.0256",
    lon: "-122.362",
    country: "CA",
    name: {
      en : "Abbotsford"
    }
  },
  YXY : {
    lat: "60.7167",
    lon: "-135.067",
    country: "CA",
    name: {
      en : "Whitehorse"
    }
  },
  YYB : {
    lat: "46.3658",
    lon: "-79.4214",
    country: "CA",
    name: {
      en : "North Bay"
    }
  },
  YYC : {
    lat: "51.1128",
    lon: "-114.02",
    country: "CA",
    name: {
      en : "Calgary"
    }
  },
  YYD : {
    lat: "54.8256",
    lon: "-127.18",
    country: "CA",
    name: {
      en : "Smithers"
    }
  },
  YYE : {
    lat: "58.8333",
    lon: "-122.583",
    country: "CA",
    name: {
      en : "Ft Nelson"
    }
  },
  YYF : {
    lat: "49.4647",
    lon: "-119.6",
    country: "CA",
    name: {
      en : "Penticton"
    }
  },
  YYG : {
    lat: "46.2861",
    lon: "-63.1306",
    country: "CA",
    name: {
      en : "Charlottetown"
    }
  },
  YYH : {
    lat: "69.5333",
    lon: "-93.5167",
    country: "CA",
    name: {
      en : "Taloyoak"
    }
  },
  YYJ : {
    lat: "48.6486",
    lon: "-123.424",
    country: "CA",
    name: {
      en : "Victoria"
    }
  },
  YYQ : {
    lat: "58.7667",
    lon: "-94.1667",
    country: "CA",
    name: {
      en : "Churchill"
    }
  },
  YYR : {
    lat: "53.3167",
    lon: "-60.4",
    country: "CA",
    name: {
      en : "Municipal Goose Bay"
    }
  },
  YYT : {
    lat: "47.6169",
    lon: "-52.75",
    country: "CA",
    name: {
      en : "St Johns"
    }
  },
  YYU : {
    lat: "49.4125",
    lon: "-82.4708",
    country: "CA",
    name: {
      en : "Japuskasing"
    }
  },
  YYY : {
    lat: "48.6",
    lon: "-68.2",
    country: "CA",
    name: {
      en : "Mont Joli"
    }
  },
  YYZ : {
    lat: "43.6833",
    lon: "-79.6333",
    country: "CA",
    city: "YTO",
    popularity: 16,
    name: {
      en : "Lester B Pearson"
    }
  },
  YZF : {
    lat: "62.4689",
    lon: "-114.444",
    country: "CA",
    name: {
      en : "Yellowknife"
    }
  },
  YZG : {
    lat: "62.2",
    lon: "-75.6333",
    country: "CA",
    name: {
      en : "Salluit"
    }
  },
  YZP : {
    lat: "53.2544",
    lon: "-131.813",
    country: "CA",
    name: {
      en : "Federal"
    }
  },
  YZR : {
    lat: "42.9972",
    lon: "-82.3111",
    country: "CA",
    name: {
      en : "Sarnia"
    }
  },
  YZS : {
    lat: "64.2",
    lon: "-83.3667",
    country: "CA",
    name: {
      en : "Coral Harbour"
    }
  },
  YZT : {
    lat: "50.6806",
    lon: "-127.364",
    country: "CA",
    name: {
      en : "Port Hardy"
    }
  },
  YZV : {
    lat: "50.2",
    lon: "-66.3833",
    country: "CA",
    name: {
      en : "Sept Iles"
    }
  },
  YZY : {
    country: "CN",
    name: {
      en : "Zhangye Ganzhou"
    }
  },
  YZZ : {
    country: "CA",
    name: {
      en : "Trail"
    }
  },
  ZAD : {
    lat: "44.0978",
    lon: "15.3567",
    country: "HR",
    popularity: 1,
    name: {
      en : "Zadar"
    }
  },
  ZAG : {
    lat: "45.7431",
    lon: "16.0703",
    country: "HR",
    popularity: 130,
    name: {
      en : "Zagreb"
    }
  },
  ZAH : {
    country: "IR",
    name: {
      en : "ZAH"
    }
  },
  ZAJ : {
    country: "AF",
    name: {
      en : "ZAJ"
    }
  },
  ZAL : {
    country: "CL",
    name: {
      en : "Pichoy"
    }
  },
  ZAM : {
    country: "PH",
    name: {
      en : "ZAM"
    }
  },
  ZAT : {
    country: "CN",
    name: {
      en : "ZAT"
    }
  },
  ZAZ : {
    lat: "41.6667",
    lon: "-1.03889",
    country: "ES",
    name: {
      en : "Zaragoza"
    }
  },
  ZBF : {
    lat: "47.6292",
    lon: "-65.7394",
    country: "CA",
    name: {
      en : "Bathurst"
    }
  },
  ZBL : {
    lat: "-24.4",
    lon: "150.517",
    country: "AU",
    name: {
      en : "Biloela"
    }
  },
  ZBP : {
    country: "US",
    city: "BWI",
    name: {
      en : "Baltimore Railway Station"
    }
  },
  ZBQ : {
    country: "DK",
    city: "ODE",
    name: {
      en : "Odense Railroad Station"
    }
  },
  ZBR : {
    country: "IR",
    name: {
      en : "ZBR"
    }
  },
  ZBV : {
    country: "US",
    city: "EGE",
    name: {
      en : "Beaver Creek Van Service"
    }
  },
  ZBW : {
    country: "BR",
    name: {
      en : "Atibaia"
    }
  },
  ZCL : {
    lat: "22.8",
    lon: "-102.55",
    country: "MX",
    name: {
      en : "Zacatecas"
    }
  },
  ZCO : {
    lat: "-38.7639",
    lon: "-72.6369",
    country: "CL",
    name: {
      en : "Manquehue"
    }
  },
  ZDH : {
    country: "CH",
    city: "EAP",
    name: {
      en : "Basel/Mullhouse SBB Rail Service"
    }
  },
  ZDJ : {
    country: "CH",
    city: "BRN",
    name: {
      en : "Berne Railroad Station"
    }
  },
  ZDU : {
    lat: "56.5",
    lon: "-2.96667",
    country: "GB",
    city: "DND",
    name: {
      en : "Dundee ScotRail"
    }
  },
  ZEL : {
    country: "CA",
    name: {
      en : "ZEL"
    }
  },
  ZEM : {
    lat: "0",
    lon: "0",
    country: "CA",
    name: {
      en : "Eastmain River Airport"
    }
  },
  ZEU : {
    country: "DE",
    name: {
      en : "ZEU"
    }
  },
  ZFI : {
    country: "GB",
    name: {
      en : "Chesterfield Bus Station"
    }
  },
  ZFJ : {
    lat: "48.15",
    lon: "4.85",
    country: "FR",
    city: "RNS",
    name: {
      en : "Gare de Rennes"
    }
  },
  ZFM : {
    country: "CA",
    name: {
      en : "ZFM"
    }
  },
  ZFN : {
    country: "CA",
    name: {
      en : "ZFN"
    }
  },
  ZFQ : {
    lat: "48.6833",
    lon: "1.1",
    country: "FR",
    city: "BOD",
    name: {
      en : "Gare de Bordeaux"
    }
  },
  ZFV : {
    country: "US",
    city: "PHL",
    name: {
      en : "ZFV"
    }
  },
  ZFZ : {
    country: "US",
    name: {
      en : "ZFZ"
    }
  },
  ZGD : {
    country: "US",
    name: {
      en : "ZGD"
    }
  },
  ZGG : {
    country: "GB",
    city: "GLA",
    name: {
      en : "Glasgow ScotRail"
    }
  },
  ZGN : {
    country: "CN",
    name: {
      en : "ZGN"
    }
  },
  ZGS : {
    lat: "50.3333",
    lon: "-60.6667",
    country: "CA",
    name: {
      en : "Gethsemanie"
    }
  },
  ZGU : {
    country: "VU",
    name: {
      en : "ZGU"
    }
  },
  ZHA : {
    lat: "21.2667",
    lon: "110.467",
    country: "CN",
    name: {
      en : "Zhanjiang"
    }
  },
  ZHO : {
    country: "CA",
    name: {
      en : "Houston Bus Station"
    }
  },
  ZHY : {
    lat: "0",
    lon: "0",
    country: "CN",
    name: {
      en : "Zhongwei Shapotou Airport"
    }
  },
  ZIA : {
    lat: "55.553333",
    lon: "38.151667",
    country: "RU",
    city: "MOW",
    popularity: 50,
    name: {
      en : "Zhukovsky"
    }
  },
  ZID : {
    country: "DK",
    city: "AAR",
    name: {
      en : "Aarhus Bus Service"
    }
  },
  ZIF : {
    country: "CA",
    city: "YOW",
    name: {
      en : "Fallowfield Railway Station"
    }
  },
  ZIG : {
    lat: "12.5561",
    lon: "-16.2758",
    country: "SN",
    name: {
      en : "Ziguinchor"
    }
  },
  ZIH : {
    lat: "17.6433",
    lon: "-101.555",
    country: "MX",
    name: {
      en : "Zihuatanejo"
    }
  },
  ZIM : {
    country: "DK",
    city: "ODE",
    name: {
      en : "Odense Bus Service"
    }
  },
  ZIX : {
    country: "RU",
    name: {
      en : "Zhigansk"
    }
  },
  ZJO : {
    country: "US",
    city: "SJC",
    name: {
      en : "San Jose Bus Service"
    }
  },
  ZKE : {
    country: "CA",
    name: {
      en : "ZKE"
    }
  },
  ZKG : {
    lat: "50.1889",
    lon: "-61.2917",
    country: "CA",
    name: {
      en : "Kegaska"
    }
  },
  ZKP : {
    name: {
      en : "Zyryanka"
    }
  },
  ZLN : {
    country: "FR",
    city: "LME",
    name: {
      en : "Le Mans Railway Station"
    }
  },
  ZLO : {
    lat: "19.1133",
    lon: "-104.351",
    country: "MX",
    name: {
      en : "Manzanillo"
    }
  },
  ZLS : {
    country: "GB",
    city: "LPL",
    name: {
      en : "Liverpool Street Station"
    }
  },
  ZLT : {
    lat: "51",
    lon: "-59",
    country: "CA",
    name: {
      en : "La Tabatiere"
    }
  },
  ZLY : {
    country: "US",
    city: "ALB",
    name: {
      en : "Albany NY Rail Station"
    }
  },
  ZME : {
    country: "US",
    name: {
      en : "NJ Metro Park Railway Station"
    }
  },
  ZML : {
    country: "US",
    city: "MKE",
    name: {
      en : "Milwaukee Airport Rail Station"
    }
  },
  ZMT : {
    country: "CA",
    name: {
      en : "ZMT"
    }
  },
  ZNA : {
    lat: "49.1667",
    lon: "-123.933",
    country: "CA",
    city: "YCD",
    name: {
      en : "Harbour Seaplane Base"
    }
  },
  ZNE : {
    lat: "-23.4167",
    lon: "119.8",
    country: "AU",
    popularity: 1,
    name: {
      en : "Newman"
    }
  },
  ZNZ : {
    lat: "-6.21917",
    lon: "39.2219",
    country: "TZ",
    name: {
      en : "Kisauni"
    }
  },
  ZOS : {
    lat: "-40.6078",
    lon: "-73.0556",
    country: "CL",
    name: {
      en : "Canal Balo"
    }
  },
  ZPB : {
    country: "CA",
    name: {
      en : "ZPB"
    }
  },
  ZQN : {
    lat: "-45.0214",
    lon: "168.739",
    country: "NZ",
    popularity: 2,
    name: {
      en : "Frankton"
    }
  },
  ZQW : {
    country: "DE",
    city: "SCN",
    name: {
      en : "Zweibruecken"
    }
  },
  ZQZ : {
    country: "CN",
    name: {
      en : "Zhangjiakou Ningyuan"
    }
  },
  ZRD : {
    country: "US",
    name: {
      en : "Richmond Va Railway Station"
    }
  },
  ZRF : {
    lat: "-32.85",
    lon: "24.1667",
    country: "US",
    city: "RFD",
    name: {
      en : "Peoria Rockford Bus Terminal"
    }
  },
  ZRG : {
    country: "SK",
    city: "BTS",
    name: {
      en : "Bratislava Bus Station"
    }
  },
  ZRH : {
    lat: "47.4583",
    lon: "8.55167",
    country: "CH",
    popularity: 204,
    name: {
      en : "Zurich"
    }
  },
  ZRJ : {
    country: "CA",
    name: {
      en : "ZRJ"
    }
  },
  ZRK : {
    lat: "-32.85",
    lon: "24.1667",
    country: "US",
    city: "RFD",
    name: {
      en : "Van Galder Bus Terminal"
    }
  },
  ZRL : {
    country: "US",
    name: {
      en : "Lancaster Pa Railway Station"
    }
  },
  ZRP : {
    country: "US",
    city: "NYC",
    name: {
      en : "NEWARK RAILWAY STATION"
    }
  },
  ZRT : {
    country: "US",
    city: "HFD",
    name: {
      en : "Hartford Railway Station"
    }
  },
  ZRU : {
    country: "US",
    city: "BOS",
    name: {
      en : "Boston Area Railway Stattions"
    }
  },
  ZRV : {
    country: "US",
    name: {
      en : "ZRV"
    }
  },
  ZSA : {
    lat: "24.06",
    lon: "-74.5331",
    country: "BS",
    name: {
      en : "San Salvador"
    }
  },
  ZSE : {
    lat: "-21.3333",
    lon: "55.4833",
    country: "RE",
    name: {
      en : "St Pierre Dela Reunion"
    }
  },
  ZSF : {
    country: "US",
    city: "SFY",
    name: {
      en : "Pringfield Ma Rr"
    }
  },
  ZSJ : {
    lat: "53.0333",
    lon: "-93.2333",
    country: "CA",
    name: {
      en : "Sandy Lake"
    }
  },
  ZSM : {
    country: "US",
    city: "SJC",
    name: {
      en : "Santa Clara Bus Service"
    }
  },
  ZTA : {
    country: "PF",
    name: {
      en : "ZTA"
    }
  },
  ZTB : {
    lat: "50.7167",
    lon: "-59.3333",
    country: "CA",
    name: {
      en : "Tete A La Baleine"
    }
  },
  ZTD : {
    country: "US",
    name: {
      en : "ZTD"
    }
  },
  ZTE : {
    country: "US",
    name: {
      en : "ZTE"
    }
  },
  ZTF : {
    country: "US",
    name: {
      en : "ZTF"
    }
  },
  ZTH : {
    lat: "37.7558",
    lon: "20.8883",
    country: "GR",
    popularity: 2,
    name: {
      en : "Zakinthos"
    }
  },
  ZTI : {
    country: "CN",
    name: {
      en : "ZTI"
    }
  },
  ZTJ : {
    country: "US",
    name: {
      en : "ZTJ"
    }
  },
  ZTN : {
    country: "US",
    city: "PHL",
    name: {
      en : "Trento Railway Station"
    }
  },
  ZTO : {
    country: "US",
    city: "BOS",
    name: {
      en : "Boston South Rail Station"
    }
  },
  ZTV : {
    country: "US",
    name: {
      en : "ZTV"
    }
  },
  ZTY : {
    country: "US",
    city: "BOS",
    name: {
      en : "Boston Area Railway Station"
    }
  },
  ZUA : {
    country: "US",
    name: {
      en : "ZUA"
    }
  },
  ZUG : {
    country: "US",
    city: "HAR",
    name: {
      en : "Harrisburg Railway Station"
    }
  },
  ZUH : {
    lat: "22.25",
    lon: "113.5",
    country: "CN",
    name: {
      en : "Zhuhai"
    }
  },
  ZUM : {
    lat: "53.5628",
    lon: "-64.1092",
    country: "CA",
    name: {
      en : "Churchhill Falls"
    }
  },
  ZUN : {
    country: "US",
    city: "CHI",
    name: {
      en : "Chicago Union Railway Station"
    }
  },
  ZVE : {
    country: "US",
    name: {
      en : "ZVE"
    }
  },
  ZVH : {
    country: "AE",
    name: {
      en : "ZVH"
    }
  },
  ZVJ : {
    country: "AE",
    name: {
      en : "ZVJ"
    }
  },
  ZVK : {
    country: "LA",
    name: {
      en : "ZVK"
    }
  },
  ZWB : {
    country: "US",
    name: {
      en : "ZWB"
    }
  },
  ZWI : {
    country: "US",
    city: "ILG",
    name: {
      en : "Wilmington Railway Station"
    }
  },
  ZWU : {
    country: "US",
    city: "WAS",
    name: {
      en : "Union Railway Station"
    }
  },
  ZWV : {
    country: "US",
    name: {
      en : "ZWV"
    }
  },
  ZWW : {
    country: "US",
    name: {
      en : "ZWW"
    }
  },
  ZWY : {
    country: "BE",
    name: {
      en : "ZWY"
    }
  },
  ZXE : {
    country: "GB",
    city: "EDI",
    name: {
      en : "Edinburgh ScotRail"
    }
  },
  ZYI : {
    country: "CN",
    name: {
      en : "Zunyi Xinzhou"
    }
  },
  ZYK : {
    country: "CN",
    name: {
      en : "ZYK"
    }
  },
  ZYL : {
    lat: "24.9589",
    lon: "91.8744",
    country: "BD",
    name: {
      en : "Sylhet Osmany"
    }
  },
  ZYN : {
    country: "FR",
    name: {
      en : "Nimes France Railway Station"
    }
  },
  ZYP : {
    country: "US",
    name: {
      en : "New York Penn STN"
    }
  },
  ZYQ : {
    country: "US",
    name: {
      en : "ZYQ"
    }
  },
  ZYR : {
    country: "BE",
    city: "BRU",
    name: {
      en : "Midi Railway Station"
    }
  },
  ZZO : {
    lat: "50.66932929784635",
    lon: "142.75642078649716",
    country: "RU",
    name: {
      en : "Zonalnoe"
    }
  },
  ZZU : {
    country: "MW",
    name: {
      en : "ZZU"
    }
  },
 'ВСЬ': {
    lat: "64.54",
    lon: "40.54",
    country: "RU",
    city: "ARH",
    name: {
      en : "Vaskovo"
    }
  },
 'ДЕП': {
    country: "RU",
    city: "DPT",
    name: {
      en : "DEPUTATSKIY"
    }
  },
 'ЖУК': {
    lat: "55.553333",
    lon: "38.151667",
    country: "RU",
    city: "MOW",
    name: {
      en : "Zhukovsky"
    }
  },
 'Оха': {
    country: "ru",
    city: "Okha",
    name: {
      en : "Okha"
    }
  }
};

global.___airports = airports;
var lang = "ru";
if (typeof window !== "undefined") {
 switch (self.document.documentElement.lang) {
     case "uk-ua":
       lang = "ua";
       break;
     case "ru-ua":
       lang = "ru";
       break;
     default:
       lang = self.document.documentElement.lang.substring(0, 2);
       break;
 }
}
const defineProps = function(obj) {
  var keys = Object.keys(obj);
  var key;
  var val;
  var type;
  var k = keys.length;
  while (k--) {
    key = keys[k];
    val = obj[key];
    val.$code = key 
    val.$type = "airport"
    type = typeof val;
    if (type === "object") {
      if (val[lang]) {
        Object.defineProperty(obj, key, {
          value: val[lang]
        });
        Object.defineProperty(obj, key+"En", {
          value: val.en,
          enumerable: true
        });
      } else {
        defineProps(val);
      }
    }
  }
};
typeof window !== "undefined" && defineProps(airports);
module.exports = airports;
